/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MOTOLYNK MARKET API
 * Admin, vendor and store APIs of the MOTOLYNK multi-vendor marketplace.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActRequest,
  Activity,
  AdjustmentRequest,
  AdminActivityListParams,
  AdminAttributeSetsListParams,
  AdminAttributesListParams,
  AdminBrandsListParams,
  AdminBulkUploadBatchesListParams,
  AdminBulkUploadBatchesRowsListParams,
  AdminBulkUploadTemplateMacroRetrieveParams,
  AdminBulkUploadTemplateRetrieveParams,
  AdminBulkUploadUpdateSheetRetrieveParams,
  AdminCmsBannersListParams,
  AdminCmsBlogPostsListParams,
  AdminCmsBlogTagsListParams,
  AdminCmsFaqsListParams,
  AdminCmsPagesListParams,
  AdminCommissionRulesListParams,
  AdminCouponsListParams,
  AdminCouriersListParams,
  AdminCouriersTrackingUrlRetrieveParams,
  AdminCustomersListParams,
  AdminFeatureFlagOverridesListParams,
  AdminFeaturesRetrieve200,
  AdminInvoicesListParams,
  AdminJobsFailedListParams,
  AdminMe,
  AdminMediaDestroyParams,
  AdminMediaFileRetrieveParams,
  AdminMediaListParams,
  AdminMediaRetrieveParams,
  AdminNotificationsListParams,
  AdminNotificationsLogListParams,
  AdminOrderDetail,
  AdminOrdersListParams,
  AdminPaymentsReconciliationParams,
  AdminPaymentsRefundsListParams,
  AdminPaymentsTransactionsListParams,
  AdminPaymentsWebhooksListParams,
  AdminPayoutsExportParams,
  AdminPayoutsLedgerParams,
  AdminPayoutsListParams,
  AdminPayoutsTaxDeductionsExportParams,
  AdminPayoutsTaxDeductionsParams,
  AdminProductsCountsParams,
  AdminProductsListParams,
  AdminReportsOverviewParams,
  AdminReportsVendorSalesParams,
  AdminReturnsListParams,
  AdminReview,
  AdminReviewsListParams,
  AdminStaffListParams,
  AdminStatusCounts,
  AdminTaxClassesListParams,
  AdminTicketsListParams,
  AdminVehiclesMakesListParams,
  AdminVehiclesModelsListParams,
  AdminVehiclesVariantsListParams,
  AdminVendorsDocumentsFileParams,
  AdminVendorsListParams,
  AdvanceRequest,
  Attribute,
  AttributeWriteRequest,
  Balance,
  Banner,
  BannerWriteRequest,
  BlockRequest,
  BlogCategory,
  BlogCategoryWriteRequest,
  Brand,
  BrandWriteRequest,
  BulkApproveResult,
  BulkBatchDetail,
  BulkBatchPage,
  BulkCategoryChoice,
  BulkImportRequestRequest,
  BulkRowPage,
  BulkUploadRequest,
  CancelRequest,
  Category,
  CategoryWriteRequest,
  CompleteRefundRequest,
  CouponDetail,
  CouponWriteRequest,
  Courier,
  CourierWriteRequest,
  CustomerDetail,
  DeactivateRequest,
  Delivery,
  Done,
  Entry,
  Export,
  ExportRequestRequest,
  FailedJob,
  FailedJobDetail,
  Faq,
  FaqCategory,
  FaqCategoryRequest,
  FaqWriteRequest,
  Flag,
  Folder,
  FolderWriteRequest,
  FooterLink,
  FooterLinkRequest,
  FormSchema,
  GenerateRequest,
  Generated,
  Group,
  GroupOrderRequest,
  GroupRequest,
  ImportRequest,
  ImportResult,
  InstalledModule,
  Integration,
  InviteRequest,
  JobRegistry,
  LayoutRequest,
  Make,
  MakeRequest,
  MarkedRead,
  MarketplaceSummary,
  MediaDetail,
  Model,
  ModelRequest,
  MoveRequest,
  NoteRequest,
  NoteWriteRequest,
  Notification,
  OptionListRequest,
  Override,
  OverrideWriteRequest,
  Overview,
  Page,
  PageList,
  PageWriteRequest,
  PaginatedActivityList,
  PaginatedAdminOrderListList,
  PaginatedAdminReviewList,
  PaginatedAttributeList,
  PaginatedBrandList,
  PaginatedCouponList,
  PaginatedCustomerList,
  PaginatedDeliveryList,
  PaginatedEntryList,
  PaginatedFailedJobList,
  PaginatedInvoiceList,
  PaginatedMakeList,
  PaginatedMediaList,
  PaginatedModelList,
  PaginatedNotificationList,
  PaginatedPayoutList,
  PaginatedPostListList,
  PaginatedProductListList,
  PaginatedRefundList,
  PaginatedReturnListList,
  PaginatedStaffList,
  PaginatedTicketListList,
  PaginatedTransactionList,
  PaginatedVariantList,
  PaginatedVendorList,
  PaginatedWebhookList,
  PaidRequest,
  PatchedAttributeWriteRequest,
  PatchedBannerWriteRequest,
  PatchedBlogCategoryWriteRequest,
  PatchedBrandWriteRequest,
  PatchedCategoryWriteRequest,
  PatchedCouponWriteRequest,
  PatchedCourierWriteRequest,
  PatchedCustomerUpdateRequest,
  PatchedFaqCategoryRequest,
  PatchedFaqWriteRequest,
  PatchedFlagUpdateRequest,
  PatchedFolderWriteRequest,
  PatchedFooterLinkRequest,
  PatchedGroupRequest,
  PatchedMakeRequest,
  PatchedMediaUpdateRequest,
  PatchedModelRequest,
  PatchedPageWriteRequest,
  PatchedPostWriteRequest,
  PatchedProductWriteRequest,
  PatchedProfileUpdateRequest,
  PatchedRateWriteRequest,
  PatchedRoleWriteRequest,
  PatchedRuleWriteRequest,
  PatchedSetRequest,
  PatchedSettingsRequest,
  PatchedStaffUpdateRequest,
  PatchedTagRequest,
  PatchedTaxClassWriteRequest,
  PatchedTicketCategoryRequest,
  PatchedTypeRequest,
  PatchedTypeSettingUpdateRequest,
  PatchedVariantRequest,
  PatchedVendorUpdateRequest,
  PatchedYearRequest,
  PayoutCancelRequest,
  PayoutCounts,
  PayoutDetail,
  PermissionModule,
  Post,
  PostWriteRequest,
  ProductBulkFitmentRequest,
  ProductBulkFitmentResult,
  ProductDetail,
  ProductHistory,
  ProductNoteRequest,
  ProductPublishRequest,
  ProductReasonRequest,
  ProductRequiredNoteRequest,
  ProductStatusCounts,
  ProductWriteRequest,
  QueueHealth,
  Quote,
  QuoteRequestRequest,
  Rate,
  RateWriteRequest,
  Reconciliation,
  Refund,
  RefundCounts,
  ReorderRequest,
  ReplyRequest,
  ResetLinkRequest,
  Resolution,
  ResolveRequestRequest,
  ReturnCounts,
  ReturnDetail,
  ReviewCounts,
  Role,
  RoleDetail,
  RoleWriteRequest,
  Rule,
  RuleWriteRequest,
  SavedVehicle,
  Set,
  SetDetail,
  SetPasswordRequest,
  SetRequest,
  Settings,
  StaffDetail,
  Tag,
  TagRequest,
  TaxClass,
  TaxClassWriteRequest,
  TaxDeductionSummary,
  TestSendRequest,
  TestSendResult,
  TicketCategory,
  TicketCategoryRequest,
  TicketCounts,
  TicketDetail,
  TrackingRequest,
  TrackingUrl,
  TransactionCounts,
  TransactionDetail,
  TreeNode,
  Type,
  TypeRequest,
  TypeSetting,
  UnblockRequest,
  UnreadCount,
  UpdateRequest,
  UploadRequest,
  ValidateRequest,
  Validated,
  Variant,
  VariantRequest,
  VendorDetail,
  VendorDocumentRequestRequest,
  VendorDocumentReviewRequest,
  VendorHistory,
  VendorNoteRequest,
  VendorReasonRequest,
  VendorSales,
  VendorStatusCounts,
  VideoRequest,
  WishlistItem,
  Year,
  YearRangeRequest
} from '../../model';

import { apiFetch } from '../../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type adminActivityListResponse200 = {
  data: PaginatedActivityList
  status: 200
}

export type adminActivityListResponseSuccess = (adminActivityListResponse200) & {
  headers: Headers;
};
;

export type adminActivityListResponse = (adminActivityListResponseSuccess)

export const getAdminActivityListUrl = (params?: AdminActivityListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/activity?${stringifiedParams}` : `/api/v1/admin/activity`
}

/**
 * Newest first; cursor pagination (`?cursor=`), stable while new entries arrive.
 */
export const adminActivityList = async (params?: AdminActivityListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminActivityListResponse> => {

  return apiFetch<adminActivityListResponse>(getAdminActivityListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminActivityListQueryKey = (params?: AdminActivityListParams,) => {
    return [
    `/api/v1/admin/activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminActivityListQueryOptions = <TData = Awaited<ReturnType<typeof adminActivityList>>, TError = unknown>(params?: AdminActivityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminActivityListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminActivityList>>> = ({ signal }) => adminActivityList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminActivityList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminActivityListQueryResult = NonNullable<Awaited<ReturnType<typeof adminActivityList>>>
export type AdminActivityListQueryError = unknown


export function useAdminActivityList<TData = Awaited<ReturnType<typeof adminActivityList>>, TError = unknown>(
 params: undefined |  AdminActivityListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminActivityList>>,
          TError,
          Awaited<ReturnType<typeof adminActivityList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminActivityList<TData = Awaited<ReturnType<typeof adminActivityList>>, TError = unknown>(
 params?: AdminActivityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminActivityList>>,
          TError,
          Awaited<ReturnType<typeof adminActivityList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminActivityList<TData = Awaited<ReturnType<typeof adminActivityList>>, TError = unknown>(
 params?: AdminActivityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminActivityList<TData = Awaited<ReturnType<typeof adminActivityList>>, TError = unknown>(
 params?: AdminActivityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminActivityListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminActivityRetrieveResponse200 = {
  data: Activity
  status: 200
}

export type adminActivityRetrieveResponseSuccess = (adminActivityRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminActivityRetrieveResponse = (adminActivityRetrieveResponseSuccess)

export const getAdminActivityRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/activity/${uid}`
}

/**
 * Look objects up by public `uid` in URLs (`/vendors/<uid>`), never by integer id.
 */
export const adminActivityRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminActivityRetrieveResponse> => {

  return apiFetch<adminActivityRetrieveResponse>(getAdminActivityRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminActivityRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/activity/${uid}`
    ] as const;
    }


export const getAdminActivityRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminActivityRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminActivityRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminActivityRetrieve>>> = ({ signal }) => adminActivityRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminActivityRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminActivityRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminActivityRetrieve>>>
export type AdminActivityRetrieveQueryError = unknown


export function useAdminActivityRetrieve<TData = Awaited<ReturnType<typeof adminActivityRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminActivityRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminActivityRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminActivityRetrieve<TData = Awaited<ReturnType<typeof adminActivityRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminActivityRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminActivityRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminActivityRetrieve<TData = Awaited<ReturnType<typeof adminActivityRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminActivityRetrieve<TData = Awaited<ReturnType<typeof adminActivityRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminActivityRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminActivityActionsListResponse200 = {
  data: string[]
  status: 200
}

export type adminActivityActionsListResponseSuccess = (adminActivityActionsListResponse200) & {
  headers: Headers;
};
;

export type adminActivityActionsListResponse = (adminActivityActionsListResponseSuccess)

export const getAdminActivityActionsListUrl = () => {




  return `/api/v1/admin/activity/actions`
}

/**
 * Actions that occur in the log, for the filter dropdown.
 */
export const adminActivityActionsList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminActivityActionsListResponse> => {

  return apiFetch<adminActivityActionsListResponse>(getAdminActivityActionsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminActivityActionsListQueryKey = () => {
    return [
    `/api/v1/admin/activity/actions`
    ] as const;
    }


export const getAdminActivityActionsListQueryOptions = <TData = Awaited<ReturnType<typeof adminActivityActionsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityActionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminActivityActionsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminActivityActionsList>>> = ({ signal }) => adminActivityActionsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminActivityActionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminActivityActionsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminActivityActionsList>>>
export type AdminActivityActionsListQueryError = unknown


export function useAdminActivityActionsList<TData = Awaited<ReturnType<typeof adminActivityActionsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityActionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminActivityActionsList>>,
          TError,
          Awaited<ReturnType<typeof adminActivityActionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminActivityActionsList<TData = Awaited<ReturnType<typeof adminActivityActionsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityActionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminActivityActionsList>>,
          TError,
          Awaited<ReturnType<typeof adminActivityActionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminActivityActionsList<TData = Awaited<ReturnType<typeof adminActivityActionsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityActionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminActivityActionsList<TData = Awaited<ReturnType<typeof adminActivityActionsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminActivityActionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminActivityActionsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminAttributeGroupsListResponse200 = {
  data: Group[]
  status: 200
}

export type adminAttributeGroupsListResponseSuccess = (adminAttributeGroupsListResponse200) & {
  headers: Headers;
};
;

export type adminAttributeGroupsListResponse = (adminAttributeGroupsListResponseSuccess)

export const getAdminAttributeGroupsListUrl = () => {




  return `/api/v1/admin/attribute-groups`
}

/**
 * Model permissions by HTTP method (`<app>.<action>_<codename>`).
 */
export const adminAttributeGroupsList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributeGroupsListResponse> => {

  return apiFetch<adminAttributeGroupsListResponse>(getAdminAttributeGroupsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminAttributeGroupsListQueryKey = () => {
    return [
    `/api/v1/admin/attribute-groups`
    ] as const;
    }


export const getAdminAttributeGroupsListQueryOptions = <TData = Awaited<ReturnType<typeof adminAttributeGroupsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeGroupsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAttributeGroupsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAttributeGroupsList>>> = ({ signal }) => adminAttributeGroupsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAttributeGroupsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAttributeGroupsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminAttributeGroupsList>>>
export type AdminAttributeGroupsListQueryError = unknown


export function useAdminAttributeGroupsList<TData = Awaited<ReturnType<typeof adminAttributeGroupsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeGroupsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAttributeGroupsList>>,
          TError,
          Awaited<ReturnType<typeof adminAttributeGroupsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAttributeGroupsList<TData = Awaited<ReturnType<typeof adminAttributeGroupsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeGroupsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAttributeGroupsList>>,
          TError,
          Awaited<ReturnType<typeof adminAttributeGroupsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAttributeGroupsList<TData = Awaited<ReturnType<typeof adminAttributeGroupsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeGroupsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminAttributeGroupsList<TData = Awaited<ReturnType<typeof adminAttributeGroupsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeGroupsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAttributeGroupsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminAttributeGroupsCreateResponse201 = {
  data: Group
  status: 201
}

export type adminAttributeGroupsCreateResponseSuccess = (adminAttributeGroupsCreateResponse201) & {
  headers: Headers;
};
;

export type adminAttributeGroupsCreateResponse = (adminAttributeGroupsCreateResponseSuccess)

export const getAdminAttributeGroupsCreateUrl = () => {




  return `/api/v1/admin/attribute-groups`
}

/**
 * Model permissions by HTTP method (`<app>.<action>_<codename>`).
 */
export const adminAttributeGroupsCreate = async (groupRequest: GroupRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributeGroupsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminAttributeGroupsCreateResponse>(getAdminAttributeGroupsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(groupRequest)
  }
);}





export const getAdminAttributeGroupsCreateMutationKey = () => ['adminAttributeGroupsCreate'] as const;

export const getAdminAttributeGroupsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeGroupsCreate>>, TError,AdminAttributeGroupsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAttributeGroupsCreate>>, TError,AdminAttributeGroupsCreateMutationVariables, TContext> => {

const mutationKey = getAdminAttributeGroupsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttributeGroupsCreate>>, AdminAttributeGroupsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminAttributeGroupsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAttributeGroupsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttributeGroupsCreate>>>
    export type AdminAttributeGroupsCreateMutationBody = GroupRequest
    export type AdminAttributeGroupsCreateMutationError = unknown
    export type AdminAttributeGroupsCreateMutationVariables = {data: GroupRequest}

    export const useAdminAttributeGroupsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeGroupsCreate>>, TError,AdminAttributeGroupsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAttributeGroupsCreate>>,
        TError,
        AdminAttributeGroupsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAttributeGroupsCreateMutationOptions(options), queryClient);
    }
    export type adminAttributeGroupsPartialUpdateResponse200 = {
  data: Group
  status: 200
}

export type adminAttributeGroupsPartialUpdateResponseSuccess = (adminAttributeGroupsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminAttributeGroupsPartialUpdateResponse = (adminAttributeGroupsPartialUpdateResponseSuccess)

export const getAdminAttributeGroupsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/attribute-groups/${uid}`
}

/**
 * Model permissions by HTTP method (`<app>.<action>_<codename>`).
 */
export const adminAttributeGroupsPartialUpdate = async (uid: string,
    patchedGroupRequest?: PatchedGroupRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributeGroupsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminAttributeGroupsPartialUpdateResponse>(getAdminAttributeGroupsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedGroupRequest)
  }
);}





export const getAdminAttributeGroupsPartialUpdateMutationKey = () => ['adminAttributeGroupsPartialUpdate'] as const;

export const getAdminAttributeGroupsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeGroupsPartialUpdate>>, TError,AdminAttributeGroupsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAttributeGroupsPartialUpdate>>, TError,AdminAttributeGroupsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminAttributeGroupsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttributeGroupsPartialUpdate>>, AdminAttributeGroupsPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminAttributeGroupsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAttributeGroupsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttributeGroupsPartialUpdate>>>
    export type AdminAttributeGroupsPartialUpdateMutationBody = PatchedGroupRequest | undefined
    export type AdminAttributeGroupsPartialUpdateMutationError = unknown
    export type AdminAttributeGroupsPartialUpdateMutationVariables = {uid: string;data?: PatchedGroupRequest}

    export const useAdminAttributeGroupsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeGroupsPartialUpdate>>, TError,AdminAttributeGroupsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAttributeGroupsPartialUpdate>>,
        TError,
        AdminAttributeGroupsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAttributeGroupsPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminAttributeGroupsDestroyResponse204 = {
  data: void
  status: 204
}

export type adminAttributeGroupsDestroyResponseSuccess = (adminAttributeGroupsDestroyResponse204) & {
  headers: Headers;
};
;

export type adminAttributeGroupsDestroyResponse = (adminAttributeGroupsDestroyResponseSuccess)

export const getAdminAttributeGroupsDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/attribute-groups/${uid}`
}

/**
 * Model permissions by HTTP method (`<app>.<action>_<codename>`).
 */
export const adminAttributeGroupsDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributeGroupsDestroyResponse> => {

  return apiFetch<adminAttributeGroupsDestroyResponse>(getAdminAttributeGroupsDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminAttributeGroupsDestroyMutationKey = () => ['adminAttributeGroupsDestroy'] as const;

export const getAdminAttributeGroupsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeGroupsDestroy>>, TError,AdminAttributeGroupsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAttributeGroupsDestroy>>, TError,AdminAttributeGroupsDestroyMutationVariables, TContext> => {

const mutationKey = getAdminAttributeGroupsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttributeGroupsDestroy>>, AdminAttributeGroupsDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminAttributeGroupsDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAttributeGroupsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttributeGroupsDestroy>>>

    export type AdminAttributeGroupsDestroyMutationError = unknown
    export type AdminAttributeGroupsDestroyMutationVariables = {uid: string}

    export const useAdminAttributeGroupsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeGroupsDestroy>>, TError,AdminAttributeGroupsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAttributeGroupsDestroy>>,
        TError,
        AdminAttributeGroupsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAttributeGroupsDestroyMutationOptions(options), queryClient);
    }
    export type adminAttributeGroupsOrderCreateResponse200 = {
  data: Group[]
  status: 200
}

export type adminAttributeGroupsOrderCreateResponseSuccess = (adminAttributeGroupsOrderCreateResponse200) & {
  headers: Headers;
};
;

export type adminAttributeGroupsOrderCreateResponse = (adminAttributeGroupsOrderCreateResponseSuccess)

export const getAdminAttributeGroupsOrderCreateUrl = () => {




  return `/api/v1/admin/attribute-groups/order`
}

export const adminAttributeGroupsOrderCreate = async (groupOrderRequest: GroupOrderRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributeGroupsOrderCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminAttributeGroupsOrderCreateResponse>(getAdminAttributeGroupsOrderCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(groupOrderRequest)
  }
);}





export const getAdminAttributeGroupsOrderCreateMutationKey = () => ['adminAttributeGroupsOrderCreate'] as const;

export const getAdminAttributeGroupsOrderCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeGroupsOrderCreate>>, TError,AdminAttributeGroupsOrderCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAttributeGroupsOrderCreate>>, TError,AdminAttributeGroupsOrderCreateMutationVariables, TContext> => {

const mutationKey = getAdminAttributeGroupsOrderCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttributeGroupsOrderCreate>>, AdminAttributeGroupsOrderCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminAttributeGroupsOrderCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAttributeGroupsOrderCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttributeGroupsOrderCreate>>>
    export type AdminAttributeGroupsOrderCreateMutationBody = GroupOrderRequest
    export type AdminAttributeGroupsOrderCreateMutationError = unknown
    export type AdminAttributeGroupsOrderCreateMutationVariables = {data: GroupOrderRequest}

    export const useAdminAttributeGroupsOrderCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeGroupsOrderCreate>>, TError,AdminAttributeGroupsOrderCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAttributeGroupsOrderCreate>>,
        TError,
        AdminAttributeGroupsOrderCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAttributeGroupsOrderCreateMutationOptions(options), queryClient);
    }
    export type adminAttributeSetsListResponse200 = {
  data: Set[]
  status: 200
}

export type adminAttributeSetsListResponseSuccess = (adminAttributeSetsListResponse200) & {
  headers: Headers;
};
;

export type adminAttributeSetsListResponse = (adminAttributeSetsListResponseSuccess)

export const getAdminAttributeSetsListUrl = (params?: AdminAttributeSetsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/attribute-sets?${stringifiedParams}` : `/api/v1/admin/attribute-sets`
}

/**
 * Model permissions by HTTP method (`<app>.<action>_<codename>`).
 */
export const adminAttributeSetsList = async (params?: AdminAttributeSetsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributeSetsListResponse> => {

  return apiFetch<adminAttributeSetsListResponse>(getAdminAttributeSetsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminAttributeSetsListQueryKey = (params?: AdminAttributeSetsListParams,) => {
    return [
    `/api/v1/admin/attribute-sets`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminAttributeSetsListQueryOptions = <TData = Awaited<ReturnType<typeof adminAttributeSetsList>>, TError = unknown>(params?: AdminAttributeSetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeSetsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAttributeSetsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAttributeSetsList>>> = ({ signal }) => adminAttributeSetsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAttributeSetsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAttributeSetsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminAttributeSetsList>>>
export type AdminAttributeSetsListQueryError = unknown


export function useAdminAttributeSetsList<TData = Awaited<ReturnType<typeof adminAttributeSetsList>>, TError = unknown>(
 params: undefined |  AdminAttributeSetsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeSetsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAttributeSetsList>>,
          TError,
          Awaited<ReturnType<typeof adminAttributeSetsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAttributeSetsList<TData = Awaited<ReturnType<typeof adminAttributeSetsList>>, TError = unknown>(
 params?: AdminAttributeSetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeSetsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAttributeSetsList>>,
          TError,
          Awaited<ReturnType<typeof adminAttributeSetsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAttributeSetsList<TData = Awaited<ReturnType<typeof adminAttributeSetsList>>, TError = unknown>(
 params?: AdminAttributeSetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeSetsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminAttributeSetsList<TData = Awaited<ReturnType<typeof adminAttributeSetsList>>, TError = unknown>(
 params?: AdminAttributeSetsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeSetsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAttributeSetsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminAttributeSetsCreateResponse201 = {
  data: SetDetail
  status: 201
}

export type adminAttributeSetsCreateResponseSuccess = (adminAttributeSetsCreateResponse201) & {
  headers: Headers;
};
;

export type adminAttributeSetsCreateResponse = (adminAttributeSetsCreateResponseSuccess)

export const getAdminAttributeSetsCreateUrl = () => {




  return `/api/v1/admin/attribute-sets`
}

/**
 * Model permissions by HTTP method (`<app>.<action>_<codename>`).
 */
export const adminAttributeSetsCreate = async (setRequest: SetRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributeSetsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminAttributeSetsCreateResponse>(getAdminAttributeSetsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setRequest)
  }
);}





export const getAdminAttributeSetsCreateMutationKey = () => ['adminAttributeSetsCreate'] as const;

export const getAdminAttributeSetsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeSetsCreate>>, TError,AdminAttributeSetsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAttributeSetsCreate>>, TError,AdminAttributeSetsCreateMutationVariables, TContext> => {

const mutationKey = getAdminAttributeSetsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttributeSetsCreate>>, AdminAttributeSetsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminAttributeSetsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAttributeSetsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttributeSetsCreate>>>
    export type AdminAttributeSetsCreateMutationBody = SetRequest
    export type AdminAttributeSetsCreateMutationError = unknown
    export type AdminAttributeSetsCreateMutationVariables = {data: SetRequest}

    export const useAdminAttributeSetsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeSetsCreate>>, TError,AdminAttributeSetsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAttributeSetsCreate>>,
        TError,
        AdminAttributeSetsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAttributeSetsCreateMutationOptions(options), queryClient);
    }
    export type adminAttributeSetsRetrieveResponse200 = {
  data: SetDetail
  status: 200
}

export type adminAttributeSetsRetrieveResponseSuccess = (adminAttributeSetsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminAttributeSetsRetrieveResponse = (adminAttributeSetsRetrieveResponseSuccess)

export const getAdminAttributeSetsRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/attribute-sets/${uid}`
}

/**
 * Model permissions by HTTP method (`<app>.<action>_<codename>`).
 */
export const adminAttributeSetsRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributeSetsRetrieveResponse> => {

  return apiFetch<adminAttributeSetsRetrieveResponse>(getAdminAttributeSetsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminAttributeSetsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/attribute-sets/${uid}`
    ] as const;
    }


export const getAdminAttributeSetsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAttributeSetsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>> = ({ signal }) => adminAttributeSetsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAttributeSetsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>>
export type AdminAttributeSetsRetrieveQueryError = unknown


export function useAdminAttributeSetsRetrieve<TData = Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAttributeSetsRetrieve<TData = Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAttributeSetsRetrieve<TData = Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminAttributeSetsRetrieve<TData = Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributeSetsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAttributeSetsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminAttributeSetsPartialUpdateResponse200 = {
  data: SetDetail
  status: 200
}

export type adminAttributeSetsPartialUpdateResponseSuccess = (adminAttributeSetsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminAttributeSetsPartialUpdateResponse = (adminAttributeSetsPartialUpdateResponseSuccess)

export const getAdminAttributeSetsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/attribute-sets/${uid}`
}

/**
 * Model permissions by HTTP method (`<app>.<action>_<codename>`).
 */
export const adminAttributeSetsPartialUpdate = async (uid: string,
    patchedSetRequest?: PatchedSetRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributeSetsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminAttributeSetsPartialUpdateResponse>(getAdminAttributeSetsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedSetRequest)
  }
);}





export const getAdminAttributeSetsPartialUpdateMutationKey = () => ['adminAttributeSetsPartialUpdate'] as const;

export const getAdminAttributeSetsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeSetsPartialUpdate>>, TError,AdminAttributeSetsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAttributeSetsPartialUpdate>>, TError,AdminAttributeSetsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminAttributeSetsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttributeSetsPartialUpdate>>, AdminAttributeSetsPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminAttributeSetsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAttributeSetsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttributeSetsPartialUpdate>>>
    export type AdminAttributeSetsPartialUpdateMutationBody = PatchedSetRequest | undefined
    export type AdminAttributeSetsPartialUpdateMutationError = unknown
    export type AdminAttributeSetsPartialUpdateMutationVariables = {uid: string;data?: PatchedSetRequest}

    export const useAdminAttributeSetsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeSetsPartialUpdate>>, TError,AdminAttributeSetsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAttributeSetsPartialUpdate>>,
        TError,
        AdminAttributeSetsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAttributeSetsPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminAttributeSetsDestroyResponse204 = {
  data: void
  status: 204
}

export type adminAttributeSetsDestroyResponseSuccess = (adminAttributeSetsDestroyResponse204) & {
  headers: Headers;
};
;

export type adminAttributeSetsDestroyResponse = (adminAttributeSetsDestroyResponseSuccess)

export const getAdminAttributeSetsDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/attribute-sets/${uid}`
}

/**
 * Model permissions by HTTP method (`<app>.<action>_<codename>`).
 */
export const adminAttributeSetsDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributeSetsDestroyResponse> => {

  return apiFetch<adminAttributeSetsDestroyResponse>(getAdminAttributeSetsDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminAttributeSetsDestroyMutationKey = () => ['adminAttributeSetsDestroy'] as const;

export const getAdminAttributeSetsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeSetsDestroy>>, TError,AdminAttributeSetsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAttributeSetsDestroy>>, TError,AdminAttributeSetsDestroyMutationVariables, TContext> => {

const mutationKey = getAdminAttributeSetsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttributeSetsDestroy>>, AdminAttributeSetsDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminAttributeSetsDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAttributeSetsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttributeSetsDestroy>>>

    export type AdminAttributeSetsDestroyMutationError = unknown
    export type AdminAttributeSetsDestroyMutationVariables = {uid: string}

    export const useAdminAttributeSetsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeSetsDestroy>>, TError,AdminAttributeSetsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAttributeSetsDestroy>>,
        TError,
        AdminAttributeSetsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAttributeSetsDestroyMutationOptions(options), queryClient);
    }
    export type adminAttributeSetsLayoutUpdateResponse200 = {
  data: SetDetail
  status: 200
}

export type adminAttributeSetsLayoutUpdateResponseSuccess = (adminAttributeSetsLayoutUpdateResponse200) & {
  headers: Headers;
};
;

export type adminAttributeSetsLayoutUpdateResponse = (adminAttributeSetsLayoutUpdateResponseSuccess)

export const getAdminAttributeSetsLayoutUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/attribute-sets/${uid}/layout`
}

/**
 * Replace the set's layout: attributes in order, each with its group and required override.
 */
export const adminAttributeSetsLayoutUpdate = async (uid: string,
    layoutRequest: LayoutRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributeSetsLayoutUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminAttributeSetsLayoutUpdateResponse>(getAdminAttributeSetsLayoutUpdateUrl(uid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(layoutRequest)
  }
);}





export const getAdminAttributeSetsLayoutUpdateMutationKey = () => ['adminAttributeSetsLayoutUpdate'] as const;

export const getAdminAttributeSetsLayoutUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeSetsLayoutUpdate>>, TError,AdminAttributeSetsLayoutUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAttributeSetsLayoutUpdate>>, TError,AdminAttributeSetsLayoutUpdateMutationVariables, TContext> => {

const mutationKey = getAdminAttributeSetsLayoutUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttributeSetsLayoutUpdate>>, AdminAttributeSetsLayoutUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminAttributeSetsLayoutUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAttributeSetsLayoutUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttributeSetsLayoutUpdate>>>
    export type AdminAttributeSetsLayoutUpdateMutationBody = LayoutRequest
    export type AdminAttributeSetsLayoutUpdateMutationError = unknown
    export type AdminAttributeSetsLayoutUpdateMutationVariables = {uid: string;data: LayoutRequest}

    export const useAdminAttributeSetsLayoutUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributeSetsLayoutUpdate>>, TError,AdminAttributeSetsLayoutUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAttributeSetsLayoutUpdate>>,
        TError,
        AdminAttributeSetsLayoutUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAttributeSetsLayoutUpdateMutationOptions(options), queryClient);
    }
    export type adminAttributesListResponse200 = {
  data: PaginatedAttributeList
  status: 200
}

export type adminAttributesListResponseSuccess = (adminAttributesListResponse200) & {
  headers: Headers;
};
;

export type adminAttributesListResponse = (adminAttributesListResponseSuccess)

export const getAdminAttributesListUrl = (params?: AdminAttributesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/attributes?${stringifiedParams}` : `/api/v1/admin/attributes`
}

/**
 * `?search=` (label or code) `?input_type=` `?active=true|false` `?group=<uid>`
 */
export const adminAttributesList = async (params?: AdminAttributesListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributesListResponse> => {

  return apiFetch<adminAttributesListResponse>(getAdminAttributesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminAttributesListQueryKey = (params?: AdminAttributesListParams,) => {
    return [
    `/api/v1/admin/attributes`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminAttributesListQueryOptions = <TData = Awaited<ReturnType<typeof adminAttributesList>>, TError = unknown>(params?: AdminAttributesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAttributesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAttributesList>>> = ({ signal }) => adminAttributesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAttributesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAttributesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminAttributesList>>>
export type AdminAttributesListQueryError = unknown


export function useAdminAttributesList<TData = Awaited<ReturnType<typeof adminAttributesList>>, TError = unknown>(
 params: undefined |  AdminAttributesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAttributesList>>,
          TError,
          Awaited<ReturnType<typeof adminAttributesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAttributesList<TData = Awaited<ReturnType<typeof adminAttributesList>>, TError = unknown>(
 params?: AdminAttributesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAttributesList>>,
          TError,
          Awaited<ReturnType<typeof adminAttributesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAttributesList<TData = Awaited<ReturnType<typeof adminAttributesList>>, TError = unknown>(
 params?: AdminAttributesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminAttributesList<TData = Awaited<ReturnType<typeof adminAttributesList>>, TError = unknown>(
 params?: AdminAttributesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAttributesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminAttributesCreateResponse201 = {
  data: Attribute
  status: 201
}

export type adminAttributesCreateResponseSuccess = (adminAttributesCreateResponse201) & {
  headers: Headers;
};
;

export type adminAttributesCreateResponse = (adminAttributesCreateResponseSuccess)

export const getAdminAttributesCreateUrl = () => {




  return `/api/v1/admin/attributes`
}

/**
 * `?search=` (label or code) `?input_type=` `?active=true|false` `?group=<uid>`
 */
export const adminAttributesCreate = async (attributeWriteRequest: AttributeWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminAttributesCreateResponse>(getAdminAttributesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(attributeWriteRequest)
  }
);}





export const getAdminAttributesCreateMutationKey = () => ['adminAttributesCreate'] as const;

export const getAdminAttributesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributesCreate>>, TError,AdminAttributesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAttributesCreate>>, TError,AdminAttributesCreateMutationVariables, TContext> => {

const mutationKey = getAdminAttributesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttributesCreate>>, AdminAttributesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminAttributesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAttributesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttributesCreate>>>
    export type AdminAttributesCreateMutationBody = AttributeWriteRequest
    export type AdminAttributesCreateMutationError = unknown
    export type AdminAttributesCreateMutationVariables = {data: AttributeWriteRequest}

    export const useAdminAttributesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributesCreate>>, TError,AdminAttributesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAttributesCreate>>,
        TError,
        AdminAttributesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAttributesCreateMutationOptions(options), queryClient);
    }
    export type adminAttributesRetrieveResponse200 = {
  data: Attribute
  status: 200
}

export type adminAttributesRetrieveResponseSuccess = (adminAttributesRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminAttributesRetrieveResponse = (adminAttributesRetrieveResponseSuccess)

export const getAdminAttributesRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/attributes/${uid}`
}

/**
 * Model permissions by HTTP method (`<app>.<action>_<codename>`).
 */
export const adminAttributesRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributesRetrieveResponse> => {

  return apiFetch<adminAttributesRetrieveResponse>(getAdminAttributesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminAttributesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/attributes/${uid}`
    ] as const;
    }


export const getAdminAttributesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminAttributesRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAttributesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAttributesRetrieve>>> = ({ signal }) => adminAttributesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAttributesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAttributesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminAttributesRetrieve>>>
export type AdminAttributesRetrieveQueryError = unknown


export function useAdminAttributesRetrieve<TData = Awaited<ReturnType<typeof adminAttributesRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAttributesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminAttributesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAttributesRetrieve<TData = Awaited<ReturnType<typeof adminAttributesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAttributesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminAttributesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAttributesRetrieve<TData = Awaited<ReturnType<typeof adminAttributesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminAttributesRetrieve<TData = Awaited<ReturnType<typeof adminAttributesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAttributesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAttributesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminAttributesPartialUpdateResponse200 = {
  data: Attribute
  status: 200
}

export type adminAttributesPartialUpdateResponseSuccess = (adminAttributesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminAttributesPartialUpdateResponse = (adminAttributesPartialUpdateResponseSuccess)

export const getAdminAttributesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/attributes/${uid}`
}

/**
 * Model permissions by HTTP method (`<app>.<action>_<codename>`).
 */
export const adminAttributesPartialUpdate = async (uid: string,
    patchedAttributeWriteRequest?: PatchedAttributeWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributesPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminAttributesPartialUpdateResponse>(getAdminAttributesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedAttributeWriteRequest)
  }
);}





export const getAdminAttributesPartialUpdateMutationKey = () => ['adminAttributesPartialUpdate'] as const;

export const getAdminAttributesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributesPartialUpdate>>, TError,AdminAttributesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAttributesPartialUpdate>>, TError,AdminAttributesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminAttributesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttributesPartialUpdate>>, AdminAttributesPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminAttributesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAttributesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttributesPartialUpdate>>>
    export type AdminAttributesPartialUpdateMutationBody = PatchedAttributeWriteRequest | undefined
    export type AdminAttributesPartialUpdateMutationError = unknown
    export type AdminAttributesPartialUpdateMutationVariables = {uid: string;data?: PatchedAttributeWriteRequest}

    export const useAdminAttributesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributesPartialUpdate>>, TError,AdminAttributesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAttributesPartialUpdate>>,
        TError,
        AdminAttributesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAttributesPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminAttributesDestroyResponse204 = {
  data: void
  status: 204
}

export type adminAttributesDestroyResponseSuccess = (adminAttributesDestroyResponse204) & {
  headers: Headers;
};
;

export type adminAttributesDestroyResponse = (adminAttributesDestroyResponseSuccess)

export const getAdminAttributesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/attributes/${uid}`
}

/**
 * Model permissions by HTTP method (`<app>.<action>_<codename>`).
 */
export const adminAttributesDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributesDestroyResponse> => {

  return apiFetch<adminAttributesDestroyResponse>(getAdminAttributesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminAttributesDestroyMutationKey = () => ['adminAttributesDestroy'] as const;

export const getAdminAttributesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributesDestroy>>, TError,AdminAttributesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAttributesDestroy>>, TError,AdminAttributesDestroyMutationVariables, TContext> => {

const mutationKey = getAdminAttributesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttributesDestroy>>, AdminAttributesDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminAttributesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAttributesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttributesDestroy>>>

    export type AdminAttributesDestroyMutationError = unknown
    export type AdminAttributesDestroyMutationVariables = {uid: string}

    export const useAdminAttributesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributesDestroy>>, TError,AdminAttributesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAttributesDestroy>>,
        TError,
        AdminAttributesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAttributesDestroyMutationOptions(options), queryClient);
    }
    export type adminAttributesOptionsUpdateResponse200 = {
  data: Attribute
  status: 200
}

export type adminAttributesOptionsUpdateResponseSuccess = (adminAttributesOptionsUpdateResponse200) & {
  headers: Headers;
};
;

export type adminAttributesOptionsUpdateResponse = (adminAttributesOptionsUpdateResponseSuccess)

export const getAdminAttributesOptionsUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/attributes/${uid}/options`
}

/**
 * Replace the whole option list (existing options keep their uid).
 */
export const adminAttributesOptionsUpdate = async (uid: string,
    optionListRequest: OptionListRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminAttributesOptionsUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminAttributesOptionsUpdateResponse>(getAdminAttributesOptionsUpdateUrl(uid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(optionListRequest)
  }
);}





export const getAdminAttributesOptionsUpdateMutationKey = () => ['adminAttributesOptionsUpdate'] as const;

export const getAdminAttributesOptionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributesOptionsUpdate>>, TError,AdminAttributesOptionsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAttributesOptionsUpdate>>, TError,AdminAttributesOptionsUpdateMutationVariables, TContext> => {

const mutationKey = getAdminAttributesOptionsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAttributesOptionsUpdate>>, AdminAttributesOptionsUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminAttributesOptionsUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAttributesOptionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAttributesOptionsUpdate>>>
    export type AdminAttributesOptionsUpdateMutationBody = OptionListRequest
    export type AdminAttributesOptionsUpdateMutationError = unknown
    export type AdminAttributesOptionsUpdateMutationVariables = {uid: string;data: OptionListRequest}

    export const useAdminAttributesOptionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAttributesOptionsUpdate>>, TError,AdminAttributesOptionsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAttributesOptionsUpdate>>,
        TError,
        AdminAttributesOptionsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAttributesOptionsUpdateMutationOptions(options), queryClient);
    }
    export type adminBrandsListResponse200 = {
  data: PaginatedBrandList
  status: 200
}

export type adminBrandsListResponseSuccess = (adminBrandsListResponse200) & {
  headers: Headers;
};
;

export type adminBrandsListResponse = (adminBrandsListResponseSuccess)

export const getAdminBrandsListUrl = (params?: AdminBrandsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/brands?${stringifiedParams}` : `/api/v1/admin/brands`
}

/**
 * `?search=` (name or slug) `?active=true|false` `?featured=true|false`
 */
export const adminBrandsList = async (params?: AdminBrandsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminBrandsListResponse> => {

  return apiFetch<adminBrandsListResponse>(getAdminBrandsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminBrandsListQueryKey = (params?: AdminBrandsListParams,) => {
    return [
    `/api/v1/admin/brands`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminBrandsListQueryOptions = <TData = Awaited<ReturnType<typeof adminBrandsList>>, TError = unknown>(params?: AdminBrandsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrandsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminBrandsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminBrandsList>>> = ({ signal }) => adminBrandsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminBrandsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminBrandsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminBrandsList>>>
export type AdminBrandsListQueryError = unknown


export function useAdminBrandsList<TData = Awaited<ReturnType<typeof adminBrandsList>>, TError = unknown>(
 params: undefined |  AdminBrandsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrandsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBrandsList>>,
          TError,
          Awaited<ReturnType<typeof adminBrandsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBrandsList<TData = Awaited<ReturnType<typeof adminBrandsList>>, TError = unknown>(
 params?: AdminBrandsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrandsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBrandsList>>,
          TError,
          Awaited<ReturnType<typeof adminBrandsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBrandsList<TData = Awaited<ReturnType<typeof adminBrandsList>>, TError = unknown>(
 params?: AdminBrandsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrandsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminBrandsList<TData = Awaited<ReturnType<typeof adminBrandsList>>, TError = unknown>(
 params?: AdminBrandsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrandsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminBrandsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminBrandsCreateResponse201 = {
  data: Brand
  status: 201
}

export type adminBrandsCreateResponseSuccess = (adminBrandsCreateResponse201) & {
  headers: Headers;
};
;

export type adminBrandsCreateResponse = (adminBrandsCreateResponseSuccess)

export const getAdminBrandsCreateUrl = () => {




  return `/api/v1/admin/brands`
}

/**
 * `?search=` (name or slug) `?active=true|false` `?featured=true|false`
 */
export const adminBrandsCreate = async (brandWriteRequest: BrandWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminBrandsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminBrandsCreateResponse>(getAdminBrandsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(brandWriteRequest)
  }
);}





export const getAdminBrandsCreateMutationKey = () => ['adminBrandsCreate'] as const;

export const getAdminBrandsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBrandsCreate>>, TError,AdminBrandsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminBrandsCreate>>, TError,AdminBrandsCreateMutationVariables, TContext> => {

const mutationKey = getAdminBrandsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminBrandsCreate>>, AdminBrandsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminBrandsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminBrandsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminBrandsCreate>>>
    export type AdminBrandsCreateMutationBody = BrandWriteRequest
    export type AdminBrandsCreateMutationError = unknown
    export type AdminBrandsCreateMutationVariables = {data: BrandWriteRequest}

    export const useAdminBrandsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBrandsCreate>>, TError,AdminBrandsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminBrandsCreate>>,
        TError,
        AdminBrandsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminBrandsCreateMutationOptions(options), queryClient);
    }
    export type adminBrandsRetrieveResponse200 = {
  data: Brand
  status: 200
}

export type adminBrandsRetrieveResponseSuccess = (adminBrandsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminBrandsRetrieveResponse = (adminBrandsRetrieveResponseSuccess)

export const getAdminBrandsRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/brands/${uid}`
}

export const adminBrandsRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminBrandsRetrieveResponse> => {

  return apiFetch<adminBrandsRetrieveResponse>(getAdminBrandsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminBrandsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/brands/${uid}`
    ] as const;
    }


export const getAdminBrandsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminBrandsRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrandsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminBrandsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminBrandsRetrieve>>> = ({ signal }) => adminBrandsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminBrandsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminBrandsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminBrandsRetrieve>>>
export type AdminBrandsRetrieveQueryError = unknown


export function useAdminBrandsRetrieve<TData = Awaited<ReturnType<typeof adminBrandsRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrandsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBrandsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminBrandsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBrandsRetrieve<TData = Awaited<ReturnType<typeof adminBrandsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrandsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBrandsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminBrandsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBrandsRetrieve<TData = Awaited<ReturnType<typeof adminBrandsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrandsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminBrandsRetrieve<TData = Awaited<ReturnType<typeof adminBrandsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrandsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminBrandsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminBrandsPartialUpdateResponse200 = {
  data: Brand
  status: 200
}

export type adminBrandsPartialUpdateResponseSuccess = (adminBrandsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminBrandsPartialUpdateResponse = (adminBrandsPartialUpdateResponseSuccess)

export const getAdminBrandsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/brands/${uid}`
}

export const adminBrandsPartialUpdate = async (uid: string,
    patchedBrandWriteRequest?: PatchedBrandWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminBrandsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminBrandsPartialUpdateResponse>(getAdminBrandsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedBrandWriteRequest)
  }
);}





export const getAdminBrandsPartialUpdateMutationKey = () => ['adminBrandsPartialUpdate'] as const;

export const getAdminBrandsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBrandsPartialUpdate>>, TError,AdminBrandsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminBrandsPartialUpdate>>, TError,AdminBrandsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminBrandsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminBrandsPartialUpdate>>, AdminBrandsPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminBrandsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminBrandsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminBrandsPartialUpdate>>>
    export type AdminBrandsPartialUpdateMutationBody = PatchedBrandWriteRequest | undefined
    export type AdminBrandsPartialUpdateMutationError = unknown
    export type AdminBrandsPartialUpdateMutationVariables = {uid: string;data?: PatchedBrandWriteRequest}

    export const useAdminBrandsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBrandsPartialUpdate>>, TError,AdminBrandsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminBrandsPartialUpdate>>,
        TError,
        AdminBrandsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminBrandsPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminBrandsDestroyResponse204 = {
  data: void
  status: 204
}

export type adminBrandsDestroyResponseSuccess = (adminBrandsDestroyResponse204) & {
  headers: Headers;
};
;

export type adminBrandsDestroyResponse = (adminBrandsDestroyResponseSuccess)

export const getAdminBrandsDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/brands/${uid}`
}

export const adminBrandsDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminBrandsDestroyResponse> => {

  return apiFetch<adminBrandsDestroyResponse>(getAdminBrandsDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminBrandsDestroyMutationKey = () => ['adminBrandsDestroy'] as const;

export const getAdminBrandsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBrandsDestroy>>, TError,AdminBrandsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminBrandsDestroy>>, TError,AdminBrandsDestroyMutationVariables, TContext> => {

const mutationKey = getAdminBrandsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminBrandsDestroy>>, AdminBrandsDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminBrandsDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminBrandsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminBrandsDestroy>>>

    export type AdminBrandsDestroyMutationError = unknown
    export type AdminBrandsDestroyMutationVariables = {uid: string}

    export const useAdminBrandsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBrandsDestroy>>, TError,AdminBrandsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminBrandsDestroy>>,
        TError,
        AdminBrandsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminBrandsDestroyMutationOptions(options), queryClient);
    }
    export type adminBulkUploadBatchesListResponse200 = {
  data: BulkBatchPage
  status: 200
}

export type adminBulkUploadBatchesListResponseSuccess = (adminBulkUploadBatchesListResponse200) & {
  headers: Headers;
};
;

export type adminBulkUploadBatchesListResponse = (adminBulkUploadBatchesListResponseSuccess)

export const getAdminBulkUploadBatchesListUrl = (params?: AdminBulkUploadBatchesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/bulk-upload/batches?${stringifiedParams}` : `/api/v1/admin/bulk-upload/batches`
}

export const adminBulkUploadBatchesList = async (params?: AdminBulkUploadBatchesListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminBulkUploadBatchesListResponse> => {

  return apiFetch<adminBulkUploadBatchesListResponse>(getAdminBulkUploadBatchesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminBulkUploadBatchesListQueryKey = (params?: AdminBulkUploadBatchesListParams,) => {
    return [
    `/api/v1/admin/bulk-upload/batches`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminBulkUploadBatchesListQueryOptions = <TData = Awaited<ReturnType<typeof adminBulkUploadBatchesList>>, TError = unknown>(params?: AdminBulkUploadBatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminBulkUploadBatchesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminBulkUploadBatchesList>>> = ({ signal }) => adminBulkUploadBatchesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminBulkUploadBatchesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminBulkUploadBatchesList>>>
export type AdminBulkUploadBatchesListQueryError = unknown


export function useAdminBulkUploadBatchesList<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesList>>, TError = unknown>(
 params: undefined |  AdminBulkUploadBatchesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadBatchesList>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadBatchesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadBatchesList<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesList>>, TError = unknown>(
 params?: AdminBulkUploadBatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadBatchesList>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadBatchesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadBatchesList<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesList>>, TError = unknown>(
 params?: AdminBulkUploadBatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminBulkUploadBatchesList<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesList>>, TError = unknown>(
 params?: AdminBulkUploadBatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminBulkUploadBatchesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminBulkUploadBatchesCreateResponse201 = {
  data: BulkBatchDetail
  status: 201
}

export type adminBulkUploadBatchesCreateResponseSuccess = (adminBulkUploadBatchesCreateResponse201) & {
  headers: Headers;
};
;

export type adminBulkUploadBatchesCreateResponse = (adminBulkUploadBatchesCreateResponseSuccess)

export const getAdminBulkUploadBatchesCreateUrl = () => {




  return `/api/v1/admin/bulk-upload/batches`
}

export const adminBulkUploadBatchesCreate = async (bulkUploadRequest: BulkUploadRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminBulkUploadBatchesCreateResponse> => {
    const formData = new FormData();
formData.append(`file`, bulkUploadRequest.file);
if(bulkUploadRequest.auto_import !== undefined) {
 formData.append(`auto_import`, bulkUploadRequest.auto_import.toString())
 }
if(bulkUploadRequest.submit_for_approval !== undefined) {
 formData.append(`submit_for_approval`, bulkUploadRequest.submit_for_approval.toString())
 }
if(bulkUploadRequest.vendor !== undefined && bulkUploadRequest.vendor !== null) {
 formData.append(`vendor`, bulkUploadRequest.vendor);
 }

  return apiFetch<adminBulkUploadBatchesCreateResponse>(getAdminBulkUploadBatchesCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getAdminBulkUploadBatchesCreateMutationKey = () => ['adminBulkUploadBatchesCreate'] as const;

export const getAdminBulkUploadBatchesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesCreate>>, TError,AdminBulkUploadBatchesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesCreate>>, TError,AdminBulkUploadBatchesCreateMutationVariables, TContext> => {

const mutationKey = getAdminBulkUploadBatchesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminBulkUploadBatchesCreate>>, AdminBulkUploadBatchesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminBulkUploadBatchesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminBulkUploadBatchesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminBulkUploadBatchesCreate>>>
    export type AdminBulkUploadBatchesCreateMutationBody = BulkUploadRequest
    export type AdminBulkUploadBatchesCreateMutationError = unknown
    export type AdminBulkUploadBatchesCreateMutationVariables = {data: BulkUploadRequest}

    export const useAdminBulkUploadBatchesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesCreate>>, TError,AdminBulkUploadBatchesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminBulkUploadBatchesCreate>>,
        TError,
        AdminBulkUploadBatchesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminBulkUploadBatchesCreateMutationOptions(options), queryClient);
    }
    export type adminBulkUploadBatchesRetrieveResponse200 = {
  data: BulkBatchDetail
  status: 200
}

export type adminBulkUploadBatchesRetrieveResponseSuccess = (adminBulkUploadBatchesRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminBulkUploadBatchesRetrieveResponse = (adminBulkUploadBatchesRetrieveResponseSuccess)

export const getAdminBulkUploadBatchesRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/bulk-upload/batches/${uid}`
}

export const adminBulkUploadBatchesRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminBulkUploadBatchesRetrieveResponse> => {

  return apiFetch<adminBulkUploadBatchesRetrieveResponse>(getAdminBulkUploadBatchesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminBulkUploadBatchesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/bulk-upload/batches/${uid}`
    ] as const;
    }


export const getAdminBulkUploadBatchesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminBulkUploadBatchesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>> = ({ signal }) => adminBulkUploadBatchesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminBulkUploadBatchesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>>
export type AdminBulkUploadBatchesRetrieveQueryError = unknown


export function useAdminBulkUploadBatchesRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadBatchesRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadBatchesRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminBulkUploadBatchesRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminBulkUploadBatchesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminBulkUploadBatchesDestroyResponse204 = {
  data: void
  status: 204
}

export type adminBulkUploadBatchesDestroyResponseSuccess = (adminBulkUploadBatchesDestroyResponse204) & {
  headers: Headers;
};
;

export type adminBulkUploadBatchesDestroyResponse = (adminBulkUploadBatchesDestroyResponseSuccess)

export const getAdminBulkUploadBatchesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/bulk-upload/batches/${uid}`
}

export const adminBulkUploadBatchesDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminBulkUploadBatchesDestroyResponse> => {

  return apiFetch<adminBulkUploadBatchesDestroyResponse>(getAdminBulkUploadBatchesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminBulkUploadBatchesDestroyMutationKey = () => ['adminBulkUploadBatchesDestroy'] as const;

export const getAdminBulkUploadBatchesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesDestroy>>, TError,AdminBulkUploadBatchesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesDestroy>>, TError,AdminBulkUploadBatchesDestroyMutationVariables, TContext> => {

const mutationKey = getAdminBulkUploadBatchesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminBulkUploadBatchesDestroy>>, AdminBulkUploadBatchesDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminBulkUploadBatchesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminBulkUploadBatchesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminBulkUploadBatchesDestroy>>>

    export type AdminBulkUploadBatchesDestroyMutationError = unknown
    export type AdminBulkUploadBatchesDestroyMutationVariables = {uid: string}

    export const useAdminBulkUploadBatchesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesDestroy>>, TError,AdminBulkUploadBatchesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminBulkUploadBatchesDestroy>>,
        TError,
        AdminBulkUploadBatchesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminBulkUploadBatchesDestroyMutationOptions(options), queryClient);
    }
    export type adminBulkUploadBatchesApproveCreateResponse200 = {
  data: BulkApproveResult
  status: 200
}

export type adminBulkUploadBatchesApproveCreateResponseSuccess = (adminBulkUploadBatchesApproveCreateResponse200) & {
  headers: Headers;
};
;

export type adminBulkUploadBatchesApproveCreateResponse = (adminBulkUploadBatchesApproveCreateResponseSuccess)

export const getAdminBulkUploadBatchesApproveCreateUrl = (uid: string,) => {




  return `/api/v1/admin/bulk-upload/batches/${uid}/approve`
}

export const adminBulkUploadBatchesApproveCreate = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminBulkUploadBatchesApproveCreateResponse> => {

  return apiFetch<adminBulkUploadBatchesApproveCreateResponse>(getAdminBulkUploadBatchesApproveCreateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminBulkUploadBatchesApproveCreateMutationKey = () => ['adminBulkUploadBatchesApproveCreate'] as const;

export const getAdminBulkUploadBatchesApproveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesApproveCreate>>, TError,AdminBulkUploadBatchesApproveCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesApproveCreate>>, TError,AdminBulkUploadBatchesApproveCreateMutationVariables, TContext> => {

const mutationKey = getAdminBulkUploadBatchesApproveCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminBulkUploadBatchesApproveCreate>>, AdminBulkUploadBatchesApproveCreateMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminBulkUploadBatchesApproveCreate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminBulkUploadBatchesApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminBulkUploadBatchesApproveCreate>>>

    export type AdminBulkUploadBatchesApproveCreateMutationError = unknown
    export type AdminBulkUploadBatchesApproveCreateMutationVariables = {uid: string}

    export const useAdminBulkUploadBatchesApproveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesApproveCreate>>, TError,AdminBulkUploadBatchesApproveCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminBulkUploadBatchesApproveCreate>>,
        TError,
        AdminBulkUploadBatchesApproveCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminBulkUploadBatchesApproveCreateMutationOptions(options), queryClient);
    }
    export type adminBulkUploadBatchesErrorsRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type adminBulkUploadBatchesErrorsRetrieveResponseSuccess = (adminBulkUploadBatchesErrorsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminBulkUploadBatchesErrorsRetrieveResponse = (adminBulkUploadBatchesErrorsRetrieveResponseSuccess)

export const getAdminBulkUploadBatchesErrorsRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/bulk-upload/batches/${uid}/errors`
}

export const adminBulkUploadBatchesErrorsRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminBulkUploadBatchesErrorsRetrieveResponse> => {

  return apiFetch<adminBulkUploadBatchesErrorsRetrieveResponse>(getAdminBulkUploadBatchesErrorsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminBulkUploadBatchesErrorsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/bulk-upload/batches/${uid}/errors`
    ] as const;
    }


export const getAdminBulkUploadBatchesErrorsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminBulkUploadBatchesErrorsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>> = ({ signal }) => adminBulkUploadBatchesErrorsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminBulkUploadBatchesErrorsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>>
export type AdminBulkUploadBatchesErrorsRetrieveQueryError = unknown


export function useAdminBulkUploadBatchesErrorsRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadBatchesErrorsRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadBatchesErrorsRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminBulkUploadBatchesErrorsRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesErrorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminBulkUploadBatchesErrorsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminBulkUploadBatchesImportCreateResponse200 = {
  data: BulkBatchDetail
  status: 200
}

export type adminBulkUploadBatchesImportCreateResponseSuccess = (adminBulkUploadBatchesImportCreateResponse200) & {
  headers: Headers;
};
;

export type adminBulkUploadBatchesImportCreateResponse = (adminBulkUploadBatchesImportCreateResponseSuccess)

export const getAdminBulkUploadBatchesImportCreateUrl = (uid: string,) => {




  return `/api/v1/admin/bulk-upload/batches/${uid}/import`
}

export const adminBulkUploadBatchesImportCreate = async (uid: string,
    bulkImportRequestRequest?: BulkImportRequestRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminBulkUploadBatchesImportCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminBulkUploadBatchesImportCreateResponse>(getAdminBulkUploadBatchesImportCreateUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkImportRequestRequest)
  }
);}





export const getAdminBulkUploadBatchesImportCreateMutationKey = () => ['adminBulkUploadBatchesImportCreate'] as const;

export const getAdminBulkUploadBatchesImportCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesImportCreate>>, TError,AdminBulkUploadBatchesImportCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesImportCreate>>, TError,AdminBulkUploadBatchesImportCreateMutationVariables, TContext> => {

const mutationKey = getAdminBulkUploadBatchesImportCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminBulkUploadBatchesImportCreate>>, AdminBulkUploadBatchesImportCreateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminBulkUploadBatchesImportCreate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminBulkUploadBatchesImportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminBulkUploadBatchesImportCreate>>>
    export type AdminBulkUploadBatchesImportCreateMutationBody = BulkImportRequestRequest | undefined
    export type AdminBulkUploadBatchesImportCreateMutationError = unknown
    export type AdminBulkUploadBatchesImportCreateMutationVariables = {uid: string;data?: BulkImportRequestRequest}

    export const useAdminBulkUploadBatchesImportCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesImportCreate>>, TError,AdminBulkUploadBatchesImportCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminBulkUploadBatchesImportCreate>>,
        TError,
        AdminBulkUploadBatchesImportCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminBulkUploadBatchesImportCreateMutationOptions(options), queryClient);
    }
    export type adminBulkUploadBatchesRowsListResponse200 = {
  data: BulkRowPage
  status: 200
}

export type adminBulkUploadBatchesRowsListResponseSuccess = (adminBulkUploadBatchesRowsListResponse200) & {
  headers: Headers;
};
;

export type adminBulkUploadBatchesRowsListResponse = (adminBulkUploadBatchesRowsListResponseSuccess)

export const getAdminBulkUploadBatchesRowsListUrl = (uid: string,
    params?: AdminBulkUploadBatchesRowsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/bulk-upload/batches/${uid}/rows?${stringifiedParams}` : `/api/v1/admin/bulk-upload/batches/${uid}/rows`
}

export const adminBulkUploadBatchesRowsList = async (uid: string,
    params?: AdminBulkUploadBatchesRowsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminBulkUploadBatchesRowsListResponse> => {

  return apiFetch<adminBulkUploadBatchesRowsListResponse>(getAdminBulkUploadBatchesRowsListUrl(uid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminBulkUploadBatchesRowsListQueryKey = (uid: string,
    params?: AdminBulkUploadBatchesRowsListParams,) => {
    return [
    `/api/v1/admin/bulk-upload/batches/${uid}/rows`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminBulkUploadBatchesRowsListQueryOptions = <TData = Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>, TError = unknown>(uid: string,
    params?: AdminBulkUploadBatchesRowsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminBulkUploadBatchesRowsListQueryKey(uid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>> = ({ signal }) => adminBulkUploadBatchesRowsList(uid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminBulkUploadBatchesRowsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>>
export type AdminBulkUploadBatchesRowsListQueryError = unknown


export function useAdminBulkUploadBatchesRowsList<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>, TError = unknown>(
 uid: string,
    params: undefined |  AdminBulkUploadBatchesRowsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadBatchesRowsList<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>, TError = unknown>(
 uid: string,
    params?: AdminBulkUploadBatchesRowsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadBatchesRowsList<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>, TError = unknown>(
 uid: string,
    params?: AdminBulkUploadBatchesRowsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminBulkUploadBatchesRowsList<TData = Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>, TError = unknown>(
 uid: string,
    params?: AdminBulkUploadBatchesRowsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadBatchesRowsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminBulkUploadBatchesRowsListQueryOptions(uid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminBulkUploadCategoriesListResponse200 = {
  data: BulkCategoryChoice[]
  status: 200
}

export type adminBulkUploadCategoriesListResponseSuccess = (adminBulkUploadCategoriesListResponse200) & {
  headers: Headers;
};
;

export type adminBulkUploadCategoriesListResponse = (adminBulkUploadCategoriesListResponseSuccess)

export const getAdminBulkUploadCategoriesListUrl = () => {




  return `/api/v1/admin/bulk-upload/categories`
}

export const adminBulkUploadCategoriesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminBulkUploadCategoriesListResponse> => {

  return apiFetch<adminBulkUploadCategoriesListResponse>(getAdminBulkUploadCategoriesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminBulkUploadCategoriesListQueryKey = () => {
    return [
    `/api/v1/admin/bulk-upload/categories`
    ] as const;
    }


export const getAdminBulkUploadCategoriesListQueryOptions = <TData = Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminBulkUploadCategoriesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>> = ({ signal }) => adminBulkUploadCategoriesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminBulkUploadCategoriesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>>
export type AdminBulkUploadCategoriesListQueryError = unknown


export function useAdminBulkUploadCategoriesList<TData = Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadCategoriesList<TData = Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadCategoriesList<TData = Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminBulkUploadCategoriesList<TData = Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminBulkUploadCategoriesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminBulkUploadTemplateRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type adminBulkUploadTemplateRetrieveResponseSuccess = (adminBulkUploadTemplateRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminBulkUploadTemplateRetrieveResponse = (adminBulkUploadTemplateRetrieveResponseSuccess)

export const getAdminBulkUploadTemplateRetrieveUrl = (params?: AdminBulkUploadTemplateRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["categories"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/bulk-upload/template?${stringifiedParams}` : `/api/v1/admin/bulk-upload/template`
}

export const adminBulkUploadTemplateRetrieve = async (params?: AdminBulkUploadTemplateRetrieveParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminBulkUploadTemplateRetrieveResponse> => {

  return apiFetch<adminBulkUploadTemplateRetrieveResponse>(getAdminBulkUploadTemplateRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminBulkUploadTemplateRetrieveQueryKey = (params?: AdminBulkUploadTemplateRetrieveParams,) => {
    return [
    `/api/v1/admin/bulk-upload/template`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminBulkUploadTemplateRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>, TError = unknown>(params?: AdminBulkUploadTemplateRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminBulkUploadTemplateRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>> = ({ signal }) => adminBulkUploadTemplateRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminBulkUploadTemplateRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>>
export type AdminBulkUploadTemplateRetrieveQueryError = unknown


export function useAdminBulkUploadTemplateRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>, TError = unknown>(
 params: undefined |  AdminBulkUploadTemplateRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadTemplateRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>, TError = unknown>(
 params?: AdminBulkUploadTemplateRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadTemplateRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>, TError = unknown>(
 params?: AdminBulkUploadTemplateRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminBulkUploadTemplateRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>, TError = unknown>(
 params?: AdminBulkUploadTemplateRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminBulkUploadTemplateRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminBulkUploadTemplateMacroRetrieveResponse200 = {
  data: string
  status: 200
}

export type adminBulkUploadTemplateMacroRetrieveResponseSuccess = (adminBulkUploadTemplateMacroRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminBulkUploadTemplateMacroRetrieveResponse = (adminBulkUploadTemplateMacroRetrieveResponseSuccess)

export const getAdminBulkUploadTemplateMacroRetrieveUrl = (params?: AdminBulkUploadTemplateMacroRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["categories"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/bulk-upload/template/macro?${stringifiedParams}` : `/api/v1/admin/bulk-upload/template/macro`
}

export const adminBulkUploadTemplateMacroRetrieve = async (params?: AdminBulkUploadTemplateMacroRetrieveParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminBulkUploadTemplateMacroRetrieveResponse> => {

  return apiFetch<adminBulkUploadTemplateMacroRetrieveResponse>(getAdminBulkUploadTemplateMacroRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminBulkUploadTemplateMacroRetrieveQueryKey = (params?: AdminBulkUploadTemplateMacroRetrieveParams,) => {
    return [
    `/api/v1/admin/bulk-upload/template/macro`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminBulkUploadTemplateMacroRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>, TError = unknown>(params?: AdminBulkUploadTemplateMacroRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminBulkUploadTemplateMacroRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>> = ({ signal }) => adminBulkUploadTemplateMacroRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminBulkUploadTemplateMacroRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>>
export type AdminBulkUploadTemplateMacroRetrieveQueryError = unknown


export function useAdminBulkUploadTemplateMacroRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>, TError = unknown>(
 params: undefined |  AdminBulkUploadTemplateMacroRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadTemplateMacroRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>, TError = unknown>(
 params?: AdminBulkUploadTemplateMacroRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadTemplateMacroRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>, TError = unknown>(
 params?: AdminBulkUploadTemplateMacroRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminBulkUploadTemplateMacroRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>, TError = unknown>(
 params?: AdminBulkUploadTemplateMacroRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadTemplateMacroRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminBulkUploadTemplateMacroRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminBulkUploadUpdateSheetRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type adminBulkUploadUpdateSheetRetrieveResponseSuccess = (adminBulkUploadUpdateSheetRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminBulkUploadUpdateSheetRetrieveResponse = (adminBulkUploadUpdateSheetRetrieveResponseSuccess)

export const getAdminBulkUploadUpdateSheetRetrieveUrl = (params?: AdminBulkUploadUpdateSheetRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/bulk-upload/update-sheet?${stringifiedParams}` : `/api/v1/admin/bulk-upload/update-sheet`
}

export const adminBulkUploadUpdateSheetRetrieve = async (params?: AdminBulkUploadUpdateSheetRetrieveParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminBulkUploadUpdateSheetRetrieveResponse> => {

  return apiFetch<adminBulkUploadUpdateSheetRetrieveResponse>(getAdminBulkUploadUpdateSheetRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminBulkUploadUpdateSheetRetrieveQueryKey = (params?: AdminBulkUploadUpdateSheetRetrieveParams,) => {
    return [
    `/api/v1/admin/bulk-upload/update-sheet`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminBulkUploadUpdateSheetRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>, TError = unknown>(params?: AdminBulkUploadUpdateSheetRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminBulkUploadUpdateSheetRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>> = ({ signal }) => adminBulkUploadUpdateSheetRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminBulkUploadUpdateSheetRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>>
export type AdminBulkUploadUpdateSheetRetrieveQueryError = unknown


export function useAdminBulkUploadUpdateSheetRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>, TError = unknown>(
 params: undefined |  AdminBulkUploadUpdateSheetRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadUpdateSheetRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>, TError = unknown>(
 params?: AdminBulkUploadUpdateSheetRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBulkUploadUpdateSheetRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>, TError = unknown>(
 params?: AdminBulkUploadUpdateSheetRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminBulkUploadUpdateSheetRetrieve<TData = Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>, TError = unknown>(
 params?: AdminBulkUploadUpdateSheetRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBulkUploadUpdateSheetRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminBulkUploadUpdateSheetRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCategoriesCreateResponse201 = {
  data: Category
  status: 201
}

export type adminCategoriesCreateResponseSuccess = (adminCategoriesCreateResponse201) & {
  headers: Headers;
};
;

export type adminCategoriesCreateResponse = (adminCategoriesCreateResponseSuccess)

export const getAdminCategoriesCreateUrl = () => {




  return `/api/v1/admin/categories`
}

export const adminCategoriesCreate = async (categoryWriteRequest: CategoryWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCategoriesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCategoriesCreateResponse>(getAdminCategoriesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(categoryWriteRequest)
  }
);}





export const getAdminCategoriesCreateMutationKey = () => ['adminCategoriesCreate'] as const;

export const getAdminCategoriesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesCreate>>, TError,AdminCategoriesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesCreate>>, TError,AdminCategoriesCreateMutationVariables, TContext> => {

const mutationKey = getAdminCategoriesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCategoriesCreate>>, AdminCategoriesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminCategoriesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCategoriesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCategoriesCreate>>>
    export type AdminCategoriesCreateMutationBody = CategoryWriteRequest
    export type AdminCategoriesCreateMutationError = unknown
    export type AdminCategoriesCreateMutationVariables = {data: CategoryWriteRequest}

    export const useAdminCategoriesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesCreate>>, TError,AdminCategoriesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCategoriesCreate>>,
        TError,
        AdminCategoriesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCategoriesCreateMutationOptions(options), queryClient);
    }
    export type adminCategoriesRetrieveResponse200 = {
  data: Category
  status: 200
}

export type adminCategoriesRetrieveResponseSuccess = (adminCategoriesRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminCategoriesRetrieveResponse = (adminCategoriesRetrieveResponseSuccess)

export const getAdminCategoriesRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/categories/${uid}`
}

export const adminCategoriesRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCategoriesRetrieveResponse> => {

  return apiFetch<adminCategoriesRetrieveResponse>(getAdminCategoriesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCategoriesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/categories/${uid}`
    ] as const;
    }


export const getAdminCategoriesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCategoriesRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCategoriesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCategoriesRetrieve>>> = ({ signal }) => adminCategoriesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCategoriesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCategoriesRetrieve>>>
export type AdminCategoriesRetrieveQueryError = unknown


export function useAdminCategoriesRetrieve<TData = Awaited<ReturnType<typeof adminCategoriesRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCategoriesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCategoriesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCategoriesRetrieve<TData = Awaited<ReturnType<typeof adminCategoriesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCategoriesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCategoriesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCategoriesRetrieve<TData = Awaited<ReturnType<typeof adminCategoriesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCategoriesRetrieve<TData = Awaited<ReturnType<typeof adminCategoriesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCategoriesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCategoriesPartialUpdateResponse200 = {
  data: Category
  status: 200
}

export type adminCategoriesPartialUpdateResponseSuccess = (adminCategoriesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminCategoriesPartialUpdateResponse = (adminCategoriesPartialUpdateResponseSuccess)

export const getAdminCategoriesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/categories/${uid}`
}

export const adminCategoriesPartialUpdate = async (uid: string,
    patchedCategoryWriteRequest?: PatchedCategoryWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCategoriesPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCategoriesPartialUpdateResponse>(getAdminCategoriesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedCategoryWriteRequest)
  }
);}





export const getAdminCategoriesPartialUpdateMutationKey = () => ['adminCategoriesPartialUpdate'] as const;

export const getAdminCategoriesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesPartialUpdate>>, TError,AdminCategoriesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesPartialUpdate>>, TError,AdminCategoriesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCategoriesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCategoriesPartialUpdate>>, AdminCategoriesPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCategoriesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCategoriesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCategoriesPartialUpdate>>>
    export type AdminCategoriesPartialUpdateMutationBody = PatchedCategoryWriteRequest | undefined
    export type AdminCategoriesPartialUpdateMutationError = unknown
    export type AdminCategoriesPartialUpdateMutationVariables = {uid: string;data?: PatchedCategoryWriteRequest}

    export const useAdminCategoriesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesPartialUpdate>>, TError,AdminCategoriesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCategoriesPartialUpdate>>,
        TError,
        AdminCategoriesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCategoriesPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminCategoriesDestroyResponse204 = {
  data: void
  status: 204
}

export type adminCategoriesDestroyResponseSuccess = (adminCategoriesDestroyResponse204) & {
  headers: Headers;
};
;

export type adminCategoriesDestroyResponse = (adminCategoriesDestroyResponseSuccess)

export const getAdminCategoriesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/categories/${uid}`
}

export const adminCategoriesDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCategoriesDestroyResponse> => {

  return apiFetch<adminCategoriesDestroyResponse>(getAdminCategoriesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminCategoriesDestroyMutationKey = () => ['adminCategoriesDestroy'] as const;

export const getAdminCategoriesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesDestroy>>, TError,AdminCategoriesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesDestroy>>, TError,AdminCategoriesDestroyMutationVariables, TContext> => {

const mutationKey = getAdminCategoriesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCategoriesDestroy>>, AdminCategoriesDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminCategoriesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCategoriesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminCategoriesDestroy>>>

    export type AdminCategoriesDestroyMutationError = unknown
    export type AdminCategoriesDestroyMutationVariables = {uid: string}

    export const useAdminCategoriesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesDestroy>>, TError,AdminCategoriesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCategoriesDestroy>>,
        TError,
        AdminCategoriesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCategoriesDestroyMutationOptions(options), queryClient);
    }
    export type adminCategoriesFormSchemaRetrieveResponse200 = {
  data: FormSchema
  status: 200
}

export type adminCategoriesFormSchemaRetrieveResponseSuccess = (adminCategoriesFormSchemaRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminCategoriesFormSchemaRetrieveResponse = (adminCategoriesFormSchemaRetrieveResponseSuccess)

export const getAdminCategoriesFormSchemaRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/categories/${uid}/form-schema`
}

/**
 * The product form of a category: its attribute set (own or inherited) and the fields by group.
 */
export const adminCategoriesFormSchemaRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCategoriesFormSchemaRetrieveResponse> => {

  return apiFetch<adminCategoriesFormSchemaRetrieveResponse>(getAdminCategoriesFormSchemaRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCategoriesFormSchemaRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/categories/${uid}/form-schema`
    ] as const;
    }


export const getAdminCategoriesFormSchemaRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCategoriesFormSchemaRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>> = ({ signal }) => adminCategoriesFormSchemaRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCategoriesFormSchemaRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>>
export type AdminCategoriesFormSchemaRetrieveQueryError = unknown


export function useAdminCategoriesFormSchemaRetrieve<TData = Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCategoriesFormSchemaRetrieve<TData = Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCategoriesFormSchemaRetrieve<TData = Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCategoriesFormSchemaRetrieve<TData = Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesFormSchemaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCategoriesFormSchemaRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCategoriesFormSchemaValidateCreateResponse200 = {
  data: Validated
  status: 200
}

export type adminCategoriesFormSchemaValidateCreateResponseSuccess = (adminCategoriesFormSchemaValidateCreateResponse200) & {
  headers: Headers;
};
;

export type adminCategoriesFormSchemaValidateCreateResponse = (adminCategoriesFormSchemaValidateCreateResponseSuccess)

export const getAdminCategoriesFormSchemaValidateCreateUrl = (uid: string,) => {




  return `/api/v1/admin/categories/${uid}/form-schema/validate`
}

/**
 * Checks specification values against the category's form; answers the cleaned values or field errors
 * (`attributes.<code>`).
 */
export const adminCategoriesFormSchemaValidateCreate = async (uid: string,
    validateRequest: ValidateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCategoriesFormSchemaValidateCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCategoriesFormSchemaValidateCreateResponse>(getAdminCategoriesFormSchemaValidateCreateUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(validateRequest)
  }
);}





export const getAdminCategoriesFormSchemaValidateCreateMutationKey = () => ['adminCategoriesFormSchemaValidateCreate'] as const;

export const getAdminCategoriesFormSchemaValidateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesFormSchemaValidateCreate>>, TError,AdminCategoriesFormSchemaValidateCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesFormSchemaValidateCreate>>, TError,AdminCategoriesFormSchemaValidateCreateMutationVariables, TContext> => {

const mutationKey = getAdminCategoriesFormSchemaValidateCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCategoriesFormSchemaValidateCreate>>, AdminCategoriesFormSchemaValidateCreateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCategoriesFormSchemaValidateCreate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCategoriesFormSchemaValidateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCategoriesFormSchemaValidateCreate>>>
    export type AdminCategoriesFormSchemaValidateCreateMutationBody = ValidateRequest
    export type AdminCategoriesFormSchemaValidateCreateMutationError = unknown
    export type AdminCategoriesFormSchemaValidateCreateMutationVariables = {uid: string;data: ValidateRequest}

    export const useAdminCategoriesFormSchemaValidateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesFormSchemaValidateCreate>>, TError,AdminCategoriesFormSchemaValidateCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCategoriesFormSchemaValidateCreate>>,
        TError,
        AdminCategoriesFormSchemaValidateCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCategoriesFormSchemaValidateCreateMutationOptions(options), queryClient);
    }
    export type adminCategoriesMoveCreateResponse200 = {
  data: Category
  status: 200
}

export type adminCategoriesMoveCreateResponseSuccess = (adminCategoriesMoveCreateResponse200) & {
  headers: Headers;
};
;

export type adminCategoriesMoveCreateResponse = (adminCategoriesMoveCreateResponseSuccess)

export const getAdminCategoriesMoveCreateUrl = (uid: string,) => {




  return `/api/v1/admin/categories/${uid}/move`
}

/**
 * Drag and drop: new parent and position among its children.
 */
export const adminCategoriesMoveCreate = async (uid: string,
    moveRequest: MoveRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCategoriesMoveCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCategoriesMoveCreateResponse>(getAdminCategoriesMoveCreateUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(moveRequest)
  }
);}





export const getAdminCategoriesMoveCreateMutationKey = () => ['adminCategoriesMoveCreate'] as const;

export const getAdminCategoriesMoveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesMoveCreate>>, TError,AdminCategoriesMoveCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesMoveCreate>>, TError,AdminCategoriesMoveCreateMutationVariables, TContext> => {

const mutationKey = getAdminCategoriesMoveCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCategoriesMoveCreate>>, AdminCategoriesMoveCreateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCategoriesMoveCreate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCategoriesMoveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCategoriesMoveCreate>>>
    export type AdminCategoriesMoveCreateMutationBody = MoveRequest
    export type AdminCategoriesMoveCreateMutationError = unknown
    export type AdminCategoriesMoveCreateMutationVariables = {uid: string;data: MoveRequest}

    export const useAdminCategoriesMoveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCategoriesMoveCreate>>, TError,AdminCategoriesMoveCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCategoriesMoveCreate>>,
        TError,
        AdminCategoriesMoveCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCategoriesMoveCreateMutationOptions(options), queryClient);
    }
    export type adminCategoriesTreeResponse200 = {
  data: TreeNode[]
  status: 200
}

export type adminCategoriesTreeResponseSuccess = (adminCategoriesTreeResponse200) & {
  headers: Headers;
};
;

export type adminCategoriesTreeResponse = (adminCategoriesTreeResponseSuccess)

export const getAdminCategoriesTreeUrl = () => {




  return `/api/v1/admin/categories/tree`
}

/**
 * The whole tree (active and switched-off categories) for the admin's tree view.
 */
export const adminCategoriesTree = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminCategoriesTreeResponse> => {

  return apiFetch<adminCategoriesTreeResponse>(getAdminCategoriesTreeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCategoriesTreeQueryKey = () => {
    return [
    `/api/v1/admin/categories/tree`
    ] as const;
    }


export const getAdminCategoriesTreeQueryOptions = <TData = Awaited<ReturnType<typeof adminCategoriesTree>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesTree>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCategoriesTreeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCategoriesTree>>> = ({ signal }) => adminCategoriesTree({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCategoriesTreeQueryResult = NonNullable<Awaited<ReturnType<typeof adminCategoriesTree>>>
export type AdminCategoriesTreeQueryError = unknown


export function useAdminCategoriesTree<TData = Awaited<ReturnType<typeof adminCategoriesTree>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCategoriesTree>>,
          TError,
          Awaited<ReturnType<typeof adminCategoriesTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCategoriesTree<TData = Awaited<ReturnType<typeof adminCategoriesTree>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCategoriesTree>>,
          TError,
          Awaited<ReturnType<typeof adminCategoriesTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCategoriesTree<TData = Awaited<ReturnType<typeof adminCategoriesTree>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesTree>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCategoriesTree<TData = Awaited<ReturnType<typeof adminCategoriesTree>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCategoriesTree>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCategoriesTreeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCmsBannersListResponse200 = {
  data: Banner[]
  status: 200
}

export type adminCmsBannersListResponseSuccess = (adminCmsBannersListResponse200) & {
  headers: Headers;
};
;

export type adminCmsBannersListResponse = (adminCmsBannersListResponseSuccess)

export const getAdminCmsBannersListUrl = (params?: AdminCmsBannersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/cms/banners?${stringifiedParams}` : `/api/v1/admin/cms/banners`
}

export const adminCmsBannersList = async (params?: AdminCmsBannersListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBannersListResponse> => {

  return apiFetch<adminCmsBannersListResponse>(getAdminCmsBannersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCmsBannersListQueryKey = (params?: AdminCmsBannersListParams,) => {
    return [
    `/api/v1/admin/cms/banners`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminCmsBannersListQueryOptions = <TData = Awaited<ReturnType<typeof adminCmsBannersList>>, TError = unknown>(params?: AdminCmsBannersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBannersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCmsBannersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCmsBannersList>>> = ({ signal }) => adminCmsBannersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCmsBannersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCmsBannersListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCmsBannersList>>>
export type AdminCmsBannersListQueryError = unknown


export function useAdminCmsBannersList<TData = Awaited<ReturnType<typeof adminCmsBannersList>>, TError = unknown>(
 params: undefined |  AdminCmsBannersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBannersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsBannersList>>,
          TError,
          Awaited<ReturnType<typeof adminCmsBannersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsBannersList<TData = Awaited<ReturnType<typeof adminCmsBannersList>>, TError = unknown>(
 params?: AdminCmsBannersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBannersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsBannersList>>,
          TError,
          Awaited<ReturnType<typeof adminCmsBannersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsBannersList<TData = Awaited<ReturnType<typeof adminCmsBannersList>>, TError = unknown>(
 params?: AdminCmsBannersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBannersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCmsBannersList<TData = Awaited<ReturnType<typeof adminCmsBannersList>>, TError = unknown>(
 params?: AdminCmsBannersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBannersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCmsBannersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCmsBannersCreateResponse201 = {
  data: Banner
  status: 201
}

export type adminCmsBannersCreateResponseSuccess = (adminCmsBannersCreateResponse201) & {
  headers: Headers;
};
;

export type adminCmsBannersCreateResponse = (adminCmsBannersCreateResponseSuccess)

export const getAdminCmsBannersCreateUrl = () => {




  return `/api/v1/admin/cms/banners`
}

export const adminCmsBannersCreate = async (bannerWriteRequest: BannerWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBannersCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCmsBannersCreateResponse>(getAdminCmsBannersCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bannerWriteRequest)
  }
);}





export const getAdminCmsBannersCreateMutationKey = () => ['adminCmsBannersCreate'] as const;

export const getAdminCmsBannersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBannersCreate>>, TError,AdminCmsBannersCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsBannersCreate>>, TError,AdminCmsBannersCreateMutationVariables, TContext> => {

const mutationKey = getAdminCmsBannersCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsBannersCreate>>, AdminCmsBannersCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminCmsBannersCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsBannersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsBannersCreate>>>
    export type AdminCmsBannersCreateMutationBody = BannerWriteRequest
    export type AdminCmsBannersCreateMutationError = unknown
    export type AdminCmsBannersCreateMutationVariables = {data: BannerWriteRequest}

    export const useAdminCmsBannersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBannersCreate>>, TError,AdminCmsBannersCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsBannersCreate>>,
        TError,
        AdminCmsBannersCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsBannersCreateMutationOptions(options), queryClient);
    }
    export type adminCmsBannersRetrieveResponse200 = {
  data: Banner
  status: 200
}

export type adminCmsBannersRetrieveResponseSuccess = (adminCmsBannersRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminCmsBannersRetrieveResponse = (adminCmsBannersRetrieveResponseSuccess)

export const getAdminCmsBannersRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/cms/banners/${uid}`
}

export const adminCmsBannersRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBannersRetrieveResponse> => {

  return apiFetch<adminCmsBannersRetrieveResponse>(getAdminCmsBannersRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCmsBannersRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/cms/banners/${uid}`
    ] as const;
    }


export const getAdminCmsBannersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCmsBannersRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBannersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCmsBannersRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCmsBannersRetrieve>>> = ({ signal }) => adminCmsBannersRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCmsBannersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCmsBannersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCmsBannersRetrieve>>>
export type AdminCmsBannersRetrieveQueryError = unknown


export function useAdminCmsBannersRetrieve<TData = Awaited<ReturnType<typeof adminCmsBannersRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBannersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsBannersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCmsBannersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsBannersRetrieve<TData = Awaited<ReturnType<typeof adminCmsBannersRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBannersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsBannersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCmsBannersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsBannersRetrieve<TData = Awaited<ReturnType<typeof adminCmsBannersRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBannersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCmsBannersRetrieve<TData = Awaited<ReturnType<typeof adminCmsBannersRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBannersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCmsBannersRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCmsBannersPartialUpdateResponse200 = {
  data: Banner
  status: 200
}

export type adminCmsBannersPartialUpdateResponseSuccess = (adminCmsBannersPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminCmsBannersPartialUpdateResponse = (adminCmsBannersPartialUpdateResponseSuccess)

export const getAdminCmsBannersPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/cms/banners/${uid}`
}

export const adminCmsBannersPartialUpdate = async (uid: string,
    patchedBannerWriteRequest?: PatchedBannerWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBannersPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCmsBannersPartialUpdateResponse>(getAdminCmsBannersPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedBannerWriteRequest)
  }
);}





export const getAdminCmsBannersPartialUpdateMutationKey = () => ['adminCmsBannersPartialUpdate'] as const;

export const getAdminCmsBannersPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBannersPartialUpdate>>, TError,AdminCmsBannersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsBannersPartialUpdate>>, TError,AdminCmsBannersPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCmsBannersPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsBannersPartialUpdate>>, AdminCmsBannersPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCmsBannersPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsBannersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsBannersPartialUpdate>>>
    export type AdminCmsBannersPartialUpdateMutationBody = PatchedBannerWriteRequest | undefined
    export type AdminCmsBannersPartialUpdateMutationError = unknown
    export type AdminCmsBannersPartialUpdateMutationVariables = {uid: string;data?: PatchedBannerWriteRequest}

    export const useAdminCmsBannersPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBannersPartialUpdate>>, TError,AdminCmsBannersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsBannersPartialUpdate>>,
        TError,
        AdminCmsBannersPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsBannersPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminCmsBannersDestroyResponse204 = {
  data: void
  status: 204
}

export type adminCmsBannersDestroyResponseSuccess = (adminCmsBannersDestroyResponse204) & {
  headers: Headers;
};
;

export type adminCmsBannersDestroyResponse = (adminCmsBannersDestroyResponseSuccess)

export const getAdminCmsBannersDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/cms/banners/${uid}`
}

export const adminCmsBannersDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBannersDestroyResponse> => {

  return apiFetch<adminCmsBannersDestroyResponse>(getAdminCmsBannersDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminCmsBannersDestroyMutationKey = () => ['adminCmsBannersDestroy'] as const;

export const getAdminCmsBannersDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBannersDestroy>>, TError,AdminCmsBannersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsBannersDestroy>>, TError,AdminCmsBannersDestroyMutationVariables, TContext> => {

const mutationKey = getAdminCmsBannersDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsBannersDestroy>>, AdminCmsBannersDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminCmsBannersDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsBannersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsBannersDestroy>>>

    export type AdminCmsBannersDestroyMutationError = unknown
    export type AdminCmsBannersDestroyMutationVariables = {uid: string}

    export const useAdminCmsBannersDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBannersDestroy>>, TError,AdminCmsBannersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsBannersDestroy>>,
        TError,
        AdminCmsBannersDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsBannersDestroyMutationOptions(options), queryClient);
    }
    export type adminCmsBlogCategoriesListResponse200 = {
  data: BlogCategory[]
  status: 200
}

export type adminCmsBlogCategoriesListResponseSuccess = (adminCmsBlogCategoriesListResponse200) & {
  headers: Headers;
};
;

export type adminCmsBlogCategoriesListResponse = (adminCmsBlogCategoriesListResponseSuccess)

export const getAdminCmsBlogCategoriesListUrl = () => {




  return `/api/v1/admin/cms/blog/categories`
}

export const adminCmsBlogCategoriesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBlogCategoriesListResponse> => {

  return apiFetch<adminCmsBlogCategoriesListResponse>(getAdminCmsBlogCategoriesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCmsBlogCategoriesListQueryKey = () => {
    return [
    `/api/v1/admin/cms/blog/categories`
    ] as const;
    }


export const getAdminCmsBlogCategoriesListQueryOptions = <TData = Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCmsBlogCategoriesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>> = ({ signal }) => adminCmsBlogCategoriesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCmsBlogCategoriesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>>
export type AdminCmsBlogCategoriesListQueryError = unknown


export function useAdminCmsBlogCategoriesList<TData = Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>,
          TError,
          Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsBlogCategoriesList<TData = Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>,
          TError,
          Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsBlogCategoriesList<TData = Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCmsBlogCategoriesList<TData = Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCmsBlogCategoriesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCmsBlogCategoriesCreateResponse201 = {
  data: BlogCategory
  status: 201
}

export type adminCmsBlogCategoriesCreateResponseSuccess = (adminCmsBlogCategoriesCreateResponse201) & {
  headers: Headers;
};
;

export type adminCmsBlogCategoriesCreateResponse = (adminCmsBlogCategoriesCreateResponseSuccess)

export const getAdminCmsBlogCategoriesCreateUrl = () => {




  return `/api/v1/admin/cms/blog/categories`
}

export const adminCmsBlogCategoriesCreate = async (blogCategoryWriteRequest: BlogCategoryWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBlogCategoriesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCmsBlogCategoriesCreateResponse>(getAdminCmsBlogCategoriesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(blogCategoryWriteRequest)
  }
);}





export const getAdminCmsBlogCategoriesCreateMutationKey = () => ['adminCmsBlogCategoriesCreate'] as const;

export const getAdminCmsBlogCategoriesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesCreate>>, TError,AdminCmsBlogCategoriesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesCreate>>, TError,AdminCmsBlogCategoriesCreateMutationVariables, TContext> => {

const mutationKey = getAdminCmsBlogCategoriesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsBlogCategoriesCreate>>, AdminCmsBlogCategoriesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminCmsBlogCategoriesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsBlogCategoriesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsBlogCategoriesCreate>>>
    export type AdminCmsBlogCategoriesCreateMutationBody = BlogCategoryWriteRequest
    export type AdminCmsBlogCategoriesCreateMutationError = unknown
    export type AdminCmsBlogCategoriesCreateMutationVariables = {data: BlogCategoryWriteRequest}

    export const useAdminCmsBlogCategoriesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesCreate>>, TError,AdminCmsBlogCategoriesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsBlogCategoriesCreate>>,
        TError,
        AdminCmsBlogCategoriesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsBlogCategoriesCreateMutationOptions(options), queryClient);
    }
    export type adminCmsBlogCategoriesPartialUpdateResponse200 = {
  data: BlogCategory
  status: 200
}

export type adminCmsBlogCategoriesPartialUpdateResponseSuccess = (adminCmsBlogCategoriesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminCmsBlogCategoriesPartialUpdateResponse = (adminCmsBlogCategoriesPartialUpdateResponseSuccess)

export const getAdminCmsBlogCategoriesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/cms/blog/categories/${uid}`
}

export const adminCmsBlogCategoriesPartialUpdate = async (uid: string,
    patchedBlogCategoryWriteRequest?: PatchedBlogCategoryWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBlogCategoriesPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCmsBlogCategoriesPartialUpdateResponse>(getAdminCmsBlogCategoriesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedBlogCategoryWriteRequest)
  }
);}





export const getAdminCmsBlogCategoriesPartialUpdateMutationKey = () => ['adminCmsBlogCategoriesPartialUpdate'] as const;

export const getAdminCmsBlogCategoriesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesPartialUpdate>>, TError,AdminCmsBlogCategoriesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesPartialUpdate>>, TError,AdminCmsBlogCategoriesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCmsBlogCategoriesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsBlogCategoriesPartialUpdate>>, AdminCmsBlogCategoriesPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCmsBlogCategoriesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsBlogCategoriesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsBlogCategoriesPartialUpdate>>>
    export type AdminCmsBlogCategoriesPartialUpdateMutationBody = PatchedBlogCategoryWriteRequest | undefined
    export type AdminCmsBlogCategoriesPartialUpdateMutationError = unknown
    export type AdminCmsBlogCategoriesPartialUpdateMutationVariables = {uid: string;data?: PatchedBlogCategoryWriteRequest}

    export const useAdminCmsBlogCategoriesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesPartialUpdate>>, TError,AdminCmsBlogCategoriesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsBlogCategoriesPartialUpdate>>,
        TError,
        AdminCmsBlogCategoriesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsBlogCategoriesPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminCmsBlogCategoriesDestroyResponse204 = {
  data: void
  status: 204
}

export type adminCmsBlogCategoriesDestroyResponseSuccess = (adminCmsBlogCategoriesDestroyResponse204) & {
  headers: Headers;
};
;

export type adminCmsBlogCategoriesDestroyResponse = (adminCmsBlogCategoriesDestroyResponseSuccess)

export const getAdminCmsBlogCategoriesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/cms/blog/categories/${uid}`
}

export const adminCmsBlogCategoriesDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBlogCategoriesDestroyResponse> => {

  return apiFetch<adminCmsBlogCategoriesDestroyResponse>(getAdminCmsBlogCategoriesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminCmsBlogCategoriesDestroyMutationKey = () => ['adminCmsBlogCategoriesDestroy'] as const;

export const getAdminCmsBlogCategoriesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesDestroy>>, TError,AdminCmsBlogCategoriesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesDestroy>>, TError,AdminCmsBlogCategoriesDestroyMutationVariables, TContext> => {

const mutationKey = getAdminCmsBlogCategoriesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsBlogCategoriesDestroy>>, AdminCmsBlogCategoriesDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminCmsBlogCategoriesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsBlogCategoriesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsBlogCategoriesDestroy>>>

    export type AdminCmsBlogCategoriesDestroyMutationError = unknown
    export type AdminCmsBlogCategoriesDestroyMutationVariables = {uid: string}

    export const useAdminCmsBlogCategoriesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogCategoriesDestroy>>, TError,AdminCmsBlogCategoriesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsBlogCategoriesDestroy>>,
        TError,
        AdminCmsBlogCategoriesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsBlogCategoriesDestroyMutationOptions(options), queryClient);
    }
    export type adminCmsBlogPostsListResponse200 = {
  data: PaginatedPostListList
  status: 200
}

export type adminCmsBlogPostsListResponseSuccess = (adminCmsBlogPostsListResponse200) & {
  headers: Headers;
};
;

export type adminCmsBlogPostsListResponse = (adminCmsBlogPostsListResponseSuccess)

export const getAdminCmsBlogPostsListUrl = (params?: AdminCmsBlogPostsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/cms/blog/posts?${stringifiedParams}` : `/api/v1/admin/cms/blog/posts`
}

/**
 * `?status=` `?category=<uid>` `?search=` (paged)
 */
export const adminCmsBlogPostsList = async (params?: AdminCmsBlogPostsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBlogPostsListResponse> => {

  return apiFetch<adminCmsBlogPostsListResponse>(getAdminCmsBlogPostsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCmsBlogPostsListQueryKey = (params?: AdminCmsBlogPostsListParams,) => {
    return [
    `/api/v1/admin/cms/blog/posts`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminCmsBlogPostsListQueryOptions = <TData = Awaited<ReturnType<typeof adminCmsBlogPostsList>>, TError = unknown>(params?: AdminCmsBlogPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogPostsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCmsBlogPostsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCmsBlogPostsList>>> = ({ signal }) => adminCmsBlogPostsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogPostsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCmsBlogPostsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCmsBlogPostsList>>>
export type AdminCmsBlogPostsListQueryError = unknown


export function useAdminCmsBlogPostsList<TData = Awaited<ReturnType<typeof adminCmsBlogPostsList>>, TError = unknown>(
 params: undefined |  AdminCmsBlogPostsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogPostsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsBlogPostsList>>,
          TError,
          Awaited<ReturnType<typeof adminCmsBlogPostsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsBlogPostsList<TData = Awaited<ReturnType<typeof adminCmsBlogPostsList>>, TError = unknown>(
 params?: AdminCmsBlogPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogPostsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsBlogPostsList>>,
          TError,
          Awaited<ReturnType<typeof adminCmsBlogPostsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsBlogPostsList<TData = Awaited<ReturnType<typeof adminCmsBlogPostsList>>, TError = unknown>(
 params?: AdminCmsBlogPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogPostsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCmsBlogPostsList<TData = Awaited<ReturnType<typeof adminCmsBlogPostsList>>, TError = unknown>(
 params?: AdminCmsBlogPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogPostsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCmsBlogPostsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCmsBlogPostsCreateResponse201 = {
  data: Post
  status: 201
}

export type adminCmsBlogPostsCreateResponseSuccess = (adminCmsBlogPostsCreateResponse201) & {
  headers: Headers;
};
;

export type adminCmsBlogPostsCreateResponse = (adminCmsBlogPostsCreateResponseSuccess)

export const getAdminCmsBlogPostsCreateUrl = () => {




  return `/api/v1/admin/cms/blog/posts`
}

/**
 * `?status=` `?category=<uid>` `?search=` (paged)
 */
export const adminCmsBlogPostsCreate = async (postWriteRequest: PostWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBlogPostsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCmsBlogPostsCreateResponse>(getAdminCmsBlogPostsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(postWriteRequest)
  }
);}





export const getAdminCmsBlogPostsCreateMutationKey = () => ['adminCmsBlogPostsCreate'] as const;

export const getAdminCmsBlogPostsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogPostsCreate>>, TError,AdminCmsBlogPostsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogPostsCreate>>, TError,AdminCmsBlogPostsCreateMutationVariables, TContext> => {

const mutationKey = getAdminCmsBlogPostsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsBlogPostsCreate>>, AdminCmsBlogPostsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminCmsBlogPostsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsBlogPostsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsBlogPostsCreate>>>
    export type AdminCmsBlogPostsCreateMutationBody = PostWriteRequest
    export type AdminCmsBlogPostsCreateMutationError = unknown
    export type AdminCmsBlogPostsCreateMutationVariables = {data: PostWriteRequest}

    export const useAdminCmsBlogPostsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogPostsCreate>>, TError,AdminCmsBlogPostsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsBlogPostsCreate>>,
        TError,
        AdminCmsBlogPostsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsBlogPostsCreateMutationOptions(options), queryClient);
    }
    export type adminCmsBlogPostsRetrieveResponse200 = {
  data: Post
  status: 200
}

export type adminCmsBlogPostsRetrieveResponseSuccess = (adminCmsBlogPostsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminCmsBlogPostsRetrieveResponse = (adminCmsBlogPostsRetrieveResponseSuccess)

export const getAdminCmsBlogPostsRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/cms/blog/posts/${uid}`
}

export const adminCmsBlogPostsRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBlogPostsRetrieveResponse> => {

  return apiFetch<adminCmsBlogPostsRetrieveResponse>(getAdminCmsBlogPostsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCmsBlogPostsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/cms/blog/posts/${uid}`
    ] as const;
    }


export const getAdminCmsBlogPostsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCmsBlogPostsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>> = ({ signal }) => adminCmsBlogPostsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCmsBlogPostsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>>
export type AdminCmsBlogPostsRetrieveQueryError = unknown


export function useAdminCmsBlogPostsRetrieve<TData = Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsBlogPostsRetrieve<TData = Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsBlogPostsRetrieve<TData = Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCmsBlogPostsRetrieve<TData = Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogPostsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCmsBlogPostsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCmsBlogPostsPartialUpdateResponse200 = {
  data: Post
  status: 200
}

export type adminCmsBlogPostsPartialUpdateResponseSuccess = (adminCmsBlogPostsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminCmsBlogPostsPartialUpdateResponse = (adminCmsBlogPostsPartialUpdateResponseSuccess)

export const getAdminCmsBlogPostsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/cms/blog/posts/${uid}`
}

export const adminCmsBlogPostsPartialUpdate = async (uid: string,
    patchedPostWriteRequest?: PatchedPostWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBlogPostsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCmsBlogPostsPartialUpdateResponse>(getAdminCmsBlogPostsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedPostWriteRequest)
  }
);}





export const getAdminCmsBlogPostsPartialUpdateMutationKey = () => ['adminCmsBlogPostsPartialUpdate'] as const;

export const getAdminCmsBlogPostsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogPostsPartialUpdate>>, TError,AdminCmsBlogPostsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogPostsPartialUpdate>>, TError,AdminCmsBlogPostsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCmsBlogPostsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsBlogPostsPartialUpdate>>, AdminCmsBlogPostsPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCmsBlogPostsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsBlogPostsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsBlogPostsPartialUpdate>>>
    export type AdminCmsBlogPostsPartialUpdateMutationBody = PatchedPostWriteRequest | undefined
    export type AdminCmsBlogPostsPartialUpdateMutationError = unknown
    export type AdminCmsBlogPostsPartialUpdateMutationVariables = {uid: string;data?: PatchedPostWriteRequest}

    export const useAdminCmsBlogPostsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogPostsPartialUpdate>>, TError,AdminCmsBlogPostsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsBlogPostsPartialUpdate>>,
        TError,
        AdminCmsBlogPostsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsBlogPostsPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminCmsBlogPostsDestroyResponse204 = {
  data: void
  status: 204
}

export type adminCmsBlogPostsDestroyResponseSuccess = (adminCmsBlogPostsDestroyResponse204) & {
  headers: Headers;
};
;

export type adminCmsBlogPostsDestroyResponse = (adminCmsBlogPostsDestroyResponseSuccess)

export const getAdminCmsBlogPostsDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/cms/blog/posts/${uid}`
}

export const adminCmsBlogPostsDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBlogPostsDestroyResponse> => {

  return apiFetch<adminCmsBlogPostsDestroyResponse>(getAdminCmsBlogPostsDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminCmsBlogPostsDestroyMutationKey = () => ['adminCmsBlogPostsDestroy'] as const;

export const getAdminCmsBlogPostsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogPostsDestroy>>, TError,AdminCmsBlogPostsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogPostsDestroy>>, TError,AdminCmsBlogPostsDestroyMutationVariables, TContext> => {

const mutationKey = getAdminCmsBlogPostsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsBlogPostsDestroy>>, AdminCmsBlogPostsDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminCmsBlogPostsDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsBlogPostsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsBlogPostsDestroy>>>

    export type AdminCmsBlogPostsDestroyMutationError = unknown
    export type AdminCmsBlogPostsDestroyMutationVariables = {uid: string}

    export const useAdminCmsBlogPostsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogPostsDestroy>>, TError,AdminCmsBlogPostsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsBlogPostsDestroy>>,
        TError,
        AdminCmsBlogPostsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsBlogPostsDestroyMutationOptions(options), queryClient);
    }
    export type adminCmsBlogTagsListResponse200 = {
  data: Tag[]
  status: 200
}

export type adminCmsBlogTagsListResponseSuccess = (adminCmsBlogTagsListResponse200) & {
  headers: Headers;
};
;

export type adminCmsBlogTagsListResponse = (adminCmsBlogTagsListResponseSuccess)

export const getAdminCmsBlogTagsListUrl = (params?: AdminCmsBlogTagsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/cms/blog/tags?${stringifiedParams}` : `/api/v1/admin/cms/blog/tags`
}

export const adminCmsBlogTagsList = async (params?: AdminCmsBlogTagsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBlogTagsListResponse> => {

  return apiFetch<adminCmsBlogTagsListResponse>(getAdminCmsBlogTagsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCmsBlogTagsListQueryKey = (params?: AdminCmsBlogTagsListParams,) => {
    return [
    `/api/v1/admin/cms/blog/tags`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminCmsBlogTagsListQueryOptions = <TData = Awaited<ReturnType<typeof adminCmsBlogTagsList>>, TError = unknown>(params?: AdminCmsBlogTagsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogTagsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCmsBlogTagsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCmsBlogTagsList>>> = ({ signal }) => adminCmsBlogTagsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogTagsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCmsBlogTagsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCmsBlogTagsList>>>
export type AdminCmsBlogTagsListQueryError = unknown


export function useAdminCmsBlogTagsList<TData = Awaited<ReturnType<typeof adminCmsBlogTagsList>>, TError = unknown>(
 params: undefined |  AdminCmsBlogTagsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogTagsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsBlogTagsList>>,
          TError,
          Awaited<ReturnType<typeof adminCmsBlogTagsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsBlogTagsList<TData = Awaited<ReturnType<typeof adminCmsBlogTagsList>>, TError = unknown>(
 params?: AdminCmsBlogTagsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogTagsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsBlogTagsList>>,
          TError,
          Awaited<ReturnType<typeof adminCmsBlogTagsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsBlogTagsList<TData = Awaited<ReturnType<typeof adminCmsBlogTagsList>>, TError = unknown>(
 params?: AdminCmsBlogTagsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogTagsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCmsBlogTagsList<TData = Awaited<ReturnType<typeof adminCmsBlogTagsList>>, TError = unknown>(
 params?: AdminCmsBlogTagsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsBlogTagsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCmsBlogTagsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCmsBlogTagsCreateResponse201 = {
  data: Tag
  status: 201
}

export type adminCmsBlogTagsCreateResponseSuccess = (adminCmsBlogTagsCreateResponse201) & {
  headers: Headers;
};
;

export type adminCmsBlogTagsCreateResponse = (adminCmsBlogTagsCreateResponseSuccess)

export const getAdminCmsBlogTagsCreateUrl = () => {




  return `/api/v1/admin/cms/blog/tags`
}

export const adminCmsBlogTagsCreate = async (tagRequest: TagRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBlogTagsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCmsBlogTagsCreateResponse>(getAdminCmsBlogTagsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(tagRequest)
  }
);}





export const getAdminCmsBlogTagsCreateMutationKey = () => ['adminCmsBlogTagsCreate'] as const;

export const getAdminCmsBlogTagsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogTagsCreate>>, TError,AdminCmsBlogTagsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogTagsCreate>>, TError,AdminCmsBlogTagsCreateMutationVariables, TContext> => {

const mutationKey = getAdminCmsBlogTagsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsBlogTagsCreate>>, AdminCmsBlogTagsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminCmsBlogTagsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsBlogTagsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsBlogTagsCreate>>>
    export type AdminCmsBlogTagsCreateMutationBody = TagRequest
    export type AdminCmsBlogTagsCreateMutationError = unknown
    export type AdminCmsBlogTagsCreateMutationVariables = {data: TagRequest}

    export const useAdminCmsBlogTagsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogTagsCreate>>, TError,AdminCmsBlogTagsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsBlogTagsCreate>>,
        TError,
        AdminCmsBlogTagsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsBlogTagsCreateMutationOptions(options), queryClient);
    }
    export type adminCmsBlogTagsPartialUpdateResponse200 = {
  data: Tag
  status: 200
}

export type adminCmsBlogTagsPartialUpdateResponseSuccess = (adminCmsBlogTagsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminCmsBlogTagsPartialUpdateResponse = (adminCmsBlogTagsPartialUpdateResponseSuccess)

export const getAdminCmsBlogTagsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/cms/blog/tags/${uid}`
}

export const adminCmsBlogTagsPartialUpdate = async (uid: string,
    patchedTagRequest?: PatchedTagRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBlogTagsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCmsBlogTagsPartialUpdateResponse>(getAdminCmsBlogTagsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedTagRequest)
  }
);}





export const getAdminCmsBlogTagsPartialUpdateMutationKey = () => ['adminCmsBlogTagsPartialUpdate'] as const;

export const getAdminCmsBlogTagsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogTagsPartialUpdate>>, TError,AdminCmsBlogTagsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogTagsPartialUpdate>>, TError,AdminCmsBlogTagsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCmsBlogTagsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsBlogTagsPartialUpdate>>, AdminCmsBlogTagsPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCmsBlogTagsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsBlogTagsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsBlogTagsPartialUpdate>>>
    export type AdminCmsBlogTagsPartialUpdateMutationBody = PatchedTagRequest | undefined
    export type AdminCmsBlogTagsPartialUpdateMutationError = unknown
    export type AdminCmsBlogTagsPartialUpdateMutationVariables = {uid: string;data?: PatchedTagRequest}

    export const useAdminCmsBlogTagsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogTagsPartialUpdate>>, TError,AdminCmsBlogTagsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsBlogTagsPartialUpdate>>,
        TError,
        AdminCmsBlogTagsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsBlogTagsPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminCmsBlogTagsDestroyResponse204 = {
  data: void
  status: 204
}

export type adminCmsBlogTagsDestroyResponseSuccess = (adminCmsBlogTagsDestroyResponse204) & {
  headers: Headers;
};
;

export type adminCmsBlogTagsDestroyResponse = (adminCmsBlogTagsDestroyResponseSuccess)

export const getAdminCmsBlogTagsDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/cms/blog/tags/${uid}`
}

export const adminCmsBlogTagsDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsBlogTagsDestroyResponse> => {

  return apiFetch<adminCmsBlogTagsDestroyResponse>(getAdminCmsBlogTagsDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminCmsBlogTagsDestroyMutationKey = () => ['adminCmsBlogTagsDestroy'] as const;

export const getAdminCmsBlogTagsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogTagsDestroy>>, TError,AdminCmsBlogTagsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogTagsDestroy>>, TError,AdminCmsBlogTagsDestroyMutationVariables, TContext> => {

const mutationKey = getAdminCmsBlogTagsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsBlogTagsDestroy>>, AdminCmsBlogTagsDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminCmsBlogTagsDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsBlogTagsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsBlogTagsDestroy>>>

    export type AdminCmsBlogTagsDestroyMutationError = unknown
    export type AdminCmsBlogTagsDestroyMutationVariables = {uid: string}

    export const useAdminCmsBlogTagsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsBlogTagsDestroy>>, TError,AdminCmsBlogTagsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsBlogTagsDestroy>>,
        TError,
        AdminCmsBlogTagsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsBlogTagsDestroyMutationOptions(options), queryClient);
    }
    export type adminCmsFaqCategoriesListResponse200 = {
  data: FaqCategory[]
  status: 200
}

export type adminCmsFaqCategoriesListResponseSuccess = (adminCmsFaqCategoriesListResponse200) & {
  headers: Headers;
};
;

export type adminCmsFaqCategoriesListResponse = (adminCmsFaqCategoriesListResponseSuccess)

export const getAdminCmsFaqCategoriesListUrl = () => {




  return `/api/v1/admin/cms/faq-categories`
}

export const adminCmsFaqCategoriesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsFaqCategoriesListResponse> => {

  return apiFetch<adminCmsFaqCategoriesListResponse>(getAdminCmsFaqCategoriesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCmsFaqCategoriesListQueryKey = () => {
    return [
    `/api/v1/admin/cms/faq-categories`
    ] as const;
    }


export const getAdminCmsFaqCategoriesListQueryOptions = <TData = Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCmsFaqCategoriesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>> = ({ signal }) => adminCmsFaqCategoriesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCmsFaqCategoriesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>>
export type AdminCmsFaqCategoriesListQueryError = unknown


export function useAdminCmsFaqCategoriesList<TData = Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>,
          TError,
          Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsFaqCategoriesList<TData = Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>,
          TError,
          Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsFaqCategoriesList<TData = Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCmsFaqCategoriesList<TData = Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCmsFaqCategoriesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCmsFaqCategoriesCreateResponse201 = {
  data: FaqCategory
  status: 201
}

export type adminCmsFaqCategoriesCreateResponseSuccess = (adminCmsFaqCategoriesCreateResponse201) & {
  headers: Headers;
};
;

export type adminCmsFaqCategoriesCreateResponse = (adminCmsFaqCategoriesCreateResponseSuccess)

export const getAdminCmsFaqCategoriesCreateUrl = () => {




  return `/api/v1/admin/cms/faq-categories`
}

export const adminCmsFaqCategoriesCreate = async (faqCategoryRequest: FaqCategoryRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsFaqCategoriesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCmsFaqCategoriesCreateResponse>(getAdminCmsFaqCategoriesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(faqCategoryRequest)
  }
);}





export const getAdminCmsFaqCategoriesCreateMutationKey = () => ['adminCmsFaqCategoriesCreate'] as const;

export const getAdminCmsFaqCategoriesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesCreate>>, TError,AdminCmsFaqCategoriesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesCreate>>, TError,AdminCmsFaqCategoriesCreateMutationVariables, TContext> => {

const mutationKey = getAdminCmsFaqCategoriesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsFaqCategoriesCreate>>, AdminCmsFaqCategoriesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminCmsFaqCategoriesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsFaqCategoriesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsFaqCategoriesCreate>>>
    export type AdminCmsFaqCategoriesCreateMutationBody = FaqCategoryRequest
    export type AdminCmsFaqCategoriesCreateMutationError = unknown
    export type AdminCmsFaqCategoriesCreateMutationVariables = {data: FaqCategoryRequest}

    export const useAdminCmsFaqCategoriesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesCreate>>, TError,AdminCmsFaqCategoriesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsFaqCategoriesCreate>>,
        TError,
        AdminCmsFaqCategoriesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsFaqCategoriesCreateMutationOptions(options), queryClient);
    }
    export type adminCmsFaqCategoriesPartialUpdateResponse200 = {
  data: FaqCategory
  status: 200
}

export type adminCmsFaqCategoriesPartialUpdateResponseSuccess = (adminCmsFaqCategoriesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminCmsFaqCategoriesPartialUpdateResponse = (adminCmsFaqCategoriesPartialUpdateResponseSuccess)

export const getAdminCmsFaqCategoriesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/cms/faq-categories/${uid}`
}

export const adminCmsFaqCategoriesPartialUpdate = async (uid: string,
    patchedFaqCategoryRequest?: PatchedFaqCategoryRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsFaqCategoriesPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCmsFaqCategoriesPartialUpdateResponse>(getAdminCmsFaqCategoriesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedFaqCategoryRequest)
  }
);}





export const getAdminCmsFaqCategoriesPartialUpdateMutationKey = () => ['adminCmsFaqCategoriesPartialUpdate'] as const;

export const getAdminCmsFaqCategoriesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesPartialUpdate>>, TError,AdminCmsFaqCategoriesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesPartialUpdate>>, TError,AdminCmsFaqCategoriesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCmsFaqCategoriesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsFaqCategoriesPartialUpdate>>, AdminCmsFaqCategoriesPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCmsFaqCategoriesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsFaqCategoriesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsFaqCategoriesPartialUpdate>>>
    export type AdminCmsFaqCategoriesPartialUpdateMutationBody = PatchedFaqCategoryRequest | undefined
    export type AdminCmsFaqCategoriesPartialUpdateMutationError = unknown
    export type AdminCmsFaqCategoriesPartialUpdateMutationVariables = {uid: string;data?: PatchedFaqCategoryRequest}

    export const useAdminCmsFaqCategoriesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesPartialUpdate>>, TError,AdminCmsFaqCategoriesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsFaqCategoriesPartialUpdate>>,
        TError,
        AdminCmsFaqCategoriesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsFaqCategoriesPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminCmsFaqCategoriesDestroyResponse204 = {
  data: void
  status: 204
}

export type adminCmsFaqCategoriesDestroyResponseSuccess = (adminCmsFaqCategoriesDestroyResponse204) & {
  headers: Headers;
};
;

export type adminCmsFaqCategoriesDestroyResponse = (adminCmsFaqCategoriesDestroyResponseSuccess)

export const getAdminCmsFaqCategoriesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/cms/faq-categories/${uid}`
}

export const adminCmsFaqCategoriesDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsFaqCategoriesDestroyResponse> => {

  return apiFetch<adminCmsFaqCategoriesDestroyResponse>(getAdminCmsFaqCategoriesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminCmsFaqCategoriesDestroyMutationKey = () => ['adminCmsFaqCategoriesDestroy'] as const;

export const getAdminCmsFaqCategoriesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesDestroy>>, TError,AdminCmsFaqCategoriesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesDestroy>>, TError,AdminCmsFaqCategoriesDestroyMutationVariables, TContext> => {

const mutationKey = getAdminCmsFaqCategoriesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsFaqCategoriesDestroy>>, AdminCmsFaqCategoriesDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminCmsFaqCategoriesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsFaqCategoriesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsFaqCategoriesDestroy>>>

    export type AdminCmsFaqCategoriesDestroyMutationError = unknown
    export type AdminCmsFaqCategoriesDestroyMutationVariables = {uid: string}

    export const useAdminCmsFaqCategoriesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqCategoriesDestroy>>, TError,AdminCmsFaqCategoriesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsFaqCategoriesDestroy>>,
        TError,
        AdminCmsFaqCategoriesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsFaqCategoriesDestroyMutationOptions(options), queryClient);
    }
    export type adminCmsFaqsListResponse200 = {
  data: Faq[]
  status: 200
}

export type adminCmsFaqsListResponseSuccess = (adminCmsFaqsListResponse200) & {
  headers: Headers;
};
;

export type adminCmsFaqsListResponse = (adminCmsFaqsListResponseSuccess)

export const getAdminCmsFaqsListUrl = (params?: AdminCmsFaqsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/cms/faqs?${stringifiedParams}` : `/api/v1/admin/cms/faqs`
}

export const adminCmsFaqsList = async (params?: AdminCmsFaqsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsFaqsListResponse> => {

  return apiFetch<adminCmsFaqsListResponse>(getAdminCmsFaqsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCmsFaqsListQueryKey = (params?: AdminCmsFaqsListParams,) => {
    return [
    `/api/v1/admin/cms/faqs`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminCmsFaqsListQueryOptions = <TData = Awaited<ReturnType<typeof adminCmsFaqsList>>, TError = unknown>(params?: AdminCmsFaqsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCmsFaqsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCmsFaqsList>>> = ({ signal }) => adminCmsFaqsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCmsFaqsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCmsFaqsList>>>
export type AdminCmsFaqsListQueryError = unknown


export function useAdminCmsFaqsList<TData = Awaited<ReturnType<typeof adminCmsFaqsList>>, TError = unknown>(
 params: undefined |  AdminCmsFaqsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsFaqsList>>,
          TError,
          Awaited<ReturnType<typeof adminCmsFaqsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsFaqsList<TData = Awaited<ReturnType<typeof adminCmsFaqsList>>, TError = unknown>(
 params?: AdminCmsFaqsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsFaqsList>>,
          TError,
          Awaited<ReturnType<typeof adminCmsFaqsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsFaqsList<TData = Awaited<ReturnType<typeof adminCmsFaqsList>>, TError = unknown>(
 params?: AdminCmsFaqsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCmsFaqsList<TData = Awaited<ReturnType<typeof adminCmsFaqsList>>, TError = unknown>(
 params?: AdminCmsFaqsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCmsFaqsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCmsFaqsCreateResponse201 = {
  data: Faq
  status: 201
}

export type adminCmsFaqsCreateResponseSuccess = (adminCmsFaqsCreateResponse201) & {
  headers: Headers;
};
;

export type adminCmsFaqsCreateResponse = (adminCmsFaqsCreateResponseSuccess)

export const getAdminCmsFaqsCreateUrl = () => {




  return `/api/v1/admin/cms/faqs`
}

export const adminCmsFaqsCreate = async (faqWriteRequest: FaqWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsFaqsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCmsFaqsCreateResponse>(getAdminCmsFaqsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(faqWriteRequest)
  }
);}





export const getAdminCmsFaqsCreateMutationKey = () => ['adminCmsFaqsCreate'] as const;

export const getAdminCmsFaqsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqsCreate>>, TError,AdminCmsFaqsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqsCreate>>, TError,AdminCmsFaqsCreateMutationVariables, TContext> => {

const mutationKey = getAdminCmsFaqsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsFaqsCreate>>, AdminCmsFaqsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminCmsFaqsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsFaqsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsFaqsCreate>>>
    export type AdminCmsFaqsCreateMutationBody = FaqWriteRequest
    export type AdminCmsFaqsCreateMutationError = unknown
    export type AdminCmsFaqsCreateMutationVariables = {data: FaqWriteRequest}

    export const useAdminCmsFaqsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqsCreate>>, TError,AdminCmsFaqsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsFaqsCreate>>,
        TError,
        AdminCmsFaqsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsFaqsCreateMutationOptions(options), queryClient);
    }
    export type adminCmsFaqsRetrieveResponse200 = {
  data: Faq
  status: 200
}

export type adminCmsFaqsRetrieveResponseSuccess = (adminCmsFaqsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminCmsFaqsRetrieveResponse = (adminCmsFaqsRetrieveResponseSuccess)

export const getAdminCmsFaqsRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/cms/faqs/${uid}`
}

export const adminCmsFaqsRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsFaqsRetrieveResponse> => {

  return apiFetch<adminCmsFaqsRetrieveResponse>(getAdminCmsFaqsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCmsFaqsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/cms/faqs/${uid}`
    ] as const;
    }


export const getAdminCmsFaqsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCmsFaqsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>> = ({ signal }) => adminCmsFaqsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCmsFaqsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>>
export type AdminCmsFaqsRetrieveQueryError = unknown


export function useAdminCmsFaqsRetrieve<TData = Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsFaqsRetrieve<TData = Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsFaqsRetrieve<TData = Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCmsFaqsRetrieve<TData = Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsFaqsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCmsFaqsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCmsFaqsPartialUpdateResponse200 = {
  data: Faq
  status: 200
}

export type adminCmsFaqsPartialUpdateResponseSuccess = (adminCmsFaqsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminCmsFaqsPartialUpdateResponse = (adminCmsFaqsPartialUpdateResponseSuccess)

export const getAdminCmsFaqsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/cms/faqs/${uid}`
}

export const adminCmsFaqsPartialUpdate = async (uid: string,
    patchedFaqWriteRequest?: PatchedFaqWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsFaqsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCmsFaqsPartialUpdateResponse>(getAdminCmsFaqsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedFaqWriteRequest)
  }
);}





export const getAdminCmsFaqsPartialUpdateMutationKey = () => ['adminCmsFaqsPartialUpdate'] as const;

export const getAdminCmsFaqsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqsPartialUpdate>>, TError,AdminCmsFaqsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqsPartialUpdate>>, TError,AdminCmsFaqsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCmsFaqsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsFaqsPartialUpdate>>, AdminCmsFaqsPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCmsFaqsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsFaqsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsFaqsPartialUpdate>>>
    export type AdminCmsFaqsPartialUpdateMutationBody = PatchedFaqWriteRequest | undefined
    export type AdminCmsFaqsPartialUpdateMutationError = unknown
    export type AdminCmsFaqsPartialUpdateMutationVariables = {uid: string;data?: PatchedFaqWriteRequest}

    export const useAdminCmsFaqsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqsPartialUpdate>>, TError,AdminCmsFaqsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsFaqsPartialUpdate>>,
        TError,
        AdminCmsFaqsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsFaqsPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminCmsFaqsDestroyResponse204 = {
  data: void
  status: 204
}

export type adminCmsFaqsDestroyResponseSuccess = (adminCmsFaqsDestroyResponse204) & {
  headers: Headers;
};
;

export type adminCmsFaqsDestroyResponse = (adminCmsFaqsDestroyResponseSuccess)

export const getAdminCmsFaqsDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/cms/faqs/${uid}`
}

export const adminCmsFaqsDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsFaqsDestroyResponse> => {

  return apiFetch<adminCmsFaqsDestroyResponse>(getAdminCmsFaqsDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminCmsFaqsDestroyMutationKey = () => ['adminCmsFaqsDestroy'] as const;

export const getAdminCmsFaqsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqsDestroy>>, TError,AdminCmsFaqsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqsDestroy>>, TError,AdminCmsFaqsDestroyMutationVariables, TContext> => {

const mutationKey = getAdminCmsFaqsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsFaqsDestroy>>, AdminCmsFaqsDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminCmsFaqsDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsFaqsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsFaqsDestroy>>>

    export type AdminCmsFaqsDestroyMutationError = unknown
    export type AdminCmsFaqsDestroyMutationVariables = {uid: string}

    export const useAdminCmsFaqsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsFaqsDestroy>>, TError,AdminCmsFaqsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsFaqsDestroy>>,
        TError,
        AdminCmsFaqsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsFaqsDestroyMutationOptions(options), queryClient);
    }
    export type adminCmsPagesListResponse200 = {
  data: PageList[]
  status: 200
}

export type adminCmsPagesListResponseSuccess = (adminCmsPagesListResponse200) & {
  headers: Headers;
};
;

export type adminCmsPagesListResponse = (adminCmsPagesListResponseSuccess)

export const getAdminCmsPagesListUrl = (params?: AdminCmsPagesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/cms/pages?${stringifiedParams}` : `/api/v1/admin/cms/pages`
}

export const adminCmsPagesList = async (params?: AdminCmsPagesListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsPagesListResponse> => {

  return apiFetch<adminCmsPagesListResponse>(getAdminCmsPagesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCmsPagesListQueryKey = (params?: AdminCmsPagesListParams,) => {
    return [
    `/api/v1/admin/cms/pages`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminCmsPagesListQueryOptions = <TData = Awaited<ReturnType<typeof adminCmsPagesList>>, TError = unknown>(params?: AdminCmsPagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsPagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCmsPagesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCmsPagesList>>> = ({ signal }) => adminCmsPagesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCmsPagesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCmsPagesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCmsPagesList>>>
export type AdminCmsPagesListQueryError = unknown


export function useAdminCmsPagesList<TData = Awaited<ReturnType<typeof adminCmsPagesList>>, TError = unknown>(
 params: undefined |  AdminCmsPagesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsPagesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsPagesList>>,
          TError,
          Awaited<ReturnType<typeof adminCmsPagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsPagesList<TData = Awaited<ReturnType<typeof adminCmsPagesList>>, TError = unknown>(
 params?: AdminCmsPagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsPagesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsPagesList>>,
          TError,
          Awaited<ReturnType<typeof adminCmsPagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsPagesList<TData = Awaited<ReturnType<typeof adminCmsPagesList>>, TError = unknown>(
 params?: AdminCmsPagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsPagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCmsPagesList<TData = Awaited<ReturnType<typeof adminCmsPagesList>>, TError = unknown>(
 params?: AdminCmsPagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsPagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCmsPagesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCmsPagesCreateResponse201 = {
  data: Page
  status: 201
}

export type adminCmsPagesCreateResponseSuccess = (adminCmsPagesCreateResponse201) & {
  headers: Headers;
};
;

export type adminCmsPagesCreateResponse = (adminCmsPagesCreateResponseSuccess)

export const getAdminCmsPagesCreateUrl = () => {




  return `/api/v1/admin/cms/pages`
}

export const adminCmsPagesCreate = async (pageWriteRequest: PageWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsPagesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCmsPagesCreateResponse>(getAdminCmsPagesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pageWriteRequest)
  }
);}





export const getAdminCmsPagesCreateMutationKey = () => ['adminCmsPagesCreate'] as const;

export const getAdminCmsPagesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsPagesCreate>>, TError,AdminCmsPagesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsPagesCreate>>, TError,AdminCmsPagesCreateMutationVariables, TContext> => {

const mutationKey = getAdminCmsPagesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsPagesCreate>>, AdminCmsPagesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminCmsPagesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsPagesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsPagesCreate>>>
    export type AdminCmsPagesCreateMutationBody = PageWriteRequest
    export type AdminCmsPagesCreateMutationError = unknown
    export type AdminCmsPagesCreateMutationVariables = {data: PageWriteRequest}

    export const useAdminCmsPagesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsPagesCreate>>, TError,AdminCmsPagesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsPagesCreate>>,
        TError,
        AdminCmsPagesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsPagesCreateMutationOptions(options), queryClient);
    }
    export type adminCmsPagesRetrieveResponse200 = {
  data: Page
  status: 200
}

export type adminCmsPagesRetrieveResponseSuccess = (adminCmsPagesRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminCmsPagesRetrieveResponse = (adminCmsPagesRetrieveResponseSuccess)

export const getAdminCmsPagesRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/cms/pages/${uid}`
}

export const adminCmsPagesRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsPagesRetrieveResponse> => {

  return apiFetch<adminCmsPagesRetrieveResponse>(getAdminCmsPagesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCmsPagesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/cms/pages/${uid}`
    ] as const;
    }


export const getAdminCmsPagesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCmsPagesRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsPagesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCmsPagesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCmsPagesRetrieve>>> = ({ signal }) => adminCmsPagesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCmsPagesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCmsPagesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCmsPagesRetrieve>>>
export type AdminCmsPagesRetrieveQueryError = unknown


export function useAdminCmsPagesRetrieve<TData = Awaited<ReturnType<typeof adminCmsPagesRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsPagesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsPagesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCmsPagesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsPagesRetrieve<TData = Awaited<ReturnType<typeof adminCmsPagesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsPagesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCmsPagesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCmsPagesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCmsPagesRetrieve<TData = Awaited<ReturnType<typeof adminCmsPagesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsPagesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCmsPagesRetrieve<TData = Awaited<ReturnType<typeof adminCmsPagesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCmsPagesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCmsPagesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCmsPagesPartialUpdateResponse200 = {
  data: Page
  status: 200
}

export type adminCmsPagesPartialUpdateResponseSuccess = (adminCmsPagesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminCmsPagesPartialUpdateResponse = (adminCmsPagesPartialUpdateResponseSuccess)

export const getAdminCmsPagesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/cms/pages/${uid}`
}

export const adminCmsPagesPartialUpdate = async (uid: string,
    patchedPageWriteRequest?: PatchedPageWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsPagesPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCmsPagesPartialUpdateResponse>(getAdminCmsPagesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedPageWriteRequest)
  }
);}





export const getAdminCmsPagesPartialUpdateMutationKey = () => ['adminCmsPagesPartialUpdate'] as const;

export const getAdminCmsPagesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsPagesPartialUpdate>>, TError,AdminCmsPagesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsPagesPartialUpdate>>, TError,AdminCmsPagesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCmsPagesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsPagesPartialUpdate>>, AdminCmsPagesPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCmsPagesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsPagesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsPagesPartialUpdate>>>
    export type AdminCmsPagesPartialUpdateMutationBody = PatchedPageWriteRequest | undefined
    export type AdminCmsPagesPartialUpdateMutationError = unknown
    export type AdminCmsPagesPartialUpdateMutationVariables = {uid: string;data?: PatchedPageWriteRequest}

    export const useAdminCmsPagesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsPagesPartialUpdate>>, TError,AdminCmsPagesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsPagesPartialUpdate>>,
        TError,
        AdminCmsPagesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsPagesPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminCmsPagesDestroyResponse204 = {
  data: void
  status: 204
}

export type adminCmsPagesDestroyResponseSuccess = (adminCmsPagesDestroyResponse204) & {
  headers: Headers;
};
;

export type adminCmsPagesDestroyResponse = (adminCmsPagesDestroyResponseSuccess)

export const getAdminCmsPagesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/cms/pages/${uid}`
}

export const adminCmsPagesDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCmsPagesDestroyResponse> => {

  return apiFetch<adminCmsPagesDestroyResponse>(getAdminCmsPagesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminCmsPagesDestroyMutationKey = () => ['adminCmsPagesDestroy'] as const;

export const getAdminCmsPagesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsPagesDestroy>>, TError,AdminCmsPagesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCmsPagesDestroy>>, TError,AdminCmsPagesDestroyMutationVariables, TContext> => {

const mutationKey = getAdminCmsPagesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCmsPagesDestroy>>, AdminCmsPagesDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminCmsPagesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCmsPagesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminCmsPagesDestroy>>>

    export type AdminCmsPagesDestroyMutationError = unknown
    export type AdminCmsPagesDestroyMutationVariables = {uid: string}

    export const useAdminCmsPagesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCmsPagesDestroy>>, TError,AdminCmsPagesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCmsPagesDestroy>>,
        TError,
        AdminCmsPagesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCmsPagesDestroyMutationOptions(options), queryClient);
    }
    export type adminCommissionRulesListResponse200 = {
  data: Rule[]
  status: 200
}

export type adminCommissionRulesListResponseSuccess = (adminCommissionRulesListResponse200) & {
  headers: Headers;
};
;

export type adminCommissionRulesListResponse = (adminCommissionRulesListResponseSuccess)

export const getAdminCommissionRulesListUrl = (params?: AdminCommissionRulesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/commission-rules?${stringifiedParams}` : `/api/v1/admin/commission-rules`
}

export const adminCommissionRulesList = async (params?: AdminCommissionRulesListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminCommissionRulesListResponse> => {

  return apiFetch<adminCommissionRulesListResponse>(getAdminCommissionRulesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCommissionRulesListQueryKey = (params?: AdminCommissionRulesListParams,) => {
    return [
    `/api/v1/admin/commission-rules`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminCommissionRulesListQueryOptions = <TData = Awaited<ReturnType<typeof adminCommissionRulesList>>, TError = unknown>(params?: AdminCommissionRulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommissionRulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCommissionRulesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCommissionRulesList>>> = ({ signal }) => adminCommissionRulesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCommissionRulesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCommissionRulesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCommissionRulesList>>>
export type AdminCommissionRulesListQueryError = unknown


export function useAdminCommissionRulesList<TData = Awaited<ReturnType<typeof adminCommissionRulesList>>, TError = unknown>(
 params: undefined |  AdminCommissionRulesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommissionRulesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCommissionRulesList>>,
          TError,
          Awaited<ReturnType<typeof adminCommissionRulesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCommissionRulesList<TData = Awaited<ReturnType<typeof adminCommissionRulesList>>, TError = unknown>(
 params?: AdminCommissionRulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommissionRulesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCommissionRulesList>>,
          TError,
          Awaited<ReturnType<typeof adminCommissionRulesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCommissionRulesList<TData = Awaited<ReturnType<typeof adminCommissionRulesList>>, TError = unknown>(
 params?: AdminCommissionRulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommissionRulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCommissionRulesList<TData = Awaited<ReturnType<typeof adminCommissionRulesList>>, TError = unknown>(
 params?: AdminCommissionRulesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommissionRulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCommissionRulesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCommissionRulesCreateResponse201 = {
  data: Rule
  status: 201
}

export type adminCommissionRulesCreateResponseSuccess = (adminCommissionRulesCreateResponse201) & {
  headers: Headers;
};
;

export type adminCommissionRulesCreateResponse = (adminCommissionRulesCreateResponseSuccess)

export const getAdminCommissionRulesCreateUrl = () => {




  return `/api/v1/admin/commission-rules`
}

export const adminCommissionRulesCreate = async (ruleWriteRequest: RuleWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCommissionRulesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCommissionRulesCreateResponse>(getAdminCommissionRulesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ruleWriteRequest)
  }
);}





export const getAdminCommissionRulesCreateMutationKey = () => ['adminCommissionRulesCreate'] as const;

export const getAdminCommissionRulesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCommissionRulesCreate>>, TError,AdminCommissionRulesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCommissionRulesCreate>>, TError,AdminCommissionRulesCreateMutationVariables, TContext> => {

const mutationKey = getAdminCommissionRulesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCommissionRulesCreate>>, AdminCommissionRulesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminCommissionRulesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCommissionRulesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCommissionRulesCreate>>>
    export type AdminCommissionRulesCreateMutationBody = RuleWriteRequest
    export type AdminCommissionRulesCreateMutationError = unknown
    export type AdminCommissionRulesCreateMutationVariables = {data: RuleWriteRequest}

    export const useAdminCommissionRulesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCommissionRulesCreate>>, TError,AdminCommissionRulesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCommissionRulesCreate>>,
        TError,
        AdminCommissionRulesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCommissionRulesCreateMutationOptions(options), queryClient);
    }
    export type adminCommissionRulesRetrieveResponse200 = {
  data: Rule
  status: 200
}

export type adminCommissionRulesRetrieveResponseSuccess = (adminCommissionRulesRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminCommissionRulesRetrieveResponse = (adminCommissionRulesRetrieveResponseSuccess)

export const getAdminCommissionRulesRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/commission-rules/${uid}`
}

export const adminCommissionRulesRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCommissionRulesRetrieveResponse> => {

  return apiFetch<adminCommissionRulesRetrieveResponse>(getAdminCommissionRulesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCommissionRulesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/commission-rules/${uid}`
    ] as const;
    }


export const getAdminCommissionRulesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCommissionRulesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>> = ({ signal }) => adminCommissionRulesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCommissionRulesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>>
export type AdminCommissionRulesRetrieveQueryError = unknown


export function useAdminCommissionRulesRetrieve<TData = Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCommissionRulesRetrieve<TData = Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCommissionRulesRetrieve<TData = Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCommissionRulesRetrieve<TData = Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCommissionRulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCommissionRulesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCommissionRulesPartialUpdateResponse200 = {
  data: Rule
  status: 200
}

export type adminCommissionRulesPartialUpdateResponseSuccess = (adminCommissionRulesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminCommissionRulesPartialUpdateResponse = (adminCommissionRulesPartialUpdateResponseSuccess)

export const getAdminCommissionRulesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/commission-rules/${uid}`
}

export const adminCommissionRulesPartialUpdate = async (uid: string,
    patchedRuleWriteRequest?: PatchedRuleWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCommissionRulesPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCommissionRulesPartialUpdateResponse>(getAdminCommissionRulesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedRuleWriteRequest)
  }
);}





export const getAdminCommissionRulesPartialUpdateMutationKey = () => ['adminCommissionRulesPartialUpdate'] as const;

export const getAdminCommissionRulesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCommissionRulesPartialUpdate>>, TError,AdminCommissionRulesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCommissionRulesPartialUpdate>>, TError,AdminCommissionRulesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCommissionRulesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCommissionRulesPartialUpdate>>, AdminCommissionRulesPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCommissionRulesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCommissionRulesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCommissionRulesPartialUpdate>>>
    export type AdminCommissionRulesPartialUpdateMutationBody = PatchedRuleWriteRequest | undefined
    export type AdminCommissionRulesPartialUpdateMutationError = unknown
    export type AdminCommissionRulesPartialUpdateMutationVariables = {uid: string;data?: PatchedRuleWriteRequest}

    export const useAdminCommissionRulesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCommissionRulesPartialUpdate>>, TError,AdminCommissionRulesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCommissionRulesPartialUpdate>>,
        TError,
        AdminCommissionRulesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCommissionRulesPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminCommissionRulesDestroyResponse204 = {
  data: void
  status: 204
}

export type adminCommissionRulesDestroyResponseSuccess = (adminCommissionRulesDestroyResponse204) & {
  headers: Headers;
};
;

export type adminCommissionRulesDestroyResponse = (adminCommissionRulesDestroyResponseSuccess)

export const getAdminCommissionRulesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/commission-rules/${uid}`
}

export const adminCommissionRulesDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCommissionRulesDestroyResponse> => {

  return apiFetch<adminCommissionRulesDestroyResponse>(getAdminCommissionRulesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminCommissionRulesDestroyMutationKey = () => ['adminCommissionRulesDestroy'] as const;

export const getAdminCommissionRulesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCommissionRulesDestroy>>, TError,AdminCommissionRulesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCommissionRulesDestroy>>, TError,AdminCommissionRulesDestroyMutationVariables, TContext> => {

const mutationKey = getAdminCommissionRulesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCommissionRulesDestroy>>, AdminCommissionRulesDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminCommissionRulesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCommissionRulesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminCommissionRulesDestroy>>>

    export type AdminCommissionRulesDestroyMutationError = unknown
    export type AdminCommissionRulesDestroyMutationVariables = {uid: string}

    export const useAdminCommissionRulesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCommissionRulesDestroy>>, TError,AdminCommissionRulesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCommissionRulesDestroy>>,
        TError,
        AdminCommissionRulesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCommissionRulesDestroyMutationOptions(options), queryClient);
    }
    export type adminCommissionRulesResolveCreateResponse200 = {
  data: Resolution
  status: 200
}

export type adminCommissionRulesResolveCreateResponseSuccess = (adminCommissionRulesResolveCreateResponse200) & {
  headers: Headers;
};
;

export type adminCommissionRulesResolveCreateResponse = (adminCommissionRulesResolveCreateResponseSuccess)

export const getAdminCommissionRulesResolveCreateUrl = () => {




  return `/api/v1/admin/commission-rules/resolve`
}

/**
 * "Which rule applies?" for an order line of a category, sold by a vendor, at a time.
 */
export const adminCommissionRulesResolveCreate = async (resolveRequestRequest?: ResolveRequestRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCommissionRulesResolveCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCommissionRulesResolveCreateResponse>(getAdminCommissionRulesResolveCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resolveRequestRequest)
  }
);}





export const getAdminCommissionRulesResolveCreateMutationKey = () => ['adminCommissionRulesResolveCreate'] as const;

export const getAdminCommissionRulesResolveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCommissionRulesResolveCreate>>, TError,AdminCommissionRulesResolveCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCommissionRulesResolveCreate>>, TError,AdminCommissionRulesResolveCreateMutationVariables, TContext> => {

const mutationKey = getAdminCommissionRulesResolveCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCommissionRulesResolveCreate>>, AdminCommissionRulesResolveCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminCommissionRulesResolveCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCommissionRulesResolveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCommissionRulesResolveCreate>>>
    export type AdminCommissionRulesResolveCreateMutationBody = ResolveRequestRequest | undefined
    export type AdminCommissionRulesResolveCreateMutationError = unknown
    export type AdminCommissionRulesResolveCreateMutationVariables = {data?: ResolveRequestRequest}

    export const useAdminCommissionRulesResolveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCommissionRulesResolveCreate>>, TError,AdminCommissionRulesResolveCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCommissionRulesResolveCreate>>,
        TError,
        AdminCommissionRulesResolveCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCommissionRulesResolveCreateMutationOptions(options), queryClient);
    }
    export type adminCouponsListResponse200 = {
  data: PaginatedCouponList
  status: 200
}

export type adminCouponsListResponseSuccess = (adminCouponsListResponse200) & {
  headers: Headers;
};
;

export type adminCouponsListResponse = (adminCouponsListResponseSuccess)

export const getAdminCouponsListUrl = (params?: AdminCouponsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/coupons?${stringifiedParams}` : `/api/v1/admin/coupons`
}

export const adminCouponsList = async (params?: AdminCouponsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminCouponsListResponse> => {

  return apiFetch<adminCouponsListResponse>(getAdminCouponsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCouponsListQueryKey = (params?: AdminCouponsListParams,) => {
    return [
    `/api/v1/admin/coupons`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminCouponsListQueryOptions = <TData = Awaited<ReturnType<typeof adminCouponsList>>, TError = unknown>(params?: AdminCouponsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCouponsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCouponsList>>> = ({ signal }) => adminCouponsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCouponsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCouponsList>>>
export type AdminCouponsListQueryError = unknown


export function useAdminCouponsList<TData = Awaited<ReturnType<typeof adminCouponsList>>, TError = unknown>(
 params: undefined |  AdminCouponsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouponsList>>,
          TError,
          Awaited<ReturnType<typeof adminCouponsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouponsList<TData = Awaited<ReturnType<typeof adminCouponsList>>, TError = unknown>(
 params?: AdminCouponsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouponsList>>,
          TError,
          Awaited<ReturnType<typeof adminCouponsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouponsList<TData = Awaited<ReturnType<typeof adminCouponsList>>, TError = unknown>(
 params?: AdminCouponsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCouponsList<TData = Awaited<ReturnType<typeof adminCouponsList>>, TError = unknown>(
 params?: AdminCouponsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCouponsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCouponsCreateResponse201 = {
  data: CouponDetail
  status: 201
}

export type adminCouponsCreateResponseSuccess = (adminCouponsCreateResponse201) & {
  headers: Headers;
};
;

export type adminCouponsCreateResponse = (adminCouponsCreateResponseSuccess)

export const getAdminCouponsCreateUrl = () => {




  return `/api/v1/admin/coupons`
}

export const adminCouponsCreate = async (couponWriteRequest: CouponWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCouponsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCouponsCreateResponse>(getAdminCouponsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(couponWriteRequest)
  }
);}





export const getAdminCouponsCreateMutationKey = () => ['adminCouponsCreate'] as const;

export const getAdminCouponsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsCreate>>, TError,AdminCouponsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCouponsCreate>>, TError,AdminCouponsCreateMutationVariables, TContext> => {

const mutationKey = getAdminCouponsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCouponsCreate>>, AdminCouponsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminCouponsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCouponsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCouponsCreate>>>
    export type AdminCouponsCreateMutationBody = CouponWriteRequest
    export type AdminCouponsCreateMutationError = unknown
    export type AdminCouponsCreateMutationVariables = {data: CouponWriteRequest}

    export const useAdminCouponsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsCreate>>, TError,AdminCouponsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCouponsCreate>>,
        TError,
        AdminCouponsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCouponsCreateMutationOptions(options), queryClient);
    }
    export type adminCouponsRetrieveResponse200 = {
  data: CouponDetail
  status: 200
}

export type adminCouponsRetrieveResponseSuccess = (adminCouponsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminCouponsRetrieveResponse = (adminCouponsRetrieveResponseSuccess)

export const getAdminCouponsRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/coupons/${uid}`
}

export const adminCouponsRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCouponsRetrieveResponse> => {

  return apiFetch<adminCouponsRetrieveResponse>(getAdminCouponsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCouponsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/coupons/${uid}`
    ] as const;
    }


export const getAdminCouponsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCouponsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCouponsRetrieve>>> = ({ signal }) => adminCouponsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCouponsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCouponsRetrieve>>>
export type AdminCouponsRetrieveQueryError = unknown


export function useAdminCouponsRetrieve<TData = Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouponsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCouponsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouponsRetrieve<TData = Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouponsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCouponsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouponsRetrieve<TData = Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCouponsRetrieve<TData = Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouponsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCouponsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCouponsPartialUpdateResponse200 = {
  data: CouponDetail
  status: 200
}

export type adminCouponsPartialUpdateResponseSuccess = (adminCouponsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminCouponsPartialUpdateResponse = (adminCouponsPartialUpdateResponseSuccess)

export const getAdminCouponsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/coupons/${uid}`
}

export const adminCouponsPartialUpdate = async (uid: string,
    patchedCouponWriteRequest?: PatchedCouponWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCouponsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCouponsPartialUpdateResponse>(getAdminCouponsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedCouponWriteRequest)
  }
);}





export const getAdminCouponsPartialUpdateMutationKey = () => ['adminCouponsPartialUpdate'] as const;

export const getAdminCouponsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsPartialUpdate>>, TError,AdminCouponsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCouponsPartialUpdate>>, TError,AdminCouponsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCouponsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCouponsPartialUpdate>>, AdminCouponsPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCouponsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCouponsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCouponsPartialUpdate>>>
    export type AdminCouponsPartialUpdateMutationBody = PatchedCouponWriteRequest | undefined
    export type AdminCouponsPartialUpdateMutationError = unknown
    export type AdminCouponsPartialUpdateMutationVariables = {uid: string;data?: PatchedCouponWriteRequest}

    export const useAdminCouponsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsPartialUpdate>>, TError,AdminCouponsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCouponsPartialUpdate>>,
        TError,
        AdminCouponsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCouponsPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminCouponsDestroyResponse204 = {
  data: void
  status: 204
}

export type adminCouponsDestroyResponseSuccess = (adminCouponsDestroyResponse204) & {
  headers: Headers;
};
;

export type adminCouponsDestroyResponse = (adminCouponsDestroyResponseSuccess)

export const getAdminCouponsDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/coupons/${uid}`
}

export const adminCouponsDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCouponsDestroyResponse> => {

  return apiFetch<adminCouponsDestroyResponse>(getAdminCouponsDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminCouponsDestroyMutationKey = () => ['adminCouponsDestroy'] as const;

export const getAdminCouponsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsDestroy>>, TError,AdminCouponsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCouponsDestroy>>, TError,AdminCouponsDestroyMutationVariables, TContext> => {

const mutationKey = getAdminCouponsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCouponsDestroy>>, AdminCouponsDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminCouponsDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCouponsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminCouponsDestroy>>>

    export type AdminCouponsDestroyMutationError = unknown
    export type AdminCouponsDestroyMutationVariables = {uid: string}

    export const useAdminCouponsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsDestroy>>, TError,AdminCouponsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCouponsDestroy>>,
        TError,
        AdminCouponsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCouponsDestroyMutationOptions(options), queryClient);
    }
    export type adminCouponsPauseResponse200 = {
  data: CouponDetail
  status: 200
}

export type adminCouponsPauseResponseSuccess = (adminCouponsPauseResponse200) & {
  headers: Headers;
};
;

export type adminCouponsPauseResponse = (adminCouponsPauseResponseSuccess)

export const getAdminCouponsPauseUrl = (uid: string,) => {




  return `/api/v1/admin/coupons/${uid}/pause`
}

export const adminCouponsPause = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCouponsPauseResponse> => {

  return apiFetch<adminCouponsPauseResponse>(getAdminCouponsPauseUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminCouponsPauseMutationKey = () => ['adminCouponsPause'] as const;

export const getAdminCouponsPauseMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsPause>>, TError,AdminCouponsPauseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCouponsPause>>, TError,AdminCouponsPauseMutationVariables, TContext> => {

const mutationKey = getAdminCouponsPauseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCouponsPause>>, AdminCouponsPauseMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminCouponsPause(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCouponsPauseMutationResult = NonNullable<Awaited<ReturnType<typeof adminCouponsPause>>>

    export type AdminCouponsPauseMutationError = unknown
    export type AdminCouponsPauseMutationVariables = {uid: string}

    export const useAdminCouponsPause = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsPause>>, TError,AdminCouponsPauseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCouponsPause>>,
        TError,
        AdminCouponsPauseMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCouponsPauseMutationOptions(options), queryClient);
    }
    export type adminCouponsResumeResponse200 = {
  data: CouponDetail
  status: 200
}

export type adminCouponsResumeResponseSuccess = (adminCouponsResumeResponse200) & {
  headers: Headers;
};
;

export type adminCouponsResumeResponse = (adminCouponsResumeResponseSuccess)

export const getAdminCouponsResumeUrl = (uid: string,) => {




  return `/api/v1/admin/coupons/${uid}/resume`
}

export const adminCouponsResume = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCouponsResumeResponse> => {

  return apiFetch<adminCouponsResumeResponse>(getAdminCouponsResumeUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminCouponsResumeMutationKey = () => ['adminCouponsResume'] as const;

export const getAdminCouponsResumeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsResume>>, TError,AdminCouponsResumeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCouponsResume>>, TError,AdminCouponsResumeMutationVariables, TContext> => {

const mutationKey = getAdminCouponsResumeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCouponsResume>>, AdminCouponsResumeMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminCouponsResume(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCouponsResumeMutationResult = NonNullable<Awaited<ReturnType<typeof adminCouponsResume>>>

    export type AdminCouponsResumeMutationError = unknown
    export type AdminCouponsResumeMutationVariables = {uid: string}

    export const useAdminCouponsResume = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouponsResume>>, TError,AdminCouponsResumeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCouponsResume>>,
        TError,
        AdminCouponsResumeMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCouponsResumeMutationOptions(options), queryClient);
    }
    export type adminCouriersListResponse200 = {
  data: Courier[]
  status: 200
}

export type adminCouriersListResponseSuccess = (adminCouriersListResponse200) & {
  headers: Headers;
};
;

export type adminCouriersListResponse = (adminCouriersListResponseSuccess)

export const getAdminCouriersListUrl = (params?: AdminCouriersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/couriers?${stringifiedParams}` : `/api/v1/admin/couriers`
}

export const adminCouriersList = async (params?: AdminCouriersListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminCouriersListResponse> => {

  return apiFetch<adminCouriersListResponse>(getAdminCouriersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCouriersListQueryKey = (params?: AdminCouriersListParams,) => {
    return [
    `/api/v1/admin/couriers`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminCouriersListQueryOptions = <TData = Awaited<ReturnType<typeof adminCouriersList>>, TError = unknown>(params?: AdminCouriersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCouriersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCouriersList>>> = ({ signal }) => adminCouriersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCouriersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCouriersListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCouriersList>>>
export type AdminCouriersListQueryError = unknown


export function useAdminCouriersList<TData = Awaited<ReturnType<typeof adminCouriersList>>, TError = unknown>(
 params: undefined |  AdminCouriersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouriersList>>,
          TError,
          Awaited<ReturnType<typeof adminCouriersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouriersList<TData = Awaited<ReturnType<typeof adminCouriersList>>, TError = unknown>(
 params?: AdminCouriersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouriersList>>,
          TError,
          Awaited<ReturnType<typeof adminCouriersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouriersList<TData = Awaited<ReturnType<typeof adminCouriersList>>, TError = unknown>(
 params?: AdminCouriersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCouriersList<TData = Awaited<ReturnType<typeof adminCouriersList>>, TError = unknown>(
 params?: AdminCouriersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCouriersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCouriersCreateResponse201 = {
  data: Courier
  status: 201
}

export type adminCouriersCreateResponseSuccess = (adminCouriersCreateResponse201) & {
  headers: Headers;
};
;

export type adminCouriersCreateResponse = (adminCouriersCreateResponseSuccess)

export const getAdminCouriersCreateUrl = () => {




  return `/api/v1/admin/couriers`
}

export const adminCouriersCreate = async (courierWriteRequest: CourierWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCouriersCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCouriersCreateResponse>(getAdminCouriersCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(courierWriteRequest)
  }
);}





export const getAdminCouriersCreateMutationKey = () => ['adminCouriersCreate'] as const;

export const getAdminCouriersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouriersCreate>>, TError,AdminCouriersCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCouriersCreate>>, TError,AdminCouriersCreateMutationVariables, TContext> => {

const mutationKey = getAdminCouriersCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCouriersCreate>>, AdminCouriersCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminCouriersCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCouriersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCouriersCreate>>>
    export type AdminCouriersCreateMutationBody = CourierWriteRequest
    export type AdminCouriersCreateMutationError = unknown
    export type AdminCouriersCreateMutationVariables = {data: CourierWriteRequest}

    export const useAdminCouriersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouriersCreate>>, TError,AdminCouriersCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCouriersCreate>>,
        TError,
        AdminCouriersCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCouriersCreateMutationOptions(options), queryClient);
    }
    export type adminCouriersRetrieveResponse200 = {
  data: Courier
  status: 200
}

export type adminCouriersRetrieveResponseSuccess = (adminCouriersRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminCouriersRetrieveResponse = (adminCouriersRetrieveResponseSuccess)

export const getAdminCouriersRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/couriers/${uid}`
}

export const adminCouriersRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCouriersRetrieveResponse> => {

  return apiFetch<adminCouriersRetrieveResponse>(getAdminCouriersRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCouriersRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/couriers/${uid}`
    ] as const;
    }


export const getAdminCouriersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCouriersRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCouriersRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCouriersRetrieve>>> = ({ signal }) => adminCouriersRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCouriersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCouriersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCouriersRetrieve>>>
export type AdminCouriersRetrieveQueryError = unknown


export function useAdminCouriersRetrieve<TData = Awaited<ReturnType<typeof adminCouriersRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouriersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCouriersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouriersRetrieve<TData = Awaited<ReturnType<typeof adminCouriersRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouriersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCouriersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouriersRetrieve<TData = Awaited<ReturnType<typeof adminCouriersRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCouriersRetrieve<TData = Awaited<ReturnType<typeof adminCouriersRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCouriersRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCouriersPartialUpdateResponse200 = {
  data: Courier
  status: 200
}

export type adminCouriersPartialUpdateResponseSuccess = (adminCouriersPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminCouriersPartialUpdateResponse = (adminCouriersPartialUpdateResponseSuccess)

export const getAdminCouriersPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/couriers/${uid}`
}

export const adminCouriersPartialUpdate = async (uid: string,
    patchedCourierWriteRequest?: PatchedCourierWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCouriersPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCouriersPartialUpdateResponse>(getAdminCouriersPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedCourierWriteRequest)
  }
);}





export const getAdminCouriersPartialUpdateMutationKey = () => ['adminCouriersPartialUpdate'] as const;

export const getAdminCouriersPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouriersPartialUpdate>>, TError,AdminCouriersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCouriersPartialUpdate>>, TError,AdminCouriersPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCouriersPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCouriersPartialUpdate>>, AdminCouriersPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCouriersPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCouriersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCouriersPartialUpdate>>>
    export type AdminCouriersPartialUpdateMutationBody = PatchedCourierWriteRequest | undefined
    export type AdminCouriersPartialUpdateMutationError = unknown
    export type AdminCouriersPartialUpdateMutationVariables = {uid: string;data?: PatchedCourierWriteRequest}

    export const useAdminCouriersPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouriersPartialUpdate>>, TError,AdminCouriersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCouriersPartialUpdate>>,
        TError,
        AdminCouriersPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCouriersPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminCouriersDestroyResponse204 = {
  data: void
  status: 204
}

export type adminCouriersDestroyResponseSuccess = (adminCouriersDestroyResponse204) & {
  headers: Headers;
};
;

export type adminCouriersDestroyResponse = (adminCouriersDestroyResponseSuccess)

export const getAdminCouriersDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/couriers/${uid}`
}

export const adminCouriersDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCouriersDestroyResponse> => {

  return apiFetch<adminCouriersDestroyResponse>(getAdminCouriersDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminCouriersDestroyMutationKey = () => ['adminCouriersDestroy'] as const;

export const getAdminCouriersDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouriersDestroy>>, TError,AdminCouriersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCouriersDestroy>>, TError,AdminCouriersDestroyMutationVariables, TContext> => {

const mutationKey = getAdminCouriersDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCouriersDestroy>>, AdminCouriersDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminCouriersDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCouriersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminCouriersDestroy>>>

    export type AdminCouriersDestroyMutationError = unknown
    export type AdminCouriersDestroyMutationVariables = {uid: string}

    export const useAdminCouriersDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCouriersDestroy>>, TError,AdminCouriersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCouriersDestroy>>,
        TError,
        AdminCouriersDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCouriersDestroyMutationOptions(options), queryClient);
    }
    export type adminCouriersTrackingUrlRetrieveResponse200 = {
  data: TrackingUrl
  status: 200
}

export type adminCouriersTrackingUrlRetrieveResponseSuccess = (adminCouriersTrackingUrlRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminCouriersTrackingUrlRetrieveResponse = (adminCouriersTrackingUrlRetrieveResponseSuccess)

export const getAdminCouriersTrackingUrlRetrieveUrl = (uid: string,
    params: AdminCouriersTrackingUrlRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/couriers/${uid}/tracking-url?${stringifiedParams}` : `/api/v1/admin/couriers/${uid}/tracking-url`
}

/**
 * The tracking link for a number (the admin's "test link").
 */
export const adminCouriersTrackingUrlRetrieve = async (uid: string,
    params: AdminCouriersTrackingUrlRetrieveParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminCouriersTrackingUrlRetrieveResponse> => {

  return apiFetch<adminCouriersTrackingUrlRetrieveResponse>(getAdminCouriersTrackingUrlRetrieveUrl(uid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCouriersTrackingUrlRetrieveQueryKey = (uid: string,
    params?: AdminCouriersTrackingUrlRetrieveParams,) => {
    return [
    `/api/v1/admin/couriers/${uid}/tracking-url`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminCouriersTrackingUrlRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>, TError = unknown>(uid: string,
    params: AdminCouriersTrackingUrlRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCouriersTrackingUrlRetrieveQueryKey(uid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>> = ({ signal }) => adminCouriersTrackingUrlRetrieve(uid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCouriersTrackingUrlRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>>
export type AdminCouriersTrackingUrlRetrieveQueryError = unknown


export function useAdminCouriersTrackingUrlRetrieve<TData = Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>, TError = unknown>(
 uid: string,
    params: AdminCouriersTrackingUrlRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouriersTrackingUrlRetrieve<TData = Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>, TError = unknown>(
 uid: string,
    params: AdminCouriersTrackingUrlRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCouriersTrackingUrlRetrieve<TData = Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>, TError = unknown>(
 uid: string,
    params: AdminCouriersTrackingUrlRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCouriersTrackingUrlRetrieve<TData = Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>, TError = unknown>(
 uid: string,
    params: AdminCouriersTrackingUrlRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCouriersTrackingUrlRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCouriersTrackingUrlRetrieveQueryOptions(uid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCustomersListResponse200 = {
  data: PaginatedCustomerList
  status: 200
}

export type adminCustomersListResponseSuccess = (adminCustomersListResponse200) & {
  headers: Headers;
};
;

export type adminCustomersListResponse = (adminCustomersListResponseSuccess)

export const getAdminCustomersListUrl = (params?: AdminCustomersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/customers?${stringifiedParams}` : `/api/v1/admin/customers`
}

export const adminCustomersList = async (params?: AdminCustomersListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminCustomersListResponse> => {

  return apiFetch<adminCustomersListResponse>(getAdminCustomersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCustomersListQueryKey = (params?: AdminCustomersListParams,) => {
    return [
    `/api/v1/admin/customers`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminCustomersListQueryOptions = <TData = Awaited<ReturnType<typeof adminCustomersList>>, TError = unknown>(params?: AdminCustomersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCustomersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCustomersList>>> = ({ signal }) => adminCustomersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCustomersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCustomersListQueryResult = NonNullable<Awaited<ReturnType<typeof adminCustomersList>>>
export type AdminCustomersListQueryError = unknown


export function useAdminCustomersList<TData = Awaited<ReturnType<typeof adminCustomersList>>, TError = unknown>(
 params: undefined |  AdminCustomersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCustomersList>>,
          TError,
          Awaited<ReturnType<typeof adminCustomersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCustomersList<TData = Awaited<ReturnType<typeof adminCustomersList>>, TError = unknown>(
 params?: AdminCustomersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCustomersList>>,
          TError,
          Awaited<ReturnType<typeof adminCustomersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCustomersList<TData = Awaited<ReturnType<typeof adminCustomersList>>, TError = unknown>(
 params?: AdminCustomersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCustomersList<TData = Awaited<ReturnType<typeof adminCustomersList>>, TError = unknown>(
 params?: AdminCustomersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCustomersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCustomersRetrieveResponse200 = {
  data: CustomerDetail
  status: 200
}

export type adminCustomersRetrieveResponseSuccess = (adminCustomersRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminCustomersRetrieveResponse = (adminCustomersRetrieveResponseSuccess)

export const getAdminCustomersRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/customers/${uid}`
}

export const adminCustomersRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCustomersRetrieveResponse> => {

  return apiFetch<adminCustomersRetrieveResponse>(getAdminCustomersRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCustomersRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/customers/${uid}`
    ] as const;
    }


export const getAdminCustomersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminCustomersRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCustomersRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCustomersRetrieve>>> = ({ signal }) => adminCustomersRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCustomersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCustomersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminCustomersRetrieve>>>
export type AdminCustomersRetrieveQueryError = unknown


export function useAdminCustomersRetrieve<TData = Awaited<ReturnType<typeof adminCustomersRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCustomersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCustomersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCustomersRetrieve<TData = Awaited<ReturnType<typeof adminCustomersRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCustomersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminCustomersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCustomersRetrieve<TData = Awaited<ReturnType<typeof adminCustomersRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCustomersRetrieve<TData = Awaited<ReturnType<typeof adminCustomersRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCustomersRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCustomersPartialUpdateResponse200 = {
  data: CustomerDetail
  status: 200
}

export type adminCustomersPartialUpdateResponseSuccess = (adminCustomersPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminCustomersPartialUpdateResponse = (adminCustomersPartialUpdateResponseSuccess)

export const getAdminCustomersPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/customers/${uid}`
}

export const adminCustomersPartialUpdate = async (uid: string,
    patchedCustomerUpdateRequest?: PatchedCustomerUpdateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCustomersPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCustomersPartialUpdateResponse>(getAdminCustomersPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedCustomerUpdateRequest)
  }
);}





export const getAdminCustomersPartialUpdateMutationKey = () => ['adminCustomersPartialUpdate'] as const;

export const getAdminCustomersPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCustomersPartialUpdate>>, TError,AdminCustomersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCustomersPartialUpdate>>, TError,AdminCustomersPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminCustomersPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCustomersPartialUpdate>>, AdminCustomersPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCustomersPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCustomersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCustomersPartialUpdate>>>
    export type AdminCustomersPartialUpdateMutationBody = PatchedCustomerUpdateRequest | undefined
    export type AdminCustomersPartialUpdateMutationError = unknown
    export type AdminCustomersPartialUpdateMutationVariables = {uid: string;data?: PatchedCustomerUpdateRequest}

    export const useAdminCustomersPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCustomersPartialUpdate>>, TError,AdminCustomersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCustomersPartialUpdate>>,
        TError,
        AdminCustomersPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCustomersPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminCustomersBlockResponse200 = {
  data: CustomerDetail
  status: 200
}

export type adminCustomersBlockResponseSuccess = (adminCustomersBlockResponse200) & {
  headers: Headers;
};
;

export type adminCustomersBlockResponse = (adminCustomersBlockResponseSuccess)

export const getAdminCustomersBlockUrl = (uid: string,) => {




  return `/api/v1/admin/customers/${uid}/block`
}

export const adminCustomersBlock = async (uid: string,
    blockRequest: BlockRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCustomersBlockResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCustomersBlockResponse>(getAdminCustomersBlockUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(blockRequest)
  }
);}





export const getAdminCustomersBlockMutationKey = () => ['adminCustomersBlock'] as const;

export const getAdminCustomersBlockMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCustomersBlock>>, TError,AdminCustomersBlockMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCustomersBlock>>, TError,AdminCustomersBlockMutationVariables, TContext> => {

const mutationKey = getAdminCustomersBlockMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCustomersBlock>>, AdminCustomersBlockMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCustomersBlock(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCustomersBlockMutationResult = NonNullable<Awaited<ReturnType<typeof adminCustomersBlock>>>
    export type AdminCustomersBlockMutationBody = BlockRequest
    export type AdminCustomersBlockMutationError = unknown
    export type AdminCustomersBlockMutationVariables = {uid: string;data: BlockRequest}

    export const useAdminCustomersBlock = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCustomersBlock>>, TError,AdminCustomersBlockMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCustomersBlock>>,
        TError,
        AdminCustomersBlockMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCustomersBlockMutationOptions(options), queryClient);
    }
    export type adminCustomersUnblockResponse200 = {
  data: CustomerDetail
  status: 200
}

export type adminCustomersUnblockResponseSuccess = (adminCustomersUnblockResponse200) & {
  headers: Headers;
};
;

export type adminCustomersUnblockResponse = (adminCustomersUnblockResponseSuccess)

export const getAdminCustomersUnblockUrl = (uid: string,) => {




  return `/api/v1/admin/customers/${uid}/unblock`
}

export const adminCustomersUnblock = async (uid: string,
    unblockRequest?: UnblockRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminCustomersUnblockResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminCustomersUnblockResponse>(getAdminCustomersUnblockUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(unblockRequest)
  }
);}





export const getAdminCustomersUnblockMutationKey = () => ['adminCustomersUnblock'] as const;

export const getAdminCustomersUnblockMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCustomersUnblock>>, TError,AdminCustomersUnblockMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCustomersUnblock>>, TError,AdminCustomersUnblockMutationVariables, TContext> => {

const mutationKey = getAdminCustomersUnblockMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCustomersUnblock>>, AdminCustomersUnblockMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminCustomersUnblock(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminCustomersUnblockMutationResult = NonNullable<Awaited<ReturnType<typeof adminCustomersUnblock>>>
    export type AdminCustomersUnblockMutationBody = UnblockRequest | undefined
    export type AdminCustomersUnblockMutationError = unknown
    export type AdminCustomersUnblockMutationVariables = {uid: string;data?: UnblockRequest}

    export const useAdminCustomersUnblock = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCustomersUnblock>>, TError,AdminCustomersUnblockMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCustomersUnblock>>,
        TError,
        AdminCustomersUnblockMutationVariables,
        TContext
      > => {
      return useMutation(getAdminCustomersUnblockMutationOptions(options), queryClient);
    }
    export type adminCustomersVehiclesResponse200 = {
  data: SavedVehicle[]
  status: 200
}

export type adminCustomersVehiclesResponseSuccess = (adminCustomersVehiclesResponse200) & {
  headers: Headers;
};
;

export type adminCustomersVehiclesResponse = (adminCustomersVehiclesResponseSuccess)

export const getAdminCustomersVehiclesUrl = (uid: string,) => {




  return `/api/v1/admin/customers/${uid}/vehicles`
}

/**
 * The customer page's "My car" tab in the admin.
 */
export const adminCustomersVehicles = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCustomersVehiclesResponse> => {

  return apiFetch<adminCustomersVehiclesResponse>(getAdminCustomersVehiclesUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCustomersVehiclesQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/customers/${uid}/vehicles`
    ] as const;
    }


export const getAdminCustomersVehiclesQueryOptions = <TData = Awaited<ReturnType<typeof adminCustomersVehicles>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersVehicles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCustomersVehiclesQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCustomersVehicles>>> = ({ signal }) => adminCustomersVehicles(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCustomersVehicles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCustomersVehiclesQueryResult = NonNullable<Awaited<ReturnType<typeof adminCustomersVehicles>>>
export type AdminCustomersVehiclesQueryError = unknown


export function useAdminCustomersVehicles<TData = Awaited<ReturnType<typeof adminCustomersVehicles>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersVehicles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCustomersVehicles>>,
          TError,
          Awaited<ReturnType<typeof adminCustomersVehicles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCustomersVehicles<TData = Awaited<ReturnType<typeof adminCustomersVehicles>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersVehicles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCustomersVehicles>>,
          TError,
          Awaited<ReturnType<typeof adminCustomersVehicles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCustomersVehicles<TData = Awaited<ReturnType<typeof adminCustomersVehicles>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersVehicles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCustomersVehicles<TData = Awaited<ReturnType<typeof adminCustomersVehicles>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersVehicles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCustomersVehiclesQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminCustomersWishlistResponse200 = {
  data: WishlistItem[]
  status: 200
}

export type adminCustomersWishlistResponseSuccess = (adminCustomersWishlistResponse200) & {
  headers: Headers;
};
;

export type adminCustomersWishlistResponse = (adminCustomersWishlistResponseSuccess)

export const getAdminCustomersWishlistUrl = (uid: string,) => {




  return `/api/v1/admin/customers/${uid}/wishlist`
}

export const adminCustomersWishlist = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminCustomersWishlistResponse> => {

  return apiFetch<adminCustomersWishlistResponse>(getAdminCustomersWishlistUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCustomersWishlistQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/customers/${uid}/wishlist`
    ] as const;
    }


export const getAdminCustomersWishlistQueryOptions = <TData = Awaited<ReturnType<typeof adminCustomersWishlist>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersWishlist>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCustomersWishlistQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCustomersWishlist>>> = ({ signal }) => adminCustomersWishlist(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCustomersWishlist>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCustomersWishlistQueryResult = NonNullable<Awaited<ReturnType<typeof adminCustomersWishlist>>>
export type AdminCustomersWishlistQueryError = unknown


export function useAdminCustomersWishlist<TData = Awaited<ReturnType<typeof adminCustomersWishlist>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersWishlist>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCustomersWishlist>>,
          TError,
          Awaited<ReturnType<typeof adminCustomersWishlist>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCustomersWishlist<TData = Awaited<ReturnType<typeof adminCustomersWishlist>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersWishlist>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCustomersWishlist>>,
          TError,
          Awaited<ReturnType<typeof adminCustomersWishlist>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCustomersWishlist<TData = Awaited<ReturnType<typeof adminCustomersWishlist>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersWishlist>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminCustomersWishlist<TData = Awaited<ReturnType<typeof adminCustomersWishlist>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCustomersWishlist>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCustomersWishlistQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminFeatureFlagsListResponse200 = {
  data: Flag[]
  status: 200
}

export type adminFeatureFlagsListResponseSuccess = (adminFeatureFlagsListResponse200) & {
  headers: Headers;
};
;

export type adminFeatureFlagsListResponse = (adminFeatureFlagsListResponseSuccess)

export const getAdminFeatureFlagsListUrl = () => {




  return `/api/v1/admin/feature-flags`
}

/**
 * Every flag of the installed modules, grouped by `group`, with its current value.
 */
export const adminFeatureFlagsList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminFeatureFlagsListResponse> => {

  return apiFetch<adminFeatureFlagsListResponse>(getAdminFeatureFlagsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminFeatureFlagsListQueryKey = () => {
    return [
    `/api/v1/admin/feature-flags`
    ] as const;
    }


export const getAdminFeatureFlagsListQueryOptions = <TData = Awaited<ReturnType<typeof adminFeatureFlagsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatureFlagsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminFeatureFlagsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminFeatureFlagsList>>> = ({ signal }) => adminFeatureFlagsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminFeatureFlagsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminFeatureFlagsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminFeatureFlagsList>>>
export type AdminFeatureFlagsListQueryError = unknown


export function useAdminFeatureFlagsList<TData = Awaited<ReturnType<typeof adminFeatureFlagsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatureFlagsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminFeatureFlagsList>>,
          TError,
          Awaited<ReturnType<typeof adminFeatureFlagsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminFeatureFlagsList<TData = Awaited<ReturnType<typeof adminFeatureFlagsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatureFlagsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminFeatureFlagsList>>,
          TError,
          Awaited<ReturnType<typeof adminFeatureFlagsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminFeatureFlagsList<TData = Awaited<ReturnType<typeof adminFeatureFlagsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatureFlagsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminFeatureFlagsList<TData = Awaited<ReturnType<typeof adminFeatureFlagsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatureFlagsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminFeatureFlagsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminFeatureFlagsUpdateResponse200 = {
  data: Flag
  status: 200
}

export type adminFeatureFlagsUpdateResponseSuccess = (adminFeatureFlagsUpdateResponse200) & {
  headers: Headers;
};
;

export type adminFeatureFlagsUpdateResponse = (adminFeatureFlagsUpdateResponseSuccess)

export const getAdminFeatureFlagsUpdateUrl = (key: string,) => {




  return `/api/v1/admin/feature-flags/${key}`
}

export const adminFeatureFlagsUpdate = async (key: string,
    patchedFlagUpdateRequest?: PatchedFlagUpdateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminFeatureFlagsUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminFeatureFlagsUpdateResponse>(getAdminFeatureFlagsUpdateUrl(key),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedFlagUpdateRequest)
  }
);}





export const getAdminFeatureFlagsUpdateMutationKey = () => ['adminFeatureFlagsUpdate'] as const;

export const getAdminFeatureFlagsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFeatureFlagsUpdate>>, TError,AdminFeatureFlagsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminFeatureFlagsUpdate>>, TError,AdminFeatureFlagsUpdateMutationVariables, TContext> => {

const mutationKey = getAdminFeatureFlagsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminFeatureFlagsUpdate>>, AdminFeatureFlagsUpdateMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  adminFeatureFlagsUpdate(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminFeatureFlagsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminFeatureFlagsUpdate>>>
    export type AdminFeatureFlagsUpdateMutationBody = PatchedFlagUpdateRequest | undefined
    export type AdminFeatureFlagsUpdateMutationError = unknown
    export type AdminFeatureFlagsUpdateMutationVariables = {key: string;data?: PatchedFlagUpdateRequest}

    export const useAdminFeatureFlagsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFeatureFlagsUpdate>>, TError,AdminFeatureFlagsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminFeatureFlagsUpdate>>,
        TError,
        AdminFeatureFlagsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminFeatureFlagsUpdateMutationOptions(options), queryClient);
    }
    export type adminFeatureFlagOverridesSetResponse200 = {
  data: Override
  status: 200
}

export type adminFeatureFlagOverridesSetResponseSuccess = (adminFeatureFlagOverridesSetResponse200) & {
  headers: Headers;
};
;

export type adminFeatureFlagOverridesSetResponse = (adminFeatureFlagOverridesSetResponseSuccess)

export const getAdminFeatureFlagOverridesSetUrl = (key: string,
    vendorUid: string,) => {




  return `/api/v1/admin/feature-flags/${key}/overrides/${vendorUid}`
}

export const adminFeatureFlagOverridesSet = async (key: string,
    vendorUid: string,
    overrideWriteRequest: OverrideWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminFeatureFlagOverridesSetResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminFeatureFlagOverridesSetResponse>(getAdminFeatureFlagOverridesSetUrl(key,vendorUid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(overrideWriteRequest)
  }
);}





export const getAdminFeatureFlagOverridesSetMutationKey = () => ['adminFeatureFlagOverridesSet'] as const;

export const getAdminFeatureFlagOverridesSetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFeatureFlagOverridesSet>>, TError,AdminFeatureFlagOverridesSetMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminFeatureFlagOverridesSet>>, TError,AdminFeatureFlagOverridesSetMutationVariables, TContext> => {

const mutationKey = getAdminFeatureFlagOverridesSetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminFeatureFlagOverridesSet>>, AdminFeatureFlagOverridesSetMutationVariables> = (props) => {
          const {key,vendorUid,data} = props ?? {};

          return  adminFeatureFlagOverridesSet(key,vendorUid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminFeatureFlagOverridesSetMutationResult = NonNullable<Awaited<ReturnType<typeof adminFeatureFlagOverridesSet>>>
    export type AdminFeatureFlagOverridesSetMutationBody = OverrideWriteRequest
    export type AdminFeatureFlagOverridesSetMutationError = unknown
    export type AdminFeatureFlagOverridesSetMutationVariables = {key: string;vendorUid: string;data: OverrideWriteRequest}

    export const useAdminFeatureFlagOverridesSet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFeatureFlagOverridesSet>>, TError,AdminFeatureFlagOverridesSetMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminFeatureFlagOverridesSet>>,
        TError,
        AdminFeatureFlagOverridesSetMutationVariables,
        TContext
      > => {
      return useMutation(getAdminFeatureFlagOverridesSetMutationOptions(options), queryClient);
    }
    export type adminFeatureFlagOverridesClearResponse204 = {
  data: void
  status: 204
}

export type adminFeatureFlagOverridesClearResponseSuccess = (adminFeatureFlagOverridesClearResponse204) & {
  headers: Headers;
};
;

export type adminFeatureFlagOverridesClearResponse = (adminFeatureFlagOverridesClearResponseSuccess)

export const getAdminFeatureFlagOverridesClearUrl = (key: string,
    vendorUid: string,) => {




  return `/api/v1/admin/feature-flags/${key}/overrides/${vendorUid}`
}

export const adminFeatureFlagOverridesClear = async (key: string,
    vendorUid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminFeatureFlagOverridesClearResponse> => {

  return apiFetch<adminFeatureFlagOverridesClearResponse>(getAdminFeatureFlagOverridesClearUrl(key,vendorUid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminFeatureFlagOverridesClearMutationKey = () => ['adminFeatureFlagOverridesClear'] as const;

export const getAdminFeatureFlagOverridesClearMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFeatureFlagOverridesClear>>, TError,AdminFeatureFlagOverridesClearMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminFeatureFlagOverridesClear>>, TError,AdminFeatureFlagOverridesClearMutationVariables, TContext> => {

const mutationKey = getAdminFeatureFlagOverridesClearMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminFeatureFlagOverridesClear>>, AdminFeatureFlagOverridesClearMutationVariables> = (props) => {
          const {key,vendorUid} = props ?? {};

          return  adminFeatureFlagOverridesClear(key,vendorUid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminFeatureFlagOverridesClearMutationResult = NonNullable<Awaited<ReturnType<typeof adminFeatureFlagOverridesClear>>>

    export type AdminFeatureFlagOverridesClearMutationError = unknown
    export type AdminFeatureFlagOverridesClearMutationVariables = {key: string;vendorUid: string}

    export const useAdminFeatureFlagOverridesClear = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFeatureFlagOverridesClear>>, TError,AdminFeatureFlagOverridesClearMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminFeatureFlagOverridesClear>>,
        TError,
        AdminFeatureFlagOverridesClearMutationVariables,
        TContext
      > => {
      return useMutation(getAdminFeatureFlagOverridesClearMutationOptions(options), queryClient);
    }
    export type adminFeatureFlagOverridesListResponse200 = {
  data: Override[]
  status: 200
}

export type adminFeatureFlagOverridesListResponseSuccess = (adminFeatureFlagOverridesListResponse200) & {
  headers: Headers;
};
;

export type adminFeatureFlagOverridesListResponse = (adminFeatureFlagOverridesListResponseSuccess)

export const getAdminFeatureFlagOverridesListUrl = (params: AdminFeatureFlagOverridesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/feature-flags/overrides?${stringifiedParams}` : `/api/v1/admin/feature-flags/overrides`
}

/**
 * A vendor's own values (`?vendor=<uid>`). Flags without an override use the platform value.
 */
export const adminFeatureFlagOverridesList = async (params: AdminFeatureFlagOverridesListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminFeatureFlagOverridesListResponse> => {

  return apiFetch<adminFeatureFlagOverridesListResponse>(getAdminFeatureFlagOverridesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminFeatureFlagOverridesListQueryKey = (params?: AdminFeatureFlagOverridesListParams,) => {
    return [
    `/api/v1/admin/feature-flags/overrides`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminFeatureFlagOverridesListQueryOptions = <TData = Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>, TError = unknown>(params: AdminFeatureFlagOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminFeatureFlagOverridesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>> = ({ signal }) => adminFeatureFlagOverridesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminFeatureFlagOverridesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>>
export type AdminFeatureFlagOverridesListQueryError = unknown


export function useAdminFeatureFlagOverridesList<TData = Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>, TError = unknown>(
 params: AdminFeatureFlagOverridesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>,
          TError,
          Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminFeatureFlagOverridesList<TData = Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>, TError = unknown>(
 params: AdminFeatureFlagOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>,
          TError,
          Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminFeatureFlagOverridesList<TData = Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>, TError = unknown>(
 params: AdminFeatureFlagOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminFeatureFlagOverridesList<TData = Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>, TError = unknown>(
 params: AdminFeatureFlagOverridesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeatureFlagOverridesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminFeatureFlagOverridesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminFeaturesRetrieveResponse200 = {
  data: AdminFeaturesRetrieve200
  status: 200
}

export type adminFeaturesRetrieveResponseSuccess = (adminFeaturesRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminFeaturesRetrieveResponse = (adminFeaturesRetrieveResponseSuccess)

export const getAdminFeaturesRetrieveUrl = () => {




  return `/api/v1/admin/features`
}

/**
 * All flags' effective values (no 2FA gate: the panel needs them to render the setup screen).
 */
export const adminFeaturesRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminFeaturesRetrieveResponse> => {

  return apiFetch<adminFeaturesRetrieveResponse>(getAdminFeaturesRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminFeaturesRetrieveQueryKey = () => {
    return [
    `/api/v1/admin/features`
    ] as const;
    }


export const getAdminFeaturesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminFeaturesRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeaturesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminFeaturesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminFeaturesRetrieve>>> = ({ signal }) => adminFeaturesRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminFeaturesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminFeaturesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminFeaturesRetrieve>>>
export type AdminFeaturesRetrieveQueryError = unknown


export function useAdminFeaturesRetrieve<TData = Awaited<ReturnType<typeof adminFeaturesRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeaturesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminFeaturesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminFeaturesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminFeaturesRetrieve<TData = Awaited<ReturnType<typeof adminFeaturesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeaturesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminFeaturesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminFeaturesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminFeaturesRetrieve<TData = Awaited<ReturnType<typeof adminFeaturesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeaturesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminFeaturesRetrieve<TData = Awaited<ReturnType<typeof adminFeaturesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFeaturesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminFeaturesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminInvoicesListResponse200 = {
  data: PaginatedInvoiceList
  status: 200
}

export type adminInvoicesListResponseSuccess = (adminInvoicesListResponse200) & {
  headers: Headers;
};
;

export type adminInvoicesListResponse = (adminInvoicesListResponseSuccess)

export const getAdminInvoicesListUrl = (params?: AdminInvoicesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/invoices?${stringifiedParams}` : `/api/v1/admin/invoices`
}

export const adminInvoicesList = async (params?: AdminInvoicesListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminInvoicesListResponse> => {

  return apiFetch<adminInvoicesListResponse>(getAdminInvoicesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminInvoicesListQueryKey = (params?: AdminInvoicesListParams,) => {
    return [
    `/api/v1/admin/invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminInvoicesListQueryOptions = <TData = Awaited<ReturnType<typeof adminInvoicesList>>, TError = unknown>(params?: AdminInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminInvoicesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminInvoicesList>>> = ({ signal }) => adminInvoicesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminInvoicesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminInvoicesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminInvoicesList>>>
export type AdminInvoicesListQueryError = unknown


export function useAdminInvoicesList<TData = Awaited<ReturnType<typeof adminInvoicesList>>, TError = unknown>(
 params: undefined |  AdminInvoicesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicesList>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicesList<TData = Awaited<ReturnType<typeof adminInvoicesList>>, TError = unknown>(
 params?: AdminInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicesList>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicesList<TData = Awaited<ReturnType<typeof adminInvoicesList>>, TError = unknown>(
 params?: AdminInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminInvoicesList<TData = Awaited<ReturnType<typeof adminInvoicesList>>, TError = unknown>(
 params?: AdminInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminInvoicesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminInvoicesPdfResponse200 = {
  data: Blob
  status: 200
}

export type adminInvoicesPdfResponseSuccess = (adminInvoicesPdfResponse200) & {
  headers: Headers;
};
;

export type adminInvoicesPdfResponse = (adminInvoicesPdfResponseSuccess)

export const getAdminInvoicesPdfUrl = (uid: string,) => {




  return `/api/v1/admin/invoices/${uid}/pdf`
}

export const adminInvoicesPdf = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminInvoicesPdfResponse> => {

  return apiFetch<adminInvoicesPdfResponse>(getAdminInvoicesPdfUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminInvoicesPdfQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/invoices/${uid}/pdf`
    ] as const;
    }


export const getAdminInvoicesPdfQueryOptions = <TData = Awaited<ReturnType<typeof adminInvoicesPdf>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicesPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminInvoicesPdfQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminInvoicesPdf>>> = ({ signal }) => adminInvoicesPdf(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminInvoicesPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminInvoicesPdfQueryResult = NonNullable<Awaited<ReturnType<typeof adminInvoicesPdf>>>
export type AdminInvoicesPdfQueryError = unknown


export function useAdminInvoicesPdf<TData = Awaited<ReturnType<typeof adminInvoicesPdf>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicesPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicesPdf>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicesPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicesPdf<TData = Awaited<ReturnType<typeof adminInvoicesPdf>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicesPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminInvoicesPdf>>,
          TError,
          Awaited<ReturnType<typeof adminInvoicesPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminInvoicesPdf<TData = Awaited<ReturnType<typeof adminInvoicesPdf>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicesPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminInvoicesPdf<TData = Awaited<ReturnType<typeof adminInvoicesPdf>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminInvoicesPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminInvoicesPdfQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminJobsRetrieveResponse200 = {
  data: JobRegistry
  status: 200
}

export type adminJobsRetrieveResponseSuccess = (adminJobsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminJobsRetrieveResponse = (adminJobsRetrieveResponseSuccess)

export const getAdminJobsRetrieveUrl = () => {




  return `/api/v1/admin/jobs`
}

/**
 * Every job the installed modules register, and which of them run on a schedule.
 */
export const adminJobsRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminJobsRetrieveResponse> => {

  return apiFetch<adminJobsRetrieveResponse>(getAdminJobsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminJobsRetrieveQueryKey = () => {
    return [
    `/api/v1/admin/jobs`
    ] as const;
    }


export const getAdminJobsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminJobsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminJobsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminJobsRetrieve>>> = ({ signal }) => adminJobsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminJobsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminJobsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminJobsRetrieve>>>
export type AdminJobsRetrieveQueryError = unknown


export function useAdminJobsRetrieve<TData = Awaited<ReturnType<typeof adminJobsRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminJobsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobsRetrieve<TData = Awaited<ReturnType<typeof adminJobsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminJobsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobsRetrieve<TData = Awaited<ReturnType<typeof adminJobsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminJobsRetrieve<TData = Awaited<ReturnType<typeof adminJobsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminJobsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminJobsFailedListResponse200 = {
  data: PaginatedFailedJobList
  status: 200
}

export type adminJobsFailedListResponseSuccess = (adminJobsFailedListResponse200) & {
  headers: Headers;
};
;

export type adminJobsFailedListResponse = (adminJobsFailedListResponseSuccess)

export const getAdminJobsFailedListUrl = (params?: AdminJobsFailedListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/jobs/failed?${stringifiedParams}` : `/api/v1/admin/jobs/failed`
}

/**
 * Newest first. `?job=medialib.generate_renditions`, `?retried=false` (default: all).
 */
export const adminJobsFailedList = async (params?: AdminJobsFailedListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminJobsFailedListResponse> => {

  return apiFetch<adminJobsFailedListResponse>(getAdminJobsFailedListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminJobsFailedListQueryKey = (params?: AdminJobsFailedListParams,) => {
    return [
    `/api/v1/admin/jobs/failed`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminJobsFailedListQueryOptions = <TData = Awaited<ReturnType<typeof adminJobsFailedList>>, TError = unknown>(params?: AdminJobsFailedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminJobsFailedListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminJobsFailedList>>> = ({ signal }) => adminJobsFailedList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminJobsFailedListQueryResult = NonNullable<Awaited<ReturnType<typeof adminJobsFailedList>>>
export type AdminJobsFailedListQueryError = unknown


export function useAdminJobsFailedList<TData = Awaited<ReturnType<typeof adminJobsFailedList>>, TError = unknown>(
 params: undefined |  AdminJobsFailedListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobsFailedList>>,
          TError,
          Awaited<ReturnType<typeof adminJobsFailedList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobsFailedList<TData = Awaited<ReturnType<typeof adminJobsFailedList>>, TError = unknown>(
 params?: AdminJobsFailedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobsFailedList>>,
          TError,
          Awaited<ReturnType<typeof adminJobsFailedList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobsFailedList<TData = Awaited<ReturnType<typeof adminJobsFailedList>>, TError = unknown>(
 params?: AdminJobsFailedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminJobsFailedList<TData = Awaited<ReturnType<typeof adminJobsFailedList>>, TError = unknown>(
 params?: AdminJobsFailedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminJobsFailedListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminJobsFailedRetrieveResponse200 = {
  data: FailedJobDetail
  status: 200
}

export type adminJobsFailedRetrieveResponseSuccess = (adminJobsFailedRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminJobsFailedRetrieveResponse = (adminJobsFailedRetrieveResponseSuccess)

export const getAdminJobsFailedRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/jobs/failed/${uid}`
}

export const adminJobsFailedRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminJobsFailedRetrieveResponse> => {

  return apiFetch<adminJobsFailedRetrieveResponse>(getAdminJobsFailedRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminJobsFailedRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/jobs/failed/${uid}`
    ] as const;
    }


export const getAdminJobsFailedRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminJobsFailedRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminJobsFailedRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminJobsFailedRetrieve>>> = ({ signal }) => adminJobsFailedRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminJobsFailedRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminJobsFailedRetrieve>>>
export type AdminJobsFailedRetrieveQueryError = unknown


export function useAdminJobsFailedRetrieve<TData = Awaited<ReturnType<typeof adminJobsFailedRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobsFailedRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminJobsFailedRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobsFailedRetrieve<TData = Awaited<ReturnType<typeof adminJobsFailedRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobsFailedRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminJobsFailedRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobsFailedRetrieve<TData = Awaited<ReturnType<typeof adminJobsFailedRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminJobsFailedRetrieve<TData = Awaited<ReturnType<typeof adminJobsFailedRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminJobsFailedRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminJobsFailedDestroyResponse204 = {
  data: void
  status: 204
}

export type adminJobsFailedDestroyResponseSuccess = (adminJobsFailedDestroyResponse204) & {
  headers: Headers;
};
;

export type adminJobsFailedDestroyResponse = (adminJobsFailedDestroyResponseSuccess)

export const getAdminJobsFailedDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/jobs/failed/${uid}`
}

export const adminJobsFailedDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminJobsFailedDestroyResponse> => {

  return apiFetch<adminJobsFailedDestroyResponse>(getAdminJobsFailedDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminJobsFailedDestroyMutationKey = () => ['adminJobsFailedDestroy'] as const;

export const getAdminJobsFailedDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminJobsFailedDestroy>>, TError,AdminJobsFailedDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminJobsFailedDestroy>>, TError,AdminJobsFailedDestroyMutationVariables, TContext> => {

const mutationKey = getAdminJobsFailedDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminJobsFailedDestroy>>, AdminJobsFailedDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminJobsFailedDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminJobsFailedDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminJobsFailedDestroy>>>

    export type AdminJobsFailedDestroyMutationError = unknown
    export type AdminJobsFailedDestroyMutationVariables = {uid: string}

    export const useAdminJobsFailedDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminJobsFailedDestroy>>, TError,AdminJobsFailedDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminJobsFailedDestroy>>,
        TError,
        AdminJobsFailedDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminJobsFailedDestroyMutationOptions(options), queryClient);
    }
    export type adminJobsFailedRetryCreateResponse200 = {
  data: FailedJob
  status: 200
}

export type adminJobsFailedRetryCreateResponseSuccess = (adminJobsFailedRetryCreateResponse200) & {
  headers: Headers;
};
;

export type adminJobsFailedRetryCreateResponse = (adminJobsFailedRetryCreateResponseSuccess)

export const getAdminJobsFailedRetryCreateUrl = (uid: string,) => {




  return `/api/v1/admin/jobs/failed/${uid}/retry`
}

/**
 * Queue the job again with the same arguments (409 if already retried or its module is gone).
 */
export const adminJobsFailedRetryCreate = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminJobsFailedRetryCreateResponse> => {

  return apiFetch<adminJobsFailedRetryCreateResponse>(getAdminJobsFailedRetryCreateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminJobsFailedRetryCreateMutationKey = () => ['adminJobsFailedRetryCreate'] as const;

export const getAdminJobsFailedRetryCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminJobsFailedRetryCreate>>, TError,AdminJobsFailedRetryCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminJobsFailedRetryCreate>>, TError,AdminJobsFailedRetryCreateMutationVariables, TContext> => {

const mutationKey = getAdminJobsFailedRetryCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminJobsFailedRetryCreate>>, AdminJobsFailedRetryCreateMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminJobsFailedRetryCreate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminJobsFailedRetryCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminJobsFailedRetryCreate>>>

    export type AdminJobsFailedRetryCreateMutationError = unknown
    export type AdminJobsFailedRetryCreateMutationVariables = {uid: string}

    export const useAdminJobsFailedRetryCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminJobsFailedRetryCreate>>, TError,AdminJobsFailedRetryCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminJobsFailedRetryCreate>>,
        TError,
        AdminJobsFailedRetryCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminJobsFailedRetryCreateMutationOptions(options), queryClient);
    }
    export type adminJobsFailedNamesListResponse200 = {
  data: string[]
  status: 200
}

export type adminJobsFailedNamesListResponseSuccess = (adminJobsFailedNamesListResponse200) & {
  headers: Headers;
};
;

export type adminJobsFailedNamesListResponse = (adminJobsFailedNamesListResponseSuccess)

export const getAdminJobsFailedNamesListUrl = () => {




  return `/api/v1/admin/jobs/failed/names`
}

export const adminJobsFailedNamesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminJobsFailedNamesListResponse> => {

  return apiFetch<adminJobsFailedNamesListResponse>(getAdminJobsFailedNamesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminJobsFailedNamesListQueryKey = () => {
    return [
    `/api/v1/admin/jobs/failed/names`
    ] as const;
    }


export const getAdminJobsFailedNamesListQueryOptions = <TData = Awaited<ReturnType<typeof adminJobsFailedNamesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedNamesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminJobsFailedNamesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminJobsFailedNamesList>>> = ({ signal }) => adminJobsFailedNamesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedNamesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminJobsFailedNamesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminJobsFailedNamesList>>>
export type AdminJobsFailedNamesListQueryError = unknown


export function useAdminJobsFailedNamesList<TData = Awaited<ReturnType<typeof adminJobsFailedNamesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedNamesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobsFailedNamesList>>,
          TError,
          Awaited<ReturnType<typeof adminJobsFailedNamesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobsFailedNamesList<TData = Awaited<ReturnType<typeof adminJobsFailedNamesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedNamesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobsFailedNamesList>>,
          TError,
          Awaited<ReturnType<typeof adminJobsFailedNamesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobsFailedNamesList<TData = Awaited<ReturnType<typeof adminJobsFailedNamesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedNamesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminJobsFailedNamesList<TData = Awaited<ReturnType<typeof adminJobsFailedNamesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsFailedNamesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminJobsFailedNamesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminJobsHealthRetrieveResponse200 = {
  data: QueueHealth
  status: 200
}

export type adminJobsHealthRetrieveResponseSuccess = (adminJobsHealthRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminJobsHealthRetrieveResponse = (adminJobsHealthRetrieveResponseSuccess)

export const getAdminJobsHealthRetrieveUrl = () => {




  return `/api/v1/admin/jobs/health`
}

/**
 * Is the worker running, and how much is waiting? (The worker writes a heartbeat every minute.)
 */
export const adminJobsHealthRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminJobsHealthRetrieveResponse> => {

  return apiFetch<adminJobsHealthRetrieveResponse>(getAdminJobsHealthRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminJobsHealthRetrieveQueryKey = () => {
    return [
    `/api/v1/admin/jobs/health`
    ] as const;
    }


export const getAdminJobsHealthRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminJobsHealthRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsHealthRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminJobsHealthRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminJobsHealthRetrieve>>> = ({ signal }) => adminJobsHealthRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminJobsHealthRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminJobsHealthRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminJobsHealthRetrieve>>>
export type AdminJobsHealthRetrieveQueryError = unknown


export function useAdminJobsHealthRetrieve<TData = Awaited<ReturnType<typeof adminJobsHealthRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsHealthRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobsHealthRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminJobsHealthRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobsHealthRetrieve<TData = Awaited<ReturnType<typeof adminJobsHealthRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsHealthRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminJobsHealthRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminJobsHealthRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminJobsHealthRetrieve<TData = Awaited<ReturnType<typeof adminJobsHealthRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsHealthRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminJobsHealthRetrieve<TData = Awaited<ReturnType<typeof adminJobsHealthRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminJobsHealthRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminJobsHealthRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminMeRetrieveResponse200 = {
  data: AdminMe
  status: 200
}

export type adminMeRetrieveResponseSuccess = (adminMeRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminMeRetrieveResponse = (adminMeRetrieveResponseSuccess)

export const getAdminMeRetrieveUrl = () => {




  return `/api/v1/admin/me`
}

/**
 * The staff member, their roles, permissions and 2FA status (drives the admin menu).
 */
export const adminMeRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminMeRetrieveResponse> => {

  return apiFetch<adminMeRetrieveResponse>(getAdminMeRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMeRetrieveQueryKey = () => {
    return [
    `/api/v1/admin/me`
    ] as const;
    }


export const getAdminMeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMeRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMeRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMeRetrieve>>> = ({ signal }) => adminMeRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMeRetrieve>>>
export type AdminMeRetrieveQueryError = unknown


export function useAdminMeRetrieve<TData = Awaited<ReturnType<typeof adminMeRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMeRetrieve<TData = Awaited<ReturnType<typeof adminMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMeRetrieve<TData = Awaited<ReturnType<typeof adminMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMeRetrieve<TData = Awaited<ReturnType<typeof adminMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminMePartialUpdateResponse200 = {
  data: AdminMe
  status: 200
}

export type adminMePartialUpdateResponseSuccess = (adminMePartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminMePartialUpdateResponse = (adminMePartialUpdateResponseSuccess)

export const getAdminMePartialUpdateUrl = () => {




  return `/api/v1/admin/me`
}

/**
 * The staff member, their roles, permissions and 2FA status (drives the admin menu).
 */
export const adminMePartialUpdate = async (patchedProfileUpdateRequest?: PatchedProfileUpdateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminMePartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminMePartialUpdateResponse>(getAdminMePartialUpdateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedProfileUpdateRequest)
  }
);}





export const getAdminMePartialUpdateMutationKey = () => ['adminMePartialUpdate'] as const;

export const getAdminMePartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMePartialUpdate>>, TError,AdminMePartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMePartialUpdate>>, TError,AdminMePartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminMePartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMePartialUpdate>>, AdminMePartialUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminMePartialUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMePartialUpdate>>>
    export type AdminMePartialUpdateMutationBody = PatchedProfileUpdateRequest | undefined
    export type AdminMePartialUpdateMutationError = unknown
    export type AdminMePartialUpdateMutationVariables = {data?: PatchedProfileUpdateRequest}

    export const useAdminMePartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMePartialUpdate>>, TError,AdminMePartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMePartialUpdate>>,
        TError,
        AdminMePartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMePartialUpdateMutationOptions(options), queryClient);
    }
    export type adminMediaListResponse200 = {
  data: PaginatedMediaList
  status: 200
}

export type adminMediaListResponseSuccess = (adminMediaListResponse200) & {
  headers: Headers;
};
;

export type adminMediaListResponse = (adminMediaListResponseSuccess)

export const getAdminMediaListUrl = (params?: AdminMediaListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/media?${stringifiedParams}` : `/api/v1/admin/media`
}

/**
 * List media (page pagination, filters) or upload a file (multipart, field `file`).
 */
export const adminMediaList = async (params?: AdminMediaListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminMediaListResponse> => {

  return apiFetch<adminMediaListResponse>(getAdminMediaListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMediaListQueryKey = (params?: AdminMediaListParams,) => {
    return [
    `/api/v1/admin/media`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMediaListQueryOptions = <TData = Awaited<ReturnType<typeof adminMediaList>>, TError = unknown>(params?: AdminMediaListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMediaListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMediaList>>> = ({ signal }) => adminMediaList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMediaList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMediaListQueryResult = NonNullable<Awaited<ReturnType<typeof adminMediaList>>>
export type AdminMediaListQueryError = unknown


export function useAdminMediaList<TData = Awaited<ReturnType<typeof adminMediaList>>, TError = unknown>(
 params: undefined |  AdminMediaListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMediaList>>,
          TError,
          Awaited<ReturnType<typeof adminMediaList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMediaList<TData = Awaited<ReturnType<typeof adminMediaList>>, TError = unknown>(
 params?: AdminMediaListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMediaList>>,
          TError,
          Awaited<ReturnType<typeof adminMediaList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMediaList<TData = Awaited<ReturnType<typeof adminMediaList>>, TError = unknown>(
 params?: AdminMediaListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMediaList<TData = Awaited<ReturnType<typeof adminMediaList>>, TError = unknown>(
 params?: AdminMediaListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMediaListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminMediaCreateResponse200 = {
  data: MediaDetail
  status: 200
}

export type adminMediaCreateResponse201 = {
  data: MediaDetail
  status: 201
}

export type adminMediaCreateResponseSuccess = (adminMediaCreateResponse200 | adminMediaCreateResponse201) & {
  headers: Headers;
};
;

export type adminMediaCreateResponse = (adminMediaCreateResponseSuccess)

export const getAdminMediaCreateUrl = () => {




  return `/api/v1/admin/media`
}

/**
 * 201 = stored; 200 = the same file was already in the library (that one is returned).
 */
export const adminMediaCreate = async (uploadRequest: UploadRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminMediaCreateResponse> => {
    const formData = new FormData();
formData.append(`file`, uploadRequest.file);
if(uploadRequest.visibility !== undefined) {
 formData.append(`visibility`, uploadRequest.visibility);
 }
if(uploadRequest.folder !== undefined && uploadRequest.folder !== null) {
 formData.append(`folder`, uploadRequest.folder);
 }
if(uploadRequest.title !== undefined) {
 formData.append(`title`, uploadRequest.title);
 }
if(uploadRequest.alt_text !== undefined) {
 formData.append(`alt_text`, uploadRequest.alt_text);
 }

  return apiFetch<adminMediaCreateResponse>(getAdminMediaCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getAdminMediaCreateMutationKey = () => ['adminMediaCreate'] as const;

export const getAdminMediaCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaCreate>>, TError,AdminMediaCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMediaCreate>>, TError,AdminMediaCreateMutationVariables, TContext> => {

const mutationKey = getAdminMediaCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMediaCreate>>, AdminMediaCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminMediaCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMediaCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMediaCreate>>>
    export type AdminMediaCreateMutationBody = UploadRequest
    export type AdminMediaCreateMutationError = unknown
    export type AdminMediaCreateMutationVariables = {data: UploadRequest}

    export const useAdminMediaCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaCreate>>, TError,AdminMediaCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMediaCreate>>,
        TError,
        AdminMediaCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMediaCreateMutationOptions(options), queryClient);
    }
    export type adminMediaRetrieveResponse200 = {
  data: MediaDetail
  status: 200
}

export type adminMediaRetrieveResponseSuccess = (adminMediaRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminMediaRetrieveResponse = (adminMediaRetrieveResponseSuccess)

export const getAdminMediaRetrieveUrl = (uid: string,
    params?: AdminMediaRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/media/${uid}?${stringifiedParams}` : `/api/v1/admin/media/${uid}`
}

/**
 * Resolves the owner scope for the panel the view is mounted in.
 */
export const adminMediaRetrieve = async (uid: string,
    params?: AdminMediaRetrieveParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminMediaRetrieveResponse> => {

  return apiFetch<adminMediaRetrieveResponse>(getAdminMediaRetrieveUrl(uid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMediaRetrieveQueryKey = (uid: string,
    params?: AdminMediaRetrieveParams,) => {
    return [
    `/api/v1/admin/media/${uid}`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMediaRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMediaRetrieve>>, TError = unknown>(uid: string,
    params?: AdminMediaRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMediaRetrieveQueryKey(uid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMediaRetrieve>>> = ({ signal }) => adminMediaRetrieve(uid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMediaRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMediaRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMediaRetrieve>>>
export type AdminMediaRetrieveQueryError = unknown


export function useAdminMediaRetrieve<TData = Awaited<ReturnType<typeof adminMediaRetrieve>>, TError = unknown>(
 uid: string,
    params: undefined |  AdminMediaRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMediaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMediaRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMediaRetrieve<TData = Awaited<ReturnType<typeof adminMediaRetrieve>>, TError = unknown>(
 uid: string,
    params?: AdminMediaRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMediaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMediaRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMediaRetrieve<TData = Awaited<ReturnType<typeof adminMediaRetrieve>>, TError = unknown>(
 uid: string,
    params?: AdminMediaRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMediaRetrieve<TData = Awaited<ReturnType<typeof adminMediaRetrieve>>, TError = unknown>(
 uid: string,
    params?: AdminMediaRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMediaRetrieveQueryOptions(uid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminMediaPartialUpdateResponse200 = {
  data: MediaDetail
  status: 200
}

export type adminMediaPartialUpdateResponseSuccess = (adminMediaPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminMediaPartialUpdateResponse = (adminMediaPartialUpdateResponseSuccess)

export const getAdminMediaPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/media/${uid}`
}

/**
 * Resolves the owner scope for the panel the view is mounted in.
 */
export const adminMediaPartialUpdate = async (uid: string,
    patchedMediaUpdateRequest?: PatchedMediaUpdateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminMediaPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminMediaPartialUpdateResponse>(getAdminMediaPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedMediaUpdateRequest)
  }
);}





export const getAdminMediaPartialUpdateMutationKey = () => ['adminMediaPartialUpdate'] as const;

export const getAdminMediaPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaPartialUpdate>>, TError,AdminMediaPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMediaPartialUpdate>>, TError,AdminMediaPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminMediaPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMediaPartialUpdate>>, AdminMediaPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminMediaPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMediaPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMediaPartialUpdate>>>
    export type AdminMediaPartialUpdateMutationBody = PatchedMediaUpdateRequest | undefined
    export type AdminMediaPartialUpdateMutationError = unknown
    export type AdminMediaPartialUpdateMutationVariables = {uid: string;data?: PatchedMediaUpdateRequest}

    export const useAdminMediaPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaPartialUpdate>>, TError,AdminMediaPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMediaPartialUpdate>>,
        TError,
        AdminMediaPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMediaPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminMediaDestroyResponse204 = {
  data: void
  status: 204
}

export type adminMediaDestroyResponseSuccess = (adminMediaDestroyResponse204) & {
  headers: Headers;
};
;

export type adminMediaDestroyResponse = (adminMediaDestroyResponseSuccess)

export const getAdminMediaDestroyUrl = (uid: string,
    params?: AdminMediaDestroyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/media/${uid}?${stringifiedParams}` : `/api/v1/admin/media/${uid}`
}

/**
 * Resolves the owner scope for the panel the view is mounted in.
 */
export const adminMediaDestroy = async (uid: string,
    params?: AdminMediaDestroyParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminMediaDestroyResponse> => {

  return apiFetch<adminMediaDestroyResponse>(getAdminMediaDestroyUrl(uid,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminMediaDestroyMutationKey = () => ['adminMediaDestroy'] as const;

export const getAdminMediaDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaDestroy>>, TError,AdminMediaDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMediaDestroy>>, TError,AdminMediaDestroyMutationVariables, TContext> => {

const mutationKey = getAdminMediaDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMediaDestroy>>, AdminMediaDestroyMutationVariables> = (props) => {
          const {uid,params} = props ?? {};

          return  adminMediaDestroy(uid,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMediaDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminMediaDestroy>>>

    export type AdminMediaDestroyMutationError = unknown
    export type AdminMediaDestroyMutationVariables = {uid: string;params?: AdminMediaDestroyParams}

    export const useAdminMediaDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaDestroy>>, TError,AdminMediaDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMediaDestroy>>,
        TError,
        AdminMediaDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMediaDestroyMutationOptions(options), queryClient);
    }
    export type adminMediaFileRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type adminMediaFileRetrieveResponse302 = {
  data: void
  status: 302
}

export type adminMediaFileRetrieveResponseSuccess = (adminMediaFileRetrieveResponse200) & {
  headers: Headers;
};
export type adminMediaFileRetrieveResponseError = (adminMediaFileRetrieveResponse302) & {
  headers: Headers;
};

export type adminMediaFileRetrieveResponse = (adminMediaFileRetrieveResponseSuccess | adminMediaFileRetrieveResponseError)

export const getAdminMediaFileRetrieveUrl = (uid: string,
    params?: AdminMediaFileRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/media/${uid}/file?${stringifiedParams}` : `/api/v1/admin/media/${uid}/file`
}

/**
 * The original file (private files only through here). `?download=true` = save instead of open.
 */
export const adminMediaFileRetrieve = async (uid: string,
    params?: AdminMediaFileRetrieveParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminMediaFileRetrieveResponse> => {

  return apiFetch<adminMediaFileRetrieveResponse>(getAdminMediaFileRetrieveUrl(uid,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMediaFileRetrieveQueryKey = (uid: string,
    params?: AdminMediaFileRetrieveParams,) => {
    return [
    `/api/v1/admin/media/${uid}/file`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMediaFileRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMediaFileRetrieve>>, TError = void>(uid: string,
    params?: AdminMediaFileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaFileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMediaFileRetrieveQueryKey(uid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMediaFileRetrieve>>> = ({ signal }) => adminMediaFileRetrieve(uid,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMediaFileRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMediaFileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMediaFileRetrieve>>>
export type AdminMediaFileRetrieveQueryError = void


export function useAdminMediaFileRetrieve<TData = Awaited<ReturnType<typeof adminMediaFileRetrieve>>, TError = void>(
 uid: string,
    params: undefined |  AdminMediaFileRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaFileRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMediaFileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMediaFileRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMediaFileRetrieve<TData = Awaited<ReturnType<typeof adminMediaFileRetrieve>>, TError = void>(
 uid: string,
    params?: AdminMediaFileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaFileRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMediaFileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMediaFileRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMediaFileRetrieve<TData = Awaited<ReturnType<typeof adminMediaFileRetrieve>>, TError = void>(
 uid: string,
    params?: AdminMediaFileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaFileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMediaFileRetrieve<TData = Awaited<ReturnType<typeof adminMediaFileRetrieve>>, TError = void>(
 uid: string,
    params?: AdminMediaFileRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaFileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMediaFileRetrieveQueryOptions(uid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminMediaRestoreCreateResponse200 = {
  data: MediaDetail
  status: 200
}

export type adminMediaRestoreCreateResponseSuccess = (adminMediaRestoreCreateResponse200) & {
  headers: Headers;
};
;

export type adminMediaRestoreCreateResponse = (adminMediaRestoreCreateResponseSuccess)

export const getAdminMediaRestoreCreateUrl = (uid: string,) => {




  return `/api/v1/admin/media/${uid}/restore`
}

/**
 * Take a file out of the trash.
 */
export const adminMediaRestoreCreate = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminMediaRestoreCreateResponse> => {

  return apiFetch<adminMediaRestoreCreateResponse>(getAdminMediaRestoreCreateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminMediaRestoreCreateMutationKey = () => ['adminMediaRestoreCreate'] as const;

export const getAdminMediaRestoreCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaRestoreCreate>>, TError,AdminMediaRestoreCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMediaRestoreCreate>>, TError,AdminMediaRestoreCreateMutationVariables, TContext> => {

const mutationKey = getAdminMediaRestoreCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMediaRestoreCreate>>, AdminMediaRestoreCreateMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminMediaRestoreCreate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMediaRestoreCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMediaRestoreCreate>>>

    export type AdminMediaRestoreCreateMutationError = unknown
    export type AdminMediaRestoreCreateMutationVariables = {uid: string}

    export const useAdminMediaRestoreCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaRestoreCreate>>, TError,AdminMediaRestoreCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMediaRestoreCreate>>,
        TError,
        AdminMediaRestoreCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMediaRestoreCreateMutationOptions(options), queryClient);
    }
    export type adminMediaFoldersListResponse200 = {
  data: Folder[]
  status: 200
}

export type adminMediaFoldersListResponseSuccess = (adminMediaFoldersListResponse200) & {
  headers: Headers;
};
;

export type adminMediaFoldersListResponse = (adminMediaFoldersListResponseSuccess)

export const getAdminMediaFoldersListUrl = () => {




  return `/api/v1/admin/media/folders`
}

/**
 * Resolves the owner scope for the panel the view is mounted in.
 */
export const adminMediaFoldersList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminMediaFoldersListResponse> => {

  return apiFetch<adminMediaFoldersListResponse>(getAdminMediaFoldersListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMediaFoldersListQueryKey = () => {
    return [
    `/api/v1/admin/media/folders`
    ] as const;
    }


export const getAdminMediaFoldersListQueryOptions = <TData = Awaited<ReturnType<typeof adminMediaFoldersList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaFoldersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMediaFoldersListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMediaFoldersList>>> = ({ signal }) => adminMediaFoldersList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMediaFoldersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMediaFoldersListQueryResult = NonNullable<Awaited<ReturnType<typeof adminMediaFoldersList>>>
export type AdminMediaFoldersListQueryError = unknown


export function useAdminMediaFoldersList<TData = Awaited<ReturnType<typeof adminMediaFoldersList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaFoldersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMediaFoldersList>>,
          TError,
          Awaited<ReturnType<typeof adminMediaFoldersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMediaFoldersList<TData = Awaited<ReturnType<typeof adminMediaFoldersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaFoldersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMediaFoldersList>>,
          TError,
          Awaited<ReturnType<typeof adminMediaFoldersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMediaFoldersList<TData = Awaited<ReturnType<typeof adminMediaFoldersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaFoldersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminMediaFoldersList<TData = Awaited<ReturnType<typeof adminMediaFoldersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMediaFoldersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMediaFoldersListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminMediaFoldersCreateResponse201 = {
  data: Folder
  status: 201
}

export type adminMediaFoldersCreateResponseSuccess = (adminMediaFoldersCreateResponse201) & {
  headers: Headers;
};
;

export type adminMediaFoldersCreateResponse = (adminMediaFoldersCreateResponseSuccess)

export const getAdminMediaFoldersCreateUrl = () => {




  return `/api/v1/admin/media/folders`
}

/**
 * Resolves the owner scope for the panel the view is mounted in.
 */
export const adminMediaFoldersCreate = async (folderWriteRequest: FolderWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminMediaFoldersCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminMediaFoldersCreateResponse>(getAdminMediaFoldersCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(folderWriteRequest)
  }
);}





export const getAdminMediaFoldersCreateMutationKey = () => ['adminMediaFoldersCreate'] as const;

export const getAdminMediaFoldersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaFoldersCreate>>, TError,AdminMediaFoldersCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMediaFoldersCreate>>, TError,AdminMediaFoldersCreateMutationVariables, TContext> => {

const mutationKey = getAdminMediaFoldersCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMediaFoldersCreate>>, AdminMediaFoldersCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminMediaFoldersCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMediaFoldersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMediaFoldersCreate>>>
    export type AdminMediaFoldersCreateMutationBody = FolderWriteRequest
    export type AdminMediaFoldersCreateMutationError = unknown
    export type AdminMediaFoldersCreateMutationVariables = {data: FolderWriteRequest}

    export const useAdminMediaFoldersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaFoldersCreate>>, TError,AdminMediaFoldersCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMediaFoldersCreate>>,
        TError,
        AdminMediaFoldersCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMediaFoldersCreateMutationOptions(options), queryClient);
    }
    export type adminMediaFoldersPartialUpdateResponse200 = {
  data: Folder
  status: 200
}

export type adminMediaFoldersPartialUpdateResponseSuccess = (adminMediaFoldersPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminMediaFoldersPartialUpdateResponse = (adminMediaFoldersPartialUpdateResponseSuccess)

export const getAdminMediaFoldersPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/media/folders/${uid}`
}

/**
 * Resolves the owner scope for the panel the view is mounted in.
 */
export const adminMediaFoldersPartialUpdate = async (uid: string,
    patchedFolderWriteRequest?: PatchedFolderWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminMediaFoldersPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminMediaFoldersPartialUpdateResponse>(getAdminMediaFoldersPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedFolderWriteRequest)
  }
);}





export const getAdminMediaFoldersPartialUpdateMutationKey = () => ['adminMediaFoldersPartialUpdate'] as const;

export const getAdminMediaFoldersPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaFoldersPartialUpdate>>, TError,AdminMediaFoldersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMediaFoldersPartialUpdate>>, TError,AdminMediaFoldersPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminMediaFoldersPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMediaFoldersPartialUpdate>>, AdminMediaFoldersPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminMediaFoldersPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMediaFoldersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMediaFoldersPartialUpdate>>>
    export type AdminMediaFoldersPartialUpdateMutationBody = PatchedFolderWriteRequest | undefined
    export type AdminMediaFoldersPartialUpdateMutationError = unknown
    export type AdminMediaFoldersPartialUpdateMutationVariables = {uid: string;data?: PatchedFolderWriteRequest}

    export const useAdminMediaFoldersPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaFoldersPartialUpdate>>, TError,AdminMediaFoldersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMediaFoldersPartialUpdate>>,
        TError,
        AdminMediaFoldersPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMediaFoldersPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminMediaFoldersDestroyResponse204 = {
  data: void
  status: 204
}

export type adminMediaFoldersDestroyResponseSuccess = (adminMediaFoldersDestroyResponse204) & {
  headers: Headers;
};
;

export type adminMediaFoldersDestroyResponse = (adminMediaFoldersDestroyResponseSuccess)

export const getAdminMediaFoldersDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/media/folders/${uid}`
}

/**
 * Resolves the owner scope for the panel the view is mounted in.
 */
export const adminMediaFoldersDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminMediaFoldersDestroyResponse> => {

  return apiFetch<adminMediaFoldersDestroyResponse>(getAdminMediaFoldersDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminMediaFoldersDestroyMutationKey = () => ['adminMediaFoldersDestroy'] as const;

export const getAdminMediaFoldersDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaFoldersDestroy>>, TError,AdminMediaFoldersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMediaFoldersDestroy>>, TError,AdminMediaFoldersDestroyMutationVariables, TContext> => {

const mutationKey = getAdminMediaFoldersDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMediaFoldersDestroy>>, AdminMediaFoldersDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminMediaFoldersDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMediaFoldersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminMediaFoldersDestroy>>>

    export type AdminMediaFoldersDestroyMutationError = unknown
    export type AdminMediaFoldersDestroyMutationVariables = {uid: string}

    export const useAdminMediaFoldersDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaFoldersDestroy>>, TError,AdminMediaFoldersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMediaFoldersDestroy>>,
        TError,
        AdminMediaFoldersDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMediaFoldersDestroyMutationOptions(options), queryClient);
    }
    export type adminMediaVideosCreateResponse201 = {
  data: MediaDetail
  status: 201
}

export type adminMediaVideosCreateResponseSuccess = (adminMediaVideosCreateResponse201) & {
  headers: Headers;
};
;

export type adminMediaVideosCreateResponse = (adminMediaVideosCreateResponseSuccess)

export const getAdminMediaVideosCreateUrl = () => {




  return `/api/v1/admin/media/videos`
}

/**
 * Add a YouTube/Vimeo video by link (no file is uploaded).
 */
export const adminMediaVideosCreate = async (videoRequest: VideoRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminMediaVideosCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminMediaVideosCreateResponse>(getAdminMediaVideosCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(videoRequest)
  }
);}





export const getAdminMediaVideosCreateMutationKey = () => ['adminMediaVideosCreate'] as const;

export const getAdminMediaVideosCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaVideosCreate>>, TError,AdminMediaVideosCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMediaVideosCreate>>, TError,AdminMediaVideosCreateMutationVariables, TContext> => {

const mutationKey = getAdminMediaVideosCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMediaVideosCreate>>, AdminMediaVideosCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminMediaVideosCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMediaVideosCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMediaVideosCreate>>>
    export type AdminMediaVideosCreateMutationBody = VideoRequest
    export type AdminMediaVideosCreateMutationError = unknown
    export type AdminMediaVideosCreateMutationVariables = {data: VideoRequest}

    export const useAdminMediaVideosCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMediaVideosCreate>>, TError,AdminMediaVideosCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMediaVideosCreate>>,
        TError,
        AdminMediaVideosCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMediaVideosCreateMutationOptions(options), queryClient);
    }
    export type adminModulesListResponse200 = {
  data: InstalledModule[]
  status: 200
}

export type adminModulesListResponseSuccess = (adminModulesListResponse200) & {
  headers: Headers;
};
;

export type adminModulesListResponse = (adminModulesListResponseSuccess)

export const getAdminModulesListUrl = () => {




  return `/api/v1/admin/modules`
}

/**
 * Modules installed on this server. The frontends hide routes/menus of modules not listed here.
 */
export const adminModulesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminModulesListResponse> => {

  return apiFetch<adminModulesListResponse>(getAdminModulesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminModulesListQueryKey = () => {
    return [
    `/api/v1/admin/modules`
    ] as const;
    }


export const getAdminModulesListQueryOptions = <TData = Awaited<ReturnType<typeof adminModulesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminModulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminModulesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminModulesList>>> = ({ signal }) => adminModulesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminModulesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminModulesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminModulesList>>>
export type AdminModulesListQueryError = unknown


export function useAdminModulesList<TData = Awaited<ReturnType<typeof adminModulesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminModulesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminModulesList>>,
          TError,
          Awaited<ReturnType<typeof adminModulesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminModulesList<TData = Awaited<ReturnType<typeof adminModulesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminModulesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminModulesList>>,
          TError,
          Awaited<ReturnType<typeof adminModulesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminModulesList<TData = Awaited<ReturnType<typeof adminModulesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminModulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminModulesList<TData = Awaited<ReturnType<typeof adminModulesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminModulesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminModulesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminNotificationsListResponse200 = {
  data: PaginatedNotificationList
  status: 200
}

export type adminNotificationsListResponseSuccess = (adminNotificationsListResponse200) & {
  headers: Headers;
};
;

export type adminNotificationsListResponse = (adminNotificationsListResponseSuccess)

export const getAdminNotificationsListUrl = (params?: AdminNotificationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/notifications?${stringifiedParams}` : `/api/v1/admin/notifications`
}

/**
 * The logged-in user's notifications in this panel, newest first. `?unread=true` for unread only.
 */
export const adminNotificationsList = async (params?: AdminNotificationsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminNotificationsListResponse> => {

  return apiFetch<adminNotificationsListResponse>(getAdminNotificationsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminNotificationsListQueryKey = (params?: AdminNotificationsListParams,) => {
    return [
    `/api/v1/admin/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminNotificationsListQueryOptions = <TData = Awaited<ReturnType<typeof adminNotificationsList>>, TError = unknown>(params?: AdminNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminNotificationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNotificationsList>>> = ({ signal }) => adminNotificationsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminNotificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminNotificationsList>>>
export type AdminNotificationsListQueryError = unknown


export function useAdminNotificationsList<TData = Awaited<ReturnType<typeof adminNotificationsList>>, TError = unknown>(
 params: undefined |  AdminNotificationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationsList>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationsList<TData = Awaited<ReturnType<typeof adminNotificationsList>>, TError = unknown>(
 params?: AdminNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationsList>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationsList<TData = Awaited<ReturnType<typeof adminNotificationsList>>, TError = unknown>(
 params?: AdminNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminNotificationsList<TData = Awaited<ReturnType<typeof adminNotificationsList>>, TError = unknown>(
 params?: AdminNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminNotificationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminNotificationsReadCreateResponse200 = {
  data: Notification
  status: 200
}

export type adminNotificationsReadCreateResponseSuccess = (adminNotificationsReadCreateResponse200) & {
  headers: Headers;
};
;

export type adminNotificationsReadCreateResponse = (adminNotificationsReadCreateResponseSuccess)

export const getAdminNotificationsReadCreateUrl = (uid: string,) => {




  return `/api/v1/admin/notifications/${uid}/read`
}

export const adminNotificationsReadCreate = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminNotificationsReadCreateResponse> => {

  return apiFetch<adminNotificationsReadCreateResponse>(getAdminNotificationsReadCreateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminNotificationsReadCreateMutationKey = () => ['adminNotificationsReadCreate'] as const;

export const getAdminNotificationsReadCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminNotificationsReadCreate>>, TError,AdminNotificationsReadCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminNotificationsReadCreate>>, TError,AdminNotificationsReadCreateMutationVariables, TContext> => {

const mutationKey = getAdminNotificationsReadCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminNotificationsReadCreate>>, AdminNotificationsReadCreateMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminNotificationsReadCreate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminNotificationsReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminNotificationsReadCreate>>>

    export type AdminNotificationsReadCreateMutationError = unknown
    export type AdminNotificationsReadCreateMutationVariables = {uid: string}

    export const useAdminNotificationsReadCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminNotificationsReadCreate>>, TError,AdminNotificationsReadCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminNotificationsReadCreate>>,
        TError,
        AdminNotificationsReadCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminNotificationsReadCreateMutationOptions(options), queryClient);
    }
    export type adminNotificationsLogListResponse200 = {
  data: PaginatedDeliveryList
  status: 200
}

export type adminNotificationsLogListResponseSuccess = (adminNotificationsLogListResponse200) & {
  headers: Headers;
};
;

export type adminNotificationsLogListResponse = (adminNotificationsLogListResponseSuccess)

export const getAdminNotificationsLogListUrl = (params?: AdminNotificationsLogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/notifications/log?${stringifiedParams}` : `/api/v1/admin/notifications/log`
}

/**
 * Every email / SMS / in-app message sent, newest first (cursor pagination).
 */
export const adminNotificationsLogList = async (params?: AdminNotificationsLogListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminNotificationsLogListResponse> => {

  return apiFetch<adminNotificationsLogListResponse>(getAdminNotificationsLogListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminNotificationsLogListQueryKey = (params?: AdminNotificationsLogListParams,) => {
    return [
    `/api/v1/admin/notifications/log`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminNotificationsLogListQueryOptions = <TData = Awaited<ReturnType<typeof adminNotificationsLogList>>, TError = unknown>(params?: AdminNotificationsLogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsLogList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminNotificationsLogListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNotificationsLogList>>> = ({ signal }) => adminNotificationsLogList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsLogList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminNotificationsLogListQueryResult = NonNullable<Awaited<ReturnType<typeof adminNotificationsLogList>>>
export type AdminNotificationsLogListQueryError = unknown


export function useAdminNotificationsLogList<TData = Awaited<ReturnType<typeof adminNotificationsLogList>>, TError = unknown>(
 params: undefined |  AdminNotificationsLogListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsLogList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationsLogList>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationsLogList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationsLogList<TData = Awaited<ReturnType<typeof adminNotificationsLogList>>, TError = unknown>(
 params?: AdminNotificationsLogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsLogList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationsLogList>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationsLogList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationsLogList<TData = Awaited<ReturnType<typeof adminNotificationsLogList>>, TError = unknown>(
 params?: AdminNotificationsLogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsLogList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminNotificationsLogList<TData = Awaited<ReturnType<typeof adminNotificationsLogList>>, TError = unknown>(
 params?: AdminNotificationsLogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsLogList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminNotificationsLogListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminNotificationsLogRetrieveResponse200 = {
  data: Delivery
  status: 200
}

export type adminNotificationsLogRetrieveResponseSuccess = (adminNotificationsLogRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminNotificationsLogRetrieveResponse = (adminNotificationsLogRetrieveResponseSuccess)

export const getAdminNotificationsLogRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/notifications/log/${uid}`
}

/**
 * Look objects up by public `uid` in URLs (`/vendors/<uid>`), never by integer id.
 */
export const adminNotificationsLogRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminNotificationsLogRetrieveResponse> => {

  return apiFetch<adminNotificationsLogRetrieveResponse>(getAdminNotificationsLogRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminNotificationsLogRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/notifications/log/${uid}`
    ] as const;
    }


export const getAdminNotificationsLogRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminNotificationsLogRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>> = ({ signal }) => adminNotificationsLogRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminNotificationsLogRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>>
export type AdminNotificationsLogRetrieveQueryError = unknown


export function useAdminNotificationsLogRetrieve<TData = Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationsLogRetrieve<TData = Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationsLogRetrieve<TData = Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminNotificationsLogRetrieve<TData = Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsLogRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminNotificationsLogRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminNotificationsReadAllCreateResponse200 = {
  data: MarkedRead
  status: 200
}

export type adminNotificationsReadAllCreateResponseSuccess = (adminNotificationsReadAllCreateResponse200) & {
  headers: Headers;
};
;

export type adminNotificationsReadAllCreateResponse = (adminNotificationsReadAllCreateResponseSuccess)

export const getAdminNotificationsReadAllCreateUrl = () => {




  return `/api/v1/admin/notifications/read-all`
}

export const adminNotificationsReadAllCreate = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminNotificationsReadAllCreateResponse> => {

  return apiFetch<adminNotificationsReadAllCreateResponse>(getAdminNotificationsReadAllCreateUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminNotificationsReadAllCreateMutationKey = () => ['adminNotificationsReadAllCreate'] as const;

export const getAdminNotificationsReadAllCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminNotificationsReadAllCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminNotificationsReadAllCreate>>, TError,void, TContext> => {

const mutationKey = getAdminNotificationsReadAllCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminNotificationsReadAllCreate>>, void> = () => {


          return  adminNotificationsReadAllCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminNotificationsReadAllCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminNotificationsReadAllCreate>>>

    export type AdminNotificationsReadAllCreateMutationError = unknown


    export const useAdminNotificationsReadAllCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminNotificationsReadAllCreate>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminNotificationsReadAllCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAdminNotificationsReadAllCreateMutationOptions(options), queryClient);
    }
    export type adminNotificationsSettingsListResponse200 = {
  data: TypeSetting[]
  status: 200
}

export type adminNotificationsSettingsListResponseSuccess = (adminNotificationsSettingsListResponse200) & {
  headers: Headers;
};
;

export type adminNotificationsSettingsListResponse = (adminNotificationsSettingsListResponseSuccess)

export const getAdminNotificationsSettingsListUrl = () => {




  return `/api/v1/admin/notifications/settings`
}

/**
 * Every notification type of the installed modules with its channel switches.
 */
export const adminNotificationsSettingsList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminNotificationsSettingsListResponse> => {

  return apiFetch<adminNotificationsSettingsListResponse>(getAdminNotificationsSettingsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminNotificationsSettingsListQueryKey = () => {
    return [
    `/api/v1/admin/notifications/settings`
    ] as const;
    }


export const getAdminNotificationsSettingsListQueryOptions = <TData = Awaited<ReturnType<typeof adminNotificationsSettingsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminNotificationsSettingsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNotificationsSettingsList>>> = ({ signal }) => adminNotificationsSettingsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsSettingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminNotificationsSettingsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminNotificationsSettingsList>>>
export type AdminNotificationsSettingsListQueryError = unknown


export function useAdminNotificationsSettingsList<TData = Awaited<ReturnType<typeof adminNotificationsSettingsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsSettingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationsSettingsList>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationsSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationsSettingsList<TData = Awaited<ReturnType<typeof adminNotificationsSettingsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsSettingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationsSettingsList>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationsSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationsSettingsList<TData = Awaited<ReturnType<typeof adminNotificationsSettingsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminNotificationsSettingsList<TData = Awaited<ReturnType<typeof adminNotificationsSettingsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminNotificationsSettingsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminNotificationsSettingsRetrieveResponse200 = {
  data: TypeSetting
  status: 200
}

export type adminNotificationsSettingsRetrieveResponseSuccess = (adminNotificationsSettingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminNotificationsSettingsRetrieveResponse = (adminNotificationsSettingsRetrieveResponseSuccess)

export const getAdminNotificationsSettingsRetrieveUrl = (code: string,) => {




  return `/api/v1/admin/notifications/settings/${code}`
}

export const adminNotificationsSettingsRetrieve = async (code: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminNotificationsSettingsRetrieveResponse> => {

  return apiFetch<adminNotificationsSettingsRetrieveResponse>(getAdminNotificationsSettingsRetrieveUrl(code),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminNotificationsSettingsRetrieveQueryKey = (code: string,) => {
    return [
    `/api/v1/admin/notifications/settings/${code}`
    ] as const;
    }


export const getAdminNotificationsSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>, TError = unknown>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminNotificationsSettingsRetrieveQueryKey(code);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>> = ({ signal }) => adminNotificationsSettingsRetrieve(code, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: code !== null && code !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminNotificationsSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>>
export type AdminNotificationsSettingsRetrieveQueryError = unknown


export function useAdminNotificationsSettingsRetrieve<TData = Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>, TError = unknown>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationsSettingsRetrieve<TData = Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationsSettingsRetrieve<TData = Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminNotificationsSettingsRetrieve<TData = Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminNotificationsSettingsRetrieveQueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminNotificationsSettingsPartialUpdateResponse200 = {
  data: TypeSetting
  status: 200
}

export type adminNotificationsSettingsPartialUpdateResponseSuccess = (adminNotificationsSettingsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminNotificationsSettingsPartialUpdateResponse = (adminNotificationsSettingsPartialUpdateResponseSuccess)

export const getAdminNotificationsSettingsPartialUpdateUrl = (code: string,) => {




  return `/api/v1/admin/notifications/settings/${code}`
}

export const adminNotificationsSettingsPartialUpdate = async (code: string,
    patchedTypeSettingUpdateRequest?: PatchedTypeSettingUpdateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminNotificationsSettingsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminNotificationsSettingsPartialUpdateResponse>(getAdminNotificationsSettingsPartialUpdateUrl(code),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedTypeSettingUpdateRequest)
  }
);}





export const getAdminNotificationsSettingsPartialUpdateMutationKey = () => ['adminNotificationsSettingsPartialUpdate'] as const;

export const getAdminNotificationsSettingsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminNotificationsSettingsPartialUpdate>>, TError,AdminNotificationsSettingsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminNotificationsSettingsPartialUpdate>>, TError,AdminNotificationsSettingsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminNotificationsSettingsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminNotificationsSettingsPartialUpdate>>, AdminNotificationsSettingsPartialUpdateMutationVariables> = (props) => {
          const {code,data} = props ?? {};

          return  adminNotificationsSettingsPartialUpdate(code,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminNotificationsSettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminNotificationsSettingsPartialUpdate>>>
    export type AdminNotificationsSettingsPartialUpdateMutationBody = PatchedTypeSettingUpdateRequest | undefined
    export type AdminNotificationsSettingsPartialUpdateMutationError = unknown
    export type AdminNotificationsSettingsPartialUpdateMutationVariables = {code: string;data?: PatchedTypeSettingUpdateRequest}

    export const useAdminNotificationsSettingsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminNotificationsSettingsPartialUpdate>>, TError,AdminNotificationsSettingsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminNotificationsSettingsPartialUpdate>>,
        TError,
        AdminNotificationsSettingsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminNotificationsSettingsPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminNotificationsTestCreateResponse202 = {
  data: TestSendResult
  status: 202
}

export type adminNotificationsTestCreateResponseSuccess = (adminNotificationsTestCreateResponse202) & {
  headers: Headers;
};
;

export type adminNotificationsTestCreateResponse = (adminNotificationsTestCreateResponseSuccess)

export const getAdminNotificationsTestCreateUrl = () => {




  return `/api/v1/admin/notifications/test`
}

/**
 * Send `notifications.test` to yourself, to check that email / SMS / in-app delivery works.
 */
export const adminNotificationsTestCreate = async (testSendRequest?: TestSendRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminNotificationsTestCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminNotificationsTestCreateResponse>(getAdminNotificationsTestCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testSendRequest)
  }
);}





export const getAdminNotificationsTestCreateMutationKey = () => ['adminNotificationsTestCreate'] as const;

export const getAdminNotificationsTestCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminNotificationsTestCreate>>, TError,AdminNotificationsTestCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminNotificationsTestCreate>>, TError,AdminNotificationsTestCreateMutationVariables, TContext> => {

const mutationKey = getAdminNotificationsTestCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminNotificationsTestCreate>>, AdminNotificationsTestCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminNotificationsTestCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminNotificationsTestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminNotificationsTestCreate>>>
    export type AdminNotificationsTestCreateMutationBody = TestSendRequest | undefined
    export type AdminNotificationsTestCreateMutationError = unknown
    export type AdminNotificationsTestCreateMutationVariables = {data?: TestSendRequest}

    export const useAdminNotificationsTestCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminNotificationsTestCreate>>, TError,AdminNotificationsTestCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminNotificationsTestCreate>>,
        TError,
        AdminNotificationsTestCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminNotificationsTestCreateMutationOptions(options), queryClient);
    }
    export type adminNotificationsUnreadCountRetrieveResponse200 = {
  data: UnreadCount
  status: 200
}

export type adminNotificationsUnreadCountRetrieveResponseSuccess = (adminNotificationsUnreadCountRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminNotificationsUnreadCountRetrieveResponse = (adminNotificationsUnreadCountRetrieveResponseSuccess)

export const getAdminNotificationsUnreadCountRetrieveUrl = () => {




  return `/api/v1/admin/notifications/unread-count`
}

/**
 * Number for the red badge on the bell (the panels poll it).
 */
export const adminNotificationsUnreadCountRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminNotificationsUnreadCountRetrieveResponse> => {

  return apiFetch<adminNotificationsUnreadCountRetrieveResponse>(getAdminNotificationsUnreadCountRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminNotificationsUnreadCountRetrieveQueryKey = () => {
    return [
    `/api/v1/admin/notifications/unread-count`
    ] as const;
    }


export const getAdminNotificationsUnreadCountRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminNotificationsUnreadCountRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>> = ({ signal }) => adminNotificationsUnreadCountRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminNotificationsUnreadCountRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>>
export type AdminNotificationsUnreadCountRetrieveQueryError = unknown


export function useAdminNotificationsUnreadCountRetrieve<TData = Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationsUnreadCountRetrieve<TData = Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminNotificationsUnreadCountRetrieve<TData = Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminNotificationsUnreadCountRetrieve<TData = Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminNotificationsUnreadCountRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminOrdersListResponse200 = {
  data: PaginatedAdminOrderListList
  status: 200
}

export type adminOrdersListResponseSuccess = (adminOrdersListResponse200) & {
  headers: Headers;
};
;

export type adminOrdersListResponse = (adminOrdersListResponseSuccess)

export const getAdminOrdersListUrl = (params?: AdminOrdersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/orders?${stringifiedParams}` : `/api/v1/admin/orders`
}

export const adminOrdersList = async (params?: AdminOrdersListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminOrdersListResponse> => {

  return apiFetch<adminOrdersListResponse>(getAdminOrdersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminOrdersListQueryKey = (params?: AdminOrdersListParams,) => {
    return [
    `/api/v1/admin/orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminOrdersListQueryOptions = <TData = Awaited<ReturnType<typeof adminOrdersList>>, TError = unknown>(params?: AdminOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrdersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrdersList>>> = ({ signal }) => adminOrdersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrdersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrdersListQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrdersList>>>
export type AdminOrdersListQueryError = unknown


export function useAdminOrdersList<TData = Awaited<ReturnType<typeof adminOrdersList>>, TError = unknown>(
 params: undefined |  AdminOrdersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrdersList>>,
          TError,
          Awaited<ReturnType<typeof adminOrdersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrdersList<TData = Awaited<ReturnType<typeof adminOrdersList>>, TError = unknown>(
 params?: AdminOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrdersList>>,
          TError,
          Awaited<ReturnType<typeof adminOrdersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrdersList<TData = Awaited<ReturnType<typeof adminOrdersList>>, TError = unknown>(
 params?: AdminOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrdersList<TData = Awaited<ReturnType<typeof adminOrdersList>>, TError = unknown>(
 params?: AdminOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrdersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminOrdersRetrieveResponse200 = {
  data: AdminOrderDetail
  status: 200
}

export type adminOrdersRetrieveResponseSuccess = (adminOrdersRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminOrdersRetrieveResponse = (adminOrdersRetrieveResponseSuccess)

export const getAdminOrdersRetrieveUrl = (number: string,) => {




  return `/api/v1/admin/orders/${number}`
}

export const adminOrdersRetrieve = async (number: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminOrdersRetrieveResponse> => {

  return apiFetch<adminOrdersRetrieveResponse>(getAdminOrdersRetrieveUrl(number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminOrdersRetrieveQueryKey = (number: string,) => {
    return [
    `/api/v1/admin/orders/${number}`
    ] as const;
    }


export const getAdminOrdersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminOrdersRetrieve>>, TError = unknown>(number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrdersRetrieveQueryKey(number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrdersRetrieve>>> = ({ signal }) => adminOrdersRetrieve(number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrdersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrdersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrdersRetrieve>>>
export type AdminOrdersRetrieveQueryError = unknown


export function useAdminOrdersRetrieve<TData = Awaited<ReturnType<typeof adminOrdersRetrieve>>, TError = unknown>(
 number: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminOrdersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrdersRetrieve<TData = Awaited<ReturnType<typeof adminOrdersRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminOrdersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrdersRetrieve<TData = Awaited<ReturnType<typeof adminOrdersRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrdersRetrieve<TData = Awaited<ReturnType<typeof adminOrdersRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrdersRetrieveQueryOptions(number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminOrdersCancelResponse200 = {
  data: AdminOrderDetail
  status: 200
}

export type adminOrdersCancelResponseSuccess = (adminOrdersCancelResponse200) & {
  headers: Headers;
};
;

export type adminOrdersCancelResponse = (adminOrdersCancelResponseSuccess)

export const getAdminOrdersCancelUrl = (number: string,) => {




  return `/api/v1/admin/orders/${number}/cancel`
}

/**
 * Cancel every part of the order that hasn't shipped (customers and stores are told, payments refunded).
 */
export const adminOrdersCancel = async (number: string,
    cancelRequest: CancelRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminOrdersCancelResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminOrdersCancelResponse>(getAdminOrdersCancelUrl(number),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cancelRequest)
  }
);}





export const getAdminOrdersCancelMutationKey = () => ['adminOrdersCancel'] as const;

export const getAdminOrdersCancelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrdersCancel>>, TError,AdminOrdersCancelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminOrdersCancel>>, TError,AdminOrdersCancelMutationVariables, TContext> => {

const mutationKey = getAdminOrdersCancelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrdersCancel>>, AdminOrdersCancelMutationVariables> = (props) => {
          const {number,data} = props ?? {};

          return  adminOrdersCancel(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminOrdersCancelMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrdersCancel>>>
    export type AdminOrdersCancelMutationBody = CancelRequest
    export type AdminOrdersCancelMutationError = unknown
    export type AdminOrdersCancelMutationVariables = {number: string;data: CancelRequest}

    export const useAdminOrdersCancel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrdersCancel>>, TError,AdminOrdersCancelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrdersCancel>>,
        TError,
        AdminOrdersCancelMutationVariables,
        TContext
      > => {
      return useMutation(getAdminOrdersCancelMutationOptions(options), queryClient);
    }
    export type adminOrdersAddNoteResponse201 = {
  data: AdminOrderDetail
  status: 201
}

export type adminOrdersAddNoteResponseSuccess = (adminOrdersAddNoteResponse201) & {
  headers: Headers;
};
;

export type adminOrdersAddNoteResponse = (adminOrdersAddNoteResponseSuccess)

export const getAdminOrdersAddNoteUrl = (number: string,) => {




  return `/api/v1/admin/orders/${number}/notes`
}

/**
 * An internal note (only the team sees it).
 */
export const adminOrdersAddNote = async (number: string,
    noteWriteRequest: NoteWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminOrdersAddNoteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminOrdersAddNoteResponse>(getAdminOrdersAddNoteUrl(number),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(noteWriteRequest)
  }
);}





export const getAdminOrdersAddNoteMutationKey = () => ['adminOrdersAddNote'] as const;

export const getAdminOrdersAddNoteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrdersAddNote>>, TError,AdminOrdersAddNoteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminOrdersAddNote>>, TError,AdminOrdersAddNoteMutationVariables, TContext> => {

const mutationKey = getAdminOrdersAddNoteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrdersAddNote>>, AdminOrdersAddNoteMutationVariables> = (props) => {
          const {number,data} = props ?? {};

          return  adminOrdersAddNote(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminOrdersAddNoteMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrdersAddNote>>>
    export type AdminOrdersAddNoteMutationBody = NoteWriteRequest
    export type AdminOrdersAddNoteMutationError = unknown
    export type AdminOrdersAddNoteMutationVariables = {number: string;data: NoteWriteRequest}

    export const useAdminOrdersAddNote = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrdersAddNote>>, TError,AdminOrdersAddNoteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrdersAddNote>>,
        TError,
        AdminOrdersAddNoteMutationVariables,
        TContext
      > => {
      return useMutation(getAdminOrdersAddNoteMutationOptions(options), queryClient);
    }
    export type adminOrdersPartCancelResponse200 = {
  data: AdminOrderDetail
  status: 200
}

export type adminOrdersPartCancelResponseSuccess = (adminOrdersPartCancelResponse200) & {
  headers: Headers;
};
;

export type adminOrdersPartCancelResponse = (adminOrdersPartCancelResponseSuccess)

export const getAdminOrdersPartCancelUrl = (number: string,
    part: string,) => {




  return `/api/v1/admin/orders/${number}/parts/${part}/cancel`
}

export const adminOrdersPartCancel = async (number: string,
    part: string,
    cancelRequest: CancelRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminOrdersPartCancelResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminOrdersPartCancelResponse>(getAdminOrdersPartCancelUrl(number,part),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cancelRequest)
  }
);}





export const getAdminOrdersPartCancelMutationKey = () => ['adminOrdersPartCancel'] as const;

export const getAdminOrdersPartCancelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrdersPartCancel>>, TError,AdminOrdersPartCancelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminOrdersPartCancel>>, TError,AdminOrdersPartCancelMutationVariables, TContext> => {

const mutationKey = getAdminOrdersPartCancelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrdersPartCancel>>, AdminOrdersPartCancelMutationVariables> = (props) => {
          const {number,part,data} = props ?? {};

          return  adminOrdersPartCancel(number,part,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminOrdersPartCancelMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrdersPartCancel>>>
    export type AdminOrdersPartCancelMutationBody = CancelRequest
    export type AdminOrdersPartCancelMutationError = unknown
    export type AdminOrdersPartCancelMutationVariables = {number: string;part: string;data: CancelRequest}

    export const useAdminOrdersPartCancel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrdersPartCancel>>, TError,AdminOrdersPartCancelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrdersPartCancel>>,
        TError,
        AdminOrdersPartCancelMutationVariables,
        TContext
      > => {
      return useMutation(getAdminOrdersPartCancelMutationOptions(options), queryClient);
    }
    export type adminOrdersPartStatusResponse200 = {
  data: AdminOrderDetail
  status: 200
}

export type adminOrdersPartStatusResponseSuccess = (adminOrdersPartStatusResponse200) & {
  headers: Headers;
};
;

export type adminOrdersPartStatusResponse = (adminOrdersPartStatusResponseSuccess)

export const getAdminOrdersPartStatusUrl = (number: string,
    part: string,) => {




  return `/api/v1/admin/orders/${number}/parts/${part}/status`
}

/**
 * Move a store's part forward, skipping steps if needed (shipping needs courier + tracking).
 */
export const adminOrdersPartStatus = async (number: string,
    part: string,
    advanceRequest: AdvanceRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminOrdersPartStatusResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminOrdersPartStatusResponse>(getAdminOrdersPartStatusUrl(number,part),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(advanceRequest)
  }
);}





export const getAdminOrdersPartStatusMutationKey = () => ['adminOrdersPartStatus'] as const;

export const getAdminOrdersPartStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrdersPartStatus>>, TError,AdminOrdersPartStatusMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminOrdersPartStatus>>, TError,AdminOrdersPartStatusMutationVariables, TContext> => {

const mutationKey = getAdminOrdersPartStatusMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrdersPartStatus>>, AdminOrdersPartStatusMutationVariables> = (props) => {
          const {number,part,data} = props ?? {};

          return  adminOrdersPartStatus(number,part,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminOrdersPartStatusMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrdersPartStatus>>>
    export type AdminOrdersPartStatusMutationBody = AdvanceRequest
    export type AdminOrdersPartStatusMutationError = unknown
    export type AdminOrdersPartStatusMutationVariables = {number: string;part: string;data: AdvanceRequest}

    export const useAdminOrdersPartStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrdersPartStatus>>, TError,AdminOrdersPartStatusMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrdersPartStatus>>,
        TError,
        AdminOrdersPartStatusMutationVariables,
        TContext
      > => {
      return useMutation(getAdminOrdersPartStatusMutationOptions(options), queryClient);
    }
    export type adminOrdersPartTrackingResponse200 = {
  data: AdminOrderDetail
  status: 200
}

export type adminOrdersPartTrackingResponseSuccess = (adminOrdersPartTrackingResponse200) & {
  headers: Headers;
};
;

export type adminOrdersPartTrackingResponse = (adminOrdersPartTrackingResponseSuccess)

export const getAdminOrdersPartTrackingUrl = (number: string,
    part: string,) => {




  return `/api/v1/admin/orders/${number}/parts/${part}/tracking`
}

export const adminOrdersPartTracking = async (number: string,
    part: string,
    trackingRequest: TrackingRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminOrdersPartTrackingResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminOrdersPartTrackingResponse>(getAdminOrdersPartTrackingUrl(number,part),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(trackingRequest)
  }
);}





export const getAdminOrdersPartTrackingMutationKey = () => ['adminOrdersPartTracking'] as const;

export const getAdminOrdersPartTrackingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrdersPartTracking>>, TError,AdminOrdersPartTrackingMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminOrdersPartTracking>>, TError,AdminOrdersPartTrackingMutationVariables, TContext> => {

const mutationKey = getAdminOrdersPartTrackingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrdersPartTracking>>, AdminOrdersPartTrackingMutationVariables> = (props) => {
          const {number,part,data} = props ?? {};

          return  adminOrdersPartTracking(number,part,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminOrdersPartTrackingMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrdersPartTracking>>>
    export type AdminOrdersPartTrackingMutationBody = TrackingRequest
    export type AdminOrdersPartTrackingMutationError = unknown
    export type AdminOrdersPartTrackingMutationVariables = {number: string;part: string;data: TrackingRequest}

    export const useAdminOrdersPartTracking = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrdersPartTracking>>, TError,AdminOrdersPartTrackingMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrdersPartTracking>>,
        TError,
        AdminOrdersPartTrackingMutationVariables,
        TContext
      > => {
      return useMutation(getAdminOrdersPartTrackingMutationOptions(options), queryClient);
    }
    export type adminOrdersCountsResponse200 = {
  data: AdminStatusCounts
  status: 200
}

export type adminOrdersCountsResponseSuccess = (adminOrdersCountsResponse200) & {
  headers: Headers;
};
;

export type adminOrdersCountsResponse = (adminOrdersCountsResponseSuccess)

export const getAdminOrdersCountsUrl = () => {




  return `/api/v1/admin/orders/counts`
}

export const adminOrdersCounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminOrdersCountsResponse> => {

  return apiFetch<adminOrdersCountsResponse>(getAdminOrdersCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminOrdersCountsQueryKey = () => {
    return [
    `/api/v1/admin/orders/counts`
    ] as const;
    }


export const getAdminOrdersCountsQueryOptions = <TData = Awaited<ReturnType<typeof adminOrdersCounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrdersCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrdersCounts>>> = ({ signal }) => adminOrdersCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrdersCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrdersCountsQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrdersCounts>>>
export type AdminOrdersCountsQueryError = unknown


export function useAdminOrdersCounts<TData = Awaited<ReturnType<typeof adminOrdersCounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrdersCounts>>,
          TError,
          Awaited<ReturnType<typeof adminOrdersCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrdersCounts<TData = Awaited<ReturnType<typeof adminOrdersCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrdersCounts>>,
          TError,
          Awaited<ReturnType<typeof adminOrdersCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrdersCounts<TData = Awaited<ReturnType<typeof adminOrdersCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrdersCounts<TData = Awaited<ReturnType<typeof adminOrdersCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrdersCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminOrdersSummaryResponse200 = {
  data: MarketplaceSummary
  status: 200
}

export type adminOrdersSummaryResponseSuccess = (adminOrdersSummaryResponse200) & {
  headers: Headers;
};
;

export type adminOrdersSummaryResponse = (adminOrdersSummaryResponseSuccess)

export const getAdminOrdersSummaryUrl = () => {




  return `/api/v1/admin/orders/summary`
}

export const adminOrdersSummary = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminOrdersSummaryResponse> => {

  return apiFetch<adminOrdersSummaryResponse>(getAdminOrdersSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminOrdersSummaryQueryKey = () => {
    return [
    `/api/v1/admin/orders/summary`
    ] as const;
    }


export const getAdminOrdersSummaryQueryOptions = <TData = Awaited<ReturnType<typeof adminOrdersSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrdersSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrdersSummary>>> = ({ signal }) => adminOrdersSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrdersSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrdersSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrdersSummary>>>
export type AdminOrdersSummaryQueryError = unknown


export function useAdminOrdersSummary<TData = Awaited<ReturnType<typeof adminOrdersSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrdersSummary>>,
          TError,
          Awaited<ReturnType<typeof adminOrdersSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrdersSummary<TData = Awaited<ReturnType<typeof adminOrdersSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrdersSummary>>,
          TError,
          Awaited<ReturnType<typeof adminOrdersSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrdersSummary<TData = Awaited<ReturnType<typeof adminOrdersSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrdersSummary<TData = Awaited<ReturnType<typeof adminOrdersSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrdersSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrdersSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPaymentsReconciliationResponse200 = {
  data: Reconciliation
  status: 200
}

export type adminPaymentsReconciliationResponseSuccess = (adminPaymentsReconciliationResponse200) & {
  headers: Headers;
};
;

export type adminPaymentsReconciliationResponse = (adminPaymentsReconciliationResponseSuccess)

export const getAdminPaymentsReconciliationUrl = (params?: AdminPaymentsReconciliationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/payments/reconciliation?${stringifiedParams}` : `/api/v1/admin/payments/reconciliation`
}

export const adminPaymentsReconciliation = async (params?: AdminPaymentsReconciliationParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminPaymentsReconciliationResponse> => {

  return apiFetch<adminPaymentsReconciliationResponse>(getAdminPaymentsReconciliationUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPaymentsReconciliationQueryKey = (params?: AdminPaymentsReconciliationParams,) => {
    return [
    `/api/v1/admin/payments/reconciliation`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminPaymentsReconciliationQueryOptions = <TData = Awaited<ReturnType<typeof adminPaymentsReconciliation>>, TError = unknown>(params?: AdminPaymentsReconciliationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsReconciliation>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPaymentsReconciliationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPaymentsReconciliation>>> = ({ signal }) => adminPaymentsReconciliation(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsReconciliation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPaymentsReconciliationQueryResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsReconciliation>>>
export type AdminPaymentsReconciliationQueryError = unknown


export function useAdminPaymentsReconciliation<TData = Awaited<ReturnType<typeof adminPaymentsReconciliation>>, TError = unknown>(
 params: undefined |  AdminPaymentsReconciliationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsReconciliation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsReconciliation>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsReconciliation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsReconciliation<TData = Awaited<ReturnType<typeof adminPaymentsReconciliation>>, TError = unknown>(
 params?: AdminPaymentsReconciliationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsReconciliation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsReconciliation>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsReconciliation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsReconciliation<TData = Awaited<ReturnType<typeof adminPaymentsReconciliation>>, TError = unknown>(
 params?: AdminPaymentsReconciliationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsReconciliation>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPaymentsReconciliation<TData = Awaited<ReturnType<typeof adminPaymentsReconciliation>>, TError = unknown>(
 params?: AdminPaymentsReconciliationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsReconciliation>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPaymentsReconciliationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPaymentsRefundsListResponse200 = {
  data: PaginatedRefundList
  status: 200
}

export type adminPaymentsRefundsListResponseSuccess = (adminPaymentsRefundsListResponse200) & {
  headers: Headers;
};
;

export type adminPaymentsRefundsListResponse = (adminPaymentsRefundsListResponseSuccess)

export const getAdminPaymentsRefundsListUrl = (params?: AdminPaymentsRefundsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/payments/refunds?${stringifiedParams}` : `/api/v1/admin/payments/refunds`
}

/**
 * List views: resolve the page's order uids to numbers in one call.
 */
export const adminPaymentsRefundsList = async (params?: AdminPaymentsRefundsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminPaymentsRefundsListResponse> => {

  return apiFetch<adminPaymentsRefundsListResponse>(getAdminPaymentsRefundsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPaymentsRefundsListQueryKey = (params?: AdminPaymentsRefundsListParams,) => {
    return [
    `/api/v1/admin/payments/refunds`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminPaymentsRefundsListQueryOptions = <TData = Awaited<ReturnType<typeof adminPaymentsRefundsList>>, TError = unknown>(params?: AdminPaymentsRefundsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsRefundsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPaymentsRefundsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPaymentsRefundsList>>> = ({ signal }) => adminPaymentsRefundsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsRefundsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPaymentsRefundsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsRefundsList>>>
export type AdminPaymentsRefundsListQueryError = unknown


export function useAdminPaymentsRefundsList<TData = Awaited<ReturnType<typeof adminPaymentsRefundsList>>, TError = unknown>(
 params: undefined |  AdminPaymentsRefundsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsRefundsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsRefundsList>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsRefundsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsRefundsList<TData = Awaited<ReturnType<typeof adminPaymentsRefundsList>>, TError = unknown>(
 params?: AdminPaymentsRefundsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsRefundsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsRefundsList>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsRefundsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsRefundsList<TData = Awaited<ReturnType<typeof adminPaymentsRefundsList>>, TError = unknown>(
 params?: AdminPaymentsRefundsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsRefundsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPaymentsRefundsList<TData = Awaited<ReturnType<typeof adminPaymentsRefundsList>>, TError = unknown>(
 params?: AdminPaymentsRefundsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsRefundsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPaymentsRefundsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPaymentsRefundsCompleteResponse200 = {
  data: Refund
  status: 200
}

export type adminPaymentsRefundsCompleteResponseSuccess = (adminPaymentsRefundsCompleteResponse200) & {
  headers: Headers;
};
;

export type adminPaymentsRefundsCompleteResponse = (adminPaymentsRefundsCompleteResponseSuccess)

export const getAdminPaymentsRefundsCompleteUrl = (uid: string,) => {




  return `/api/v1/admin/payments/refunds/${uid}/complete`
}

/**
 * The team transferred the money by bank (COD orders, or the gateway couldn't): mark it done with the
 * transfer's reference.
 */
export const adminPaymentsRefundsComplete = async (uid: string,
    completeRefundRequest: CompleteRefundRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminPaymentsRefundsCompleteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminPaymentsRefundsCompleteResponse>(getAdminPaymentsRefundsCompleteUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(completeRefundRequest)
  }
);}





export const getAdminPaymentsRefundsCompleteMutationKey = () => ['adminPaymentsRefundsComplete'] as const;

export const getAdminPaymentsRefundsCompleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsRefundsComplete>>, TError,AdminPaymentsRefundsCompleteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsRefundsComplete>>, TError,AdminPaymentsRefundsCompleteMutationVariables, TContext> => {

const mutationKey = getAdminPaymentsRefundsCompleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPaymentsRefundsComplete>>, AdminPaymentsRefundsCompleteMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminPaymentsRefundsComplete(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminPaymentsRefundsCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsRefundsComplete>>>
    export type AdminPaymentsRefundsCompleteMutationBody = CompleteRefundRequest
    export type AdminPaymentsRefundsCompleteMutationError = unknown
    export type AdminPaymentsRefundsCompleteMutationVariables = {uid: string;data: CompleteRefundRequest}

    export const useAdminPaymentsRefundsComplete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsRefundsComplete>>, TError,AdminPaymentsRefundsCompleteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminPaymentsRefundsComplete>>,
        TError,
        AdminPaymentsRefundsCompleteMutationVariables,
        TContext
      > => {
      return useMutation(getAdminPaymentsRefundsCompleteMutationOptions(options), queryClient);
    }
    export type adminPaymentsRefundsRetryResponse201 = {
  data: Refund
  status: 201
}

export type adminPaymentsRefundsRetryResponseSuccess = (adminPaymentsRefundsRetryResponse201) & {
  headers: Headers;
};
;

export type adminPaymentsRefundsRetryResponse = (adminPaymentsRefundsRetryResponseSuccess)

export const getAdminPaymentsRefundsRetryUrl = (uid: string,) => {




  return `/api/v1/admin/payments/refunds/${uid}/retry`
}

/**
 * Send a failed refund to the gateway again (as a new refund).
 */
export const adminPaymentsRefundsRetry = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminPaymentsRefundsRetryResponse> => {

  return apiFetch<adminPaymentsRefundsRetryResponse>(getAdminPaymentsRefundsRetryUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminPaymentsRefundsRetryMutationKey = () => ['adminPaymentsRefundsRetry'] as const;

export const getAdminPaymentsRefundsRetryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsRefundsRetry>>, TError,AdminPaymentsRefundsRetryMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsRefundsRetry>>, TError,AdminPaymentsRefundsRetryMutationVariables, TContext> => {

const mutationKey = getAdminPaymentsRefundsRetryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPaymentsRefundsRetry>>, AdminPaymentsRefundsRetryMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminPaymentsRefundsRetry(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminPaymentsRefundsRetryMutationResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsRefundsRetry>>>

    export type AdminPaymentsRefundsRetryMutationError = unknown
    export type AdminPaymentsRefundsRetryMutationVariables = {uid: string}

    export const useAdminPaymentsRefundsRetry = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsRefundsRetry>>, TError,AdminPaymentsRefundsRetryMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminPaymentsRefundsRetry>>,
        TError,
        AdminPaymentsRefundsRetryMutationVariables,
        TContext
      > => {
      return useMutation(getAdminPaymentsRefundsRetryMutationOptions(options), queryClient);
    }
    export type adminPaymentsRefundsCountsResponse200 = {
  data: RefundCounts
  status: 200
}

export type adminPaymentsRefundsCountsResponseSuccess = (adminPaymentsRefundsCountsResponse200) & {
  headers: Headers;
};
;

export type adminPaymentsRefundsCountsResponse = (adminPaymentsRefundsCountsResponseSuccess)

export const getAdminPaymentsRefundsCountsUrl = () => {




  return `/api/v1/admin/payments/refunds/counts`
}

export const adminPaymentsRefundsCounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminPaymentsRefundsCountsResponse> => {

  return apiFetch<adminPaymentsRefundsCountsResponse>(getAdminPaymentsRefundsCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPaymentsRefundsCountsQueryKey = () => {
    return [
    `/api/v1/admin/payments/refunds/counts`
    ] as const;
    }


export const getAdminPaymentsRefundsCountsQueryOptions = <TData = Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPaymentsRefundsCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>> = ({ signal }) => adminPaymentsRefundsCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPaymentsRefundsCountsQueryResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>>
export type AdminPaymentsRefundsCountsQueryError = unknown


export function useAdminPaymentsRefundsCounts<TData = Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsRefundsCounts<TData = Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsRefundsCounts<TData = Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPaymentsRefundsCounts<TData = Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsRefundsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPaymentsRefundsCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPaymentsTransactionsListResponse200 = {
  data: PaginatedTransactionList
  status: 200
}

export type adminPaymentsTransactionsListResponseSuccess = (adminPaymentsTransactionsListResponse200) & {
  headers: Headers;
};
;

export type adminPaymentsTransactionsListResponse = (adminPaymentsTransactionsListResponseSuccess)

export const getAdminPaymentsTransactionsListUrl = (params?: AdminPaymentsTransactionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/payments/transactions?${stringifiedParams}` : `/api/v1/admin/payments/transactions`
}

/**
 * Every gateway transaction (payments and refunds), newest first.
 */
export const adminPaymentsTransactionsList = async (params?: AdminPaymentsTransactionsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminPaymentsTransactionsListResponse> => {

  return apiFetch<adminPaymentsTransactionsListResponse>(getAdminPaymentsTransactionsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPaymentsTransactionsListQueryKey = (params?: AdminPaymentsTransactionsListParams,) => {
    return [
    `/api/v1/admin/payments/transactions`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminPaymentsTransactionsListQueryOptions = <TData = Awaited<ReturnType<typeof adminPaymentsTransactionsList>>, TError = unknown>(params?: AdminPaymentsTransactionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPaymentsTransactionsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPaymentsTransactionsList>>> = ({ signal }) => adminPaymentsTransactionsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPaymentsTransactionsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsTransactionsList>>>
export type AdminPaymentsTransactionsListQueryError = unknown


export function useAdminPaymentsTransactionsList<TData = Awaited<ReturnType<typeof adminPaymentsTransactionsList>>, TError = unknown>(
 params: undefined |  AdminPaymentsTransactionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsTransactionsList>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsTransactionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsTransactionsList<TData = Awaited<ReturnType<typeof adminPaymentsTransactionsList>>, TError = unknown>(
 params?: AdminPaymentsTransactionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsTransactionsList>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsTransactionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsTransactionsList<TData = Awaited<ReturnType<typeof adminPaymentsTransactionsList>>, TError = unknown>(
 params?: AdminPaymentsTransactionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPaymentsTransactionsList<TData = Awaited<ReturnType<typeof adminPaymentsTransactionsList>>, TError = unknown>(
 params?: AdminPaymentsTransactionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPaymentsTransactionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPaymentsTransactionsRetrieveResponse200 = {
  data: TransactionDetail
  status: 200
}

export type adminPaymentsTransactionsRetrieveResponseSuccess = (adminPaymentsTransactionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminPaymentsTransactionsRetrieveResponse = (adminPaymentsTransactionsRetrieveResponseSuccess)

export const getAdminPaymentsTransactionsRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/payments/transactions/${uid}`
}

export const adminPaymentsTransactionsRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminPaymentsTransactionsRetrieveResponse> => {

  return apiFetch<adminPaymentsTransactionsRetrieveResponse>(getAdminPaymentsTransactionsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPaymentsTransactionsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/payments/transactions/${uid}`
    ] as const;
    }


export const getAdminPaymentsTransactionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPaymentsTransactionsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>> = ({ signal }) => adminPaymentsTransactionsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPaymentsTransactionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>>
export type AdminPaymentsTransactionsRetrieveQueryError = unknown


export function useAdminPaymentsTransactionsRetrieve<TData = Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsTransactionsRetrieve<TData = Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsTransactionsRetrieve<TData = Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPaymentsTransactionsRetrieve<TData = Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPaymentsTransactionsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPaymentsTransactionsCheckResponse200 = {
  data: TransactionDetail
  status: 200
}

export type adminPaymentsTransactionsCheckResponseSuccess = (adminPaymentsTransactionsCheckResponse200) & {
  headers: Headers;
};
;

export type adminPaymentsTransactionsCheckResponse = (adminPaymentsTransactionsCheckResponseSuccess)

export const getAdminPaymentsTransactionsCheckUrl = (uid: string,) => {




  return `/api/v1/admin/payments/transactions/${uid}/check`
}

/**
 * Ask the gateway about a payment that is still pending and record the answer.
 */
export const adminPaymentsTransactionsCheck = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminPaymentsTransactionsCheckResponse> => {

  return apiFetch<adminPaymentsTransactionsCheckResponse>(getAdminPaymentsTransactionsCheckUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminPaymentsTransactionsCheckMutationKey = () => ['adminPaymentsTransactionsCheck'] as const;

export const getAdminPaymentsTransactionsCheckMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsCheck>>, TError,AdminPaymentsTransactionsCheckMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsCheck>>, TError,AdminPaymentsTransactionsCheckMutationVariables, TContext> => {

const mutationKey = getAdminPaymentsTransactionsCheckMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPaymentsTransactionsCheck>>, AdminPaymentsTransactionsCheckMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminPaymentsTransactionsCheck(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminPaymentsTransactionsCheckMutationResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsTransactionsCheck>>>

    export type AdminPaymentsTransactionsCheckMutationError = unknown
    export type AdminPaymentsTransactionsCheckMutationVariables = {uid: string}

    export const useAdminPaymentsTransactionsCheck = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsCheck>>, TError,AdminPaymentsTransactionsCheckMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminPaymentsTransactionsCheck>>,
        TError,
        AdminPaymentsTransactionsCheckMutationVariables,
        TContext
      > => {
      return useMutation(getAdminPaymentsTransactionsCheckMutationOptions(options), queryClient);
    }
    export type adminPaymentsTransactionsCountsResponse200 = {
  data: TransactionCounts
  status: 200
}

export type adminPaymentsTransactionsCountsResponseSuccess = (adminPaymentsTransactionsCountsResponse200) & {
  headers: Headers;
};
;

export type adminPaymentsTransactionsCountsResponse = (adminPaymentsTransactionsCountsResponseSuccess)

export const getAdminPaymentsTransactionsCountsUrl = () => {




  return `/api/v1/admin/payments/transactions/counts`
}

export const adminPaymentsTransactionsCounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminPaymentsTransactionsCountsResponse> => {

  return apiFetch<adminPaymentsTransactionsCountsResponse>(getAdminPaymentsTransactionsCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPaymentsTransactionsCountsQueryKey = () => {
    return [
    `/api/v1/admin/payments/transactions/counts`
    ] as const;
    }


export const getAdminPaymentsTransactionsCountsQueryOptions = <TData = Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPaymentsTransactionsCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>> = ({ signal }) => adminPaymentsTransactionsCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPaymentsTransactionsCountsQueryResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>>
export type AdminPaymentsTransactionsCountsQueryError = unknown


export function useAdminPaymentsTransactionsCounts<TData = Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsTransactionsCounts<TData = Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsTransactionsCounts<TData = Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPaymentsTransactionsCounts<TData = Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsTransactionsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPaymentsTransactionsCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPaymentsWebhooksListResponse200 = {
  data: PaginatedWebhookList
  status: 200
}

export type adminPaymentsWebhooksListResponseSuccess = (adminPaymentsWebhooksListResponse200) & {
  headers: Headers;
};
;

export type adminPaymentsWebhooksListResponse = (adminPaymentsWebhooksListResponseSuccess)

export const getAdminPaymentsWebhooksListUrl = (params?: AdminPaymentsWebhooksListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/payments/webhooks?${stringifiedParams}` : `/api/v1/admin/payments/webhooks`
}

export const adminPaymentsWebhooksList = async (params?: AdminPaymentsWebhooksListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminPaymentsWebhooksListResponse> => {

  return apiFetch<adminPaymentsWebhooksListResponse>(getAdminPaymentsWebhooksListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPaymentsWebhooksListQueryKey = (params?: AdminPaymentsWebhooksListParams,) => {
    return [
    `/api/v1/admin/payments/webhooks`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminPaymentsWebhooksListQueryOptions = <TData = Awaited<ReturnType<typeof adminPaymentsWebhooksList>>, TError = unknown>(params?: AdminPaymentsWebhooksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsWebhooksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPaymentsWebhooksListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPaymentsWebhooksList>>> = ({ signal }) => adminPaymentsWebhooksList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsWebhooksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPaymentsWebhooksListQueryResult = NonNullable<Awaited<ReturnType<typeof adminPaymentsWebhooksList>>>
export type AdminPaymentsWebhooksListQueryError = unknown


export function useAdminPaymentsWebhooksList<TData = Awaited<ReturnType<typeof adminPaymentsWebhooksList>>, TError = unknown>(
 params: undefined |  AdminPaymentsWebhooksListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsWebhooksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsWebhooksList>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsWebhooksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsWebhooksList<TData = Awaited<ReturnType<typeof adminPaymentsWebhooksList>>, TError = unknown>(
 params?: AdminPaymentsWebhooksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsWebhooksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsWebhooksList>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsWebhooksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPaymentsWebhooksList<TData = Awaited<ReturnType<typeof adminPaymentsWebhooksList>>, TError = unknown>(
 params?: AdminPaymentsWebhooksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsWebhooksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPaymentsWebhooksList<TData = Awaited<ReturnType<typeof adminPaymentsWebhooksList>>, TError = unknown>(
 params?: AdminPaymentsWebhooksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsWebhooksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPaymentsWebhooksListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPayoutsListResponse200 = {
  data: PaginatedPayoutList
  status: 200
}

export type adminPayoutsListResponseSuccess = (adminPayoutsListResponse200) & {
  headers: Headers;
};
;

export type adminPayoutsListResponse = (adminPayoutsListResponseSuccess)

export const getAdminPayoutsListUrl = (params?: AdminPayoutsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/payouts?${stringifiedParams}` : `/api/v1/admin/payouts`
}

/**
 * List views put the store names of the page in the context (one call to the vendors module).
 */
export const adminPayoutsList = async (params?: AdminPayoutsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminPayoutsListResponse> => {

  return apiFetch<adminPayoutsListResponse>(getAdminPayoutsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPayoutsListQueryKey = (params?: AdminPayoutsListParams,) => {
    return [
    `/api/v1/admin/payouts`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminPayoutsListQueryOptions = <TData = Awaited<ReturnType<typeof adminPayoutsList>>, TError = unknown>(params?: AdminPayoutsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPayoutsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutsList>>> = ({ signal }) => adminPayoutsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPayoutsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminPayoutsList>>>
export type AdminPayoutsListQueryError = unknown


export function useAdminPayoutsList<TData = Awaited<ReturnType<typeof adminPayoutsList>>, TError = unknown>(
 params: undefined |  AdminPayoutsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsList>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsList<TData = Awaited<ReturnType<typeof adminPayoutsList>>, TError = unknown>(
 params?: AdminPayoutsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsList>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsList<TData = Awaited<ReturnType<typeof adminPayoutsList>>, TError = unknown>(
 params?: AdminPayoutsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPayoutsList<TData = Awaited<ReturnType<typeof adminPayoutsList>>, TError = unknown>(
 params?: AdminPayoutsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPayoutsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPayoutsRetrieveResponse200 = {
  data: PayoutDetail
  status: 200
}

export type adminPayoutsRetrieveResponseSuccess = (adminPayoutsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminPayoutsRetrieveResponse = (adminPayoutsRetrieveResponseSuccess)

export const getAdminPayoutsRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/payouts/${uid}`
}

export const adminPayoutsRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminPayoutsRetrieveResponse> => {

  return apiFetch<adminPayoutsRetrieveResponse>(getAdminPayoutsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPayoutsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/payouts/${uid}`
    ] as const;
    }


export const getAdminPayoutsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminPayoutsRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPayoutsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutsRetrieve>>> = ({ signal }) => adminPayoutsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPayoutsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminPayoutsRetrieve>>>
export type AdminPayoutsRetrieveQueryError = unknown


export function useAdminPayoutsRetrieve<TData = Awaited<ReturnType<typeof adminPayoutsRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsRetrieve<TData = Awaited<ReturnType<typeof adminPayoutsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsRetrieve<TData = Awaited<ReturnType<typeof adminPayoutsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPayoutsRetrieve<TData = Awaited<ReturnType<typeof adminPayoutsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPayoutsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPayoutsApproveResponse200 = {
  data: PayoutDetail
  status: 200
}

export type adminPayoutsApproveResponseSuccess = (adminPayoutsApproveResponse200) & {
  headers: Headers;
};
;

export type adminPayoutsApproveResponse = (adminPayoutsApproveResponseSuccess)

export const getAdminPayoutsApproveUrl = (uid: string,) => {




  return `/api/v1/admin/payouts/${uid}/approve`
}

export const adminPayoutsApprove = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminPayoutsApproveResponse> => {

  return apiFetch<adminPayoutsApproveResponse>(getAdminPayoutsApproveUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminPayoutsApproveMutationKey = () => ['adminPayoutsApprove'] as const;

export const getAdminPayoutsApproveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsApprove>>, TError,AdminPayoutsApproveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsApprove>>, TError,AdminPayoutsApproveMutationVariables, TContext> => {

const mutationKey = getAdminPayoutsApproveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPayoutsApprove>>, AdminPayoutsApproveMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminPayoutsApprove(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminPayoutsApproveMutationResult = NonNullable<Awaited<ReturnType<typeof adminPayoutsApprove>>>

    export type AdminPayoutsApproveMutationError = unknown
    export type AdminPayoutsApproveMutationVariables = {uid: string}

    export const useAdminPayoutsApprove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsApprove>>, TError,AdminPayoutsApproveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminPayoutsApprove>>,
        TError,
        AdminPayoutsApproveMutationVariables,
        TContext
      > => {
      return useMutation(getAdminPayoutsApproveMutationOptions(options), queryClient);
    }
    export type adminPayoutsCancelResponse200 = {
  data: PayoutDetail
  status: 200
}

export type adminPayoutsCancelResponseSuccess = (adminPayoutsCancelResponse200) & {
  headers: Headers;
};
;

export type adminPayoutsCancelResponse = (adminPayoutsCancelResponseSuccess)

export const getAdminPayoutsCancelUrl = (uid: string,) => {




  return `/api/v1/admin/payouts/${uid}/cancel`
}

export const adminPayoutsCancel = async (uid: string,
    payoutCancelRequest?: PayoutCancelRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminPayoutsCancelResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminPayoutsCancelResponse>(getAdminPayoutsCancelUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(payoutCancelRequest)
  }
);}





export const getAdminPayoutsCancelMutationKey = () => ['adminPayoutsCancel'] as const;

export const getAdminPayoutsCancelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsCancel>>, TError,AdminPayoutsCancelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsCancel>>, TError,AdminPayoutsCancelMutationVariables, TContext> => {

const mutationKey = getAdminPayoutsCancelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPayoutsCancel>>, AdminPayoutsCancelMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminPayoutsCancel(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminPayoutsCancelMutationResult = NonNullable<Awaited<ReturnType<typeof adminPayoutsCancel>>>
    export type AdminPayoutsCancelMutationBody = PayoutCancelRequest | undefined
    export type AdminPayoutsCancelMutationError = unknown
    export type AdminPayoutsCancelMutationVariables = {uid: string;data?: PayoutCancelRequest}

    export const useAdminPayoutsCancel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsCancel>>, TError,AdminPayoutsCancelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminPayoutsCancel>>,
        TError,
        AdminPayoutsCancelMutationVariables,
        TContext
      > => {
      return useMutation(getAdminPayoutsCancelMutationOptions(options), queryClient);
    }
    export type adminPayoutsPaidResponse200 = {
  data: PayoutDetail
  status: 200
}

export type adminPayoutsPaidResponseSuccess = (adminPayoutsPaidResponse200) & {
  headers: Headers;
};
;

export type adminPayoutsPaidResponse = (adminPayoutsPaidResponseSuccess)

export const getAdminPayoutsPaidUrl = (uid: string,) => {




  return `/api/v1/admin/payouts/${uid}/paid`
}

/**
 * The bank transfer is done: record its UTR; the store is told.
 */
export const adminPayoutsPaid = async (uid: string,
    paidRequest: PaidRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminPayoutsPaidResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminPayoutsPaidResponse>(getAdminPayoutsPaidUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(paidRequest)
  }
);}





export const getAdminPayoutsPaidMutationKey = () => ['adminPayoutsPaid'] as const;

export const getAdminPayoutsPaidMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsPaid>>, TError,AdminPayoutsPaidMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsPaid>>, TError,AdminPayoutsPaidMutationVariables, TContext> => {

const mutationKey = getAdminPayoutsPaidMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPayoutsPaid>>, AdminPayoutsPaidMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminPayoutsPaid(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminPayoutsPaidMutationResult = NonNullable<Awaited<ReturnType<typeof adminPayoutsPaid>>>
    export type AdminPayoutsPaidMutationBody = PaidRequest
    export type AdminPayoutsPaidMutationError = unknown
    export type AdminPayoutsPaidMutationVariables = {uid: string;data: PaidRequest}

    export const useAdminPayoutsPaid = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsPaid>>, TError,AdminPayoutsPaidMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminPayoutsPaid>>,
        TError,
        AdminPayoutsPaidMutationVariables,
        TContext
      > => {
      return useMutation(getAdminPayoutsPaidMutationOptions(options), queryClient);
    }
    export type adminPayoutsBalancesResponse200 = {
  data: Balance[]
  status: 200
}

export type adminPayoutsBalancesResponseSuccess = (adminPayoutsBalancesResponse200) & {
  headers: Headers;
};
;

export type adminPayoutsBalancesResponse = (adminPayoutsBalancesResponseSuccess)

export const getAdminPayoutsBalancesUrl = () => {




  return `/api/v1/admin/payouts/balances`
}

export const adminPayoutsBalances = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminPayoutsBalancesResponse> => {

  return apiFetch<adminPayoutsBalancesResponse>(getAdminPayoutsBalancesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPayoutsBalancesQueryKey = () => {
    return [
    `/api/v1/admin/payouts/balances`
    ] as const;
    }


export const getAdminPayoutsBalancesQueryOptions = <TData = Awaited<ReturnType<typeof adminPayoutsBalances>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsBalances>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPayoutsBalancesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutsBalances>>> = ({ signal }) => adminPayoutsBalances({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsBalances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPayoutsBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof adminPayoutsBalances>>>
export type AdminPayoutsBalancesQueryError = unknown


export function useAdminPayoutsBalances<TData = Awaited<ReturnType<typeof adminPayoutsBalances>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsBalances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsBalances>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsBalances<TData = Awaited<ReturnType<typeof adminPayoutsBalances>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsBalances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsBalances>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsBalances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsBalances<TData = Awaited<ReturnType<typeof adminPayoutsBalances>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsBalances>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPayoutsBalances<TData = Awaited<ReturnType<typeof adminPayoutsBalances>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsBalances>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPayoutsBalancesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPayoutsCountsResponse200 = {
  data: PayoutCounts
  status: 200
}

export type adminPayoutsCountsResponseSuccess = (adminPayoutsCountsResponse200) & {
  headers: Headers;
};
;

export type adminPayoutsCountsResponse = (adminPayoutsCountsResponseSuccess)

export const getAdminPayoutsCountsUrl = () => {




  return `/api/v1/admin/payouts/counts`
}

export const adminPayoutsCounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminPayoutsCountsResponse> => {

  return apiFetch<adminPayoutsCountsResponse>(getAdminPayoutsCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPayoutsCountsQueryKey = () => {
    return [
    `/api/v1/admin/payouts/counts`
    ] as const;
    }


export const getAdminPayoutsCountsQueryOptions = <TData = Awaited<ReturnType<typeof adminPayoutsCounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPayoutsCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutsCounts>>> = ({ signal }) => adminPayoutsCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPayoutsCountsQueryResult = NonNullable<Awaited<ReturnType<typeof adminPayoutsCounts>>>
export type AdminPayoutsCountsQueryError = unknown


export function useAdminPayoutsCounts<TData = Awaited<ReturnType<typeof adminPayoutsCounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsCounts<TData = Awaited<ReturnType<typeof adminPayoutsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsCounts<TData = Awaited<ReturnType<typeof adminPayoutsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPayoutsCounts<TData = Awaited<ReturnType<typeof adminPayoutsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPayoutsCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPayoutsExportResponse200 = {
  data: string
  status: 200
}

export type adminPayoutsExportResponseSuccess = (adminPayoutsExportResponse200) & {
  headers: Headers;
};
;

export type adminPayoutsExportResponse = (adminPayoutsExportResponseSuccess)

export const getAdminPayoutsExportUrl = (params?: AdminPayoutsExportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/payouts/export?${stringifiedParams}` : `/api/v1/admin/payouts/export`
}

/**
 * The payouts as CSV (e.g. to upload a bulk transfer to the bank).
 */
export const adminPayoutsExport = async (params?: AdminPayoutsExportParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminPayoutsExportResponse> => {

  return apiFetch<adminPayoutsExportResponse>(getAdminPayoutsExportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPayoutsExportQueryKey = (params?: AdminPayoutsExportParams,) => {
    return [
    `/api/v1/admin/payouts/export`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminPayoutsExportQueryOptions = <TData = Awaited<ReturnType<typeof adminPayoutsExport>>, TError = unknown>(params?: AdminPayoutsExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPayoutsExportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutsExport>>> = ({ signal }) => adminPayoutsExport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPayoutsExportQueryResult = NonNullable<Awaited<ReturnType<typeof adminPayoutsExport>>>
export type AdminPayoutsExportQueryError = unknown


export function useAdminPayoutsExport<TData = Awaited<ReturnType<typeof adminPayoutsExport>>, TError = unknown>(
 params: undefined |  AdminPayoutsExportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsExport>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsExport<TData = Awaited<ReturnType<typeof adminPayoutsExport>>, TError = unknown>(
 params?: AdminPayoutsExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsExport>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsExport<TData = Awaited<ReturnType<typeof adminPayoutsExport>>, TError = unknown>(
 params?: AdminPayoutsExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPayoutsExport<TData = Awaited<ReturnType<typeof adminPayoutsExport>>, TError = unknown>(
 params?: AdminPayoutsExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPayoutsExportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPayoutsGenerateResponse201 = {
  data: Generated
  status: 201
}

export type adminPayoutsGenerateResponseSuccess = (adminPayoutsGenerateResponse201) & {
  headers: Headers;
};
;

export type adminPayoutsGenerateResponse = (adminPayoutsGenerateResponseSuccess)

export const getAdminPayoutsGenerateUrl = () => {




  return `/api/v1/admin/payouts/generate`
}

/**
 * Draft payouts for every store with available earnings (or one store).
 */
export const adminPayoutsGenerate = async (generateRequest?: GenerateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminPayoutsGenerateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminPayoutsGenerateResponse>(getAdminPayoutsGenerateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(generateRequest)
  }
);}





export const getAdminPayoutsGenerateMutationKey = () => ['adminPayoutsGenerate'] as const;

export const getAdminPayoutsGenerateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsGenerate>>, TError,AdminPayoutsGenerateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsGenerate>>, TError,AdminPayoutsGenerateMutationVariables, TContext> => {

const mutationKey = getAdminPayoutsGenerateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPayoutsGenerate>>, AdminPayoutsGenerateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminPayoutsGenerate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminPayoutsGenerateMutationResult = NonNullable<Awaited<ReturnType<typeof adminPayoutsGenerate>>>
    export type AdminPayoutsGenerateMutationBody = GenerateRequest | undefined
    export type AdminPayoutsGenerateMutationError = unknown
    export type AdminPayoutsGenerateMutationVariables = {data?: GenerateRequest}

    export const useAdminPayoutsGenerate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsGenerate>>, TError,AdminPayoutsGenerateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminPayoutsGenerate>>,
        TError,
        AdminPayoutsGenerateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminPayoutsGenerateMutationOptions(options), queryClient);
    }
    export type adminPayoutsLedgerResponse200 = {
  data: PaginatedEntryList
  status: 200
}

export type adminPayoutsLedgerResponseSuccess = (adminPayoutsLedgerResponse200) & {
  headers: Headers;
};
;

export type adminPayoutsLedgerResponse = (adminPayoutsLedgerResponseSuccess)

export const getAdminPayoutsLedgerUrl = (params?: AdminPayoutsLedgerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/payouts/ledger?${stringifiedParams}` : `/api/v1/admin/payouts/ledger`
}

/**
 * List views put the store names of the page in the context (one call to the vendors module).
 */
export const adminPayoutsLedger = async (params?: AdminPayoutsLedgerParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminPayoutsLedgerResponse> => {

  return apiFetch<adminPayoutsLedgerResponse>(getAdminPayoutsLedgerUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPayoutsLedgerQueryKey = (params?: AdminPayoutsLedgerParams,) => {
    return [
    `/api/v1/admin/payouts/ledger`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminPayoutsLedgerQueryOptions = <TData = Awaited<ReturnType<typeof adminPayoutsLedger>>, TError = unknown>(params?: AdminPayoutsLedgerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsLedger>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPayoutsLedgerQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutsLedger>>> = ({ signal }) => adminPayoutsLedger(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsLedger>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPayoutsLedgerQueryResult = NonNullable<Awaited<ReturnType<typeof adminPayoutsLedger>>>
export type AdminPayoutsLedgerQueryError = unknown


export function useAdminPayoutsLedger<TData = Awaited<ReturnType<typeof adminPayoutsLedger>>, TError = unknown>(
 params: undefined |  AdminPayoutsLedgerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsLedger>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsLedger>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsLedger>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsLedger<TData = Awaited<ReturnType<typeof adminPayoutsLedger>>, TError = unknown>(
 params?: AdminPayoutsLedgerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsLedger>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsLedger>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsLedger>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsLedger<TData = Awaited<ReturnType<typeof adminPayoutsLedger>>, TError = unknown>(
 params?: AdminPayoutsLedgerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsLedger>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPayoutsLedger<TData = Awaited<ReturnType<typeof adminPayoutsLedger>>, TError = unknown>(
 params?: AdminPayoutsLedgerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsLedger>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPayoutsLedgerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPayoutsAdjustResponse201 = {
  data: Entry
  status: 201
}

export type adminPayoutsAdjustResponseSuccess = (adminPayoutsAdjustResponse201) & {
  headers: Headers;
};
;

export type adminPayoutsAdjustResponse = (adminPayoutsAdjustResponseSuccess)

export const getAdminPayoutsAdjustUrl = () => {




  return `/api/v1/admin/payouts/ledger/adjustments`
}

/**
 * A manual correction on a store's ledger, payable in the next payout (e.g. a goodwill credit).
 */
export const adminPayoutsAdjust = async (adjustmentRequest: AdjustmentRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminPayoutsAdjustResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminPayoutsAdjustResponse>(getAdminPayoutsAdjustUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adjustmentRequest)
  }
);}





export const getAdminPayoutsAdjustMutationKey = () => ['adminPayoutsAdjust'] as const;

export const getAdminPayoutsAdjustMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsAdjust>>, TError,AdminPayoutsAdjustMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsAdjust>>, TError,AdminPayoutsAdjustMutationVariables, TContext> => {

const mutationKey = getAdminPayoutsAdjustMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminPayoutsAdjust>>, AdminPayoutsAdjustMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminPayoutsAdjust(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminPayoutsAdjustMutationResult = NonNullable<Awaited<ReturnType<typeof adminPayoutsAdjust>>>
    export type AdminPayoutsAdjustMutationBody = AdjustmentRequest
    export type AdminPayoutsAdjustMutationError = unknown
    export type AdminPayoutsAdjustMutationVariables = {data: AdjustmentRequest}

    export const useAdminPayoutsAdjust = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminPayoutsAdjust>>, TError,AdminPayoutsAdjustMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminPayoutsAdjust>>,
        TError,
        AdminPayoutsAdjustMutationVariables,
        TContext
      > => {
      return useMutation(getAdminPayoutsAdjustMutationOptions(options), queryClient);
    }
    export type adminPayoutsTaxDeductionsResponse200 = {
  data: TaxDeductionSummary
  status: 200
}

export type adminPayoutsTaxDeductionsResponseSuccess = (adminPayoutsTaxDeductionsResponse200) & {
  headers: Headers;
};
;

export type adminPayoutsTaxDeductionsResponse = (adminPayoutsTaxDeductionsResponseSuccess)

export const getAdminPayoutsTaxDeductionsUrl = (params?: AdminPayoutsTaxDeductionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/payouts/tax-deductions?${stringifiedParams}` : `/api/v1/admin/payouts/tax-deductions`
}

export const adminPayoutsTaxDeductions = async (params?: AdminPayoutsTaxDeductionsParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminPayoutsTaxDeductionsResponse> => {

  return apiFetch<adminPayoutsTaxDeductionsResponse>(getAdminPayoutsTaxDeductionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPayoutsTaxDeductionsQueryKey = (params?: AdminPayoutsTaxDeductionsParams,) => {
    return [
    `/api/v1/admin/payouts/tax-deductions`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminPayoutsTaxDeductionsQueryOptions = <TData = Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>, TError = unknown>(params?: AdminPayoutsTaxDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPayoutsTaxDeductionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>> = ({ signal }) => adminPayoutsTaxDeductions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPayoutsTaxDeductionsQueryResult = NonNullable<Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>>
export type AdminPayoutsTaxDeductionsQueryError = unknown


export function useAdminPayoutsTaxDeductions<TData = Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>, TError = unknown>(
 params: undefined |  AdminPayoutsTaxDeductionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsTaxDeductions<TData = Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>, TError = unknown>(
 params?: AdminPayoutsTaxDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsTaxDeductions<TData = Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>, TError = unknown>(
 params?: AdminPayoutsTaxDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPayoutsTaxDeductions<TData = Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>, TError = unknown>(
 params?: AdminPayoutsTaxDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsTaxDeductions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPayoutsTaxDeductionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPayoutsTaxDeductionsExportResponse200 = {
  data: string
  status: 200
}

export type adminPayoutsTaxDeductionsExportResponseSuccess = (adminPayoutsTaxDeductionsExportResponse200) & {
  headers: Headers;
};
;

export type adminPayoutsTaxDeductionsExportResponse = (adminPayoutsTaxDeductionsExportResponseSuccess)

export const getAdminPayoutsTaxDeductionsExportUrl = (params?: AdminPayoutsTaxDeductionsExportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/payouts/tax-deductions/export?${stringifiedParams}` : `/api/v1/admin/payouts/tax-deductions/export`
}

export const adminPayoutsTaxDeductionsExport = async (params?: AdminPayoutsTaxDeductionsExportParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminPayoutsTaxDeductionsExportResponse> => {

  return apiFetch<adminPayoutsTaxDeductionsExportResponse>(getAdminPayoutsTaxDeductionsExportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPayoutsTaxDeductionsExportQueryKey = (params?: AdminPayoutsTaxDeductionsExportParams,) => {
    return [
    `/api/v1/admin/payouts/tax-deductions/export`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminPayoutsTaxDeductionsExportQueryOptions = <TData = Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>, TError = unknown>(params?: AdminPayoutsTaxDeductionsExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPayoutsTaxDeductionsExportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>> = ({ signal }) => adminPayoutsTaxDeductionsExport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPayoutsTaxDeductionsExportQueryResult = NonNullable<Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>>
export type AdminPayoutsTaxDeductionsExportQueryError = unknown


export function useAdminPayoutsTaxDeductionsExport<TData = Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>, TError = unknown>(
 params: undefined |  AdminPayoutsTaxDeductionsExportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsTaxDeductionsExport<TData = Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>, TError = unknown>(
 params?: AdminPayoutsTaxDeductionsExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>,
          TError,
          Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPayoutsTaxDeductionsExport<TData = Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>, TError = unknown>(
 params?: AdminPayoutsTaxDeductionsExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPayoutsTaxDeductionsExport<TData = Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>, TError = unknown>(
 params?: AdminPayoutsTaxDeductionsExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutsTaxDeductionsExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPayoutsTaxDeductionsExportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminPermissionsListResponse200 = {
  data: PermissionModule[]
  status: 200
}

export type adminPermissionsListResponseSuccess = (adminPermissionsListResponse200) & {
  headers: Headers;
};
;

export type adminPermissionsListResponse = (adminPermissionsListResponseSuccess)

export const getAdminPermissionsListUrl = () => {




  return `/api/v1/admin/permissions`
}

/**
 * Every permission a role can have, grouped by module and model (the role editor's matrix).
 */
export const adminPermissionsList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminPermissionsListResponse> => {

  return apiFetch<adminPermissionsListResponse>(getAdminPermissionsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminPermissionsListQueryKey = () => {
    return [
    `/api/v1/admin/permissions`
    ] as const;
    }


export const getAdminPermissionsListQueryOptions = <TData = Awaited<ReturnType<typeof adminPermissionsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPermissionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminPermissionsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPermissionsList>>> = ({ signal }) => adminPermissionsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminPermissionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminPermissionsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminPermissionsList>>>
export type AdminPermissionsListQueryError = unknown


export function useAdminPermissionsList<TData = Awaited<ReturnType<typeof adminPermissionsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPermissionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPermissionsList>>,
          TError,
          Awaited<ReturnType<typeof adminPermissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPermissionsList<TData = Awaited<ReturnType<typeof adminPermissionsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPermissionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPermissionsList>>,
          TError,
          Awaited<ReturnType<typeof adminPermissionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminPermissionsList<TData = Awaited<ReturnType<typeof adminPermissionsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPermissionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminPermissionsList<TData = Awaited<ReturnType<typeof adminPermissionsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPermissionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminPermissionsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminProductsListResponse200 = {
  data: PaginatedProductListList
  status: 200
}

export type adminProductsListResponseSuccess = (adminProductsListResponse200) & {
  headers: Headers;
};
;

export type adminProductsListResponse = (adminProductsListResponseSuccess)

export const getAdminProductsListUrl = (params?: AdminProductsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/products?${stringifiedParams}` : `/api/v1/admin/products`
}

export const adminProductsList = async (params?: AdminProductsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminProductsListResponse> => {

  return apiFetch<adminProductsListResponse>(getAdminProductsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminProductsListQueryKey = (params?: AdminProductsListParams,) => {
    return [
    `/api/v1/admin/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminProductsListQueryOptions = <TData = Awaited<ReturnType<typeof adminProductsList>>, TError = unknown>(params?: AdminProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminProductsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminProductsList>>> = ({ signal }) => adminProductsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminProductsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminProductsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminProductsList>>>
export type AdminProductsListQueryError = unknown


export function useAdminProductsList<TData = Awaited<ReturnType<typeof adminProductsList>>, TError = unknown>(
 params: undefined |  AdminProductsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminProductsList>>,
          TError,
          Awaited<ReturnType<typeof adminProductsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminProductsList<TData = Awaited<ReturnType<typeof adminProductsList>>, TError = unknown>(
 params?: AdminProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminProductsList>>,
          TError,
          Awaited<ReturnType<typeof adminProductsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminProductsList<TData = Awaited<ReturnType<typeof adminProductsList>>, TError = unknown>(
 params?: AdminProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminProductsList<TData = Awaited<ReturnType<typeof adminProductsList>>, TError = unknown>(
 params?: AdminProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminProductsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminProductsCreateResponse201 = {
  data: ProductDetail
  status: 201
}

export type adminProductsCreateResponseSuccess = (adminProductsCreateResponse201) & {
  headers: Headers;
};
;

export type adminProductsCreateResponse = (adminProductsCreateResponseSuccess)

export const getAdminProductsCreateUrl = () => {




  return `/api/v1/admin/products`
}

/**
 * A company product (sold by the platform vendor), saved as a draft.
 */
export const adminProductsCreate = async (productWriteRequest?: ProductWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminProductsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminProductsCreateResponse>(getAdminProductsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productWriteRequest)
  }
);}





export const getAdminProductsCreateMutationKey = () => ['adminProductsCreate'] as const;

export const getAdminProductsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsCreate>>, TError,AdminProductsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProductsCreate>>, TError,AdminProductsCreateMutationVariables, TContext> => {

const mutationKey = getAdminProductsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProductsCreate>>, AdminProductsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminProductsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminProductsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminProductsCreate>>>
    export type AdminProductsCreateMutationBody = ProductWriteRequest | undefined
    export type AdminProductsCreateMutationError = unknown
    export type AdminProductsCreateMutationVariables = {data?: ProductWriteRequest}

    export const useAdminProductsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsCreate>>, TError,AdminProductsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProductsCreate>>,
        TError,
        AdminProductsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminProductsCreateMutationOptions(options), queryClient);
    }
    export type adminProductsRetrieveResponse200 = {
  data: ProductDetail
  status: 200
}

export type adminProductsRetrieveResponseSuccess = (adminProductsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminProductsRetrieveResponse = (adminProductsRetrieveResponseSuccess)

export const getAdminProductsRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/products/${uid}`
}

export const adminProductsRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminProductsRetrieveResponse> => {

  return apiFetch<adminProductsRetrieveResponse>(getAdminProductsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminProductsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/products/${uid}`
    ] as const;
    }


export const getAdminProductsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminProductsRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminProductsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminProductsRetrieve>>> = ({ signal }) => adminProductsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminProductsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminProductsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminProductsRetrieve>>>
export type AdminProductsRetrieveQueryError = unknown


export function useAdminProductsRetrieve<TData = Awaited<ReturnType<typeof adminProductsRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminProductsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminProductsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminProductsRetrieve<TData = Awaited<ReturnType<typeof adminProductsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminProductsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminProductsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminProductsRetrieve<TData = Awaited<ReturnType<typeof adminProductsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminProductsRetrieve<TData = Awaited<ReturnType<typeof adminProductsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminProductsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminProductsPartialUpdateResponse200 = {
  data: ProductDetail
  status: 200
}

export type adminProductsPartialUpdateResponseSuccess = (adminProductsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminProductsPartialUpdateResponse = (adminProductsPartialUpdateResponseSuccess)

export const getAdminProductsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/products/${uid}`
}

export const adminProductsPartialUpdate = async (uid: string,
    patchedProductWriteRequest?: PatchedProductWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminProductsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminProductsPartialUpdateResponse>(getAdminProductsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedProductWriteRequest)
  }
);}





export const getAdminProductsPartialUpdateMutationKey = () => ['adminProductsPartialUpdate'] as const;

export const getAdminProductsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsPartialUpdate>>, TError,AdminProductsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProductsPartialUpdate>>, TError,AdminProductsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminProductsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProductsPartialUpdate>>, AdminProductsPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminProductsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminProductsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminProductsPartialUpdate>>>
    export type AdminProductsPartialUpdateMutationBody = PatchedProductWriteRequest | undefined
    export type AdminProductsPartialUpdateMutationError = unknown
    export type AdminProductsPartialUpdateMutationVariables = {uid: string;data?: PatchedProductWriteRequest}

    export const useAdminProductsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsPartialUpdate>>, TError,AdminProductsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProductsPartialUpdate>>,
        TError,
        AdminProductsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminProductsPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminProductsDestroyResponse204 = {
  data: void
  status: 204
}

export type adminProductsDestroyResponseSuccess = (adminProductsDestroyResponse204) & {
  headers: Headers;
};
;

export type adminProductsDestroyResponse = (adminProductsDestroyResponseSuccess)

export const getAdminProductsDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/products/${uid}`
}

export const adminProductsDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminProductsDestroyResponse> => {

  return apiFetch<adminProductsDestroyResponse>(getAdminProductsDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminProductsDestroyMutationKey = () => ['adminProductsDestroy'] as const;

export const getAdminProductsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsDestroy>>, TError,AdminProductsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProductsDestroy>>, TError,AdminProductsDestroyMutationVariables, TContext> => {

const mutationKey = getAdminProductsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProductsDestroy>>, AdminProductsDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminProductsDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminProductsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminProductsDestroy>>>

    export type AdminProductsDestroyMutationError = unknown
    export type AdminProductsDestroyMutationVariables = {uid: string}

    export const useAdminProductsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsDestroy>>, TError,AdminProductsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProductsDestroy>>,
        TError,
        AdminProductsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminProductsDestroyMutationOptions(options), queryClient);
    }
    export type adminProductsApproveResponse200 = {
  data: ProductDetail
  status: 200
}

export type adminProductsApproveResponseSuccess = (adminProductsApproveResponse200) & {
  headers: Headers;
};
;

export type adminProductsApproveResponse = (adminProductsApproveResponseSuccess)

export const getAdminProductsApproveUrl = (uid: string,) => {




  return `/api/v1/admin/products/${uid}/approve`
}

export const adminProductsApprove = async (uid: string,
    productNoteRequest?: ProductNoteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminProductsApproveResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminProductsApproveResponse>(getAdminProductsApproveUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productNoteRequest)
  }
);}





export const getAdminProductsApproveMutationKey = () => ['adminProductsApprove'] as const;

export const getAdminProductsApproveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsApprove>>, TError,AdminProductsApproveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProductsApprove>>, TError,AdminProductsApproveMutationVariables, TContext> => {

const mutationKey = getAdminProductsApproveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProductsApprove>>, AdminProductsApproveMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminProductsApprove(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminProductsApproveMutationResult = NonNullable<Awaited<ReturnType<typeof adminProductsApprove>>>
    export type AdminProductsApproveMutationBody = ProductNoteRequest | undefined
    export type AdminProductsApproveMutationError = unknown
    export type AdminProductsApproveMutationVariables = {uid: string;data?: ProductNoteRequest}

    export const useAdminProductsApprove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsApprove>>, TError,AdminProductsApproveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProductsApprove>>,
        TError,
        AdminProductsApproveMutationVariables,
        TContext
      > => {
      return useMutation(getAdminProductsApproveMutationOptions(options), queryClient);
    }
    export type adminProductsHistoryResponse200 = {
  data: ProductHistory[]
  status: 200
}

export type adminProductsHistoryResponseSuccess = (adminProductsHistoryResponse200) & {
  headers: Headers;
};
;

export type adminProductsHistoryResponse = (adminProductsHistoryResponseSuccess)

export const getAdminProductsHistoryUrl = (uid: string,) => {




  return `/api/v1/admin/products/${uid}/history`
}

export const adminProductsHistory = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminProductsHistoryResponse> => {

  return apiFetch<adminProductsHistoryResponse>(getAdminProductsHistoryUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminProductsHistoryQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/products/${uid}/history`
    ] as const;
    }


export const getAdminProductsHistoryQueryOptions = <TData = Awaited<ReturnType<typeof adminProductsHistory>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsHistory>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminProductsHistoryQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminProductsHistory>>> = ({ signal }) => adminProductsHistory(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminProductsHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminProductsHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof adminProductsHistory>>>
export type AdminProductsHistoryQueryError = unknown


export function useAdminProductsHistory<TData = Awaited<ReturnType<typeof adminProductsHistory>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminProductsHistory>>,
          TError,
          Awaited<ReturnType<typeof adminProductsHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminProductsHistory<TData = Awaited<ReturnType<typeof adminProductsHistory>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminProductsHistory>>,
          TError,
          Awaited<ReturnType<typeof adminProductsHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminProductsHistory<TData = Awaited<ReturnType<typeof adminProductsHistory>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsHistory>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminProductsHistory<TData = Awaited<ReturnType<typeof adminProductsHistory>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsHistory>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminProductsHistoryQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminProductsKeepUnderReviewResponse200 = {
  data: ProductDetail
  status: 200
}

export type adminProductsKeepUnderReviewResponseSuccess = (adminProductsKeepUnderReviewResponse200) & {
  headers: Headers;
};
;

export type adminProductsKeepUnderReviewResponse = (adminProductsKeepUnderReviewResponseSuccess)

export const getAdminProductsKeepUnderReviewUrl = (uid: string,) => {




  return `/api/v1/admin/products/${uid}/keep-under-review`
}

export const adminProductsKeepUnderReview = async (uid: string,
    productRequiredNoteRequest: ProductRequiredNoteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminProductsKeepUnderReviewResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminProductsKeepUnderReviewResponse>(getAdminProductsKeepUnderReviewUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productRequiredNoteRequest)
  }
);}





export const getAdminProductsKeepUnderReviewMutationKey = () => ['adminProductsKeepUnderReview'] as const;

export const getAdminProductsKeepUnderReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsKeepUnderReview>>, TError,AdminProductsKeepUnderReviewMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProductsKeepUnderReview>>, TError,AdminProductsKeepUnderReviewMutationVariables, TContext> => {

const mutationKey = getAdminProductsKeepUnderReviewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProductsKeepUnderReview>>, AdminProductsKeepUnderReviewMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminProductsKeepUnderReview(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminProductsKeepUnderReviewMutationResult = NonNullable<Awaited<ReturnType<typeof adminProductsKeepUnderReview>>>
    export type AdminProductsKeepUnderReviewMutationBody = ProductRequiredNoteRequest
    export type AdminProductsKeepUnderReviewMutationError = unknown
    export type AdminProductsKeepUnderReviewMutationVariables = {uid: string;data: ProductRequiredNoteRequest}

    export const useAdminProductsKeepUnderReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsKeepUnderReview>>, TError,AdminProductsKeepUnderReviewMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProductsKeepUnderReview>>,
        TError,
        AdminProductsKeepUnderReviewMutationVariables,
        TContext
      > => {
      return useMutation(getAdminProductsKeepUnderReviewMutationOptions(options), queryClient);
    }
    export type adminProductsPublishResponse200 = {
  data: ProductDetail
  status: 200
}

export type adminProductsPublishResponseSuccess = (adminProductsPublishResponse200) & {
  headers: Headers;
};
;

export type adminProductsPublishResponse = (adminProductsPublishResponseSuccess)

export const getAdminProductsPublishUrl = (uid: string,) => {




  return `/api/v1/admin/products/${uid}/publish`
}

export const adminProductsPublish = async (uid: string,
    productPublishRequest: ProductPublishRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminProductsPublishResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminProductsPublishResponse>(getAdminProductsPublishUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productPublishRequest)
  }
);}





export const getAdminProductsPublishMutationKey = () => ['adminProductsPublish'] as const;

export const getAdminProductsPublishMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsPublish>>, TError,AdminProductsPublishMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProductsPublish>>, TError,AdminProductsPublishMutationVariables, TContext> => {

const mutationKey = getAdminProductsPublishMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProductsPublish>>, AdminProductsPublishMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminProductsPublish(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminProductsPublishMutationResult = NonNullable<Awaited<ReturnType<typeof adminProductsPublish>>>
    export type AdminProductsPublishMutationBody = ProductPublishRequest
    export type AdminProductsPublishMutationError = unknown
    export type AdminProductsPublishMutationVariables = {uid: string;data: ProductPublishRequest}

    export const useAdminProductsPublish = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsPublish>>, TError,AdminProductsPublishMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProductsPublish>>,
        TError,
        AdminProductsPublishMutationVariables,
        TContext
      > => {
      return useMutation(getAdminProductsPublishMutationOptions(options), queryClient);
    }
    export type adminProductsRejectResponse200 = {
  data: ProductDetail
  status: 200
}

export type adminProductsRejectResponseSuccess = (adminProductsRejectResponse200) & {
  headers: Headers;
};
;

export type adminProductsRejectResponse = (adminProductsRejectResponseSuccess)

export const getAdminProductsRejectUrl = (uid: string,) => {




  return `/api/v1/admin/products/${uid}/reject`
}

export const adminProductsReject = async (uid: string,
    productReasonRequest: ProductReasonRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminProductsRejectResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminProductsRejectResponse>(getAdminProductsRejectUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productReasonRequest)
  }
);}





export const getAdminProductsRejectMutationKey = () => ['adminProductsReject'] as const;

export const getAdminProductsRejectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsReject>>, TError,AdminProductsRejectMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProductsReject>>, TError,AdminProductsRejectMutationVariables, TContext> => {

const mutationKey = getAdminProductsRejectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProductsReject>>, AdminProductsRejectMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminProductsReject(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminProductsRejectMutationResult = NonNullable<Awaited<ReturnType<typeof adminProductsReject>>>
    export type AdminProductsRejectMutationBody = ProductReasonRequest
    export type AdminProductsRejectMutationError = unknown
    export type AdminProductsRejectMutationVariables = {uid: string;data: ProductReasonRequest}

    export const useAdminProductsReject = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsReject>>, TError,AdminProductsRejectMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProductsReject>>,
        TError,
        AdminProductsRejectMutationVariables,
        TContext
      > => {
      return useMutation(getAdminProductsRejectMutationOptions(options), queryClient);
    }
    export type adminProductsRequestChangesResponse200 = {
  data: ProductDetail
  status: 200
}

export type adminProductsRequestChangesResponseSuccess = (adminProductsRequestChangesResponse200) & {
  headers: Headers;
};
;

export type adminProductsRequestChangesResponse = (adminProductsRequestChangesResponseSuccess)

export const getAdminProductsRequestChangesUrl = (uid: string,) => {




  return `/api/v1/admin/products/${uid}/request-changes`
}

export const adminProductsRequestChanges = async (uid: string,
    productRequiredNoteRequest: ProductRequiredNoteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminProductsRequestChangesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminProductsRequestChangesResponse>(getAdminProductsRequestChangesUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productRequiredNoteRequest)
  }
);}





export const getAdminProductsRequestChangesMutationKey = () => ['adminProductsRequestChanges'] as const;

export const getAdminProductsRequestChangesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsRequestChanges>>, TError,AdminProductsRequestChangesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProductsRequestChanges>>, TError,AdminProductsRequestChangesMutationVariables, TContext> => {

const mutationKey = getAdminProductsRequestChangesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProductsRequestChanges>>, AdminProductsRequestChangesMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminProductsRequestChanges(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminProductsRequestChangesMutationResult = NonNullable<Awaited<ReturnType<typeof adminProductsRequestChanges>>>
    export type AdminProductsRequestChangesMutationBody = ProductRequiredNoteRequest
    export type AdminProductsRequestChangesMutationError = unknown
    export type AdminProductsRequestChangesMutationVariables = {uid: string;data: ProductRequiredNoteRequest}

    export const useAdminProductsRequestChanges = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsRequestChanges>>, TError,AdminProductsRequestChangesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProductsRequestChanges>>,
        TError,
        AdminProductsRequestChangesMutationVariables,
        TContext
      > => {
      return useMutation(getAdminProductsRequestChangesMutationOptions(options), queryClient);
    }
    export type adminProductsSubmitResponse200 = {
  data: ProductDetail
  status: 200
}

export type adminProductsSubmitResponseSuccess = (adminProductsSubmitResponse200) & {
  headers: Headers;
};
;

export type adminProductsSubmitResponse = (adminProductsSubmitResponseSuccess)

export const getAdminProductsSubmitUrl = (uid: string,) => {




  return `/api/v1/admin/products/${uid}/submit`
}

/**
 * Submit a company product (published without review).
 */
export const adminProductsSubmit = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminProductsSubmitResponse> => {

  return apiFetch<adminProductsSubmitResponse>(getAdminProductsSubmitUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminProductsSubmitMutationKey = () => ['adminProductsSubmit'] as const;

export const getAdminProductsSubmitMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsSubmit>>, TError,AdminProductsSubmitMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProductsSubmit>>, TError,AdminProductsSubmitMutationVariables, TContext> => {

const mutationKey = getAdminProductsSubmitMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProductsSubmit>>, AdminProductsSubmitMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminProductsSubmit(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminProductsSubmitMutationResult = NonNullable<Awaited<ReturnType<typeof adminProductsSubmit>>>

    export type AdminProductsSubmitMutationError = unknown
    export type AdminProductsSubmitMutationVariables = {uid: string}

    export const useAdminProductsSubmit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsSubmit>>, TError,AdminProductsSubmitMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProductsSubmit>>,
        TError,
        AdminProductsSubmitMutationVariables,
        TContext
      > => {
      return useMutation(getAdminProductsSubmitMutationOptions(options), queryClient);
    }
    export type adminProductsBulkFitmentResponse200 = {
  data: ProductBulkFitmentResult
  status: 200
}

export type adminProductsBulkFitmentResponseSuccess = (adminProductsBulkFitmentResponse200) & {
  headers: Headers;
};
;

export type adminProductsBulkFitmentResponse = (adminProductsBulkFitmentResponseSuccess)

export const getAdminProductsBulkFitmentUrl = () => {




  return `/api/v1/admin/products/bulk-fitment`
}

export const adminProductsBulkFitment = async (productBulkFitmentRequest: ProductBulkFitmentRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminProductsBulkFitmentResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminProductsBulkFitmentResponse>(getAdminProductsBulkFitmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productBulkFitmentRequest)
  }
);}





export const getAdminProductsBulkFitmentMutationKey = () => ['adminProductsBulkFitment'] as const;

export const getAdminProductsBulkFitmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsBulkFitment>>, TError,AdminProductsBulkFitmentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProductsBulkFitment>>, TError,AdminProductsBulkFitmentMutationVariables, TContext> => {

const mutationKey = getAdminProductsBulkFitmentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProductsBulkFitment>>, AdminProductsBulkFitmentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminProductsBulkFitment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminProductsBulkFitmentMutationResult = NonNullable<Awaited<ReturnType<typeof adminProductsBulkFitment>>>
    export type AdminProductsBulkFitmentMutationBody = ProductBulkFitmentRequest
    export type AdminProductsBulkFitmentMutationError = unknown
    export type AdminProductsBulkFitmentMutationVariables = {data: ProductBulkFitmentRequest}

    export const useAdminProductsBulkFitment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProductsBulkFitment>>, TError,AdminProductsBulkFitmentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProductsBulkFitment>>,
        TError,
        AdminProductsBulkFitmentMutationVariables,
        TContext
      > => {
      return useMutation(getAdminProductsBulkFitmentMutationOptions(options), queryClient);
    }
    export type adminProductsCountsResponse200 = {
  data: ProductStatusCounts
  status: 200
}

export type adminProductsCountsResponseSuccess = (adminProductsCountsResponse200) & {
  headers: Headers;
};
;

export type adminProductsCountsResponse = (adminProductsCountsResponseSuccess)

export const getAdminProductsCountsUrl = (params?: AdminProductsCountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/products/counts?${stringifiedParams}` : `/api/v1/admin/products/counts`
}

export const adminProductsCounts = async (params?: AdminProductsCountsParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminProductsCountsResponse> => {

  return apiFetch<adminProductsCountsResponse>(getAdminProductsCountsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminProductsCountsQueryKey = (params?: AdminProductsCountsParams,) => {
    return [
    `/api/v1/admin/products/counts`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminProductsCountsQueryOptions = <TData = Awaited<ReturnType<typeof adminProductsCounts>>, TError = unknown>(params?: AdminProductsCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminProductsCountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminProductsCounts>>> = ({ signal }) => adminProductsCounts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminProductsCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminProductsCountsQueryResult = NonNullable<Awaited<ReturnType<typeof adminProductsCounts>>>
export type AdminProductsCountsQueryError = unknown


export function useAdminProductsCounts<TData = Awaited<ReturnType<typeof adminProductsCounts>>, TError = unknown>(
 params: undefined |  AdminProductsCountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminProductsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminProductsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminProductsCounts<TData = Awaited<ReturnType<typeof adminProductsCounts>>, TError = unknown>(
 params?: AdminProductsCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminProductsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminProductsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminProductsCounts<TData = Awaited<ReturnType<typeof adminProductsCounts>>, TError = unknown>(
 params?: AdminProductsCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminProductsCounts<TData = Awaited<ReturnType<typeof adminProductsCounts>>, TError = unknown>(
 params?: AdminProductsCountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminProductsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminProductsCountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminReportsExportsListResponse200 = {
  data: Export[]
  status: 200
}

export type adminReportsExportsListResponseSuccess = (adminReportsExportsListResponse200) & {
  headers: Headers;
};
;

export type adminReportsExportsListResponse = (adminReportsExportsListResponseSuccess)

export const getAdminReportsExportsListUrl = () => {




  return `/api/v1/admin/reports/exports`
}

export const adminReportsExportsList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminReportsExportsListResponse> => {

  return apiFetch<adminReportsExportsListResponse>(getAdminReportsExportsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminReportsExportsListQueryKey = () => {
    return [
    `/api/v1/admin/reports/exports`
    ] as const;
    }


export const getAdminReportsExportsListQueryOptions = <TData = Awaited<ReturnType<typeof adminReportsExportsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsExportsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminReportsExportsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminReportsExportsList>>> = ({ signal }) => adminReportsExportsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminReportsExportsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminReportsExportsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminReportsExportsList>>>
export type AdminReportsExportsListQueryError = unknown


export function useAdminReportsExportsList<TData = Awaited<ReturnType<typeof adminReportsExportsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsExportsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReportsExportsList>>,
          TError,
          Awaited<ReturnType<typeof adminReportsExportsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReportsExportsList<TData = Awaited<ReturnType<typeof adminReportsExportsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsExportsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReportsExportsList>>,
          TError,
          Awaited<ReturnType<typeof adminReportsExportsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReportsExportsList<TData = Awaited<ReturnType<typeof adminReportsExportsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsExportsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminReportsExportsList<TData = Awaited<ReturnType<typeof adminReportsExportsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsExportsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminReportsExportsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminReportsExportsCreateResponse201 = {
  data: Export
  status: 201
}

export type adminReportsExportsCreateResponseSuccess = (adminReportsExportsCreateResponse201) & {
  headers: Headers;
};
;

export type adminReportsExportsCreateResponse = (adminReportsExportsCreateResponseSuccess)

export const getAdminReportsExportsCreateUrl = () => {




  return `/api/v1/admin/reports/exports`
}

export const adminReportsExportsCreate = async (exportRequestRequest: ExportRequestRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminReportsExportsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminReportsExportsCreateResponse>(getAdminReportsExportsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(exportRequestRequest)
  }
);}





export const getAdminReportsExportsCreateMutationKey = () => ['adminReportsExportsCreate'] as const;

export const getAdminReportsExportsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReportsExportsCreate>>, TError,AdminReportsExportsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminReportsExportsCreate>>, TError,AdminReportsExportsCreateMutationVariables, TContext> => {

const mutationKey = getAdminReportsExportsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminReportsExportsCreate>>, AdminReportsExportsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminReportsExportsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminReportsExportsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminReportsExportsCreate>>>
    export type AdminReportsExportsCreateMutationBody = ExportRequestRequest
    export type AdminReportsExportsCreateMutationError = unknown
    export type AdminReportsExportsCreateMutationVariables = {data: ExportRequestRequest}

    export const useAdminReportsExportsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReportsExportsCreate>>, TError,AdminReportsExportsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminReportsExportsCreate>>,
        TError,
        AdminReportsExportsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminReportsExportsCreateMutationOptions(options), queryClient);
    }
    export type adminReportsExportsFileResponse200 = {
  data: Blob
  status: 200
}

export type adminReportsExportsFileResponseSuccess = (adminReportsExportsFileResponse200) & {
  headers: Headers;
};
;

export type adminReportsExportsFileResponse = (adminReportsExportsFileResponseSuccess)

export const getAdminReportsExportsFileUrl = (uid: string,) => {




  return `/api/v1/admin/reports/exports/${uid}/file`
}

export const adminReportsExportsFile = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminReportsExportsFileResponse> => {

  return apiFetch<adminReportsExportsFileResponse>(getAdminReportsExportsFileUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminReportsExportsFileQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/reports/exports/${uid}/file`
    ] as const;
    }


export const getAdminReportsExportsFileQueryOptions = <TData = Awaited<ReturnType<typeof adminReportsExportsFile>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsExportsFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminReportsExportsFileQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminReportsExportsFile>>> = ({ signal }) => adminReportsExportsFile(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminReportsExportsFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminReportsExportsFileQueryResult = NonNullable<Awaited<ReturnType<typeof adminReportsExportsFile>>>
export type AdminReportsExportsFileQueryError = unknown


export function useAdminReportsExportsFile<TData = Awaited<ReturnType<typeof adminReportsExportsFile>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsExportsFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReportsExportsFile>>,
          TError,
          Awaited<ReturnType<typeof adminReportsExportsFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReportsExportsFile<TData = Awaited<ReturnType<typeof adminReportsExportsFile>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsExportsFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReportsExportsFile>>,
          TError,
          Awaited<ReturnType<typeof adminReportsExportsFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReportsExportsFile<TData = Awaited<ReturnType<typeof adminReportsExportsFile>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsExportsFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminReportsExportsFile<TData = Awaited<ReturnType<typeof adminReportsExportsFile>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsExportsFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminReportsExportsFileQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminReportsOverviewResponse200 = {
  data: Overview
  status: 200
}

export type adminReportsOverviewResponseSuccess = (adminReportsOverviewResponse200) & {
  headers: Headers;
};
;

export type adminReportsOverviewResponse = (adminReportsOverviewResponseSuccess)

export const getAdminReportsOverviewUrl = (params?: AdminReportsOverviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/reports/overview?${stringifiedParams}` : `/api/v1/admin/reports/overview`
}

export const adminReportsOverview = async (params?: AdminReportsOverviewParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminReportsOverviewResponse> => {

  return apiFetch<adminReportsOverviewResponse>(getAdminReportsOverviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminReportsOverviewQueryKey = (params?: AdminReportsOverviewParams,) => {
    return [
    `/api/v1/admin/reports/overview`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminReportsOverviewQueryOptions = <TData = Awaited<ReturnType<typeof adminReportsOverview>>, TError = unknown>(params?: AdminReportsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsOverview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminReportsOverviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminReportsOverview>>> = ({ signal }) => adminReportsOverview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminReportsOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminReportsOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof adminReportsOverview>>>
export type AdminReportsOverviewQueryError = unknown


export function useAdminReportsOverview<TData = Awaited<ReturnType<typeof adminReportsOverview>>, TError = unknown>(
 params: undefined |  AdminReportsOverviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReportsOverview>>,
          TError,
          Awaited<ReturnType<typeof adminReportsOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReportsOverview<TData = Awaited<ReturnType<typeof adminReportsOverview>>, TError = unknown>(
 params?: AdminReportsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReportsOverview>>,
          TError,
          Awaited<ReturnType<typeof adminReportsOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReportsOverview<TData = Awaited<ReturnType<typeof adminReportsOverview>>, TError = unknown>(
 params?: AdminReportsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsOverview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminReportsOverview<TData = Awaited<ReturnType<typeof adminReportsOverview>>, TError = unknown>(
 params?: AdminReportsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsOverview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminReportsOverviewQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminReportsVendorSalesResponse200 = {
  data: VendorSales[]
  status: 200
}

export type adminReportsVendorSalesResponseSuccess = (adminReportsVendorSalesResponse200) & {
  headers: Headers;
};
;

export type adminReportsVendorSalesResponse = (adminReportsVendorSalesResponseSuccess)

export const getAdminReportsVendorSalesUrl = (params?: AdminReportsVendorSalesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/reports/vendor-sales?${stringifiedParams}` : `/api/v1/admin/reports/vendor-sales`
}

export const adminReportsVendorSales = async (params?: AdminReportsVendorSalesParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminReportsVendorSalesResponse> => {

  return apiFetch<adminReportsVendorSalesResponse>(getAdminReportsVendorSalesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminReportsVendorSalesQueryKey = (params?: AdminReportsVendorSalesParams,) => {
    return [
    `/api/v1/admin/reports/vendor-sales`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminReportsVendorSalesQueryOptions = <TData = Awaited<ReturnType<typeof adminReportsVendorSales>>, TError = unknown>(params?: AdminReportsVendorSalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsVendorSales>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminReportsVendorSalesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminReportsVendorSales>>> = ({ signal }) => adminReportsVendorSales(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminReportsVendorSales>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminReportsVendorSalesQueryResult = NonNullable<Awaited<ReturnType<typeof adminReportsVendorSales>>>
export type AdminReportsVendorSalesQueryError = unknown


export function useAdminReportsVendorSales<TData = Awaited<ReturnType<typeof adminReportsVendorSales>>, TError = unknown>(
 params: undefined |  AdminReportsVendorSalesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsVendorSales>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReportsVendorSales>>,
          TError,
          Awaited<ReturnType<typeof adminReportsVendorSales>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReportsVendorSales<TData = Awaited<ReturnType<typeof adminReportsVendorSales>>, TError = unknown>(
 params?: AdminReportsVendorSalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsVendorSales>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReportsVendorSales>>,
          TError,
          Awaited<ReturnType<typeof adminReportsVendorSales>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReportsVendorSales<TData = Awaited<ReturnType<typeof adminReportsVendorSales>>, TError = unknown>(
 params?: AdminReportsVendorSalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsVendorSales>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminReportsVendorSales<TData = Awaited<ReturnType<typeof adminReportsVendorSales>>, TError = unknown>(
 params?: AdminReportsVendorSalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReportsVendorSales>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminReportsVendorSalesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminReturnsListResponse200 = {
  data: PaginatedReturnListList
  status: 200
}

export type adminReturnsListResponseSuccess = (adminReturnsListResponse200) & {
  headers: Headers;
};
;

export type adminReturnsListResponse = (adminReturnsListResponseSuccess)

export const getAdminReturnsListUrl = (params?: AdminReturnsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/returns?${stringifiedParams}` : `/api/v1/admin/returns`
}

export const adminReturnsList = async (params?: AdminReturnsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminReturnsListResponse> => {

  return apiFetch<adminReturnsListResponse>(getAdminReturnsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminReturnsListQueryKey = (params?: AdminReturnsListParams,) => {
    return [
    `/api/v1/admin/returns`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminReturnsListQueryOptions = <TData = Awaited<ReturnType<typeof adminReturnsList>>, TError = unknown>(params?: AdminReturnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminReturnsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminReturnsList>>> = ({ signal }) => adminReturnsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminReturnsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminReturnsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminReturnsList>>>
export type AdminReturnsListQueryError = unknown


export function useAdminReturnsList<TData = Awaited<ReturnType<typeof adminReturnsList>>, TError = unknown>(
 params: undefined |  AdminReturnsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReturnsList>>,
          TError,
          Awaited<ReturnType<typeof adminReturnsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReturnsList<TData = Awaited<ReturnType<typeof adminReturnsList>>, TError = unknown>(
 params?: AdminReturnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReturnsList>>,
          TError,
          Awaited<ReturnType<typeof adminReturnsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReturnsList<TData = Awaited<ReturnType<typeof adminReturnsList>>, TError = unknown>(
 params?: AdminReturnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminReturnsList<TData = Awaited<ReturnType<typeof adminReturnsList>>, TError = unknown>(
 params?: AdminReturnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminReturnsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminReturnsRetrieveResponse200 = {
  data: ReturnDetail
  status: 200
}

export type adminReturnsRetrieveResponseSuccess = (adminReturnsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminReturnsRetrieveResponse = (adminReturnsRetrieveResponseSuccess)

export const getAdminReturnsRetrieveUrl = (number: string,) => {




  return `/api/v1/admin/returns/${number}`
}

export const adminReturnsRetrieve = async (number: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminReturnsRetrieveResponse> => {

  return apiFetch<adminReturnsRetrieveResponse>(getAdminReturnsRetrieveUrl(number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminReturnsRetrieveQueryKey = (number: string,) => {
    return [
    `/api/v1/admin/returns/${number}`
    ] as const;
    }


export const getAdminReturnsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminReturnsRetrieve>>, TError = unknown>(number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminReturnsRetrieveQueryKey(number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminReturnsRetrieve>>> = ({ signal }) => adminReturnsRetrieve(number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminReturnsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminReturnsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminReturnsRetrieve>>>
export type AdminReturnsRetrieveQueryError = unknown


export function useAdminReturnsRetrieve<TData = Awaited<ReturnType<typeof adminReturnsRetrieve>>, TError = unknown>(
 number: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReturnsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminReturnsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReturnsRetrieve<TData = Awaited<ReturnType<typeof adminReturnsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReturnsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminReturnsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReturnsRetrieve<TData = Awaited<ReturnType<typeof adminReturnsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminReturnsRetrieve<TData = Awaited<ReturnType<typeof adminReturnsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminReturnsRetrieveQueryOptions(number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminReturnsActResponse200 = {
  data: ReturnDetail
  status: 200
}

export type adminReturnsActResponseSuccess = (adminReturnsActResponse200) & {
  headers: Headers;
};
;

export type adminReturnsActResponse = (adminReturnsActResponseSuccess)

export const getAdminReturnsActUrl = (number: string,) => {




  return `/api/v1/admin/returns/${number}/act`
}

export const adminReturnsAct = async (number: string,
    actRequest: ActRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminReturnsActResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminReturnsActResponse>(getAdminReturnsActUrl(number),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(actRequest)
  }
);}





export const getAdminReturnsActMutationKey = () => ['adminReturnsAct'] as const;

export const getAdminReturnsActMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReturnsAct>>, TError,AdminReturnsActMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminReturnsAct>>, TError,AdminReturnsActMutationVariables, TContext> => {

const mutationKey = getAdminReturnsActMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminReturnsAct>>, AdminReturnsActMutationVariables> = (props) => {
          const {number,data} = props ?? {};

          return  adminReturnsAct(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminReturnsActMutationResult = NonNullable<Awaited<ReturnType<typeof adminReturnsAct>>>
    export type AdminReturnsActMutationBody = ActRequest
    export type AdminReturnsActMutationError = unknown
    export type AdminReturnsActMutationVariables = {number: string;data: ActRequest}

    export const useAdminReturnsAct = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReturnsAct>>, TError,AdminReturnsActMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminReturnsAct>>,
        TError,
        AdminReturnsActMutationVariables,
        TContext
      > => {
      return useMutation(getAdminReturnsActMutationOptions(options), queryClient);
    }
    export type adminReturnsPhotoResponse200 = {
  data: Blob
  status: 200
}

export type adminReturnsPhotoResponseSuccess = (adminReturnsPhotoResponse200) & {
  headers: Headers;
};
;

export type adminReturnsPhotoResponse = (adminReturnsPhotoResponseSuccess)

export const getAdminReturnsPhotoUrl = (number: string,
    mediaUid: string,) => {




  return `/api/v1/admin/returns/${number}/photos/${mediaUid}`
}

export const adminReturnsPhoto = async (number: string,
    mediaUid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminReturnsPhotoResponse> => {

  return apiFetch<adminReturnsPhotoResponse>(getAdminReturnsPhotoUrl(number,mediaUid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminReturnsPhotoQueryKey = (number: string,
    mediaUid: string,) => {
    return [
    `/api/v1/admin/returns/${number}/photos/${mediaUid}`
    ] as const;
    }


export const getAdminReturnsPhotoQueryOptions = <TData = Awaited<ReturnType<typeof adminReturnsPhoto>>, TError = unknown>(number: string,
    mediaUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsPhoto>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminReturnsPhotoQueryKey(number,mediaUid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminReturnsPhoto>>> = ({ signal }) => adminReturnsPhoto(number,mediaUid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined && mediaUid !== null && mediaUid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminReturnsPhoto>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminReturnsPhotoQueryResult = NonNullable<Awaited<ReturnType<typeof adminReturnsPhoto>>>
export type AdminReturnsPhotoQueryError = unknown


export function useAdminReturnsPhoto<TData = Awaited<ReturnType<typeof adminReturnsPhoto>>, TError = unknown>(
 number: string,
    mediaUid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsPhoto>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReturnsPhoto>>,
          TError,
          Awaited<ReturnType<typeof adminReturnsPhoto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReturnsPhoto<TData = Awaited<ReturnType<typeof adminReturnsPhoto>>, TError = unknown>(
 number: string,
    mediaUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsPhoto>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReturnsPhoto>>,
          TError,
          Awaited<ReturnType<typeof adminReturnsPhoto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReturnsPhoto<TData = Awaited<ReturnType<typeof adminReturnsPhoto>>, TError = unknown>(
 number: string,
    mediaUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsPhoto>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminReturnsPhoto<TData = Awaited<ReturnType<typeof adminReturnsPhoto>>, TError = unknown>(
 number: string,
    mediaUid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsPhoto>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminReturnsPhotoQueryOptions(number,mediaUid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminReturnsCountsResponse200 = {
  data: ReturnCounts
  status: 200
}

export type adminReturnsCountsResponseSuccess = (adminReturnsCountsResponse200) & {
  headers: Headers;
};
;

export type adminReturnsCountsResponse = (adminReturnsCountsResponseSuccess)

export const getAdminReturnsCountsUrl = () => {




  return `/api/v1/admin/returns/counts`
}

export const adminReturnsCounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminReturnsCountsResponse> => {

  return apiFetch<adminReturnsCountsResponse>(getAdminReturnsCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminReturnsCountsQueryKey = () => {
    return [
    `/api/v1/admin/returns/counts`
    ] as const;
    }


export const getAdminReturnsCountsQueryOptions = <TData = Awaited<ReturnType<typeof adminReturnsCounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminReturnsCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminReturnsCounts>>> = ({ signal }) => adminReturnsCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminReturnsCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminReturnsCountsQueryResult = NonNullable<Awaited<ReturnType<typeof adminReturnsCounts>>>
export type AdminReturnsCountsQueryError = unknown


export function useAdminReturnsCounts<TData = Awaited<ReturnType<typeof adminReturnsCounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReturnsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminReturnsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReturnsCounts<TData = Awaited<ReturnType<typeof adminReturnsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReturnsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminReturnsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReturnsCounts<TData = Awaited<ReturnType<typeof adminReturnsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminReturnsCounts<TData = Awaited<ReturnType<typeof adminReturnsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReturnsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminReturnsCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminReviewsListResponse200 = {
  data: PaginatedAdminReviewList
  status: 200
}

export type adminReviewsListResponseSuccess = (adminReviewsListResponse200) & {
  headers: Headers;
};
;

export type adminReviewsListResponse = (adminReviewsListResponseSuccess)

export const getAdminReviewsListUrl = (params?: AdminReviewsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/reviews?${stringifiedParams}` : `/api/v1/admin/reviews`
}

export const adminReviewsList = async (params?: AdminReviewsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminReviewsListResponse> => {

  return apiFetch<adminReviewsListResponse>(getAdminReviewsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminReviewsListQueryKey = (params?: AdminReviewsListParams,) => {
    return [
    `/api/v1/admin/reviews`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminReviewsListQueryOptions = <TData = Awaited<ReturnType<typeof adminReviewsList>>, TError = unknown>(params?: AdminReviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReviewsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminReviewsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminReviewsList>>> = ({ signal }) => adminReviewsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminReviewsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminReviewsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminReviewsList>>>
export type AdminReviewsListQueryError = unknown


export function useAdminReviewsList<TData = Awaited<ReturnType<typeof adminReviewsList>>, TError = unknown>(
 params: undefined |  AdminReviewsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReviewsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReviewsList>>,
          TError,
          Awaited<ReturnType<typeof adminReviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReviewsList<TData = Awaited<ReturnType<typeof adminReviewsList>>, TError = unknown>(
 params?: AdminReviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReviewsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReviewsList>>,
          TError,
          Awaited<ReturnType<typeof adminReviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReviewsList<TData = Awaited<ReturnType<typeof adminReviewsList>>, TError = unknown>(
 params?: AdminReviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReviewsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminReviewsList<TData = Awaited<ReturnType<typeof adminReviewsList>>, TError = unknown>(
 params?: AdminReviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReviewsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminReviewsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminReviewsApproveResponse200 = {
  data: AdminReview
  status: 200
}

export type adminReviewsApproveResponseSuccess = (adminReviewsApproveResponse200) & {
  headers: Headers;
};
;

export type adminReviewsApproveResponse = (adminReviewsApproveResponseSuccess)

export const getAdminReviewsApproveUrl = (uid: string,) => {




  return `/api/v1/admin/reviews/${uid}/approve`
}

export const adminReviewsApprove = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminReviewsApproveResponse> => {

  return apiFetch<adminReviewsApproveResponse>(getAdminReviewsApproveUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminReviewsApproveMutationKey = () => ['adminReviewsApprove'] as const;

export const getAdminReviewsApproveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReviewsApprove>>, TError,AdminReviewsApproveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminReviewsApprove>>, TError,AdminReviewsApproveMutationVariables, TContext> => {

const mutationKey = getAdminReviewsApproveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminReviewsApprove>>, AdminReviewsApproveMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminReviewsApprove(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminReviewsApproveMutationResult = NonNullable<Awaited<ReturnType<typeof adminReviewsApprove>>>

    export type AdminReviewsApproveMutationError = unknown
    export type AdminReviewsApproveMutationVariables = {uid: string}

    export const useAdminReviewsApprove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReviewsApprove>>, TError,AdminReviewsApproveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminReviewsApprove>>,
        TError,
        AdminReviewsApproveMutationVariables,
        TContext
      > => {
      return useMutation(getAdminReviewsApproveMutationOptions(options), queryClient);
    }
    export type adminReviewsRejectResponse200 = {
  data: AdminReview
  status: 200
}

export type adminReviewsRejectResponseSuccess = (adminReviewsRejectResponse200) & {
  headers: Headers;
};
;

export type adminReviewsRejectResponse = (adminReviewsRejectResponseSuccess)

export const getAdminReviewsRejectUrl = (uid: string,) => {




  return `/api/v1/admin/reviews/${uid}/reject`
}

export const adminReviewsReject = async (uid: string,
    noteRequest: NoteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminReviewsRejectResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminReviewsRejectResponse>(getAdminReviewsRejectUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(noteRequest)
  }
);}





export const getAdminReviewsRejectMutationKey = () => ['adminReviewsReject'] as const;

export const getAdminReviewsRejectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReviewsReject>>, TError,AdminReviewsRejectMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminReviewsReject>>, TError,AdminReviewsRejectMutationVariables, TContext> => {

const mutationKey = getAdminReviewsRejectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminReviewsReject>>, AdminReviewsRejectMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminReviewsReject(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminReviewsRejectMutationResult = NonNullable<Awaited<ReturnType<typeof adminReviewsReject>>>
    export type AdminReviewsRejectMutationBody = NoteRequest
    export type AdminReviewsRejectMutationError = unknown
    export type AdminReviewsRejectMutationVariables = {uid: string;data: NoteRequest}

    export const useAdminReviewsReject = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReviewsReject>>, TError,AdminReviewsRejectMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminReviewsReject>>,
        TError,
        AdminReviewsRejectMutationVariables,
        TContext
      > => {
      return useMutation(getAdminReviewsRejectMutationOptions(options), queryClient);
    }
    export type adminReviewsRemoveResponse200 = {
  data: AdminReview
  status: 200
}

export type adminReviewsRemoveResponseSuccess = (adminReviewsRemoveResponse200) & {
  headers: Headers;
};
;

export type adminReviewsRemoveResponse = (adminReviewsRemoveResponseSuccess)

export const getAdminReviewsRemoveUrl = (uid: string,) => {




  return `/api/v1/admin/reviews/${uid}/remove`
}

export const adminReviewsRemove = async (uid: string,
    noteRequest: NoteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminReviewsRemoveResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminReviewsRemoveResponse>(getAdminReviewsRemoveUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(noteRequest)
  }
);}





export const getAdminReviewsRemoveMutationKey = () => ['adminReviewsRemove'] as const;

export const getAdminReviewsRemoveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReviewsRemove>>, TError,AdminReviewsRemoveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminReviewsRemove>>, TError,AdminReviewsRemoveMutationVariables, TContext> => {

const mutationKey = getAdminReviewsRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminReviewsRemove>>, AdminReviewsRemoveMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminReviewsRemove(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminReviewsRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof adminReviewsRemove>>>
    export type AdminReviewsRemoveMutationBody = NoteRequest
    export type AdminReviewsRemoveMutationError = unknown
    export type AdminReviewsRemoveMutationVariables = {uid: string;data: NoteRequest}

    export const useAdminReviewsRemove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminReviewsRemove>>, TError,AdminReviewsRemoveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminReviewsRemove>>,
        TError,
        AdminReviewsRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getAdminReviewsRemoveMutationOptions(options), queryClient);
    }
    export type adminReviewsCountsResponse200 = {
  data: ReviewCounts
  status: 200
}

export type adminReviewsCountsResponseSuccess = (adminReviewsCountsResponse200) & {
  headers: Headers;
};
;

export type adminReviewsCountsResponse = (adminReviewsCountsResponseSuccess)

export const getAdminReviewsCountsUrl = () => {




  return `/api/v1/admin/reviews/counts`
}

export const adminReviewsCounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminReviewsCountsResponse> => {

  return apiFetch<adminReviewsCountsResponse>(getAdminReviewsCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminReviewsCountsQueryKey = () => {
    return [
    `/api/v1/admin/reviews/counts`
    ] as const;
    }


export const getAdminReviewsCountsQueryOptions = <TData = Awaited<ReturnType<typeof adminReviewsCounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReviewsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminReviewsCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminReviewsCounts>>> = ({ signal }) => adminReviewsCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminReviewsCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminReviewsCountsQueryResult = NonNullable<Awaited<ReturnType<typeof adminReviewsCounts>>>
export type AdminReviewsCountsQueryError = unknown


export function useAdminReviewsCounts<TData = Awaited<ReturnType<typeof adminReviewsCounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReviewsCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReviewsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminReviewsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReviewsCounts<TData = Awaited<ReturnType<typeof adminReviewsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReviewsCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminReviewsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminReviewsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminReviewsCounts<TData = Awaited<ReturnType<typeof adminReviewsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReviewsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminReviewsCounts<TData = Awaited<ReturnType<typeof adminReviewsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminReviewsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminReviewsCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminRolesListResponse200 = {
  data: Role[]
  status: 200
}

export type adminRolesListResponseSuccess = (adminRolesListResponse200) & {
  headers: Headers;
};
;

export type adminRolesListResponse = (adminRolesListResponseSuccess)

export const getAdminRolesListUrl = () => {




  return `/api/v1/admin/roles`
}

export const adminRolesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminRolesListResponse> => {

  return apiFetch<adminRolesListResponse>(getAdminRolesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminRolesListQueryKey = () => {
    return [
    `/api/v1/admin/roles`
    ] as const;
    }


export const getAdminRolesListQueryOptions = <TData = Awaited<ReturnType<typeof adminRolesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminRolesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminRolesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminRolesList>>> = ({ signal }) => adminRolesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminRolesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminRolesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminRolesList>>>
export type AdminRolesListQueryError = unknown


export function useAdminRolesList<TData = Awaited<ReturnType<typeof adminRolesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminRolesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminRolesList>>,
          TError,
          Awaited<ReturnType<typeof adminRolesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminRolesList<TData = Awaited<ReturnType<typeof adminRolesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminRolesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminRolesList>>,
          TError,
          Awaited<ReturnType<typeof adminRolesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminRolesList<TData = Awaited<ReturnType<typeof adminRolesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminRolesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminRolesList<TData = Awaited<ReturnType<typeof adminRolesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminRolesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminRolesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminRolesCreateResponse201 = {
  data: RoleDetail
  status: 201
}

export type adminRolesCreateResponseSuccess = (adminRolesCreateResponse201) & {
  headers: Headers;
};
;

export type adminRolesCreateResponse = (adminRolesCreateResponseSuccess)

export const getAdminRolesCreateUrl = () => {




  return `/api/v1/admin/roles`
}

export const adminRolesCreate = async (roleWriteRequest: RoleWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminRolesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminRolesCreateResponse>(getAdminRolesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(roleWriteRequest)
  }
);}





export const getAdminRolesCreateMutationKey = () => ['adminRolesCreate'] as const;

export const getAdminRolesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRolesCreate>>, TError,AdminRolesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRolesCreate>>, TError,AdminRolesCreateMutationVariables, TContext> => {

const mutationKey = getAdminRolesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRolesCreate>>, AdminRolesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminRolesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRolesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminRolesCreate>>>
    export type AdminRolesCreateMutationBody = RoleWriteRequest
    export type AdminRolesCreateMutationError = unknown
    export type AdminRolesCreateMutationVariables = {data: RoleWriteRequest}

    export const useAdminRolesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRolesCreate>>, TError,AdminRolesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminRolesCreate>>,
        TError,
        AdminRolesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminRolesCreateMutationOptions(options), queryClient);
    }
    export type adminRolesRetrieveResponse200 = {
  data: RoleDetail
  status: 200
}

export type adminRolesRetrieveResponseSuccess = (adminRolesRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminRolesRetrieveResponse = (adminRolesRetrieveResponseSuccess)

export const getAdminRolesRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/roles/${uid}`
}

export const adminRolesRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminRolesRetrieveResponse> => {

  return apiFetch<adminRolesRetrieveResponse>(getAdminRolesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminRolesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/roles/${uid}`
    ] as const;
    }


export const getAdminRolesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminRolesRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminRolesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminRolesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminRolesRetrieve>>> = ({ signal }) => adminRolesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminRolesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminRolesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminRolesRetrieve>>>
export type AdminRolesRetrieveQueryError = unknown


export function useAdminRolesRetrieve<TData = Awaited<ReturnType<typeof adminRolesRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminRolesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminRolesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminRolesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminRolesRetrieve<TData = Awaited<ReturnType<typeof adminRolesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminRolesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminRolesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminRolesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminRolesRetrieve<TData = Awaited<ReturnType<typeof adminRolesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminRolesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminRolesRetrieve<TData = Awaited<ReturnType<typeof adminRolesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminRolesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminRolesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminRolesPartialUpdateResponse200 = {
  data: RoleDetail
  status: 200
}

export type adminRolesPartialUpdateResponseSuccess = (adminRolesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminRolesPartialUpdateResponse = (adminRolesPartialUpdateResponseSuccess)

export const getAdminRolesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/roles/${uid}`
}

export const adminRolesPartialUpdate = async (uid: string,
    patchedRoleWriteRequest?: PatchedRoleWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminRolesPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminRolesPartialUpdateResponse>(getAdminRolesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedRoleWriteRequest)
  }
);}





export const getAdminRolesPartialUpdateMutationKey = () => ['adminRolesPartialUpdate'] as const;

export const getAdminRolesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRolesPartialUpdate>>, TError,AdminRolesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRolesPartialUpdate>>, TError,AdminRolesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminRolesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRolesPartialUpdate>>, AdminRolesPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminRolesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRolesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminRolesPartialUpdate>>>
    export type AdminRolesPartialUpdateMutationBody = PatchedRoleWriteRequest | undefined
    export type AdminRolesPartialUpdateMutationError = unknown
    export type AdminRolesPartialUpdateMutationVariables = {uid: string;data?: PatchedRoleWriteRequest}

    export const useAdminRolesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRolesPartialUpdate>>, TError,AdminRolesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminRolesPartialUpdate>>,
        TError,
        AdminRolesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminRolesPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminRolesDestroyResponse204 = {
  data: void
  status: 204
}

export type adminRolesDestroyResponseSuccess = (adminRolesDestroyResponse204) & {
  headers: Headers;
};
;

export type adminRolesDestroyResponse = (adminRolesDestroyResponseSuccess)

export const getAdminRolesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/roles/${uid}`
}

export const adminRolesDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminRolesDestroyResponse> => {

  return apiFetch<adminRolesDestroyResponse>(getAdminRolesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminRolesDestroyMutationKey = () => ['adminRolesDestroy'] as const;

export const getAdminRolesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRolesDestroy>>, TError,AdminRolesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRolesDestroy>>, TError,AdminRolesDestroyMutationVariables, TContext> => {

const mutationKey = getAdminRolesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRolesDestroy>>, AdminRolesDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminRolesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRolesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminRolesDestroy>>>

    export type AdminRolesDestroyMutationError = unknown
    export type AdminRolesDestroyMutationVariables = {uid: string}

    export const useAdminRolesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRolesDestroy>>, TError,AdminRolesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminRolesDestroy>>,
        TError,
        AdminRolesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminRolesDestroyMutationOptions(options), queryClient);
    }
    export type adminSettingsRetrieveResponse200 = {
  data: Settings
  status: 200
}

export type adminSettingsRetrieveResponseSuccess = (adminSettingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminSettingsRetrieveResponse = (adminSettingsRetrieveResponseSuccess)

export const getAdminSettingsRetrieveUrl = () => {




  return `/api/v1/admin/settings`
}

/**
 * Marketplace-wide values (store info, payment amounts, return window…).
 */
export const adminSettingsRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminSettingsRetrieveResponse> => {

  return apiFetch<adminSettingsRetrieveResponse>(getAdminSettingsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminSettingsRetrieveQueryKey = () => {
    return [
    `/api/v1/admin/settings`
    ] as const;
    }


export const getAdminSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminSettingsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminSettingsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSettingsRetrieve>>> = ({ signal }) => adminSettingsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminSettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminSettingsRetrieve>>>
export type AdminSettingsRetrieveQueryError = unknown


export function useAdminSettingsRetrieve<TData = Awaited<ReturnType<typeof adminSettingsRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSettingsRetrieve<TData = Awaited<ReturnType<typeof adminSettingsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSettingsRetrieve<TData = Awaited<ReturnType<typeof adminSettingsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminSettingsRetrieve<TData = Awaited<ReturnType<typeof adminSettingsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminSettingsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminSettingsPartialUpdateResponse200 = {
  data: Settings
  status: 200
}

export type adminSettingsPartialUpdateResponseSuccess = (adminSettingsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminSettingsPartialUpdateResponse = (adminSettingsPartialUpdateResponseSuccess)

export const getAdminSettingsPartialUpdateUrl = () => {




  return `/api/v1/admin/settings`
}

/**
 * Marketplace-wide values (store info, payment amounts, return window…).
 */
export const adminSettingsPartialUpdate = async (patchedSettingsRequest?: PatchedSettingsRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminSettingsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminSettingsPartialUpdateResponse>(getAdminSettingsPartialUpdateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedSettingsRequest)
  }
);}





export const getAdminSettingsPartialUpdateMutationKey = () => ['adminSettingsPartialUpdate'] as const;

export const getAdminSettingsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSettingsPartialUpdate>>, TError,AdminSettingsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSettingsPartialUpdate>>, TError,AdminSettingsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminSettingsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSettingsPartialUpdate>>, AdminSettingsPartialUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminSettingsPartialUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminSettingsPartialUpdate>>>
    export type AdminSettingsPartialUpdateMutationBody = PatchedSettingsRequest | undefined
    export type AdminSettingsPartialUpdateMutationError = unknown
    export type AdminSettingsPartialUpdateMutationVariables = {data?: PatchedSettingsRequest}

    export const useAdminSettingsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSettingsPartialUpdate>>, TError,AdminSettingsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSettingsPartialUpdate>>,
        TError,
        AdminSettingsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminSettingsPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminFooterLinksListResponse200 = {
  data: FooterLink[]
  status: 200
}

export type adminFooterLinksListResponseSuccess = (adminFooterLinksListResponse200) & {
  headers: Headers;
};
;

export type adminFooterLinksListResponse = (adminFooterLinksListResponseSuccess)

export const getAdminFooterLinksListUrl = () => {




  return `/api/v1/admin/settings/footer-links`
}

export const adminFooterLinksList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminFooterLinksListResponse> => {

  return apiFetch<adminFooterLinksListResponse>(getAdminFooterLinksListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminFooterLinksListQueryKey = () => {
    return [
    `/api/v1/admin/settings/footer-links`
    ] as const;
    }


export const getAdminFooterLinksListQueryOptions = <TData = Awaited<ReturnType<typeof adminFooterLinksList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFooterLinksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminFooterLinksListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminFooterLinksList>>> = ({ signal }) => adminFooterLinksList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminFooterLinksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminFooterLinksListQueryResult = NonNullable<Awaited<ReturnType<typeof adminFooterLinksList>>>
export type AdminFooterLinksListQueryError = unknown


export function useAdminFooterLinksList<TData = Awaited<ReturnType<typeof adminFooterLinksList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFooterLinksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminFooterLinksList>>,
          TError,
          Awaited<ReturnType<typeof adminFooterLinksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminFooterLinksList<TData = Awaited<ReturnType<typeof adminFooterLinksList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFooterLinksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminFooterLinksList>>,
          TError,
          Awaited<ReturnType<typeof adminFooterLinksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminFooterLinksList<TData = Awaited<ReturnType<typeof adminFooterLinksList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFooterLinksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminFooterLinksList<TData = Awaited<ReturnType<typeof adminFooterLinksList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminFooterLinksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminFooterLinksListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminFooterLinksCreateResponse201 = {
  data: FooterLink
  status: 201
}

export type adminFooterLinksCreateResponseSuccess = (adminFooterLinksCreateResponse201) & {
  headers: Headers;
};
;

export type adminFooterLinksCreateResponse = (adminFooterLinksCreateResponseSuccess)

export const getAdminFooterLinksCreateUrl = () => {




  return `/api/v1/admin/settings/footer-links`
}

export const adminFooterLinksCreate = async (footerLinkRequest: FooterLinkRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminFooterLinksCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminFooterLinksCreateResponse>(getAdminFooterLinksCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(footerLinkRequest)
  }
);}





export const getAdminFooterLinksCreateMutationKey = () => ['adminFooterLinksCreate'] as const;

export const getAdminFooterLinksCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFooterLinksCreate>>, TError,AdminFooterLinksCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminFooterLinksCreate>>, TError,AdminFooterLinksCreateMutationVariables, TContext> => {

const mutationKey = getAdminFooterLinksCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminFooterLinksCreate>>, AdminFooterLinksCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminFooterLinksCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminFooterLinksCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminFooterLinksCreate>>>
    export type AdminFooterLinksCreateMutationBody = FooterLinkRequest
    export type AdminFooterLinksCreateMutationError = unknown
    export type AdminFooterLinksCreateMutationVariables = {data: FooterLinkRequest}

    export const useAdminFooterLinksCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFooterLinksCreate>>, TError,AdminFooterLinksCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminFooterLinksCreate>>,
        TError,
        AdminFooterLinksCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminFooterLinksCreateMutationOptions(options), queryClient);
    }
    export type adminFooterLinksPartialUpdateResponse200 = {
  data: FooterLink
  status: 200
}

export type adminFooterLinksPartialUpdateResponseSuccess = (adminFooterLinksPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminFooterLinksPartialUpdateResponse = (adminFooterLinksPartialUpdateResponseSuccess)

export const getAdminFooterLinksPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/settings/footer-links/${uid}`
}

export const adminFooterLinksPartialUpdate = async (uid: string,
    patchedFooterLinkRequest?: PatchedFooterLinkRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminFooterLinksPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminFooterLinksPartialUpdateResponse>(getAdminFooterLinksPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedFooterLinkRequest)
  }
);}





export const getAdminFooterLinksPartialUpdateMutationKey = () => ['adminFooterLinksPartialUpdate'] as const;

export const getAdminFooterLinksPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFooterLinksPartialUpdate>>, TError,AdminFooterLinksPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminFooterLinksPartialUpdate>>, TError,AdminFooterLinksPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminFooterLinksPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminFooterLinksPartialUpdate>>, AdminFooterLinksPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminFooterLinksPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminFooterLinksPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminFooterLinksPartialUpdate>>>
    export type AdminFooterLinksPartialUpdateMutationBody = PatchedFooterLinkRequest | undefined
    export type AdminFooterLinksPartialUpdateMutationError = unknown
    export type AdminFooterLinksPartialUpdateMutationVariables = {uid: string;data?: PatchedFooterLinkRequest}

    export const useAdminFooterLinksPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFooterLinksPartialUpdate>>, TError,AdminFooterLinksPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminFooterLinksPartialUpdate>>,
        TError,
        AdminFooterLinksPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminFooterLinksPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminFooterLinksDestroyResponse204 = {
  data: void
  status: 204
}

export type adminFooterLinksDestroyResponseSuccess = (adminFooterLinksDestroyResponse204) & {
  headers: Headers;
};
;

export type adminFooterLinksDestroyResponse = (adminFooterLinksDestroyResponseSuccess)

export const getAdminFooterLinksDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/settings/footer-links/${uid}`
}

export const adminFooterLinksDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminFooterLinksDestroyResponse> => {

  return apiFetch<adminFooterLinksDestroyResponse>(getAdminFooterLinksDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminFooterLinksDestroyMutationKey = () => ['adminFooterLinksDestroy'] as const;

export const getAdminFooterLinksDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFooterLinksDestroy>>, TError,AdminFooterLinksDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminFooterLinksDestroy>>, TError,AdminFooterLinksDestroyMutationVariables, TContext> => {

const mutationKey = getAdminFooterLinksDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminFooterLinksDestroy>>, AdminFooterLinksDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminFooterLinksDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminFooterLinksDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminFooterLinksDestroy>>>

    export type AdminFooterLinksDestroyMutationError = unknown
    export type AdminFooterLinksDestroyMutationVariables = {uid: string}

    export const useAdminFooterLinksDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFooterLinksDestroy>>, TError,AdminFooterLinksDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminFooterLinksDestroy>>,
        TError,
        AdminFooterLinksDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminFooterLinksDestroyMutationOptions(options), queryClient);
    }
    export type adminFooterLinksReorderResponse200 = {
  data: FooterLink[]
  status: 200
}

export type adminFooterLinksReorderResponseSuccess = (adminFooterLinksReorderResponse200) & {
  headers: Headers;
};
;

export type adminFooterLinksReorderResponse = (adminFooterLinksReorderResponseSuccess)

export const getAdminFooterLinksReorderUrl = () => {




  return `/api/v1/admin/settings/footer-links/reorder`
}

export const adminFooterLinksReorder = async (reorderRequest: ReorderRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminFooterLinksReorderResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminFooterLinksReorderResponse>(getAdminFooterLinksReorderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reorderRequest)
  }
);}





export const getAdminFooterLinksReorderMutationKey = () => ['adminFooterLinksReorder'] as const;

export const getAdminFooterLinksReorderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFooterLinksReorder>>, TError,AdminFooterLinksReorderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminFooterLinksReorder>>, TError,AdminFooterLinksReorderMutationVariables, TContext> => {

const mutationKey = getAdminFooterLinksReorderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminFooterLinksReorder>>, AdminFooterLinksReorderMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminFooterLinksReorder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminFooterLinksReorderMutationResult = NonNullable<Awaited<ReturnType<typeof adminFooterLinksReorder>>>
    export type AdminFooterLinksReorderMutationBody = ReorderRequest
    export type AdminFooterLinksReorderMutationError = unknown
    export type AdminFooterLinksReorderMutationVariables = {data: ReorderRequest}

    export const useAdminFooterLinksReorder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFooterLinksReorder>>, TError,AdminFooterLinksReorderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminFooterLinksReorder>>,
        TError,
        AdminFooterLinksReorderMutationVariables,
        TContext
      > => {
      return useMutation(getAdminFooterLinksReorderMutationOptions(options), queryClient);
    }
    export type adminSettingsIntegrationsListResponse200 = {
  data: Integration[]
  status: 200
}

export type adminSettingsIntegrationsListResponseSuccess = (adminSettingsIntegrationsListResponse200) & {
  headers: Headers;
};
;

export type adminSettingsIntegrationsListResponse = (adminSettingsIntegrationsListResponseSuccess)

export const getAdminSettingsIntegrationsListUrl = () => {




  return `/api/v1/admin/settings/integrations`
}

/**
 * Email, SMS, storage, jobs and payment gateway: which driver is in use. Never shows secrets.
 */
export const adminSettingsIntegrationsList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminSettingsIntegrationsListResponse> => {

  return apiFetch<adminSettingsIntegrationsListResponse>(getAdminSettingsIntegrationsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminSettingsIntegrationsListQueryKey = () => {
    return [
    `/api/v1/admin/settings/integrations`
    ] as const;
    }


export const getAdminSettingsIntegrationsListQueryOptions = <TData = Awaited<ReturnType<typeof adminSettingsIntegrationsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSettingsIntegrationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminSettingsIntegrationsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSettingsIntegrationsList>>> = ({ signal }) => adminSettingsIntegrationsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminSettingsIntegrationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminSettingsIntegrationsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminSettingsIntegrationsList>>>
export type AdminSettingsIntegrationsListQueryError = unknown


export function useAdminSettingsIntegrationsList<TData = Awaited<ReturnType<typeof adminSettingsIntegrationsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSettingsIntegrationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSettingsIntegrationsList>>,
          TError,
          Awaited<ReturnType<typeof adminSettingsIntegrationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSettingsIntegrationsList<TData = Awaited<ReturnType<typeof adminSettingsIntegrationsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSettingsIntegrationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSettingsIntegrationsList>>,
          TError,
          Awaited<ReturnType<typeof adminSettingsIntegrationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSettingsIntegrationsList<TData = Awaited<ReturnType<typeof adminSettingsIntegrationsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSettingsIntegrationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminSettingsIntegrationsList<TData = Awaited<ReturnType<typeof adminSettingsIntegrationsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSettingsIntegrationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminSettingsIntegrationsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminShippingRatesListResponse200 = {
  data: Rate[]
  status: 200
}

export type adminShippingRatesListResponseSuccess = (adminShippingRatesListResponse200) & {
  headers: Headers;
};
;

export type adminShippingRatesListResponse = (adminShippingRatesListResponseSuccess)

export const getAdminShippingRatesListUrl = () => {




  return `/api/v1/admin/shipping-rates`
}

export const adminShippingRatesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminShippingRatesListResponse> => {

  return apiFetch<adminShippingRatesListResponse>(getAdminShippingRatesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminShippingRatesListQueryKey = () => {
    return [
    `/api/v1/admin/shipping-rates`
    ] as const;
    }


export const getAdminShippingRatesListQueryOptions = <TData = Awaited<ReturnType<typeof adminShippingRatesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminShippingRatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminShippingRatesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminShippingRatesList>>> = ({ signal }) => adminShippingRatesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminShippingRatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminShippingRatesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminShippingRatesList>>>
export type AdminShippingRatesListQueryError = unknown


export function useAdminShippingRatesList<TData = Awaited<ReturnType<typeof adminShippingRatesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminShippingRatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminShippingRatesList>>,
          TError,
          Awaited<ReturnType<typeof adminShippingRatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminShippingRatesList<TData = Awaited<ReturnType<typeof adminShippingRatesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminShippingRatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminShippingRatesList>>,
          TError,
          Awaited<ReturnType<typeof adminShippingRatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminShippingRatesList<TData = Awaited<ReturnType<typeof adminShippingRatesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminShippingRatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminShippingRatesList<TData = Awaited<ReturnType<typeof adminShippingRatesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminShippingRatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminShippingRatesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminShippingRatesCreateResponse201 = {
  data: Rate
  status: 201
}

export type adminShippingRatesCreateResponseSuccess = (adminShippingRatesCreateResponse201) & {
  headers: Headers;
};
;

export type adminShippingRatesCreateResponse = (adminShippingRatesCreateResponseSuccess)

export const getAdminShippingRatesCreateUrl = () => {




  return `/api/v1/admin/shipping-rates`
}

export const adminShippingRatesCreate = async (rateWriteRequest: RateWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminShippingRatesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminShippingRatesCreateResponse>(getAdminShippingRatesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(rateWriteRequest)
  }
);}





export const getAdminShippingRatesCreateMutationKey = () => ['adminShippingRatesCreate'] as const;

export const getAdminShippingRatesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminShippingRatesCreate>>, TError,AdminShippingRatesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminShippingRatesCreate>>, TError,AdminShippingRatesCreateMutationVariables, TContext> => {

const mutationKey = getAdminShippingRatesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminShippingRatesCreate>>, AdminShippingRatesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminShippingRatesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminShippingRatesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminShippingRatesCreate>>>
    export type AdminShippingRatesCreateMutationBody = RateWriteRequest
    export type AdminShippingRatesCreateMutationError = unknown
    export type AdminShippingRatesCreateMutationVariables = {data: RateWriteRequest}

    export const useAdminShippingRatesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminShippingRatesCreate>>, TError,AdminShippingRatesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminShippingRatesCreate>>,
        TError,
        AdminShippingRatesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminShippingRatesCreateMutationOptions(options), queryClient);
    }
    export type adminShippingRatesRetrieveResponse200 = {
  data: Rate
  status: 200
}

export type adminShippingRatesRetrieveResponseSuccess = (adminShippingRatesRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminShippingRatesRetrieveResponse = (adminShippingRatesRetrieveResponseSuccess)

export const getAdminShippingRatesRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/shipping-rates/${uid}`
}

export const adminShippingRatesRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminShippingRatesRetrieveResponse> => {

  return apiFetch<adminShippingRatesRetrieveResponse>(getAdminShippingRatesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminShippingRatesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/shipping-rates/${uid}`
    ] as const;
    }


export const getAdminShippingRatesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminShippingRatesRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminShippingRatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminShippingRatesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminShippingRatesRetrieve>>> = ({ signal }) => adminShippingRatesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminShippingRatesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminShippingRatesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminShippingRatesRetrieve>>>
export type AdminShippingRatesRetrieveQueryError = unknown


export function useAdminShippingRatesRetrieve<TData = Awaited<ReturnType<typeof adminShippingRatesRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminShippingRatesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminShippingRatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminShippingRatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminShippingRatesRetrieve<TData = Awaited<ReturnType<typeof adminShippingRatesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminShippingRatesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminShippingRatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminShippingRatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminShippingRatesRetrieve<TData = Awaited<ReturnType<typeof adminShippingRatesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminShippingRatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminShippingRatesRetrieve<TData = Awaited<ReturnType<typeof adminShippingRatesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminShippingRatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminShippingRatesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminShippingRatesPartialUpdateResponse200 = {
  data: Rate
  status: 200
}

export type adminShippingRatesPartialUpdateResponseSuccess = (adminShippingRatesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminShippingRatesPartialUpdateResponse = (adminShippingRatesPartialUpdateResponseSuccess)

export const getAdminShippingRatesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/shipping-rates/${uid}`
}

export const adminShippingRatesPartialUpdate = async (uid: string,
    patchedRateWriteRequest?: PatchedRateWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminShippingRatesPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminShippingRatesPartialUpdateResponse>(getAdminShippingRatesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedRateWriteRequest)
  }
);}





export const getAdminShippingRatesPartialUpdateMutationKey = () => ['adminShippingRatesPartialUpdate'] as const;

export const getAdminShippingRatesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminShippingRatesPartialUpdate>>, TError,AdminShippingRatesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminShippingRatesPartialUpdate>>, TError,AdminShippingRatesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminShippingRatesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminShippingRatesPartialUpdate>>, AdminShippingRatesPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminShippingRatesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminShippingRatesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminShippingRatesPartialUpdate>>>
    export type AdminShippingRatesPartialUpdateMutationBody = PatchedRateWriteRequest | undefined
    export type AdminShippingRatesPartialUpdateMutationError = unknown
    export type AdminShippingRatesPartialUpdateMutationVariables = {uid: string;data?: PatchedRateWriteRequest}

    export const useAdminShippingRatesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminShippingRatesPartialUpdate>>, TError,AdminShippingRatesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminShippingRatesPartialUpdate>>,
        TError,
        AdminShippingRatesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminShippingRatesPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminShippingRatesDestroyResponse204 = {
  data: void
  status: 204
}

export type adminShippingRatesDestroyResponseSuccess = (adminShippingRatesDestroyResponse204) & {
  headers: Headers;
};
;

export type adminShippingRatesDestroyResponse = (adminShippingRatesDestroyResponseSuccess)

export const getAdminShippingRatesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/shipping-rates/${uid}`
}

export const adminShippingRatesDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminShippingRatesDestroyResponse> => {

  return apiFetch<adminShippingRatesDestroyResponse>(getAdminShippingRatesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminShippingRatesDestroyMutationKey = () => ['adminShippingRatesDestroy'] as const;

export const getAdminShippingRatesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminShippingRatesDestroy>>, TError,AdminShippingRatesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminShippingRatesDestroy>>, TError,AdminShippingRatesDestroyMutationVariables, TContext> => {

const mutationKey = getAdminShippingRatesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminShippingRatesDestroy>>, AdminShippingRatesDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminShippingRatesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminShippingRatesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminShippingRatesDestroy>>>

    export type AdminShippingRatesDestroyMutationError = unknown
    export type AdminShippingRatesDestroyMutationVariables = {uid: string}

    export const useAdminShippingRatesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminShippingRatesDestroy>>, TError,AdminShippingRatesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminShippingRatesDestroy>>,
        TError,
        AdminShippingRatesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminShippingRatesDestroyMutationOptions(options), queryClient);
    }
    export type adminShippingRatesQuoteCreateResponse200 = {
  data: Quote
  status: 200
}

export type adminShippingRatesQuoteCreateResponseSuccess = (adminShippingRatesQuoteCreateResponse200) & {
  headers: Headers;
};
;

export type adminShippingRatesQuoteCreateResponse = (adminShippingRatesQuoteCreateResponseSuccess)

export const getAdminShippingRatesQuoteCreateUrl = () => {




  return `/api/v1/admin/shipping-rates/quote`
}

/**
 * Calculator preview: what a vendor order of this value and weight would pay, and why.
 */
export const adminShippingRatesQuoteCreate = async (quoteRequestRequest: QuoteRequestRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminShippingRatesQuoteCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminShippingRatesQuoteCreateResponse>(getAdminShippingRatesQuoteCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(quoteRequestRequest)
  }
);}





export const getAdminShippingRatesQuoteCreateMutationKey = () => ['adminShippingRatesQuoteCreate'] as const;

export const getAdminShippingRatesQuoteCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminShippingRatesQuoteCreate>>, TError,AdminShippingRatesQuoteCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminShippingRatesQuoteCreate>>, TError,AdminShippingRatesQuoteCreateMutationVariables, TContext> => {

const mutationKey = getAdminShippingRatesQuoteCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminShippingRatesQuoteCreate>>, AdminShippingRatesQuoteCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminShippingRatesQuoteCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminShippingRatesQuoteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminShippingRatesQuoteCreate>>>
    export type AdminShippingRatesQuoteCreateMutationBody = QuoteRequestRequest
    export type AdminShippingRatesQuoteCreateMutationError = unknown
    export type AdminShippingRatesQuoteCreateMutationVariables = {data: QuoteRequestRequest}

    export const useAdminShippingRatesQuoteCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminShippingRatesQuoteCreate>>, TError,AdminShippingRatesQuoteCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminShippingRatesQuoteCreate>>,
        TError,
        AdminShippingRatesQuoteCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminShippingRatesQuoteCreateMutationOptions(options), queryClient);
    }
    export type adminStaffListResponse200 = {
  data: PaginatedStaffList
  status: 200
}

export type adminStaffListResponseSuccess = (adminStaffListResponse200) & {
  headers: Headers;
};
;

export type adminStaffListResponse = (adminStaffListResponseSuccess)

export const getAdminStaffListUrl = (params?: AdminStaffListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/staff?${stringifiedParams}` : `/api/v1/admin/staff`
}

/**
 * The team. Filters: `?search=`, `?role=<role uid>`, `?active=true|false`. POST invites someone.
 */
export const adminStaffList = async (params?: AdminStaffListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminStaffListResponse> => {

  return apiFetch<adminStaffListResponse>(getAdminStaffListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminStaffListQueryKey = (params?: AdminStaffListParams,) => {
    return [
    `/api/v1/admin/staff`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminStaffListQueryOptions = <TData = Awaited<ReturnType<typeof adminStaffList>>, TError = unknown>(params?: AdminStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStaffList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminStaffListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminStaffList>>> = ({ signal }) => adminStaffList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminStaffList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminStaffListQueryResult = NonNullable<Awaited<ReturnType<typeof adminStaffList>>>
export type AdminStaffListQueryError = unknown


export function useAdminStaffList<TData = Awaited<ReturnType<typeof adminStaffList>>, TError = unknown>(
 params: undefined |  AdminStaffListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStaffList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStaffList>>,
          TError,
          Awaited<ReturnType<typeof adminStaffList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminStaffList<TData = Awaited<ReturnType<typeof adminStaffList>>, TError = unknown>(
 params?: AdminStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStaffList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStaffList>>,
          TError,
          Awaited<ReturnType<typeof adminStaffList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminStaffList<TData = Awaited<ReturnType<typeof adminStaffList>>, TError = unknown>(
 params?: AdminStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStaffList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminStaffList<TData = Awaited<ReturnType<typeof adminStaffList>>, TError = unknown>(
 params?: AdminStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStaffList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminStaffListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminStaffCreateResponse201 = {
  data: StaffDetail
  status: 201
}

export type adminStaffCreateResponseSuccess = (adminStaffCreateResponse201) & {
  headers: Headers;
};
;

export type adminStaffCreateResponse = (adminStaffCreateResponseSuccess)

export const getAdminStaffCreateUrl = () => {




  return `/api/v1/admin/staff`
}

/**
 * The team. Filters: `?search=`, `?role=<role uid>`, `?active=true|false`. POST invites someone.
 */
export const adminStaffCreate = async (inviteRequest: InviteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminStaffCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminStaffCreateResponse>(getAdminStaffCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(inviteRequest)
  }
);}





export const getAdminStaffCreateMutationKey = () => ['adminStaffCreate'] as const;

export const getAdminStaffCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStaffCreate>>, TError,AdminStaffCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminStaffCreate>>, TError,AdminStaffCreateMutationVariables, TContext> => {

const mutationKey = getAdminStaffCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStaffCreate>>, AdminStaffCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminStaffCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminStaffCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminStaffCreate>>>
    export type AdminStaffCreateMutationBody = InviteRequest
    export type AdminStaffCreateMutationError = unknown
    export type AdminStaffCreateMutationVariables = {data: InviteRequest}

    export const useAdminStaffCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStaffCreate>>, TError,AdminStaffCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStaffCreate>>,
        TError,
        AdminStaffCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminStaffCreateMutationOptions(options), queryClient);
    }
    export type adminStaffRetrieveResponse200 = {
  data: StaffDetail
  status: 200
}

export type adminStaffRetrieveResponseSuccess = (adminStaffRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminStaffRetrieveResponse = (adminStaffRetrieveResponseSuccess)

export const getAdminStaffRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/staff/${uid}`
}

export const adminStaffRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminStaffRetrieveResponse> => {

  return apiFetch<adminStaffRetrieveResponse>(getAdminStaffRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminStaffRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/staff/${uid}`
    ] as const;
    }


export const getAdminStaffRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminStaffRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStaffRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminStaffRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminStaffRetrieve>>> = ({ signal }) => adminStaffRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminStaffRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminStaffRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminStaffRetrieve>>>
export type AdminStaffRetrieveQueryError = unknown


export function useAdminStaffRetrieve<TData = Awaited<ReturnType<typeof adminStaffRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStaffRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStaffRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminStaffRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminStaffRetrieve<TData = Awaited<ReturnType<typeof adminStaffRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStaffRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStaffRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminStaffRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminStaffRetrieve<TData = Awaited<ReturnType<typeof adminStaffRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStaffRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminStaffRetrieve<TData = Awaited<ReturnType<typeof adminStaffRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStaffRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminStaffRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminStaffPartialUpdateResponse200 = {
  data: StaffDetail
  status: 200
}

export type adminStaffPartialUpdateResponseSuccess = (adminStaffPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminStaffPartialUpdateResponse = (adminStaffPartialUpdateResponseSuccess)

export const getAdminStaffPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/staff/${uid}`
}

export const adminStaffPartialUpdate = async (uid: string,
    patchedStaffUpdateRequest?: PatchedStaffUpdateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminStaffPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminStaffPartialUpdateResponse>(getAdminStaffPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedStaffUpdateRequest)
  }
);}





export const getAdminStaffPartialUpdateMutationKey = () => ['adminStaffPartialUpdate'] as const;

export const getAdminStaffPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStaffPartialUpdate>>, TError,AdminStaffPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminStaffPartialUpdate>>, TError,AdminStaffPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminStaffPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStaffPartialUpdate>>, AdminStaffPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminStaffPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminStaffPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminStaffPartialUpdate>>>
    export type AdminStaffPartialUpdateMutationBody = PatchedStaffUpdateRequest | undefined
    export type AdminStaffPartialUpdateMutationError = unknown
    export type AdminStaffPartialUpdateMutationVariables = {uid: string;data?: PatchedStaffUpdateRequest}

    export const useAdminStaffPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStaffPartialUpdate>>, TError,AdminStaffPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStaffPartialUpdate>>,
        TError,
        AdminStaffPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminStaffPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminStaffDeactivateResponse200 = {
  data: StaffDetail
  status: 200
}

export type adminStaffDeactivateResponseSuccess = (adminStaffDeactivateResponse200) & {
  headers: Headers;
};
;

export type adminStaffDeactivateResponse = (adminStaffDeactivateResponseSuccess)

export const getAdminStaffDeactivateUrl = (uid: string,) => {




  return `/api/v1/admin/staff/${uid}/deactivate`
}

/**
 * POST actions on one team member (all need `accounts.change_user`).
 */
export const adminStaffDeactivate = async (uid: string,
    deactivateRequest?: DeactivateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminStaffDeactivateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminStaffDeactivateResponse>(getAdminStaffDeactivateUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deactivateRequest)
  }
);}





export const getAdminStaffDeactivateMutationKey = () => ['adminStaffDeactivate'] as const;

export const getAdminStaffDeactivateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStaffDeactivate>>, TError,AdminStaffDeactivateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminStaffDeactivate>>, TError,AdminStaffDeactivateMutationVariables, TContext> => {

const mutationKey = getAdminStaffDeactivateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStaffDeactivate>>, AdminStaffDeactivateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminStaffDeactivate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminStaffDeactivateMutationResult = NonNullable<Awaited<ReturnType<typeof adminStaffDeactivate>>>
    export type AdminStaffDeactivateMutationBody = DeactivateRequest | undefined
    export type AdminStaffDeactivateMutationError = unknown
    export type AdminStaffDeactivateMutationVariables = {uid: string;data?: DeactivateRequest}

    export const useAdminStaffDeactivate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStaffDeactivate>>, TError,AdminStaffDeactivateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStaffDeactivate>>,
        TError,
        AdminStaffDeactivateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminStaffDeactivateMutationOptions(options), queryClient);
    }
    export type adminStaffReactivateResponse200 = {
  data: StaffDetail
  status: 200
}

export type adminStaffReactivateResponseSuccess = (adminStaffReactivateResponse200) & {
  headers: Headers;
};
;

export type adminStaffReactivateResponse = (adminStaffReactivateResponseSuccess)

export const getAdminStaffReactivateUrl = (uid: string,) => {




  return `/api/v1/admin/staff/${uid}/reactivate`
}

/**
 * POST actions on one team member (all need `accounts.change_user`).
 */
export const adminStaffReactivate = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminStaffReactivateResponse> => {

  return apiFetch<adminStaffReactivateResponse>(getAdminStaffReactivateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminStaffReactivateMutationKey = () => ['adminStaffReactivate'] as const;

export const getAdminStaffReactivateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStaffReactivate>>, TError,AdminStaffReactivateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminStaffReactivate>>, TError,AdminStaffReactivateMutationVariables, TContext> => {

const mutationKey = getAdminStaffReactivateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStaffReactivate>>, AdminStaffReactivateMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminStaffReactivate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminStaffReactivateMutationResult = NonNullable<Awaited<ReturnType<typeof adminStaffReactivate>>>

    export type AdminStaffReactivateMutationError = unknown
    export type AdminStaffReactivateMutationVariables = {uid: string}

    export const useAdminStaffReactivate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStaffReactivate>>, TError,AdminStaffReactivateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStaffReactivate>>,
        TError,
        AdminStaffReactivateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminStaffReactivateMutationOptions(options), queryClient);
    }
    export type adminStaffRemoveResponse204 = {
  data: void
  status: 204
}

export type adminStaffRemoveResponseSuccess = (adminStaffRemoveResponse204) & {
  headers: Headers;
};
;

export type adminStaffRemoveResponse = (adminStaffRemoveResponseSuccess)

export const getAdminStaffRemoveUrl = (uid: string,) => {




  return `/api/v1/admin/staff/${uid}/remove`
}

/**
 * POST actions on one team member (all need `accounts.change_user`).
 */
export const adminStaffRemove = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminStaffRemoveResponse> => {

  return apiFetch<adminStaffRemoveResponse>(getAdminStaffRemoveUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminStaffRemoveMutationKey = () => ['adminStaffRemove'] as const;

export const getAdminStaffRemoveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStaffRemove>>, TError,AdminStaffRemoveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminStaffRemove>>, TError,AdminStaffRemoveMutationVariables, TContext> => {

const mutationKey = getAdminStaffRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStaffRemove>>, AdminStaffRemoveMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminStaffRemove(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminStaffRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof adminStaffRemove>>>

    export type AdminStaffRemoveMutationError = unknown
    export type AdminStaffRemoveMutationVariables = {uid: string}

    export const useAdminStaffRemove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStaffRemove>>, TError,AdminStaffRemoveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStaffRemove>>,
        TError,
        AdminStaffRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getAdminStaffRemoveMutationOptions(options), queryClient);
    }
    export type adminStaffResendInviteResponse200 = {
  data: StaffDetail
  status: 200
}

export type adminStaffResendInviteResponseSuccess = (adminStaffResendInviteResponse200) & {
  headers: Headers;
};
;

export type adminStaffResendInviteResponse = (adminStaffResendInviteResponseSuccess)

export const getAdminStaffResendInviteUrl = (uid: string,) => {




  return `/api/v1/admin/staff/${uid}/resend-invite`
}

/**
 * POST actions on one team member (all need `accounts.change_user`).
 */
export const adminStaffResendInvite = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminStaffResendInviteResponse> => {

  return apiFetch<adminStaffResendInviteResponse>(getAdminStaffResendInviteUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminStaffResendInviteMutationKey = () => ['adminStaffResendInvite'] as const;

export const getAdminStaffResendInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStaffResendInvite>>, TError,AdminStaffResendInviteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminStaffResendInvite>>, TError,AdminStaffResendInviteMutationVariables, TContext> => {

const mutationKey = getAdminStaffResendInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStaffResendInvite>>, AdminStaffResendInviteMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminStaffResendInvite(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminStaffResendInviteMutationResult = NonNullable<Awaited<ReturnType<typeof adminStaffResendInvite>>>

    export type AdminStaffResendInviteMutationError = unknown
    export type AdminStaffResendInviteMutationVariables = {uid: string}

    export const useAdminStaffResendInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStaffResendInvite>>, TError,AdminStaffResendInviteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStaffResendInvite>>,
        TError,
        AdminStaffResendInviteMutationVariables,
        TContext
      > => {
      return useMutation(getAdminStaffResendInviteMutationOptions(options), queryClient);
    }
    export type adminStaffResetMfaResponse200 = {
  data: StaffDetail
  status: 200
}

export type adminStaffResetMfaResponseSuccess = (adminStaffResetMfaResponse200) & {
  headers: Headers;
};
;

export type adminStaffResetMfaResponse = (adminStaffResetMfaResponseSuccess)

export const getAdminStaffResetMfaUrl = (uid: string,) => {




  return `/api/v1/admin/staff/${uid}/reset-mfa`
}

/**
 * POST actions on one team member (all need `accounts.change_user`).
 */
export const adminStaffResetMfa = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminStaffResetMfaResponse> => {

  return apiFetch<adminStaffResetMfaResponse>(getAdminStaffResetMfaUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminStaffResetMfaMutationKey = () => ['adminStaffResetMfa'] as const;

export const getAdminStaffResetMfaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStaffResetMfa>>, TError,AdminStaffResetMfaMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminStaffResetMfa>>, TError,AdminStaffResetMfaMutationVariables, TContext> => {

const mutationKey = getAdminStaffResetMfaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStaffResetMfa>>, AdminStaffResetMfaMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminStaffResetMfa(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminStaffResetMfaMutationResult = NonNullable<Awaited<ReturnType<typeof adminStaffResetMfa>>>

    export type AdminStaffResetMfaMutationError = unknown
    export type AdminStaffResetMfaMutationVariables = {uid: string}

    export const useAdminStaffResetMfa = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStaffResetMfa>>, TError,AdminStaffResetMfaMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStaffResetMfa>>,
        TError,
        AdminStaffResetMfaMutationVariables,
        TContext
      > => {
      return useMutation(getAdminStaffResetMfaMutationOptions(options), queryClient);
    }
    export type adminSupportCategoriesListResponse200 = {
  data: TicketCategory[]
  status: 200
}

export type adminSupportCategoriesListResponseSuccess = (adminSupportCategoriesListResponse200) & {
  headers: Headers;
};
;

export type adminSupportCategoriesListResponse = (adminSupportCategoriesListResponseSuccess)

export const getAdminSupportCategoriesListUrl = () => {




  return `/api/v1/admin/support/categories`
}

export const adminSupportCategoriesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminSupportCategoriesListResponse> => {

  return apiFetch<adminSupportCategoriesListResponse>(getAdminSupportCategoriesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminSupportCategoriesListQueryKey = () => {
    return [
    `/api/v1/admin/support/categories`
    ] as const;
    }


export const getAdminSupportCategoriesListQueryOptions = <TData = Awaited<ReturnType<typeof adminSupportCategoriesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSupportCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminSupportCategoriesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSupportCategoriesList>>> = ({ signal }) => adminSupportCategoriesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminSupportCategoriesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminSupportCategoriesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminSupportCategoriesList>>>
export type AdminSupportCategoriesListQueryError = unknown


export function useAdminSupportCategoriesList<TData = Awaited<ReturnType<typeof adminSupportCategoriesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSupportCategoriesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSupportCategoriesList>>,
          TError,
          Awaited<ReturnType<typeof adminSupportCategoriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSupportCategoriesList<TData = Awaited<ReturnType<typeof adminSupportCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSupportCategoriesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSupportCategoriesList>>,
          TError,
          Awaited<ReturnType<typeof adminSupportCategoriesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminSupportCategoriesList<TData = Awaited<ReturnType<typeof adminSupportCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSupportCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminSupportCategoriesList<TData = Awaited<ReturnType<typeof adminSupportCategoriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminSupportCategoriesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminSupportCategoriesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminSupportCategoriesCreateResponse201 = {
  data: TicketCategory
  status: 201
}

export type adminSupportCategoriesCreateResponseSuccess = (adminSupportCategoriesCreateResponse201) & {
  headers: Headers;
};
;

export type adminSupportCategoriesCreateResponse = (adminSupportCategoriesCreateResponseSuccess)

export const getAdminSupportCategoriesCreateUrl = () => {




  return `/api/v1/admin/support/categories`
}

export const adminSupportCategoriesCreate = async (ticketCategoryRequest: TicketCategoryRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminSupportCategoriesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminSupportCategoriesCreateResponse>(getAdminSupportCategoriesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ticketCategoryRequest)
  }
);}





export const getAdminSupportCategoriesCreateMutationKey = () => ['adminSupportCategoriesCreate'] as const;

export const getAdminSupportCategoriesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSupportCategoriesCreate>>, TError,AdminSupportCategoriesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSupportCategoriesCreate>>, TError,AdminSupportCategoriesCreateMutationVariables, TContext> => {

const mutationKey = getAdminSupportCategoriesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSupportCategoriesCreate>>, AdminSupportCategoriesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminSupportCategoriesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSupportCategoriesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminSupportCategoriesCreate>>>
    export type AdminSupportCategoriesCreateMutationBody = TicketCategoryRequest
    export type AdminSupportCategoriesCreateMutationError = unknown
    export type AdminSupportCategoriesCreateMutationVariables = {data: TicketCategoryRequest}

    export const useAdminSupportCategoriesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSupportCategoriesCreate>>, TError,AdminSupportCategoriesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSupportCategoriesCreate>>,
        TError,
        AdminSupportCategoriesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminSupportCategoriesCreateMutationOptions(options), queryClient);
    }
    export type adminSupportCategoriesUpdateResponse200 = {
  data: TicketCategory
  status: 200
}

export type adminSupportCategoriesUpdateResponseSuccess = (adminSupportCategoriesUpdateResponse200) & {
  headers: Headers;
};
;

export type adminSupportCategoriesUpdateResponse = (adminSupportCategoriesUpdateResponseSuccess)

export const getAdminSupportCategoriesUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/support/categories/${uid}`
}

export const adminSupportCategoriesUpdate = async (uid: string,
    patchedTicketCategoryRequest?: PatchedTicketCategoryRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminSupportCategoriesUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminSupportCategoriesUpdateResponse>(getAdminSupportCategoriesUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedTicketCategoryRequest)
  }
);}





export const getAdminSupportCategoriesUpdateMutationKey = () => ['adminSupportCategoriesUpdate'] as const;

export const getAdminSupportCategoriesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSupportCategoriesUpdate>>, TError,AdminSupportCategoriesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSupportCategoriesUpdate>>, TError,AdminSupportCategoriesUpdateMutationVariables, TContext> => {

const mutationKey = getAdminSupportCategoriesUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSupportCategoriesUpdate>>, AdminSupportCategoriesUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminSupportCategoriesUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSupportCategoriesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminSupportCategoriesUpdate>>>
    export type AdminSupportCategoriesUpdateMutationBody = PatchedTicketCategoryRequest | undefined
    export type AdminSupportCategoriesUpdateMutationError = unknown
    export type AdminSupportCategoriesUpdateMutationVariables = {uid: string;data?: PatchedTicketCategoryRequest}

    export const useAdminSupportCategoriesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSupportCategoriesUpdate>>, TError,AdminSupportCategoriesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSupportCategoriesUpdate>>,
        TError,
        AdminSupportCategoriesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminSupportCategoriesUpdateMutationOptions(options), queryClient);
    }
    export type adminSupportCategoriesDestroyResponse204 = {
  data: void
  status: 204
}

export type adminSupportCategoriesDestroyResponseSuccess = (adminSupportCategoriesDestroyResponse204) & {
  headers: Headers;
};
;

export type adminSupportCategoriesDestroyResponse = (adminSupportCategoriesDestroyResponseSuccess)

export const getAdminSupportCategoriesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/support/categories/${uid}`
}

export const adminSupportCategoriesDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminSupportCategoriesDestroyResponse> => {

  return apiFetch<adminSupportCategoriesDestroyResponse>(getAdminSupportCategoriesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminSupportCategoriesDestroyMutationKey = () => ['adminSupportCategoriesDestroy'] as const;

export const getAdminSupportCategoriesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSupportCategoriesDestroy>>, TError,AdminSupportCategoriesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSupportCategoriesDestroy>>, TError,AdminSupportCategoriesDestroyMutationVariables, TContext> => {

const mutationKey = getAdminSupportCategoriesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSupportCategoriesDestroy>>, AdminSupportCategoriesDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminSupportCategoriesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminSupportCategoriesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminSupportCategoriesDestroy>>>

    export type AdminSupportCategoriesDestroyMutationError = unknown
    export type AdminSupportCategoriesDestroyMutationVariables = {uid: string}

    export const useAdminSupportCategoriesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSupportCategoriesDestroy>>, TError,AdminSupportCategoriesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSupportCategoriesDestroy>>,
        TError,
        AdminSupportCategoriesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminSupportCategoriesDestroyMutationOptions(options), queryClient);
    }
    export type adminTaxClassesListResponse200 = {
  data: TaxClass[]
  status: 200
}

export type adminTaxClassesListResponseSuccess = (adminTaxClassesListResponse200) & {
  headers: Headers;
};
;

export type adminTaxClassesListResponse = (adminTaxClassesListResponseSuccess)

export const getAdminTaxClassesListUrl = (params?: AdminTaxClassesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/tax-classes?${stringifiedParams}` : `/api/v1/admin/tax-classes`
}

export const adminTaxClassesList = async (params?: AdminTaxClassesListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminTaxClassesListResponse> => {

  return apiFetch<adminTaxClassesListResponse>(getAdminTaxClassesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminTaxClassesListQueryKey = (params?: AdminTaxClassesListParams,) => {
    return [
    `/api/v1/admin/tax-classes`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminTaxClassesListQueryOptions = <TData = Awaited<ReturnType<typeof adminTaxClassesList>>, TError = unknown>(params?: AdminTaxClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaxClassesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminTaxClassesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminTaxClassesList>>> = ({ signal }) => adminTaxClassesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminTaxClassesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminTaxClassesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminTaxClassesList>>>
export type AdminTaxClassesListQueryError = unknown


export function useAdminTaxClassesList<TData = Awaited<ReturnType<typeof adminTaxClassesList>>, TError = unknown>(
 params: undefined |  AdminTaxClassesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaxClassesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTaxClassesList>>,
          TError,
          Awaited<ReturnType<typeof adminTaxClassesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTaxClassesList<TData = Awaited<ReturnType<typeof adminTaxClassesList>>, TError = unknown>(
 params?: AdminTaxClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaxClassesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTaxClassesList>>,
          TError,
          Awaited<ReturnType<typeof adminTaxClassesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTaxClassesList<TData = Awaited<ReturnType<typeof adminTaxClassesList>>, TError = unknown>(
 params?: AdminTaxClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaxClassesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminTaxClassesList<TData = Awaited<ReturnType<typeof adminTaxClassesList>>, TError = unknown>(
 params?: AdminTaxClassesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaxClassesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminTaxClassesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminTaxClassesCreateResponse201 = {
  data: TaxClass
  status: 201
}

export type adminTaxClassesCreateResponseSuccess = (adminTaxClassesCreateResponse201) & {
  headers: Headers;
};
;

export type adminTaxClassesCreateResponse = (adminTaxClassesCreateResponseSuccess)

export const getAdminTaxClassesCreateUrl = () => {




  return `/api/v1/admin/tax-classes`
}

export const adminTaxClassesCreate = async (taxClassWriteRequest: TaxClassWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminTaxClassesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminTaxClassesCreateResponse>(getAdminTaxClassesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(taxClassWriteRequest)
  }
);}





export const getAdminTaxClassesCreateMutationKey = () => ['adminTaxClassesCreate'] as const;

export const getAdminTaxClassesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTaxClassesCreate>>, TError,AdminTaxClassesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminTaxClassesCreate>>, TError,AdminTaxClassesCreateMutationVariables, TContext> => {

const mutationKey = getAdminTaxClassesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminTaxClassesCreate>>, AdminTaxClassesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminTaxClassesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminTaxClassesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminTaxClassesCreate>>>
    export type AdminTaxClassesCreateMutationBody = TaxClassWriteRequest
    export type AdminTaxClassesCreateMutationError = unknown
    export type AdminTaxClassesCreateMutationVariables = {data: TaxClassWriteRequest}

    export const useAdminTaxClassesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTaxClassesCreate>>, TError,AdminTaxClassesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminTaxClassesCreate>>,
        TError,
        AdminTaxClassesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminTaxClassesCreateMutationOptions(options), queryClient);
    }
    export type adminTaxClassesRetrieveResponse200 = {
  data: TaxClass
  status: 200
}

export type adminTaxClassesRetrieveResponseSuccess = (adminTaxClassesRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminTaxClassesRetrieveResponse = (adminTaxClassesRetrieveResponseSuccess)

export const getAdminTaxClassesRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/tax-classes/${uid}`
}

export const adminTaxClassesRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminTaxClassesRetrieveResponse> => {

  return apiFetch<adminTaxClassesRetrieveResponse>(getAdminTaxClassesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminTaxClassesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/tax-classes/${uid}`
    ] as const;
    }


export const getAdminTaxClassesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminTaxClassesRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaxClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminTaxClassesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminTaxClassesRetrieve>>> = ({ signal }) => adminTaxClassesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminTaxClassesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminTaxClassesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminTaxClassesRetrieve>>>
export type AdminTaxClassesRetrieveQueryError = unknown


export function useAdminTaxClassesRetrieve<TData = Awaited<ReturnType<typeof adminTaxClassesRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaxClassesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTaxClassesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminTaxClassesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTaxClassesRetrieve<TData = Awaited<ReturnType<typeof adminTaxClassesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaxClassesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTaxClassesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminTaxClassesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTaxClassesRetrieve<TData = Awaited<ReturnType<typeof adminTaxClassesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaxClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminTaxClassesRetrieve<TData = Awaited<ReturnType<typeof adminTaxClassesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaxClassesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminTaxClassesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminTaxClassesPartialUpdateResponse200 = {
  data: TaxClass
  status: 200
}

export type adminTaxClassesPartialUpdateResponseSuccess = (adminTaxClassesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminTaxClassesPartialUpdateResponse = (adminTaxClassesPartialUpdateResponseSuccess)

export const getAdminTaxClassesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/tax-classes/${uid}`
}

export const adminTaxClassesPartialUpdate = async (uid: string,
    patchedTaxClassWriteRequest?: PatchedTaxClassWriteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminTaxClassesPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminTaxClassesPartialUpdateResponse>(getAdminTaxClassesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedTaxClassWriteRequest)
  }
);}





export const getAdminTaxClassesPartialUpdateMutationKey = () => ['adminTaxClassesPartialUpdate'] as const;

export const getAdminTaxClassesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTaxClassesPartialUpdate>>, TError,AdminTaxClassesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminTaxClassesPartialUpdate>>, TError,AdminTaxClassesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminTaxClassesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminTaxClassesPartialUpdate>>, AdminTaxClassesPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminTaxClassesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminTaxClassesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminTaxClassesPartialUpdate>>>
    export type AdminTaxClassesPartialUpdateMutationBody = PatchedTaxClassWriteRequest | undefined
    export type AdminTaxClassesPartialUpdateMutationError = unknown
    export type AdminTaxClassesPartialUpdateMutationVariables = {uid: string;data?: PatchedTaxClassWriteRequest}

    export const useAdminTaxClassesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTaxClassesPartialUpdate>>, TError,AdminTaxClassesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminTaxClassesPartialUpdate>>,
        TError,
        AdminTaxClassesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminTaxClassesPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminTaxClassesDestroyResponse204 = {
  data: void
  status: 204
}

export type adminTaxClassesDestroyResponseSuccess = (adminTaxClassesDestroyResponse204) & {
  headers: Headers;
};
;

export type adminTaxClassesDestroyResponse = (adminTaxClassesDestroyResponseSuccess)

export const getAdminTaxClassesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/tax-classes/${uid}`
}

export const adminTaxClassesDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminTaxClassesDestroyResponse> => {

  return apiFetch<adminTaxClassesDestroyResponse>(getAdminTaxClassesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminTaxClassesDestroyMutationKey = () => ['adminTaxClassesDestroy'] as const;

export const getAdminTaxClassesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTaxClassesDestroy>>, TError,AdminTaxClassesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminTaxClassesDestroy>>, TError,AdminTaxClassesDestroyMutationVariables, TContext> => {

const mutationKey = getAdminTaxClassesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminTaxClassesDestroy>>, AdminTaxClassesDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminTaxClassesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminTaxClassesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminTaxClassesDestroy>>>

    export type AdminTaxClassesDestroyMutationError = unknown
    export type AdminTaxClassesDestroyMutationVariables = {uid: string}

    export const useAdminTaxClassesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTaxClassesDestroy>>, TError,AdminTaxClassesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminTaxClassesDestroy>>,
        TError,
        AdminTaxClassesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminTaxClassesDestroyMutationOptions(options), queryClient);
    }
    export type adminTaxClassesDefaultCreateResponse200 = {
  data: TaxClass
  status: 200
}

export type adminTaxClassesDefaultCreateResponseSuccess = (adminTaxClassesDefaultCreateResponse200) & {
  headers: Headers;
};
;

export type adminTaxClassesDefaultCreateResponse = (adminTaxClassesDefaultCreateResponseSuccess)

export const getAdminTaxClassesDefaultCreateUrl = (uid: string,) => {




  return `/api/v1/admin/tax-classes/${uid}/default`
}

/**
 * Make this class the marketplace default.
 */
export const adminTaxClassesDefaultCreate = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminTaxClassesDefaultCreateResponse> => {

  return apiFetch<adminTaxClassesDefaultCreateResponse>(getAdminTaxClassesDefaultCreateUrl(uid),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminTaxClassesDefaultCreateMutationKey = () => ['adminTaxClassesDefaultCreate'] as const;

export const getAdminTaxClassesDefaultCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTaxClassesDefaultCreate>>, TError,AdminTaxClassesDefaultCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminTaxClassesDefaultCreate>>, TError,AdminTaxClassesDefaultCreateMutationVariables, TContext> => {

const mutationKey = getAdminTaxClassesDefaultCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminTaxClassesDefaultCreate>>, AdminTaxClassesDefaultCreateMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminTaxClassesDefaultCreate(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminTaxClassesDefaultCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminTaxClassesDefaultCreate>>>

    export type AdminTaxClassesDefaultCreateMutationError = unknown
    export type AdminTaxClassesDefaultCreateMutationVariables = {uid: string}

    export const useAdminTaxClassesDefaultCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTaxClassesDefaultCreate>>, TError,AdminTaxClassesDefaultCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminTaxClassesDefaultCreate>>,
        TError,
        AdminTaxClassesDefaultCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminTaxClassesDefaultCreateMutationOptions(options), queryClient);
    }
    export type adminTicketsListResponse200 = {
  data: PaginatedTicketListList
  status: 200
}

export type adminTicketsListResponseSuccess = (adminTicketsListResponse200) & {
  headers: Headers;
};
;

export type adminTicketsListResponse = (adminTicketsListResponseSuccess)

export const getAdminTicketsListUrl = (params?: AdminTicketsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/tickets?${stringifiedParams}` : `/api/v1/admin/tickets`
}

export const adminTicketsList = async (params?: AdminTicketsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminTicketsListResponse> => {

  return apiFetch<adminTicketsListResponse>(getAdminTicketsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminTicketsListQueryKey = (params?: AdminTicketsListParams,) => {
    return [
    `/api/v1/admin/tickets`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminTicketsListQueryOptions = <TData = Awaited<ReturnType<typeof adminTicketsList>>, TError = unknown>(params?: AdminTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminTicketsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminTicketsList>>> = ({ signal }) => adminTicketsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminTicketsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminTicketsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminTicketsList>>>
export type AdminTicketsListQueryError = unknown


export function useAdminTicketsList<TData = Awaited<ReturnType<typeof adminTicketsList>>, TError = unknown>(
 params: undefined |  AdminTicketsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTicketsList>>,
          TError,
          Awaited<ReturnType<typeof adminTicketsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTicketsList<TData = Awaited<ReturnType<typeof adminTicketsList>>, TError = unknown>(
 params?: AdminTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTicketsList>>,
          TError,
          Awaited<ReturnType<typeof adminTicketsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTicketsList<TData = Awaited<ReturnType<typeof adminTicketsList>>, TError = unknown>(
 params?: AdminTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminTicketsList<TData = Awaited<ReturnType<typeof adminTicketsList>>, TError = unknown>(
 params?: AdminTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminTicketsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminTicketsRetrieveResponse200 = {
  data: TicketDetail
  status: 200
}

export type adminTicketsRetrieveResponseSuccess = (adminTicketsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminTicketsRetrieveResponse = (adminTicketsRetrieveResponseSuccess)

export const getAdminTicketsRetrieveUrl = (number: string,) => {




  return `/api/v1/admin/tickets/${number}`
}

export const adminTicketsRetrieve = async (number: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminTicketsRetrieveResponse> => {

  return apiFetch<adminTicketsRetrieveResponse>(getAdminTicketsRetrieveUrl(number),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminTicketsRetrieveQueryKey = (number: string,) => {
    return [
    `/api/v1/admin/tickets/${number}`
    ] as const;
    }


export const getAdminTicketsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminTicketsRetrieve>>, TError = unknown>(number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminTicketsRetrieveQueryKey(number);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminTicketsRetrieve>>> = ({ signal }) => adminTicketsRetrieve(number, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminTicketsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminTicketsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminTicketsRetrieve>>>
export type AdminTicketsRetrieveQueryError = unknown


export function useAdminTicketsRetrieve<TData = Awaited<ReturnType<typeof adminTicketsRetrieve>>, TError = unknown>(
 number: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTicketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminTicketsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTicketsRetrieve<TData = Awaited<ReturnType<typeof adminTicketsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTicketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminTicketsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTicketsRetrieve<TData = Awaited<ReturnType<typeof adminTicketsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminTicketsRetrieve<TData = Awaited<ReturnType<typeof adminTicketsRetrieve>>, TError = unknown>(
 number: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminTicketsRetrieveQueryOptions(number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminTicketsAttachmentResponse200 = {
  data: Blob
  status: 200
}

export type adminTicketsAttachmentResponseSuccess = (adminTicketsAttachmentResponse200) & {
  headers: Headers;
};
;

export type adminTicketsAttachmentResponse = (adminTicketsAttachmentResponseSuccess)

export const getAdminTicketsAttachmentUrl = (number: string,
    media: string,) => {




  return `/api/v1/admin/tickets/${number}/attachments/${media}`
}

export const adminTicketsAttachment = async (number: string,
    media: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminTicketsAttachmentResponse> => {

  return apiFetch<adminTicketsAttachmentResponse>(getAdminTicketsAttachmentUrl(number,media),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminTicketsAttachmentQueryKey = (number: string,
    media: string,) => {
    return [
    `/api/v1/admin/tickets/${number}/attachments/${media}`
    ] as const;
    }


export const getAdminTicketsAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof adminTicketsAttachment>>, TError = unknown>(number: string,
    media: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsAttachment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminTicketsAttachmentQueryKey(number,media);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminTicketsAttachment>>> = ({ signal }) => adminTicketsAttachment(number,media, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: number !== null && number !== undefined && media !== null && media !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminTicketsAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminTicketsAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof adminTicketsAttachment>>>
export type AdminTicketsAttachmentQueryError = unknown


export function useAdminTicketsAttachment<TData = Awaited<ReturnType<typeof adminTicketsAttachment>>, TError = unknown>(
 number: string,
    media: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTicketsAttachment>>,
          TError,
          Awaited<ReturnType<typeof adminTicketsAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTicketsAttachment<TData = Awaited<ReturnType<typeof adminTicketsAttachment>>, TError = unknown>(
 number: string,
    media: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTicketsAttachment>>,
          TError,
          Awaited<ReturnType<typeof adminTicketsAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTicketsAttachment<TData = Awaited<ReturnType<typeof adminTicketsAttachment>>, TError = unknown>(
 number: string,
    media: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsAttachment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminTicketsAttachment<TData = Awaited<ReturnType<typeof adminTicketsAttachment>>, TError = unknown>(
 number: string,
    media: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsAttachment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminTicketsAttachmentQueryOptions(number,media,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminTicketsReplyResponse200 = {
  data: TicketDetail
  status: 200
}

export type adminTicketsReplyResponseSuccess = (adminTicketsReplyResponse200) & {
  headers: Headers;
};
;

export type adminTicketsReplyResponse = (adminTicketsReplyResponseSuccess)

export const getAdminTicketsReplyUrl = (number: string,) => {




  return `/api/v1/admin/tickets/${number}/reply`
}

export const adminTicketsReply = async (number: string,
    replyRequest: ReplyRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminTicketsReplyResponse> => {
    const formData = new FormData();
formData.append(`body`, replyRequest.body);
if(replyRequest.is_internal_note !== undefined) {
 formData.append(`is_internal_note`, replyRequest.is_internal_note.toString())
 }
if(replyRequest.attachments !== undefined) {
 replyRequest.attachments.forEach(value => formData.append(`attachments`, value));
 }

  return apiFetch<adminTicketsReplyResponse>(getAdminTicketsReplyUrl(number),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getAdminTicketsReplyMutationKey = () => ['adminTicketsReply'] as const;

export const getAdminTicketsReplyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTicketsReply>>, TError,AdminTicketsReplyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminTicketsReply>>, TError,AdminTicketsReplyMutationVariables, TContext> => {

const mutationKey = getAdminTicketsReplyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminTicketsReply>>, AdminTicketsReplyMutationVariables> = (props) => {
          const {number,data} = props ?? {};

          return  adminTicketsReply(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminTicketsReplyMutationResult = NonNullable<Awaited<ReturnType<typeof adminTicketsReply>>>
    export type AdminTicketsReplyMutationBody = ReplyRequest
    export type AdminTicketsReplyMutationError = unknown
    export type AdminTicketsReplyMutationVariables = {number: string;data: ReplyRequest}

    export const useAdminTicketsReply = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTicketsReply>>, TError,AdminTicketsReplyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminTicketsReply>>,
        TError,
        AdminTicketsReplyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminTicketsReplyMutationOptions(options), queryClient);
    }
    export type adminTicketsUpdateResponse200 = {
  data: TicketDetail
  status: 200
}

export type adminTicketsUpdateResponseSuccess = (adminTicketsUpdateResponse200) & {
  headers: Headers;
};
;

export type adminTicketsUpdateResponse = (adminTicketsUpdateResponseSuccess)

export const getAdminTicketsUpdateUrl = (number: string,) => {




  return `/api/v1/admin/tickets/${number}/update`
}

export const adminTicketsUpdate = async (number: string,
    updateRequest?: UpdateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminTicketsUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminTicketsUpdateResponse>(getAdminTicketsUpdateUrl(number),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateRequest)
  }
);}





export const getAdminTicketsUpdateMutationKey = () => ['adminTicketsUpdate'] as const;

export const getAdminTicketsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTicketsUpdate>>, TError,AdminTicketsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminTicketsUpdate>>, TError,AdminTicketsUpdateMutationVariables, TContext> => {

const mutationKey = getAdminTicketsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminTicketsUpdate>>, AdminTicketsUpdateMutationVariables> = (props) => {
          const {number,data} = props ?? {};

          return  adminTicketsUpdate(number,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminTicketsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminTicketsUpdate>>>
    export type AdminTicketsUpdateMutationBody = UpdateRequest | undefined
    export type AdminTicketsUpdateMutationError = unknown
    export type AdminTicketsUpdateMutationVariables = {number: string;data?: UpdateRequest}

    export const useAdminTicketsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTicketsUpdate>>, TError,AdminTicketsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminTicketsUpdate>>,
        TError,
        AdminTicketsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminTicketsUpdateMutationOptions(options), queryClient);
    }
    export type adminTicketsCountsResponse200 = {
  data: TicketCounts
  status: 200
}

export type adminTicketsCountsResponseSuccess = (adminTicketsCountsResponse200) & {
  headers: Headers;
};
;

export type adminTicketsCountsResponse = (adminTicketsCountsResponseSuccess)

export const getAdminTicketsCountsUrl = () => {




  return `/api/v1/admin/tickets/counts`
}

export const adminTicketsCounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminTicketsCountsResponse> => {

  return apiFetch<adminTicketsCountsResponse>(getAdminTicketsCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminTicketsCountsQueryKey = () => {
    return [
    `/api/v1/admin/tickets/counts`
    ] as const;
    }


export const getAdminTicketsCountsQueryOptions = <TData = Awaited<ReturnType<typeof adminTicketsCounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminTicketsCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminTicketsCounts>>> = ({ signal }) => adminTicketsCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminTicketsCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminTicketsCountsQueryResult = NonNullable<Awaited<ReturnType<typeof adminTicketsCounts>>>
export type AdminTicketsCountsQueryError = unknown


export function useAdminTicketsCounts<TData = Awaited<ReturnType<typeof adminTicketsCounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTicketsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminTicketsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTicketsCounts<TData = Awaited<ReturnType<typeof adminTicketsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTicketsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminTicketsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTicketsCounts<TData = Awaited<ReturnType<typeof adminTicketsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminTicketsCounts<TData = Awaited<ReturnType<typeof adminTicketsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTicketsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminTicketsCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminUsersPasswordSetResponse200 = {
  data: Done
  status: 200
}

export type adminUsersPasswordSetResponseSuccess = (adminUsersPasswordSetResponse200) & {
  headers: Headers;
};
;

export type adminUsersPasswordSetResponse = (adminUsersPasswordSetResponseSuccess)

export const getAdminUsersPasswordSetUrl = (uid: string,) => {




  return `/api/v1/admin/users/${uid}/password`
}

export const adminUsersPasswordSet = async (uid: string,
    setPasswordRequest: SetPasswordRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminUsersPasswordSetResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminUsersPasswordSetResponse>(getAdminUsersPasswordSetUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setPasswordRequest)
  }
);}





export const getAdminUsersPasswordSetMutationKey = () => ['adminUsersPasswordSet'] as const;

export const getAdminUsersPasswordSetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersPasswordSet>>, TError,AdminUsersPasswordSetMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUsersPasswordSet>>, TError,AdminUsersPasswordSetMutationVariables, TContext> => {

const mutationKey = getAdminUsersPasswordSetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUsersPasswordSet>>, AdminUsersPasswordSetMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminUsersPasswordSet(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUsersPasswordSetMutationResult = NonNullable<Awaited<ReturnType<typeof adminUsersPasswordSet>>>
    export type AdminUsersPasswordSetMutationBody = SetPasswordRequest
    export type AdminUsersPasswordSetMutationError = unknown
    export type AdminUsersPasswordSetMutationVariables = {uid: string;data: SetPasswordRequest}

    export const useAdminUsersPasswordSet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersPasswordSet>>, TError,AdminUsersPasswordSetMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminUsersPasswordSet>>,
        TError,
        AdminUsersPasswordSetMutationVariables,
        TContext
      > => {
      return useMutation(getAdminUsersPasswordSetMutationOptions(options), queryClient);
    }
    export type adminUsersPasswordResetResponse200 = {
  data: Done
  status: 200
}

export type adminUsersPasswordResetResponseSuccess = (adminUsersPasswordResetResponse200) & {
  headers: Headers;
};
;

export type adminUsersPasswordResetResponse = (adminUsersPasswordResetResponseSuccess)

export const getAdminUsersPasswordResetUrl = (uid: string,) => {




  return `/api/v1/admin/users/${uid}/password-reset`
}

export const adminUsersPasswordReset = async (uid: string,
    resetLinkRequest?: ResetLinkRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminUsersPasswordResetResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminUsersPasswordResetResponse>(getAdminUsersPasswordResetUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resetLinkRequest)
  }
);}





export const getAdminUsersPasswordResetMutationKey = () => ['adminUsersPasswordReset'] as const;

export const getAdminUsersPasswordResetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersPasswordReset>>, TError,AdminUsersPasswordResetMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUsersPasswordReset>>, TError,AdminUsersPasswordResetMutationVariables, TContext> => {

const mutationKey = getAdminUsersPasswordResetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUsersPasswordReset>>, AdminUsersPasswordResetMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminUsersPasswordReset(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminUsersPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof adminUsersPasswordReset>>>
    export type AdminUsersPasswordResetMutationBody = ResetLinkRequest | undefined
    export type AdminUsersPasswordResetMutationError = unknown
    export type AdminUsersPasswordResetMutationVariables = {uid: string;data?: ResetLinkRequest}

    export const useAdminUsersPasswordReset = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersPasswordReset>>, TError,AdminUsersPasswordResetMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminUsersPasswordReset>>,
        TError,
        AdminUsersPasswordResetMutationVariables,
        TContext
      > => {
      return useMutation(getAdminUsersPasswordResetMutationOptions(options), queryClient);
    }
    export type adminVehiclesExportRetrieveResponse200 = {
  data: string
  status: 200
}

export type adminVehiclesExportRetrieveResponseSuccess = (adminVehiclesExportRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesExportRetrieveResponse = (adminVehiclesExportRetrieveResponseSuccess)

export const getAdminVehiclesExportRetrieveUrl = () => {




  return `/api/v1/admin/vehicles/export`
}

export const adminVehiclesExportRetrieve = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesExportRetrieveResponse> => {

  return apiFetch<adminVehiclesExportRetrieveResponse>(getAdminVehiclesExportRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVehiclesExportRetrieveQueryKey = () => {
    return [
    `/api/v1/admin/vehicles/export`
    ] as const;
    }


export const getAdminVehiclesExportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVehiclesExportRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>> = ({ signal }) => adminVehiclesExportRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVehiclesExportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>>
export type AdminVehiclesExportRetrieveQueryError = unknown


export function useAdminVehiclesExportRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesExportRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesExportRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVehiclesExportRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVehiclesExportRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVehiclesImportCreateResponse200 = {
  data: ImportResult
  status: 200
}

export type adminVehiclesImportCreateResponseSuccess = (adminVehiclesImportCreateResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesImportCreateResponse = (adminVehiclesImportCreateResponseSuccess)

export const getAdminVehiclesImportCreateUrl = () => {




  return `/api/v1/admin/vehicles/import`
}

/**
 * Upload a CSV; `dry_run=true` only checks. The answer is 200 with `ok: false` and the row errors when the
 * file has problems (nothing is saved then); a file that can't be read at all is a 400.
 */
export const adminVehiclesImportCreate = async (importRequest: ImportRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesImportCreateResponse> => {
    const formData = new FormData();
formData.append(`file`, importRequest.file);
if(importRequest.dry_run !== undefined) {
 formData.append(`dry_run`, importRequest.dry_run.toString())
 }

  return apiFetch<adminVehiclesImportCreateResponse>(getAdminVehiclesImportCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getAdminVehiclesImportCreateMutationKey = () => ['adminVehiclesImportCreate'] as const;

export const getAdminVehiclesImportCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesImportCreate>>, TError,AdminVehiclesImportCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesImportCreate>>, TError,AdminVehiclesImportCreateMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesImportCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesImportCreate>>, AdminVehiclesImportCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminVehiclesImportCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesImportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesImportCreate>>>
    export type AdminVehiclesImportCreateMutationBody = ImportRequest
    export type AdminVehiclesImportCreateMutationError = unknown
    export type AdminVehiclesImportCreateMutationVariables = {data: ImportRequest}

    export const useAdminVehiclesImportCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesImportCreate>>, TError,AdminVehiclesImportCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesImportCreate>>,
        TError,
        AdminVehiclesImportCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesImportCreateMutationOptions(options), queryClient);
    }
    export type adminVehiclesMakesListResponse200 = {
  data: PaginatedMakeList
  status: 200
}

export type adminVehiclesMakesListResponseSuccess = (adminVehiclesMakesListResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesMakesListResponse = (adminVehiclesMakesListResponseSuccess)

export const getAdminVehiclesMakesListUrl = (params?: AdminVehiclesMakesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/vehicles/makes?${stringifiedParams}` : `/api/v1/admin/vehicles/makes`
}

/**
 * `?search=` `?type=<type uid>`
 */
export const adminVehiclesMakesList = async (params?: AdminVehiclesMakesListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesMakesListResponse> => {

  return apiFetch<adminVehiclesMakesListResponse>(getAdminVehiclesMakesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVehiclesMakesListQueryKey = (params?: AdminVehiclesMakesListParams,) => {
    return [
    `/api/v1/admin/vehicles/makes`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminVehiclesMakesListQueryOptions = <TData = Awaited<ReturnType<typeof adminVehiclesMakesList>>, TError = unknown>(params?: AdminVehiclesMakesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesMakesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVehiclesMakesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVehiclesMakesList>>> = ({ signal }) => adminVehiclesMakesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesMakesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVehiclesMakesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesMakesList>>>
export type AdminVehiclesMakesListQueryError = unknown


export function useAdminVehiclesMakesList<TData = Awaited<ReturnType<typeof adminVehiclesMakesList>>, TError = unknown>(
 params: undefined |  AdminVehiclesMakesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesMakesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesMakesList>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesMakesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesMakesList<TData = Awaited<ReturnType<typeof adminVehiclesMakesList>>, TError = unknown>(
 params?: AdminVehiclesMakesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesMakesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesMakesList>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesMakesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesMakesList<TData = Awaited<ReturnType<typeof adminVehiclesMakesList>>, TError = unknown>(
 params?: AdminVehiclesMakesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesMakesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVehiclesMakesList<TData = Awaited<ReturnType<typeof adminVehiclesMakesList>>, TError = unknown>(
 params?: AdminVehiclesMakesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesMakesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVehiclesMakesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVehiclesMakesCreateResponse200 = {
  data: Make
  status: 200
}

export type adminVehiclesMakesCreateResponseSuccess = (adminVehiclesMakesCreateResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesMakesCreateResponse = (adminVehiclesMakesCreateResponseSuccess)

export const getAdminVehiclesMakesCreateUrl = () => {




  return `/api/v1/admin/vehicles/makes`
}

/**
 * `?search=` `?type=<type uid>`
 */
export const adminVehiclesMakesCreate = async (makeRequest: MakeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesMakesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVehiclesMakesCreateResponse>(getAdminVehiclesMakesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(makeRequest)
  }
);}





export const getAdminVehiclesMakesCreateMutationKey = () => ['adminVehiclesMakesCreate'] as const;

export const getAdminVehiclesMakesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesMakesCreate>>, TError,AdminVehiclesMakesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesMakesCreate>>, TError,AdminVehiclesMakesCreateMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesMakesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesMakesCreate>>, AdminVehiclesMakesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminVehiclesMakesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesMakesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesMakesCreate>>>
    export type AdminVehiclesMakesCreateMutationBody = MakeRequest
    export type AdminVehiclesMakesCreateMutationError = unknown
    export type AdminVehiclesMakesCreateMutationVariables = {data: MakeRequest}

    export const useAdminVehiclesMakesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesMakesCreate>>, TError,AdminVehiclesMakesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesMakesCreate>>,
        TError,
        AdminVehiclesMakesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesMakesCreateMutationOptions(options), queryClient);
    }
    export type adminVehiclesMakesRetrieveResponse200 = {
  data: Make
  status: 200
}

export type adminVehiclesMakesRetrieveResponseSuccess = (adminVehiclesMakesRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesMakesRetrieveResponse = (adminVehiclesMakesRetrieveResponseSuccess)

export const getAdminVehiclesMakesRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/makes/${uid}`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesMakesRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesMakesRetrieveResponse> => {

  return apiFetch<adminVehiclesMakesRetrieveResponse>(getAdminVehiclesMakesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVehiclesMakesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/vehicles/makes/${uid}`
    ] as const;
    }


export const getAdminVehiclesMakesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVehiclesMakesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>> = ({ signal }) => adminVehiclesMakesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVehiclesMakesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>>
export type AdminVehiclesMakesRetrieveQueryError = unknown


export function useAdminVehiclesMakesRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesMakesRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesMakesRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVehiclesMakesRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesMakesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVehiclesMakesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVehiclesMakesPartialUpdateResponse200 = {
  data: Make
  status: 200
}

export type adminVehiclesMakesPartialUpdateResponseSuccess = (adminVehiclesMakesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesMakesPartialUpdateResponse = (adminVehiclesMakesPartialUpdateResponseSuccess)

export const getAdminVehiclesMakesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/makes/${uid}`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesMakesPartialUpdate = async (uid: string,
    patchedMakeRequest?: PatchedMakeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesMakesPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVehiclesMakesPartialUpdateResponse>(getAdminVehiclesMakesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedMakeRequest)
  }
);}





export const getAdminVehiclesMakesPartialUpdateMutationKey = () => ['adminVehiclesMakesPartialUpdate'] as const;

export const getAdminVehiclesMakesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesMakesPartialUpdate>>, TError,AdminVehiclesMakesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesMakesPartialUpdate>>, TError,AdminVehiclesMakesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesMakesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesMakesPartialUpdate>>, AdminVehiclesMakesPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminVehiclesMakesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesMakesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesMakesPartialUpdate>>>
    export type AdminVehiclesMakesPartialUpdateMutationBody = PatchedMakeRequest | undefined
    export type AdminVehiclesMakesPartialUpdateMutationError = unknown
    export type AdminVehiclesMakesPartialUpdateMutationVariables = {uid: string;data?: PatchedMakeRequest}

    export const useAdminVehiclesMakesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesMakesPartialUpdate>>, TError,AdminVehiclesMakesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesMakesPartialUpdate>>,
        TError,
        AdminVehiclesMakesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesMakesPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminVehiclesMakesDestroyResponse204 = {
  data: void
  status: 204
}

export type adminVehiclesMakesDestroyResponseSuccess = (adminVehiclesMakesDestroyResponse204) & {
  headers: Headers;
};
;

export type adminVehiclesMakesDestroyResponse = (adminVehiclesMakesDestroyResponseSuccess)

export const getAdminVehiclesMakesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/makes/${uid}`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesMakesDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesMakesDestroyResponse> => {

  return apiFetch<adminVehiclesMakesDestroyResponse>(getAdminVehiclesMakesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminVehiclesMakesDestroyMutationKey = () => ['adminVehiclesMakesDestroy'] as const;

export const getAdminVehiclesMakesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesMakesDestroy>>, TError,AdminVehiclesMakesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesMakesDestroy>>, TError,AdminVehiclesMakesDestroyMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesMakesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesMakesDestroy>>, AdminVehiclesMakesDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminVehiclesMakesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesMakesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesMakesDestroy>>>

    export type AdminVehiclesMakesDestroyMutationError = unknown
    export type AdminVehiclesMakesDestroyMutationVariables = {uid: string}

    export const useAdminVehiclesMakesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesMakesDestroy>>, TError,AdminVehiclesMakesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesMakesDestroy>>,
        TError,
        AdminVehiclesMakesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesMakesDestroyMutationOptions(options), queryClient);
    }
    export type adminVehiclesModelsListResponse200 = {
  data: PaginatedModelList
  status: 200
}

export type adminVehiclesModelsListResponseSuccess = (adminVehiclesModelsListResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesModelsListResponse = (adminVehiclesModelsListResponseSuccess)

export const getAdminVehiclesModelsListUrl = (params?: AdminVehiclesModelsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/vehicles/models?${stringifiedParams}` : `/api/v1/admin/vehicles/models`
}

/**
 * `?make=<uid>` `?type=<uid>` `?search=`
 */
export const adminVehiclesModelsList = async (params?: AdminVehiclesModelsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesModelsListResponse> => {

  return apiFetch<adminVehiclesModelsListResponse>(getAdminVehiclesModelsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVehiclesModelsListQueryKey = (params?: AdminVehiclesModelsListParams,) => {
    return [
    `/api/v1/admin/vehicles/models`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminVehiclesModelsListQueryOptions = <TData = Awaited<ReturnType<typeof adminVehiclesModelsList>>, TError = unknown>(params?: AdminVehiclesModelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesModelsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVehiclesModelsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVehiclesModelsList>>> = ({ signal }) => adminVehiclesModelsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesModelsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVehiclesModelsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesModelsList>>>
export type AdminVehiclesModelsListQueryError = unknown


export function useAdminVehiclesModelsList<TData = Awaited<ReturnType<typeof adminVehiclesModelsList>>, TError = unknown>(
 params: undefined |  AdminVehiclesModelsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesModelsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesModelsList>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesModelsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesModelsList<TData = Awaited<ReturnType<typeof adminVehiclesModelsList>>, TError = unknown>(
 params?: AdminVehiclesModelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesModelsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesModelsList>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesModelsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesModelsList<TData = Awaited<ReturnType<typeof adminVehiclesModelsList>>, TError = unknown>(
 params?: AdminVehiclesModelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesModelsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVehiclesModelsList<TData = Awaited<ReturnType<typeof adminVehiclesModelsList>>, TError = unknown>(
 params?: AdminVehiclesModelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesModelsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVehiclesModelsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVehiclesModelsCreateResponse200 = {
  data: Model
  status: 200
}

export type adminVehiclesModelsCreateResponseSuccess = (adminVehiclesModelsCreateResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesModelsCreateResponse = (adminVehiclesModelsCreateResponseSuccess)

export const getAdminVehiclesModelsCreateUrl = () => {




  return `/api/v1/admin/vehicles/models`
}

/**
 * `?make=<uid>` `?type=<uid>` `?search=`
 */
export const adminVehiclesModelsCreate = async (modelRequest: ModelRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesModelsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVehiclesModelsCreateResponse>(getAdminVehiclesModelsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(modelRequest)
  }
);}





export const getAdminVehiclesModelsCreateMutationKey = () => ['adminVehiclesModelsCreate'] as const;

export const getAdminVehiclesModelsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesModelsCreate>>, TError,AdminVehiclesModelsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesModelsCreate>>, TError,AdminVehiclesModelsCreateMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesModelsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesModelsCreate>>, AdminVehiclesModelsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminVehiclesModelsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesModelsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesModelsCreate>>>
    export type AdminVehiclesModelsCreateMutationBody = ModelRequest
    export type AdminVehiclesModelsCreateMutationError = unknown
    export type AdminVehiclesModelsCreateMutationVariables = {data: ModelRequest}

    export const useAdminVehiclesModelsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesModelsCreate>>, TError,AdminVehiclesModelsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesModelsCreate>>,
        TError,
        AdminVehiclesModelsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesModelsCreateMutationOptions(options), queryClient);
    }
    export type adminVehiclesModelsRetrieveResponse200 = {
  data: Model
  status: 200
}

export type adminVehiclesModelsRetrieveResponseSuccess = (adminVehiclesModelsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesModelsRetrieveResponse = (adminVehiclesModelsRetrieveResponseSuccess)

export const getAdminVehiclesModelsRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/models/${uid}`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesModelsRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesModelsRetrieveResponse> => {

  return apiFetch<adminVehiclesModelsRetrieveResponse>(getAdminVehiclesModelsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVehiclesModelsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/vehicles/models/${uid}`
    ] as const;
    }


export const getAdminVehiclesModelsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVehiclesModelsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>> = ({ signal }) => adminVehiclesModelsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVehiclesModelsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>>
export type AdminVehiclesModelsRetrieveQueryError = unknown


export function useAdminVehiclesModelsRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesModelsRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesModelsRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVehiclesModelsRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesModelsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVehiclesModelsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVehiclesModelsPartialUpdateResponse200 = {
  data: Model
  status: 200
}

export type adminVehiclesModelsPartialUpdateResponseSuccess = (adminVehiclesModelsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesModelsPartialUpdateResponse = (adminVehiclesModelsPartialUpdateResponseSuccess)

export const getAdminVehiclesModelsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/models/${uid}`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesModelsPartialUpdate = async (uid: string,
    patchedModelRequest?: PatchedModelRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesModelsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVehiclesModelsPartialUpdateResponse>(getAdminVehiclesModelsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedModelRequest)
  }
);}





export const getAdminVehiclesModelsPartialUpdateMutationKey = () => ['adminVehiclesModelsPartialUpdate'] as const;

export const getAdminVehiclesModelsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesModelsPartialUpdate>>, TError,AdminVehiclesModelsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesModelsPartialUpdate>>, TError,AdminVehiclesModelsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesModelsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesModelsPartialUpdate>>, AdminVehiclesModelsPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminVehiclesModelsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesModelsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesModelsPartialUpdate>>>
    export type AdminVehiclesModelsPartialUpdateMutationBody = PatchedModelRequest | undefined
    export type AdminVehiclesModelsPartialUpdateMutationError = unknown
    export type AdminVehiclesModelsPartialUpdateMutationVariables = {uid: string;data?: PatchedModelRequest}

    export const useAdminVehiclesModelsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesModelsPartialUpdate>>, TError,AdminVehiclesModelsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesModelsPartialUpdate>>,
        TError,
        AdminVehiclesModelsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesModelsPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminVehiclesModelsDestroyResponse204 = {
  data: void
  status: 204
}

export type adminVehiclesModelsDestroyResponseSuccess = (adminVehiclesModelsDestroyResponse204) & {
  headers: Headers;
};
;

export type adminVehiclesModelsDestroyResponse = (adminVehiclesModelsDestroyResponseSuccess)

export const getAdminVehiclesModelsDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/models/${uid}`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesModelsDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesModelsDestroyResponse> => {

  return apiFetch<adminVehiclesModelsDestroyResponse>(getAdminVehiclesModelsDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminVehiclesModelsDestroyMutationKey = () => ['adminVehiclesModelsDestroy'] as const;

export const getAdminVehiclesModelsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesModelsDestroy>>, TError,AdminVehiclesModelsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesModelsDestroy>>, TError,AdminVehiclesModelsDestroyMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesModelsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesModelsDestroy>>, AdminVehiclesModelsDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminVehiclesModelsDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesModelsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesModelsDestroy>>>

    export type AdminVehiclesModelsDestroyMutationError = unknown
    export type AdminVehiclesModelsDestroyMutationVariables = {uid: string}

    export const useAdminVehiclesModelsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesModelsDestroy>>, TError,AdminVehiclesModelsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesModelsDestroy>>,
        TError,
        AdminVehiclesModelsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesModelsDestroyMutationOptions(options), queryClient);
    }
    export type adminVehiclesTypesListResponse200 = {
  data: Type[]
  status: 200
}

export type adminVehiclesTypesListResponseSuccess = (adminVehiclesTypesListResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesTypesListResponse = (adminVehiclesTypesListResponseSuccess)

export const getAdminVehiclesTypesListUrl = () => {




  return `/api/v1/admin/vehicles/types`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesTypesList = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesTypesListResponse> => {

  return apiFetch<adminVehiclesTypesListResponse>(getAdminVehiclesTypesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVehiclesTypesListQueryKey = () => {
    return [
    `/api/v1/admin/vehicles/types`
    ] as const;
    }


export const getAdminVehiclesTypesListQueryOptions = <TData = Awaited<ReturnType<typeof adminVehiclesTypesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesTypesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVehiclesTypesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVehiclesTypesList>>> = ({ signal }) => adminVehiclesTypesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesTypesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVehiclesTypesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesTypesList>>>
export type AdminVehiclesTypesListQueryError = unknown


export function useAdminVehiclesTypesList<TData = Awaited<ReturnType<typeof adminVehiclesTypesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesTypesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesTypesList>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesTypesList<TData = Awaited<ReturnType<typeof adminVehiclesTypesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesTypesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesTypesList>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesTypesList<TData = Awaited<ReturnType<typeof adminVehiclesTypesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesTypesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVehiclesTypesList<TData = Awaited<ReturnType<typeof adminVehiclesTypesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesTypesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVehiclesTypesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVehiclesTypesCreateResponse200 = {
  data: Type
  status: 200
}

export type adminVehiclesTypesCreateResponseSuccess = (adminVehiclesTypesCreateResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesTypesCreateResponse = (adminVehiclesTypesCreateResponseSuccess)

export const getAdminVehiclesTypesCreateUrl = () => {




  return `/api/v1/admin/vehicles/types`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesTypesCreate = async (typeRequest: TypeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesTypesCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVehiclesTypesCreateResponse>(getAdminVehiclesTypesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(typeRequest)
  }
);}





export const getAdminVehiclesTypesCreateMutationKey = () => ['adminVehiclesTypesCreate'] as const;

export const getAdminVehiclesTypesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesTypesCreate>>, TError,AdminVehiclesTypesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesTypesCreate>>, TError,AdminVehiclesTypesCreateMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesTypesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesTypesCreate>>, AdminVehiclesTypesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminVehiclesTypesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesTypesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesTypesCreate>>>
    export type AdminVehiclesTypesCreateMutationBody = TypeRequest
    export type AdminVehiclesTypesCreateMutationError = unknown
    export type AdminVehiclesTypesCreateMutationVariables = {data: TypeRequest}

    export const useAdminVehiclesTypesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesTypesCreate>>, TError,AdminVehiclesTypesCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesTypesCreate>>,
        TError,
        AdminVehiclesTypesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesTypesCreateMutationOptions(options), queryClient);
    }
    export type adminVehiclesTypesRetrieveResponse200 = {
  data: Type
  status: 200
}

export type adminVehiclesTypesRetrieveResponseSuccess = (adminVehiclesTypesRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesTypesRetrieveResponse = (adminVehiclesTypesRetrieveResponseSuccess)

export const getAdminVehiclesTypesRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/types/${uid}`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesTypesRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesTypesRetrieveResponse> => {

  return apiFetch<adminVehiclesTypesRetrieveResponse>(getAdminVehiclesTypesRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVehiclesTypesRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/vehicles/types/${uid}`
    ] as const;
    }


export const getAdminVehiclesTypesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVehiclesTypesRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>> = ({ signal }) => adminVehiclesTypesRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVehiclesTypesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>>
export type AdminVehiclesTypesRetrieveQueryError = unknown


export function useAdminVehiclesTypesRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesTypesRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesTypesRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVehiclesTypesRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVehiclesTypesRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVehiclesTypesPartialUpdateResponse200 = {
  data: Type
  status: 200
}

export type adminVehiclesTypesPartialUpdateResponseSuccess = (adminVehiclesTypesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesTypesPartialUpdateResponse = (adminVehiclesTypesPartialUpdateResponseSuccess)

export const getAdminVehiclesTypesPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/types/${uid}`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesTypesPartialUpdate = async (uid: string,
    patchedTypeRequest?: PatchedTypeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesTypesPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVehiclesTypesPartialUpdateResponse>(getAdminVehiclesTypesPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedTypeRequest)
  }
);}





export const getAdminVehiclesTypesPartialUpdateMutationKey = () => ['adminVehiclesTypesPartialUpdate'] as const;

export const getAdminVehiclesTypesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesTypesPartialUpdate>>, TError,AdminVehiclesTypesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesTypesPartialUpdate>>, TError,AdminVehiclesTypesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesTypesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesTypesPartialUpdate>>, AdminVehiclesTypesPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminVehiclesTypesPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesTypesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesTypesPartialUpdate>>>
    export type AdminVehiclesTypesPartialUpdateMutationBody = PatchedTypeRequest | undefined
    export type AdminVehiclesTypesPartialUpdateMutationError = unknown
    export type AdminVehiclesTypesPartialUpdateMutationVariables = {uid: string;data?: PatchedTypeRequest}

    export const useAdminVehiclesTypesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesTypesPartialUpdate>>, TError,AdminVehiclesTypesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesTypesPartialUpdate>>,
        TError,
        AdminVehiclesTypesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesTypesPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminVehiclesTypesDestroyResponse204 = {
  data: void
  status: 204
}

export type adminVehiclesTypesDestroyResponseSuccess = (adminVehiclesTypesDestroyResponse204) & {
  headers: Headers;
};
;

export type adminVehiclesTypesDestroyResponse = (adminVehiclesTypesDestroyResponseSuccess)

export const getAdminVehiclesTypesDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/types/${uid}`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesTypesDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesTypesDestroyResponse> => {

  return apiFetch<adminVehiclesTypesDestroyResponse>(getAdminVehiclesTypesDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminVehiclesTypesDestroyMutationKey = () => ['adminVehiclesTypesDestroy'] as const;

export const getAdminVehiclesTypesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesTypesDestroy>>, TError,AdminVehiclesTypesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesTypesDestroy>>, TError,AdminVehiclesTypesDestroyMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesTypesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesTypesDestroy>>, AdminVehiclesTypesDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminVehiclesTypesDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesTypesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesTypesDestroy>>>

    export type AdminVehiclesTypesDestroyMutationError = unknown
    export type AdminVehiclesTypesDestroyMutationVariables = {uid: string}

    export const useAdminVehiclesTypesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesTypesDestroy>>, TError,AdminVehiclesTypesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesTypesDestroy>>,
        TError,
        AdminVehiclesTypesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesTypesDestroyMutationOptions(options), queryClient);
    }
    export type adminVehiclesVariantsListResponse200 = {
  data: PaginatedVariantList
  status: 200
}

export type adminVehiclesVariantsListResponseSuccess = (adminVehiclesVariantsListResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesVariantsListResponse = (adminVehiclesVariantsListResponseSuccess)

export const getAdminVehiclesVariantsListUrl = (params?: AdminVehiclesVariantsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/vehicles/variants?${stringifiedParams}` : `/api/v1/admin/vehicles/variants`
}

/**
 * `?model=<uid>` `?search=`
 */
export const adminVehiclesVariantsList = async (params?: AdminVehiclesVariantsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesVariantsListResponse> => {

  return apiFetch<adminVehiclesVariantsListResponse>(getAdminVehiclesVariantsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVehiclesVariantsListQueryKey = (params?: AdminVehiclesVariantsListParams,) => {
    return [
    `/api/v1/admin/vehicles/variants`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminVehiclesVariantsListQueryOptions = <TData = Awaited<ReturnType<typeof adminVehiclesVariantsList>>, TError = unknown>(params?: AdminVehiclesVariantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVehiclesVariantsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVehiclesVariantsList>>> = ({ signal }) => adminVehiclesVariantsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVehiclesVariantsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesVariantsList>>>
export type AdminVehiclesVariantsListQueryError = unknown


export function useAdminVehiclesVariantsList<TData = Awaited<ReturnType<typeof adminVehiclesVariantsList>>, TError = unknown>(
 params: undefined |  AdminVehiclesVariantsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesVariantsList>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesVariantsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesVariantsList<TData = Awaited<ReturnType<typeof adminVehiclesVariantsList>>, TError = unknown>(
 params?: AdminVehiclesVariantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesVariantsList>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesVariantsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesVariantsList<TData = Awaited<ReturnType<typeof adminVehiclesVariantsList>>, TError = unknown>(
 params?: AdminVehiclesVariantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVehiclesVariantsList<TData = Awaited<ReturnType<typeof adminVehiclesVariantsList>>, TError = unknown>(
 params?: AdminVehiclesVariantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVehiclesVariantsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVehiclesVariantsCreateResponse200 = {
  data: Variant
  status: 200
}

export type adminVehiclesVariantsCreateResponseSuccess = (adminVehiclesVariantsCreateResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesVariantsCreateResponse = (adminVehiclesVariantsCreateResponseSuccess)

export const getAdminVehiclesVariantsCreateUrl = () => {




  return `/api/v1/admin/vehicles/variants`
}

/**
 * `?model=<uid>` `?search=`
 */
export const adminVehiclesVariantsCreate = async (variantRequest: VariantRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesVariantsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVehiclesVariantsCreateResponse>(getAdminVehiclesVariantsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(variantRequest)
  }
);}





export const getAdminVehiclesVariantsCreateMutationKey = () => ['adminVehiclesVariantsCreate'] as const;

export const getAdminVehiclesVariantsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesVariantsCreate>>, TError,AdminVehiclesVariantsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesVariantsCreate>>, TError,AdminVehiclesVariantsCreateMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesVariantsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesVariantsCreate>>, AdminVehiclesVariantsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminVehiclesVariantsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesVariantsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesVariantsCreate>>>
    export type AdminVehiclesVariantsCreateMutationBody = VariantRequest
    export type AdminVehiclesVariantsCreateMutationError = unknown
    export type AdminVehiclesVariantsCreateMutationVariables = {data: VariantRequest}

    export const useAdminVehiclesVariantsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesVariantsCreate>>, TError,AdminVehiclesVariantsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesVariantsCreate>>,
        TError,
        AdminVehiclesVariantsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesVariantsCreateMutationOptions(options), queryClient);
    }
    export type adminVehiclesVariantsRetrieveResponse200 = {
  data: Variant
  status: 200
}

export type adminVehiclesVariantsRetrieveResponseSuccess = (adminVehiclesVariantsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesVariantsRetrieveResponse = (adminVehiclesVariantsRetrieveResponseSuccess)

export const getAdminVehiclesVariantsRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/variants/${uid}`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesVariantsRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesVariantsRetrieveResponse> => {

  return apiFetch<adminVehiclesVariantsRetrieveResponse>(getAdminVehiclesVariantsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVehiclesVariantsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/vehicles/variants/${uid}`
    ] as const;
    }


export const getAdminVehiclesVariantsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVehiclesVariantsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>> = ({ signal }) => adminVehiclesVariantsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVehiclesVariantsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>>
export type AdminVehiclesVariantsRetrieveQueryError = unknown


export function useAdminVehiclesVariantsRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesVariantsRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesVariantsRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVehiclesVariantsRetrieve<TData = Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVehiclesVariantsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVehiclesVariantsPartialUpdateResponse200 = {
  data: Variant
  status: 200
}

export type adminVehiclesVariantsPartialUpdateResponseSuccess = (adminVehiclesVariantsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesVariantsPartialUpdateResponse = (adminVehiclesVariantsPartialUpdateResponseSuccess)

export const getAdminVehiclesVariantsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/variants/${uid}`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesVariantsPartialUpdate = async (uid: string,
    patchedVariantRequest?: PatchedVariantRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesVariantsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVehiclesVariantsPartialUpdateResponse>(getAdminVehiclesVariantsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedVariantRequest)
  }
);}





export const getAdminVehiclesVariantsPartialUpdateMutationKey = () => ['adminVehiclesVariantsPartialUpdate'] as const;

export const getAdminVehiclesVariantsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesVariantsPartialUpdate>>, TError,AdminVehiclesVariantsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesVariantsPartialUpdate>>, TError,AdminVehiclesVariantsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesVariantsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesVariantsPartialUpdate>>, AdminVehiclesVariantsPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminVehiclesVariantsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesVariantsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesVariantsPartialUpdate>>>
    export type AdminVehiclesVariantsPartialUpdateMutationBody = PatchedVariantRequest | undefined
    export type AdminVehiclesVariantsPartialUpdateMutationError = unknown
    export type AdminVehiclesVariantsPartialUpdateMutationVariables = {uid: string;data?: PatchedVariantRequest}

    export const useAdminVehiclesVariantsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesVariantsPartialUpdate>>, TError,AdminVehiclesVariantsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesVariantsPartialUpdate>>,
        TError,
        AdminVehiclesVariantsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesVariantsPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminVehiclesVariantsDestroyResponse204 = {
  data: void
  status: 204
}

export type adminVehiclesVariantsDestroyResponseSuccess = (adminVehiclesVariantsDestroyResponse204) & {
  headers: Headers;
};
;

export type adminVehiclesVariantsDestroyResponse = (adminVehiclesVariantsDestroyResponseSuccess)

export const getAdminVehiclesVariantsDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/variants/${uid}`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesVariantsDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesVariantsDestroyResponse> => {

  return apiFetch<adminVehiclesVariantsDestroyResponse>(getAdminVehiclesVariantsDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminVehiclesVariantsDestroyMutationKey = () => ['adminVehiclesVariantsDestroy'] as const;

export const getAdminVehiclesVariantsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesVariantsDestroy>>, TError,AdminVehiclesVariantsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesVariantsDestroy>>, TError,AdminVehiclesVariantsDestroyMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesVariantsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesVariantsDestroy>>, AdminVehiclesVariantsDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminVehiclesVariantsDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesVariantsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesVariantsDestroy>>>

    export type AdminVehiclesVariantsDestroyMutationError = unknown
    export type AdminVehiclesVariantsDestroyMutationVariables = {uid: string}

    export const useAdminVehiclesVariantsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesVariantsDestroy>>, TError,AdminVehiclesVariantsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesVariantsDestroy>>,
        TError,
        AdminVehiclesVariantsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesVariantsDestroyMutationOptions(options), queryClient);
    }
    export type adminVehiclesVariantsYearsListResponse200 = {
  data: Year[]
  status: 200
}

export type adminVehiclesVariantsYearsListResponseSuccess = (adminVehiclesVariantsYearsListResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesVariantsYearsListResponse = (adminVehiclesVariantsYearsListResponseSuccess)

export const getAdminVehiclesVariantsYearsListUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/variants/${uid}/years`
}

/**
 * The model years of a variant; POST adds a range (missing years only).
 */
export const adminVehiclesVariantsYearsList = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesVariantsYearsListResponse> => {

  return apiFetch<adminVehiclesVariantsYearsListResponse>(getAdminVehiclesVariantsYearsListUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVehiclesVariantsYearsListQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/vehicles/variants/${uid}/years`
    ] as const;
    }


export const getAdminVehiclesVariantsYearsListQueryOptions = <TData = Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVehiclesVariantsYearsListQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>> = ({ signal }) => adminVehiclesVariantsYearsList(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVehiclesVariantsYearsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>>
export type AdminVehiclesVariantsYearsListQueryError = unknown


export function useAdminVehiclesVariantsYearsList<TData = Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesVariantsYearsList<TData = Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>,
          TError,
          Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVehiclesVariantsYearsList<TData = Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVehiclesVariantsYearsList<TData = Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVehiclesVariantsYearsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVehiclesVariantsYearsListQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVehiclesVariantsYearsCreateResponse201 = {
  data: Year[]
  status: 201
}

export type adminVehiclesVariantsYearsCreateResponseSuccess = (adminVehiclesVariantsYearsCreateResponse201) & {
  headers: Headers;
};
;

export type adminVehiclesVariantsYearsCreateResponse = (adminVehiclesVariantsYearsCreateResponseSuccess)

export const getAdminVehiclesVariantsYearsCreateUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/variants/${uid}/years`
}

/**
 * The model years of a variant; POST adds a range (missing years only).
 */
export const adminVehiclesVariantsYearsCreate = async (uid: string,
    yearRangeRequest: YearRangeRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesVariantsYearsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVehiclesVariantsYearsCreateResponse>(getAdminVehiclesVariantsYearsCreateUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(yearRangeRequest)
  }
);}





export const getAdminVehiclesVariantsYearsCreateMutationKey = () => ['adminVehiclesVariantsYearsCreate'] as const;

export const getAdminVehiclesVariantsYearsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesVariantsYearsCreate>>, TError,AdminVehiclesVariantsYearsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesVariantsYearsCreate>>, TError,AdminVehiclesVariantsYearsCreateMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesVariantsYearsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesVariantsYearsCreate>>, AdminVehiclesVariantsYearsCreateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminVehiclesVariantsYearsCreate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesVariantsYearsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesVariantsYearsCreate>>>
    export type AdminVehiclesVariantsYearsCreateMutationBody = YearRangeRequest
    export type AdminVehiclesVariantsYearsCreateMutationError = unknown
    export type AdminVehiclesVariantsYearsCreateMutationVariables = {uid: string;data: YearRangeRequest}

    export const useAdminVehiclesVariantsYearsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesVariantsYearsCreate>>, TError,AdminVehiclesVariantsYearsCreateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesVariantsYearsCreate>>,
        TError,
        AdminVehiclesVariantsYearsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesVariantsYearsCreateMutationOptions(options), queryClient);
    }
    export type adminVehiclesYearsPartialUpdateResponse200 = {
  data: Year
  status: 200
}

export type adminVehiclesYearsPartialUpdateResponseSuccess = (adminVehiclesYearsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminVehiclesYearsPartialUpdateResponse = (adminVehiclesYearsPartialUpdateResponseSuccess)

export const getAdminVehiclesYearsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/years/${uid}`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesYearsPartialUpdate = async (uid: string,
    patchedYearRequest?: PatchedYearRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesYearsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVehiclesYearsPartialUpdateResponse>(getAdminVehiclesYearsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedYearRequest)
  }
);}





export const getAdminVehiclesYearsPartialUpdateMutationKey = () => ['adminVehiclesYearsPartialUpdate'] as const;

export const getAdminVehiclesYearsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesYearsPartialUpdate>>, TError,AdminVehiclesYearsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesYearsPartialUpdate>>, TError,AdminVehiclesYearsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesYearsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesYearsPartialUpdate>>, AdminVehiclesYearsPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminVehiclesYearsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesYearsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesYearsPartialUpdate>>>
    export type AdminVehiclesYearsPartialUpdateMutationBody = PatchedYearRequest | undefined
    export type AdminVehiclesYearsPartialUpdateMutationError = unknown
    export type AdminVehiclesYearsPartialUpdateMutationVariables = {uid: string;data?: PatchedYearRequest}

    export const useAdminVehiclesYearsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesYearsPartialUpdate>>, TError,AdminVehiclesYearsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesYearsPartialUpdate>>,
        TError,
        AdminVehiclesYearsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesYearsPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminVehiclesYearsDestroyResponse204 = {
  data: void
  status: 204
}

export type adminVehiclesYearsDestroyResponseSuccess = (adminVehiclesYearsDestroyResponse204) & {
  headers: Headers;
};
;

export type adminVehiclesYearsDestroyResponse = (adminVehiclesYearsDestroyResponseSuccess)

export const getAdminVehiclesYearsDestroyUrl = (uid: string,) => {




  return `/api/v1/admin/vehicles/years/${uid}`
}

/**
 * One level of the hierarchy: its permission codename suffix, serializer and services.
 */
export const adminVehiclesYearsDestroy = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminVehiclesYearsDestroyResponse> => {

  return apiFetch<adminVehiclesYearsDestroyResponse>(getAdminVehiclesYearsDestroyUrl(uid),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminVehiclesYearsDestroyMutationKey = () => ['adminVehiclesYearsDestroy'] as const;

export const getAdminVehiclesYearsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesYearsDestroy>>, TError,AdminVehiclesYearsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesYearsDestroy>>, TError,AdminVehiclesYearsDestroyMutationVariables, TContext> => {

const mutationKey = getAdminVehiclesYearsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVehiclesYearsDestroy>>, AdminVehiclesYearsDestroyMutationVariables> = (props) => {
          const {uid} = props ?? {};

          return  adminVehiclesYearsDestroy(uid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVehiclesYearsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof adminVehiclesYearsDestroy>>>

    export type AdminVehiclesYearsDestroyMutationError = unknown
    export type AdminVehiclesYearsDestroyMutationVariables = {uid: string}

    export const useAdminVehiclesYearsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVehiclesYearsDestroy>>, TError,AdminVehiclesYearsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVehiclesYearsDestroy>>,
        TError,
        AdminVehiclesYearsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVehiclesYearsDestroyMutationOptions(options), queryClient);
    }
    export type adminVendorsListResponse200 = {
  data: PaginatedVendorList
  status: 200
}

export type adminVendorsListResponseSuccess = (adminVendorsListResponse200) & {
  headers: Headers;
};
;

export type adminVendorsListResponse = (adminVendorsListResponseSuccess)

export const getAdminVendorsListUrl = (params?: AdminVendorsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/vendors?${stringifiedParams}` : `/api/v1/admin/vendors`
}

export const adminVendorsList = async (params?: AdminVendorsListParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsListResponse> => {

  return apiFetch<adminVendorsListResponse>(getAdminVendorsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVendorsListQueryKey = (params?: AdminVendorsListParams,) => {
    return [
    `/api/v1/admin/vendors`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminVendorsListQueryOptions = <TData = Awaited<ReturnType<typeof adminVendorsList>>, TError = unknown>(params?: AdminVendorsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVendorsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVendorsList>>> = ({ signal }) => adminVendorsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVendorsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVendorsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminVendorsList>>>
export type AdminVendorsListQueryError = unknown


export function useAdminVendorsList<TData = Awaited<ReturnType<typeof adminVendorsList>>, TError = unknown>(
 params: undefined |  AdminVendorsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVendorsList>>,
          TError,
          Awaited<ReturnType<typeof adminVendorsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVendorsList<TData = Awaited<ReturnType<typeof adminVendorsList>>, TError = unknown>(
 params?: AdminVendorsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVendorsList>>,
          TError,
          Awaited<ReturnType<typeof adminVendorsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVendorsList<TData = Awaited<ReturnType<typeof adminVendorsList>>, TError = unknown>(
 params?: AdminVendorsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVendorsList<TData = Awaited<ReturnType<typeof adminVendorsList>>, TError = unknown>(
 params?: AdminVendorsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVendorsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVendorsRetrieveResponse200 = {
  data: VendorDetail
  status: 200
}

export type adminVendorsRetrieveResponseSuccess = (adminVendorsRetrieveResponse200) & {
  headers: Headers;
};
;

export type adminVendorsRetrieveResponse = (adminVendorsRetrieveResponseSuccess)

export const getAdminVendorsRetrieveUrl = (uid: string,) => {




  return `/api/v1/admin/vendors/${uid}`
}

export const adminVendorsRetrieve = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsRetrieveResponse> => {

  return apiFetch<adminVendorsRetrieveResponse>(getAdminVendorsRetrieveUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVendorsRetrieveQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/vendors/${uid}`
    ] as const;
    }


export const getAdminVendorsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminVendorsRetrieve>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVendorsRetrieveQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVendorsRetrieve>>> = ({ signal }) => adminVendorsRetrieve(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVendorsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVendorsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminVendorsRetrieve>>>
export type AdminVendorsRetrieveQueryError = unknown


export function useAdminVendorsRetrieve<TData = Awaited<ReturnType<typeof adminVendorsRetrieve>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVendorsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminVendorsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVendorsRetrieve<TData = Awaited<ReturnType<typeof adminVendorsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVendorsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminVendorsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVendorsRetrieve<TData = Awaited<ReturnType<typeof adminVendorsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVendorsRetrieve<TData = Awaited<ReturnType<typeof adminVendorsRetrieve>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVendorsRetrieveQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVendorsPartialUpdateResponse200 = {
  data: VendorDetail
  status: 200
}

export type adminVendorsPartialUpdateResponseSuccess = (adminVendorsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type adminVendorsPartialUpdateResponse = (adminVendorsPartialUpdateResponseSuccess)

export const getAdminVendorsPartialUpdateUrl = (uid: string,) => {




  return `/api/v1/admin/vendors/${uid}`
}

export const adminVendorsPartialUpdate = async (uid: string,
    patchedVendorUpdateRequest?: PatchedVendorUpdateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVendorsPartialUpdateResponse>(getAdminVendorsPartialUpdateUrl(uid),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedVendorUpdateRequest)
  }
);}





export const getAdminVendorsPartialUpdateMutationKey = () => ['adminVendorsPartialUpdate'] as const;

export const getAdminVendorsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsPartialUpdate>>, TError,AdminVendorsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVendorsPartialUpdate>>, TError,AdminVendorsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getAdminVendorsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVendorsPartialUpdate>>, AdminVendorsPartialUpdateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminVendorsPartialUpdate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVendorsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVendorsPartialUpdate>>>
    export type AdminVendorsPartialUpdateMutationBody = PatchedVendorUpdateRequest | undefined
    export type AdminVendorsPartialUpdateMutationError = unknown
    export type AdminVendorsPartialUpdateMutationVariables = {uid: string;data?: PatchedVendorUpdateRequest}

    export const useAdminVendorsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsPartialUpdate>>, TError,AdminVendorsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVendorsPartialUpdate>>,
        TError,
        AdminVendorsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVendorsPartialUpdateMutationOptions(options), queryClient);
    }
    export type adminVendorsApproveResponse200 = {
  data: VendorDetail
  status: 200
}

export type adminVendorsApproveResponseSuccess = (adminVendorsApproveResponse200) & {
  headers: Headers;
};
;

export type adminVendorsApproveResponse = (adminVendorsApproveResponseSuccess)

export const getAdminVendorsApproveUrl = (uid: string,) => {




  return `/api/v1/admin/vendors/${uid}/approve`
}

export const adminVendorsApprove = async (uid: string,
    vendorNoteRequest?: VendorNoteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsApproveResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVendorsApproveResponse>(getAdminVendorsApproveUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(vendorNoteRequest)
  }
);}





export const getAdminVendorsApproveMutationKey = () => ['adminVendorsApprove'] as const;

export const getAdminVendorsApproveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsApprove>>, TError,AdminVendorsApproveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVendorsApprove>>, TError,AdminVendorsApproveMutationVariables, TContext> => {

const mutationKey = getAdminVendorsApproveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVendorsApprove>>, AdminVendorsApproveMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminVendorsApprove(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVendorsApproveMutationResult = NonNullable<Awaited<ReturnType<typeof adminVendorsApprove>>>
    export type AdminVendorsApproveMutationBody = VendorNoteRequest | undefined
    export type AdminVendorsApproveMutationError = unknown
    export type AdminVendorsApproveMutationVariables = {uid: string;data?: VendorNoteRequest}

    export const useAdminVendorsApprove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsApprove>>, TError,AdminVendorsApproveMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVendorsApprove>>,
        TError,
        AdminVendorsApproveMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVendorsApproveMutationOptions(options), queryClient);
    }
    export type adminVendorsDocumentsWithdrawResponse204 = {
  data: void
  status: 204
}

export type adminVendorsDocumentsWithdrawResponseSuccess = (adminVendorsDocumentsWithdrawResponse204) & {
  headers: Headers;
};
;

export type adminVendorsDocumentsWithdrawResponse = (adminVendorsDocumentsWithdrawResponseSuccess)

export const getAdminVendorsDocumentsWithdrawUrl = (uid: string,
    document: string,) => {




  return `/api/v1/admin/vendors/${uid}/documents/${document}`
}

/**
 * Withdraw a document request (DELETE).
 */
export const adminVendorsDocumentsWithdraw = async (uid: string,
    document: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsDocumentsWithdrawResponse> => {

  return apiFetch<adminVendorsDocumentsWithdrawResponse>(getAdminVendorsDocumentsWithdrawUrl(uid,document),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminVendorsDocumentsWithdrawMutationKey = () => ['adminVendorsDocumentsWithdraw'] as const;

export const getAdminVendorsDocumentsWithdrawMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsDocumentsWithdraw>>, TError,AdminVendorsDocumentsWithdrawMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVendorsDocumentsWithdraw>>, TError,AdminVendorsDocumentsWithdrawMutationVariables, TContext> => {

const mutationKey = getAdminVendorsDocumentsWithdrawMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVendorsDocumentsWithdraw>>, AdminVendorsDocumentsWithdrawMutationVariables> = (props) => {
          const {uid,document} = props ?? {};

          return  adminVendorsDocumentsWithdraw(uid,document,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVendorsDocumentsWithdrawMutationResult = NonNullable<Awaited<ReturnType<typeof adminVendorsDocumentsWithdraw>>>

    export type AdminVendorsDocumentsWithdrawMutationError = unknown
    export type AdminVendorsDocumentsWithdrawMutationVariables = {uid: string;document: string}

    export const useAdminVendorsDocumentsWithdraw = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsDocumentsWithdraw>>, TError,AdminVendorsDocumentsWithdrawMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVendorsDocumentsWithdraw>>,
        TError,
        AdminVendorsDocumentsWithdrawMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVendorsDocumentsWithdrawMutationOptions(options), queryClient);
    }
    export type adminVendorsDocumentsFileResponse200 = {
  data: Blob
  status: 200
}

export type adminVendorsDocumentsFileResponse302 = {
  data: void
  status: 302
}

export type adminVendorsDocumentsFileResponseSuccess = (adminVendorsDocumentsFileResponse200) & {
  headers: Headers;
};
export type adminVendorsDocumentsFileResponseError = (adminVendorsDocumentsFileResponse302) & {
  headers: Headers;
};

export type adminVendorsDocumentsFileResponse = (adminVendorsDocumentsFileResponseSuccess | adminVendorsDocumentsFileResponseError)

export const getAdminVendorsDocumentsFileUrl = (uid: string,
    document: string,
    params?: AdminVendorsDocumentsFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/vendors/${uid}/documents/${document}/file?${stringifiedParams}` : `/api/v1/admin/vendors/${uid}/documents/${document}/file`
}

/**
 * The uploaded file (private; opened in the browser, `?download=true` to save).
 */
export const adminVendorsDocumentsFile = async (uid: string,
    document: string,
    params?: AdminVendorsDocumentsFileParams, options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsDocumentsFileResponse> => {

  return apiFetch<adminVendorsDocumentsFileResponse>(getAdminVendorsDocumentsFileUrl(uid,document,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVendorsDocumentsFileQueryKey = (uid: string,
    document: string,
    params?: AdminVendorsDocumentsFileParams,) => {
    return [
    `/api/v1/admin/vendors/${uid}/documents/${document}/file`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminVendorsDocumentsFileQueryOptions = <TData = Awaited<ReturnType<typeof adminVendorsDocumentsFile>>, TError = void>(uid: string,
    document: string,
    params?: AdminVendorsDocumentsFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsDocumentsFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVendorsDocumentsFileQueryKey(uid,document,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVendorsDocumentsFile>>> = ({ signal }) => adminVendorsDocumentsFile(uid,document,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined && document !== null && document !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVendorsDocumentsFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVendorsDocumentsFileQueryResult = NonNullable<Awaited<ReturnType<typeof adminVendorsDocumentsFile>>>
export type AdminVendorsDocumentsFileQueryError = void


export function useAdminVendorsDocumentsFile<TData = Awaited<ReturnType<typeof adminVendorsDocumentsFile>>, TError = void>(
 uid: string,
    document: string,
    params: undefined |  AdminVendorsDocumentsFileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsDocumentsFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVendorsDocumentsFile>>,
          TError,
          Awaited<ReturnType<typeof adminVendorsDocumentsFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVendorsDocumentsFile<TData = Awaited<ReturnType<typeof adminVendorsDocumentsFile>>, TError = void>(
 uid: string,
    document: string,
    params?: AdminVendorsDocumentsFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsDocumentsFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVendorsDocumentsFile>>,
          TError,
          Awaited<ReturnType<typeof adminVendorsDocumentsFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVendorsDocumentsFile<TData = Awaited<ReturnType<typeof adminVendorsDocumentsFile>>, TError = void>(
 uid: string,
    document: string,
    params?: AdminVendorsDocumentsFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsDocumentsFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVendorsDocumentsFile<TData = Awaited<ReturnType<typeof adminVendorsDocumentsFile>>, TError = void>(
 uid: string,
    document: string,
    params?: AdminVendorsDocumentsFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsDocumentsFile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVendorsDocumentsFileQueryOptions(uid,document,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVendorsDocumentsReviewResponse200 = {
  data: VendorDetail
  status: 200
}

export type adminVendorsDocumentsReviewResponseSuccess = (adminVendorsDocumentsReviewResponse200) & {
  headers: Headers;
};
;

export type adminVendorsDocumentsReviewResponse = (adminVendorsDocumentsReviewResponseSuccess)

export const getAdminVendorsDocumentsReviewUrl = (uid: string,
    document: string,) => {




  return `/api/v1/admin/vendors/${uid}/documents/${document}/review`
}

export const adminVendorsDocumentsReview = async (uid: string,
    document: string,
    vendorDocumentReviewRequest: VendorDocumentReviewRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsDocumentsReviewResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVendorsDocumentsReviewResponse>(getAdminVendorsDocumentsReviewUrl(uid,document),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(vendorDocumentReviewRequest)
  }
);}





export const getAdminVendorsDocumentsReviewMutationKey = () => ['adminVendorsDocumentsReview'] as const;

export const getAdminVendorsDocumentsReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsDocumentsReview>>, TError,AdminVendorsDocumentsReviewMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVendorsDocumentsReview>>, TError,AdminVendorsDocumentsReviewMutationVariables, TContext> => {

const mutationKey = getAdminVendorsDocumentsReviewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVendorsDocumentsReview>>, AdminVendorsDocumentsReviewMutationVariables> = (props) => {
          const {uid,document,data} = props ?? {};

          return  adminVendorsDocumentsReview(uid,document,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVendorsDocumentsReviewMutationResult = NonNullable<Awaited<ReturnType<typeof adminVendorsDocumentsReview>>>
    export type AdminVendorsDocumentsReviewMutationBody = VendorDocumentReviewRequest
    export type AdminVendorsDocumentsReviewMutationError = unknown
    export type AdminVendorsDocumentsReviewMutationVariables = {uid: string;document: string;data: VendorDocumentReviewRequest}

    export const useAdminVendorsDocumentsReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsDocumentsReview>>, TError,AdminVendorsDocumentsReviewMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVendorsDocumentsReview>>,
        TError,
        AdminVendorsDocumentsReviewMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVendorsDocumentsReviewMutationOptions(options), queryClient);
    }
    export type adminVendorsHistoryResponse200 = {
  data: VendorHistory[]
  status: 200
}

export type adminVendorsHistoryResponseSuccess = (adminVendorsHistoryResponse200) & {
  headers: Headers;
};
;

export type adminVendorsHistoryResponse = (adminVendorsHistoryResponseSuccess)

export const getAdminVendorsHistoryUrl = (uid: string,) => {




  return `/api/v1/admin/vendors/${uid}/history`
}

export const adminVendorsHistory = async (uid: string, options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsHistoryResponse> => {

  return apiFetch<adminVendorsHistoryResponse>(getAdminVendorsHistoryUrl(uid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVendorsHistoryQueryKey = (uid: string,) => {
    return [
    `/api/v1/admin/vendors/${uid}/history`
    ] as const;
    }


export const getAdminVendorsHistoryQueryOptions = <TData = Awaited<ReturnType<typeof adminVendorsHistory>>, TError = unknown>(uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsHistory>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVendorsHistoryQueryKey(uid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVendorsHistory>>> = ({ signal }) => adminVendorsHistory(uid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uid !== null && uid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVendorsHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVendorsHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof adminVendorsHistory>>>
export type AdminVendorsHistoryQueryError = unknown


export function useAdminVendorsHistory<TData = Awaited<ReturnType<typeof adminVendorsHistory>>, TError = unknown>(
 uid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVendorsHistory>>,
          TError,
          Awaited<ReturnType<typeof adminVendorsHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVendorsHistory<TData = Awaited<ReturnType<typeof adminVendorsHistory>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVendorsHistory>>,
          TError,
          Awaited<ReturnType<typeof adminVendorsHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVendorsHistory<TData = Awaited<ReturnType<typeof adminVendorsHistory>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsHistory>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVendorsHistory<TData = Awaited<ReturnType<typeof adminVendorsHistory>>, TError = unknown>(
 uid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsHistory>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVendorsHistoryQueryOptions(uid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVendorsReactivateResponse200 = {
  data: VendorDetail
  status: 200
}

export type adminVendorsReactivateResponseSuccess = (adminVendorsReactivateResponse200) & {
  headers: Headers;
};
;

export type adminVendorsReactivateResponse = (adminVendorsReactivateResponseSuccess)

export const getAdminVendorsReactivateUrl = (uid: string,) => {




  return `/api/v1/admin/vendors/${uid}/reactivate`
}

export const adminVendorsReactivate = async (uid: string,
    vendorNoteRequest?: VendorNoteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsReactivateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVendorsReactivateResponse>(getAdminVendorsReactivateUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(vendorNoteRequest)
  }
);}





export const getAdminVendorsReactivateMutationKey = () => ['adminVendorsReactivate'] as const;

export const getAdminVendorsReactivateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsReactivate>>, TError,AdminVendorsReactivateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVendorsReactivate>>, TError,AdminVendorsReactivateMutationVariables, TContext> => {

const mutationKey = getAdminVendorsReactivateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVendorsReactivate>>, AdminVendorsReactivateMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminVendorsReactivate(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVendorsReactivateMutationResult = NonNullable<Awaited<ReturnType<typeof adminVendorsReactivate>>>
    export type AdminVendorsReactivateMutationBody = VendorNoteRequest | undefined
    export type AdminVendorsReactivateMutationError = unknown
    export type AdminVendorsReactivateMutationVariables = {uid: string;data?: VendorNoteRequest}

    export const useAdminVendorsReactivate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsReactivate>>, TError,AdminVendorsReactivateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVendorsReactivate>>,
        TError,
        AdminVendorsReactivateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVendorsReactivateMutationOptions(options), queryClient);
    }
    export type adminVendorsRejectResponse200 = {
  data: VendorDetail
  status: 200
}

export type adminVendorsRejectResponseSuccess = (adminVendorsRejectResponse200) & {
  headers: Headers;
};
;

export type adminVendorsRejectResponse = (adminVendorsRejectResponseSuccess)

export const getAdminVendorsRejectUrl = (uid: string,) => {




  return `/api/v1/admin/vendors/${uid}/reject`
}

export const adminVendorsReject = async (uid: string,
    vendorReasonRequest: VendorReasonRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsRejectResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVendorsRejectResponse>(getAdminVendorsRejectUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(vendorReasonRequest)
  }
);}





export const getAdminVendorsRejectMutationKey = () => ['adminVendorsReject'] as const;

export const getAdminVendorsRejectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsReject>>, TError,AdminVendorsRejectMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVendorsReject>>, TError,AdminVendorsRejectMutationVariables, TContext> => {

const mutationKey = getAdminVendorsRejectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVendorsReject>>, AdminVendorsRejectMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminVendorsReject(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVendorsRejectMutationResult = NonNullable<Awaited<ReturnType<typeof adminVendorsReject>>>
    export type AdminVendorsRejectMutationBody = VendorReasonRequest
    export type AdminVendorsRejectMutationError = unknown
    export type AdminVendorsRejectMutationVariables = {uid: string;data: VendorReasonRequest}

    export const useAdminVendorsReject = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsReject>>, TError,AdminVendorsRejectMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVendorsReject>>,
        TError,
        AdminVendorsRejectMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVendorsRejectMutationOptions(options), queryClient);
    }
    export type adminVendorsRequestDocumentsResponse200 = {
  data: VendorDetail
  status: 200
}

export type adminVendorsRequestDocumentsResponseSuccess = (adminVendorsRequestDocumentsResponse200) & {
  headers: Headers;
};
;

export type adminVendorsRequestDocumentsResponse = (adminVendorsRequestDocumentsResponseSuccess)

export const getAdminVendorsRequestDocumentsUrl = (uid: string,) => {




  return `/api/v1/admin/vendors/${uid}/request-documents`
}

export const adminVendorsRequestDocuments = async (uid: string,
    vendorDocumentRequestRequest: VendorDocumentRequestRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsRequestDocumentsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVendorsRequestDocumentsResponse>(getAdminVendorsRequestDocumentsUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(vendorDocumentRequestRequest)
  }
);}





export const getAdminVendorsRequestDocumentsMutationKey = () => ['adminVendorsRequestDocuments'] as const;

export const getAdminVendorsRequestDocumentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsRequestDocuments>>, TError,AdminVendorsRequestDocumentsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVendorsRequestDocuments>>, TError,AdminVendorsRequestDocumentsMutationVariables, TContext> => {

const mutationKey = getAdminVendorsRequestDocumentsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVendorsRequestDocuments>>, AdminVendorsRequestDocumentsMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminVendorsRequestDocuments(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVendorsRequestDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof adminVendorsRequestDocuments>>>
    export type AdminVendorsRequestDocumentsMutationBody = VendorDocumentRequestRequest
    export type AdminVendorsRequestDocumentsMutationError = unknown
    export type AdminVendorsRequestDocumentsMutationVariables = {uid: string;data: VendorDocumentRequestRequest}

    export const useAdminVendorsRequestDocuments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsRequestDocuments>>, TError,AdminVendorsRequestDocumentsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVendorsRequestDocuments>>,
        TError,
        AdminVendorsRequestDocumentsMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVendorsRequestDocumentsMutationOptions(options), queryClient);
    }
    export type adminVendorsStartReviewResponse200 = {
  data: VendorDetail
  status: 200
}

export type adminVendorsStartReviewResponseSuccess = (adminVendorsStartReviewResponse200) & {
  headers: Headers;
};
;

export type adminVendorsStartReviewResponse = (adminVendorsStartReviewResponseSuccess)

export const getAdminVendorsStartReviewUrl = (uid: string,) => {




  return `/api/v1/admin/vendors/${uid}/start-review`
}

export const adminVendorsStartReview = async (uid: string,
    vendorNoteRequest?: VendorNoteRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsStartReviewResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVendorsStartReviewResponse>(getAdminVendorsStartReviewUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(vendorNoteRequest)
  }
);}





export const getAdminVendorsStartReviewMutationKey = () => ['adminVendorsStartReview'] as const;

export const getAdminVendorsStartReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsStartReview>>, TError,AdminVendorsStartReviewMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVendorsStartReview>>, TError,AdminVendorsStartReviewMutationVariables, TContext> => {

const mutationKey = getAdminVendorsStartReviewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVendorsStartReview>>, AdminVendorsStartReviewMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminVendorsStartReview(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVendorsStartReviewMutationResult = NonNullable<Awaited<ReturnType<typeof adminVendorsStartReview>>>
    export type AdminVendorsStartReviewMutationBody = VendorNoteRequest | undefined
    export type AdminVendorsStartReviewMutationError = unknown
    export type AdminVendorsStartReviewMutationVariables = {uid: string;data?: VendorNoteRequest}

    export const useAdminVendorsStartReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsStartReview>>, TError,AdminVendorsStartReviewMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVendorsStartReview>>,
        TError,
        AdminVendorsStartReviewMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVendorsStartReviewMutationOptions(options), queryClient);
    }
    export type adminVendorsSuspendResponse200 = {
  data: VendorDetail
  status: 200
}

export type adminVendorsSuspendResponseSuccess = (adminVendorsSuspendResponse200) & {
  headers: Headers;
};
;

export type adminVendorsSuspendResponse = (adminVendorsSuspendResponseSuccess)

export const getAdminVendorsSuspendUrl = (uid: string,) => {




  return `/api/v1/admin/vendors/${uid}/suspend`
}

export const adminVendorsSuspend = async (uid: string,
    vendorReasonRequest: VendorReasonRequest, options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsSuspendResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<adminVendorsSuspendResponse>(getAdminVendorsSuspendUrl(uid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(vendorReasonRequest)
  }
);}





export const getAdminVendorsSuspendMutationKey = () => ['adminVendorsSuspend'] as const;

export const getAdminVendorsSuspendMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsSuspend>>, TError,AdminVendorsSuspendMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVendorsSuspend>>, TError,AdminVendorsSuspendMutationVariables, TContext> => {

const mutationKey = getAdminVendorsSuspendMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVendorsSuspend>>, AdminVendorsSuspendMutationVariables> = (props) => {
          const {uid,data} = props ?? {};

          return  adminVendorsSuspend(uid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVendorsSuspendMutationResult = NonNullable<Awaited<ReturnType<typeof adminVendorsSuspend>>>
    export type AdminVendorsSuspendMutationBody = VendorReasonRequest
    export type AdminVendorsSuspendMutationError = unknown
    export type AdminVendorsSuspendMutationVariables = {uid: string;data: VendorReasonRequest}

    export const useAdminVendorsSuspend = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVendorsSuspend>>, TError,AdminVendorsSuspendMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminVendorsSuspend>>,
        TError,
        AdminVendorsSuspendMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVendorsSuspendMutationOptions(options), queryClient);
    }
    export type adminVendorsCountsResponse200 = {
  data: VendorStatusCounts
  status: 200
}

export type adminVendorsCountsResponseSuccess = (adminVendorsCountsResponse200) & {
  headers: Headers;
};
;

export type adminVendorsCountsResponse = (adminVendorsCountsResponseSuccess)

export const getAdminVendorsCountsUrl = () => {




  return `/api/v1/admin/vendors/counts`
}

export const adminVendorsCounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsCountsResponse> => {

  return apiFetch<adminVendorsCountsResponse>(getAdminVendorsCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVendorsCountsQueryKey = () => {
    return [
    `/api/v1/admin/vendors/counts`
    ] as const;
    }


export const getAdminVendorsCountsQueryOptions = <TData = Awaited<ReturnType<typeof adminVendorsCounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVendorsCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVendorsCounts>>> = ({ signal }) => adminVendorsCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVendorsCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVendorsCountsQueryResult = NonNullable<Awaited<ReturnType<typeof adminVendorsCounts>>>
export type AdminVendorsCountsQueryError = unknown


export function useAdminVendorsCounts<TData = Awaited<ReturnType<typeof adminVendorsCounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVendorsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminVendorsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVendorsCounts<TData = Awaited<ReturnType<typeof adminVendorsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVendorsCounts>>,
          TError,
          Awaited<ReturnType<typeof adminVendorsCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVendorsCounts<TData = Awaited<ReturnType<typeof adminVendorsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVendorsCounts<TData = Awaited<ReturnType<typeof adminVendorsCounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsCounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVendorsCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type adminVendorsPlatformResponse200 = {
  data: VendorDetail
  status: 200
}

export type adminVendorsPlatformResponseSuccess = (adminVendorsPlatformResponse200) & {
  headers: Headers;
};
;

export type adminVendorsPlatformResponse = (adminVendorsPlatformResponseSuccess)

export const getAdminVendorsPlatformUrl = () => {




  return `/api/v1/admin/vendors/platform`
}

export const adminVendorsPlatform = async ( options?: Parameters<typeof apiFetch>[1]): Promise<adminVendorsPlatformResponse> => {

  return apiFetch<adminVendorsPlatformResponse>(getAdminVendorsPlatformUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminVendorsPlatformQueryKey = () => {
    return [
    `/api/v1/admin/vendors/platform`
    ] as const;
    }


export const getAdminVendorsPlatformQueryOptions = <TData = Awaited<ReturnType<typeof adminVendorsPlatform>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsPlatform>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminVendorsPlatformQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminVendorsPlatform>>> = ({ signal }) => adminVendorsPlatform({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminVendorsPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminVendorsPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof adminVendorsPlatform>>>
export type AdminVendorsPlatformQueryError = unknown


export function useAdminVendorsPlatform<TData = Awaited<ReturnType<typeof adminVendorsPlatform>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVendorsPlatform>>,
          TError,
          Awaited<ReturnType<typeof adminVendorsPlatform>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVendorsPlatform<TData = Awaited<ReturnType<typeof adminVendorsPlatform>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminVendorsPlatform>>,
          TError,
          Awaited<ReturnType<typeof adminVendorsPlatform>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminVendorsPlatform<TData = Awaited<ReturnType<typeof adminVendorsPlatform>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsPlatform>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminVendorsPlatform<TData = Awaited<ReturnType<typeof adminVendorsPlatform>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminVendorsPlatform>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminVendorsPlatformQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






